"use strict";

const EChat = {
    eChatState: false,
    eChatMoving: false,
    eChatTouch: false,
    SavedMessageChange: false,
    __height: 385,
    __width: 350
};

EChat.CustomEvent = {
    SEARCH: "Search",
    SHOWDIALOG: "ShowDialog",
    NEWMESSAGE: "NewMessage",
    // REDRAWGROUP: "RedrawGroup",
    DELETEGROUP: "DeleteGroup",
    REDDOT: "RedDot",
    REDRAWTABLEALERTS: "RedrawTableAlerts"
};

EChat.LocalStorageType = {
    // ECHATCOMMAND: "EChatCommand",
    ECHATAUTHID: "EChatAuthenticationID",
    // ECHATUSERSETTING: "EChatUserSetting",
    DBUPDATE: "DBUpdate",
    DBDELETED: "DBDeleted",
    UNREADDATA: "UnReadData",
    ECHATSTARTSESSION: "EChatStartSession",
    STARTSCREENSHARE: "StartScreenShare",
    CLOSTSCREENSHARECONFIRM: "CloseScreenShareConfirm",
    RECEIVETASKDETAIL: "ReceiveTaskDetail",
    GROUPREADLOCK: "GroupReadLock"
};

// Task 521304: Team Calendar: updates based on Clay's feedback
EChat.InitState = {
    UserData: false, // Init User data to memory
    InitUser: false// Init personal information
};

EChat.PromptType = {
    Normal: 0, // Sound, Push message, Unread tips,
    DoNotDisturb: 1// No Sound, No Push message, Unread tips
};

EChat.PostPermissionType = {
    Block: 0,
    ReadOnly: 1,
    Post: 2
};

EChat.DeliveryMethod = {
    eChat: 1,
    Email: 2,
    TextMessage: 3
};

EChat.DBTableName = {
    GROUPINFO: "GroupInfo",
    SETTINGS: "Settings",
    USERS: "Users",
    TABLEALERTS: "TableAlerts",
    LOG: "Log",
    // SUPPORTGROUPS: "SupportGroups",
    SENDMESSAGES: "SendMessages",
    TASKS: "Tasks"
};

EChat.ErrorType = {
    AJAX_ERROR: "AjaxError",
    WEBSOCKECT_ERROR: "WebSocketError",
    SENDMESSAG_EERROR: "SendMessageError",
    LOCALSTORAGE_ERROR: "LocalStorageError",
    SESSION_ERROR: "VerifySessionFailed",
    DATA_ERROR: "DataError",
    UnKnownError: 0,
    ParameterError: 1,
    QueryFailed: 2,
    VerifySessionFailed: 3,
    VerifyUserFailed: 4
};

EChat.Setting = {
    GroupNumPerShow: 10,
    MessageNumPerShow: 10,
    CharactersOfMessage: 4000,
    TabNumPerWindow: 5,
    minTabWidth: 120,
    MaxCharacterGroupNameDisplay: 1020, // title only displays 1020 character + ...
    DefaultUserIcon: "https://cdn.e8.co/GlobalDocs/587681.png",
    DefaultGroupIcon: "https://cdn.e8.co/GlobalDocs/587682.png",
    DefaultTaskIcon: "https://cdn.e8.co/GlobalDocs/587683.png",
    DefaultAlertIcon: "DefaultAlertIcon",
    showView: true
};

// restorage EChat user status
EChat.UserStatus = {
    userId: null,
    mainPage: {
        isShow: false,
        currentTabName: null, // index of left menu
        position: {
            top: null,
            left: null,
            zIndex: null
        }
    },
    messageWindow: []
};

EChat.EmployeesAlertsType = {
    Day_Close: "Day Close",
    End_of_Day_Warnings: "End of Day Warnings",
    ASN_Receipt: "ASN Receipt",
    New_Customer_Account: "New Customer Account",
    PO_Receipt: "PO Receipt",
    REMIT_Receipt: "REMIT Receipt",
    Import_Conflict: "Import Conflict",
    Picker_Cut: "Picker Cut",
    Supplier_Comm_Warnings: "Supplier Comm Warnings",
    EDI_Download_Reminder: "EDI Download Reminder",
    EDI_Inbound_Errors: "EDI Inbound Errors",
    EDI_Outbound_Errors: "EDI Outbound Errors",
    Account_Mismapping: "Account Mis-Mapping",
    Can_Count_Import: "Can Count Import"
};

EChat.ViewType = {
    CloseView: 0,
    OpenView: 1,
    MinimizeView: 2
};
// Task 467970: Uncaught TypeError: Cannot read property 'UserList' of undefined
EChat.UserType = {
    0: "None",
    1: "Employee_Restricted",
    2: "Employee_NotRestricted",
    10: "Employee_MaxUserTypeID",
    12: "Supplier",
    13: "Customer",
    14: "Chain",
    15: "Carrier",
    16: "Vendor",
    17: "Guest",
    18: "Support"
};

// dispatch custom event
EChat.EventDispatcher = function () {
    const _this = this;
    // An object containing all handlers
    let _h = {};

    this.bind = function (eventName, handler) {
        if (typeof eventName === "undefined") {
            return _this;
        }
        const eArr = ((typeof eventName) === "string") ? eventName.split(" ") : eventName;
        for (let i = 0; i < eArr.length; i++) {
            const ev = eArr[i];
            if (!_h[ev]) {
                _h[ev] = [];
            }
            _h[ev].push(handler);
        }
        return _this;
    };

    this.unbind = function (eventName, handler) {
        if (!eventName) {
            _h = {};
            return _this;
        }
        const eArr = ((typeof eventName) === "string") ? eventName.split(" ") : eventName;
        for (let i = 0; i < eArr.length; i++) {
            const ev = eArr[i];
            if (_h[ev]) {
                if (handler) {
                    for (let j = _h[ev].length - 1; j >= 0; j--) {
                        if (_h[ev][j] === handler) {
                            delete _h[ev][j];
                            _h[ev].splice(j, 1);
                        }
                    }
                } else {
                    delete _h[ev];
                }
            }
        }
        return _this;
    };

    this.dispatch = function (eventName, content) {
        if (eventName && _h[eventName]) {
            for (let i = 0; i < _h[eventName].length; i++) {
                if (_h[eventName][i] !== undefined) {
                    _h[eventName][i](content);
                }
            }
        }
        return _this;
    };

    this.createHandlerArgument = function (e, data) {
        return {
            event: e,
            data
        };
    };
};

EChat.Util = {
    initEChat() {
        return new Promise(((resolve) => {
            requestIdleCallback(() => {
                if (!EChat.ErrorBind) {
                    EChat.ErrorBind = true;
                    window.addEventListener("error", (event) => {
                        if (event.filename.indexOf("EChat.js") !== -1) {
                            let error_stack = "";
                            if (event.error) {
                                error_stack = event.error.stack;
                            }
                            const Log = {
                                lineno: event.lineno,
                                message: event.message,
                                timeStamp: event.timeStamp,
                                type: event.type,
                                stack: error_stack
                            };
                            EChat.IndexedDB.WriteError(Log.message, Log.stack);
                        }
                    });
                }

                const eChatBtn = document.getElementById("EChatButton");
                if (eChatBtn) {
                    if (EChat.Util.availableCheck()) {
                        EChat.Util.initMain().then(() => {
                            resolve();
                            EC_Fmt.TriggerEvent(document, "EChatReady");
                        });
                    } else {
                        eChatBtn.style.display = "none";
                        resolve();
                    }
                }
            });
        }));
    },

    initMain() {
        return new Promise(((resolve) => {
            requestIdleCallback(() => {
                const HandleQueue = [];
                HandleQueue.push(async () => {
                    EChat.V2010 = true;
                    const EChatV2010 = await EChat.IndexedDB.GetSetting("EChatV2010");
                    if (!EChatV2010) {
                        if (EChat.MainPageController) {
                            EChat.MainPageController.closeAllWindow();
                        }

                        EChat.Util.removeEChat();
                        await EChat.IndexedDB.ClearDateBase();
                        await EChat.IndexedDB.UpdateSetting("EChatV2010", EChat.Util.getTimeStamp(), true);
                    }
                });

                // Task 998660: eChat Sound Alerts persist when disabled from eChat
                EChat.MainPageController.initSoundAlert();
                HandleQueue.push(() => EChat.IndexedDB.InitDB());
                HandleQueue.push(() => {
                    EChat.MainPageController.unreadSumCountChange();
                    return EChat.DataProvider.initUser();
                });

                EChat.IndexedDB.DBHandleQueue(HandleQueue).then(() => {
                    document.getElementById("EChatButton").addEventListener("click", () => {
                        if (!EChat.eChatState) {
                            EChat.eChatState = true;
                            EChat.Util.Loading(true);
                            EChat.MainPageController.initMainPage().then(() => {
                                EChat.IndexedDB.InitViewData().then(() => {
                                    EChat.IndexedDB.InitDBData().then(() => {
                                        EC_Fmt.TriggerEvent(document, "EChatFirstOpen");
                                    });
                                    EChat.MainPageController.unreadSumCountChange();
                                });
                            }).catch((e) => {
                                EChat.Util.Loading(false);
                                EChat.Util.errorAlert(e);
                            });
                        }
                    });
                    EChat.LocalStorage.startListen();

                    resolve();
                });
            });
        }));
    },

    removeEChat() {
        const eChatBtn = document.getElementById("EChatButton");
        if (eChatBtn && EChat.eChatState === true) {
            EChat.MainPageController.removeEChatView();
            EChat.FullWindowController.Destroy();
            eChatBtn.style.display = "none";
            EChat.eChatState = false;
        }
    },

    availableCheck() {
        const myUserAgent = navigator.userAgent.toLowerCase();
        const bIsIpad = myUserAgent.match(/ipad/i) === "ipad";
        const bIsIphoneOs = myUserAgent.match(/iphone/i) === "iphone";
        const bIsAndroid = myUserAgent.match(/android/i) === "android";
        const bIsWp = myUserAgent.match(/wpdesktop/i) === "wpdesktop";

        if (bIsIpad || bIsIphoneOs || bIsWp || bIsAndroid || (!EChat.WebSocket.check()) || (!EChat.LocalStorage.check()) || (!EChat.IndexedDB.check())) {
            return false;
        }
        return true;
    },

    nav(url, e) {
        if (e && (e.ctrlKey || e.metaKey || e.button === 1)) {
            window.open(url);
        } else if (!e || e.button === 0) {
            if (!window.onbeforeunload) {
                EChat.Util.ShowLoading("All");
            }
            window.location.href = url;
        }
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
    },

    ShowLoading(mySelector, loadingText) {
        if (!loadingText) {
            loadingText = "Loading";
        }

        let borderRadius = "";
        if (mySelector === "All") {
            mySelector = null;
        } else if (mySelector) {
            borderRadius = "8px";
        } else {
            mySelector = document.getElementById("EChatMainPage");
            borderRadius = "8px 8px 0 0";
        }

        const loadDom = ECP.Dialog.ShowLoading(loadingText, mySelector);
        if (borderRadius) {
            const mark = loadDom.querySelector(".ecp-html-loading-mask");
            if (mark) {
                mark.style.borderRadius = borderRadius;
            }
        }

        return loadDom;
    },

    ShowLoader(mySelector, center) {
        if (mySelector) {
            const loader = document.createElement("DIV");
            loader.classList.add("eChat-SuperLoading", "donutSpinner");
            loader.innerHTML = "<div class=loader></div>";
            if (center) {
                loader.style.height = "100%";
                loader.style.display = "flex";
                loader.style.alignItems = "center";
            }
            mySelector.append(loader);
        }
    },

    SetWindowLocation(windowElement) {
        const windowCount = EChat.MainPageController.messageWindowList.length - 1;
        const windowHig = window.innerHeight;
        const windowWid = window.innerWidth;
        windowElement.style.display = "block";
        const tmpTop = windowHig / 2 - EChat.MainPageController.chatWindowSize.height / 2 + windowCount * 50;
        const tmpLeft = windowWid / 2 - EChat.MainPageController.chatWindowSize.width / 2 + windowCount * 50;
        const point = EChat.Util.checkPoint(tmpLeft, tmpTop, windowElement);
        windowElement.style.top = `${point.Top}px`;
        windowElement.style.left = `${point.Left}px`;
        const zIndex = EChat.Util.draggableZIndex();
        windowElement.style.zIndex = zIndex;
    },

    HideLoader(mySelector) {
        if (mySelector) {
            const loader = mySelector.querySelector(".eChat-SuperLoading");
            if (loader) {
                loader.remove();
            }
        }
    },

    getSearchText() {
        const dom = document.getElementById("EChatSearchText");
        if (dom) {
            return dom.value.trim();
        }
        return "";
    },

    ListenerVisibility() {
        EChat.PageActive = true;
        document.addEventListener("visibilitychange", async () => {
            if (document.visibilityState === "visible") {
                EChat.PageActive = true;
                if (EChat.eChatState) {
                    EChat.IndexedDB.InitDBData();
                    if (EChat.SavedMessageChange) {
                        const curTab = document.querySelector("#EChatMainPage .eChat-CurrentTab");
                        if (curTab?.getAttribute("switch-tab") === "EChatSavedTab") {
                            EC_Fmt.TriggerEvent(document.getElementById("EChatSearchText"), "keyup");
                        }
                        EChat.SavedMessageChange = true;
                    }
                }
            } else if (document.visibilityState === "hidden") {
                EChat.PageActive = false;
            }
        }, { passive: true });
    },

    highLight(text, find, color, mini) {
        const resultDom = document.createElement("span");
        resultDom.innerHTML = text;
        if (text && find) {
            if (resultDom?.textContent) {
                text = resultDom.textContent;
                let index = text.toLowerCase().indexOf(find.toLowerCase());
                if (mini) {
                    if (index > 60) {
                        const space = text.indexOf(" ", index - 60);
                        if (space >= 0 && space < index) {
                            text = `... ${text.substr(space + 1)}`;
                        } else {
                            text = `... ${text.substr(index)}`;
                        }
                        index = text.toLowerCase().indexOf(find.toLowerCase());
                    }
                }

                // Task 996347: Some issues with the new version of Web UI eChat
                if (index > -1) {
                    const start = text.substring(0, index);
                    const replaceWith = `<span style=background:${color}>${text.substr(index, find.length)}</span>`;
                    const end = text.substr(index + find.length);
                    text = start + replaceWith + end;

                    resultDom.innerHTML = "";

                    if (start) {
                        const startDom = document.createElement("SPAN");
                        startDom.textContent = start;
                        resultDom.append(startDom);
                    }

                    const colorDom = EC_Fmt.HtmlStrToElement(replaceWith);
                    resultDom.append(colorDom);

                    if (end) {
                        const endDom = document.createElement("SPAN");
                        endDom.textContent = end;
                        resultDom.append(endDom);
                    }
                }
            }
        } else {
            text = EC_Fmt.Null2EmptyStr(text);
        }

        return { text, dom: resultDom };
    },

    errorAlert(ex) {
        if (ex) {
            let message;
            if (ex.ErrorCode && ex.ErrorMessage) {
                let errorCodeStr = ex.ErrorCode;
                if (ex.ErrorCode === SocketUtil.ErrorCode.HttpError) {
                    errorCodeStr = "HttpRequestError";
                }
                message = `${errorCodeStr} ${ex.ErrorMessage}`;
            } else {
                message = ex;
            }
            // eslint-disable-next-line no-console
            console.error(ex);

            const alertHTMLObj = document.createElement("div");
            alertHTMLObj.innerHTML = message;
            if (alertHTMLObj.querySelector("#MainLayout")) {
                ECP.Dialog.Alert(alertHTMLObj.querySelector("#MainLayout").innerHTML);
            } else {
                ECP.Dialog.Alert(message);
            }
        }
        ECP.Dialog.HideLoading();
    },

    throwError(errorCode, errorMessage) {
        EChat.Util.handleError({ ErrorCode: errorCode, ErrorMessage: errorMessage });
    },

    ajaxHandleError(xhrObj, status, err) {
        EChat.Util.throwError(EChat.ErrorType.AJAX_ERROR, { xhrObj, status, err });
    },

    handleError(errorObj) {
        const eChatErrorType = EChat.ErrorType;
        switch (errorObj.ErrorCode) {
            case eChatErrorType.SENDMESSAG_EERROR:
                throw new Error(`error: ${errorObj.content}`);
            case eChatErrorType.VerifySessionFailed:
                EWS.VerifySession();
                break;
            default:
                // eslint-disable-next-line no-console
                console.error(errorObj.ErrorMessage);
                break;
        }
        return false;
    },

    // Task 917777: Copy a historical echat message with font format
    CopyFormat() {
    },

    // Class: content flicker
    FlickerContentClass(element) {
        const obj = element;
        let intervalID = null; // receive ID from window.setInterval()
        const originalContent = obj.textContent; // remember the original content of title
        let flickerFadeOutContent = null; // display when flag === true
        let flickerFadeInContent = null; // display when flag === false
        let flag = true; // auxiliary to judgment title fadeIn or fadeOut

        this.FlickerOn = function (str, interval) {
            if (!intervalID) {
                flickerFadeOutContent = `[${str}] ${originalContent}`;
                flickerFadeInContent = "[";
                for (let i = 0; i < str.length / 2 + 1; i++) { // append BlackSpaces
                    flickerFadeInContent += "　";
                }
                flickerFadeInContent += `] ${originalContent}`;

                intervalID = window.setInterval(() => {
                    if (flag) {
                        obj.textContent = flickerFadeOutContent;
                    } else {
                        obj.textContent = flickerFadeInContent;
                    }
                    flag = !flag;
                }, parseInt(interval));
            }
        };
        this.FlickerOff = function (isFlicker) {
            if (intervalID) {
                window.clearInterval(intervalID);
                intervalID = null;
                if (isFlicker) {
                    obj.textContent = flickerFadeOutContent;
                } else {
                    obj.textContent = originalContent; // restore the original title
                }
            } else if (!isFlicker) {
                obj.textContent = originalContent;
            }
        };
    },

    draggableZIndex() {
        let maxZIndex = 200;
        document.querySelectorAll(".eChatDraggable").forEach((dom) => {
            const index = Number(dom.style.zIndex);
            maxZIndex = index > maxZIndex ? index : maxZIndex;
        });
        return maxZIndex + 1;
    },

    // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
    resizeDialogMessage() {
        if (EChat.MainPageController.ClientOS === "Mobile") {
            const EchatMessageWindowDialog = document.querySelector("body > div.eChat-MessageWindow.eChatDraggable > div.eChat-MessageWindowDialog");

            const EChatMessageWindowHeight = document.querySelector("body > div.eChat-MessageWindow.eChatDraggable").clientHeight;
            const EchatMessageWindowHeadHeight = document.querySelector("body > div.eChat-MessageWindow.eChatDraggable > div.eChat-MessageWindowHead.eChatDragTarget").clientHeight;
            const EChatMessageWindowSendHeight = document.querySelector("body > div.eChat-MessageWindow.eChatDraggable > div.eChat-MessageWindowSend").clientHeight;
            const EchatMessageWindowTitleBoxHeight = document.querySelector("body > div.eChat-MessageWindow.eChatDraggable > div.eChat-MessageWindowTitleBox").clientHeight;
            const EchatMessageWindowSearchHeight = document.querySelector("body > div.eChat-MessageWindow.eChatDraggable > div.eChat-MessageWindowSearch").clientHeight;

            const height = EChatMessageWindowHeight - (EchatMessageWindowHeadHeight + EChatMessageWindowSendHeight + EchatMessageWindowTitleBoxHeight + EchatMessageWindowSearchHeight);
            EchatMessageWindowDialog.style.height = `${height}px`;
        }
    },

    getTimeStamp() {
        return (new Date()).getTime();
    },

    insertText(element, str) {
        if (typeof element.selectionStart === "number" && typeof element.selectionEnd === "number") {
            const startPos = element.selectionStart;
            const endPos = element.selectionEnd;
            let cursorPos = startPos;
            const tmpStr = element.value;
            element.value = tmpStr.substring(0, startPos) + str + tmpStr.substring(endPos, tmpStr.length);
            if (str === "\r\n") {
                cursorPos += 1;
            } else {
                cursorPos += str.length;
            }
            element.selectionStart = cursorPos;
            element.selectionEnd = cursorPos;
        }
    },

    urlConverter(msg) {
        if (msg.indexOf("<img") > -1 || msg.indexOf("</a>") > -1) {
            return msg;
        }
        // Task 960423: eChat Message seems to have disrupted echat/Encompass mobile
        msg = msg.replace(/&nbsp;/g, "✢");
        // Task 960423: eChat Message seems to have disrupted echat/Encompass mobile
        const urlReg = /[a-zA-z]+:\/\/[^\s"'<>{}✢]*/gi;
        const replaceText = "<a href='$&'>$&</a>";
        msg = msg.replace(urlReg, replaceText);
        msg = msg.replace(/✢/g, "&nbsp;");

        msg = msg.replace("<div></div>", "<br>");
        msg = msg.replace(/(<br(\/?)>)+$/, "");
        return msg;
    },

    longToDataTime(longNum) {
        longNum = Number(longNum);
        if (longNum === 0 || !EC_Fmt.isNumber(longNum)) {
            return "";
        }
        const dateTime = new Date(longNum);
        const year = dateTime.getFullYear();
        const month = dateTime.getMonth() + 1;
        const date = dateTime.getDate();
        let hour = dateTime.getHours();
        let minute = dateTime.getMinutes();
        const now = new Date();
        const sameYear = dateTime.getFullYear() === now.getFullYear();
        const sameDay = sameYear && dateTime.getMonth() === now.getMonth() && dateTime.getDate() === now.getDate();
        if (minute.toString().length === 1) {
            minute = `0${minute.toString()}`;
        }
        let second = dateTime.getSeconds();
        if (second.toString().length === 1) {
            second = `0${second.toString()}`;
        }

        let data = "";
        let time;
        if (!sameDay) {
            switch (EChat.DataProvider.CurrentUserInfo.DateFormat) {
                case 2:
                    if (sameYear) {
                        data = `${month}-${date}`;
                    } else {
                        data = `${year}-${month}-${date}`;
                    }
                    break;
                case 3:
                    if (sameYear) {
                        data = `${date}.${month}`;
                    } else {
                        data = `${date}.${month}.${year}`;
                    }
                    break;
                default:
                    if (sameYear) {
                        data = `${month}/${date}`;
                    } else {
                        data = `${month}/${date}/${year}`;
                    }
                    break;
            }
        }
        switch (EChat.DataProvider.CurrentUserInfo.TimeFormat) {
            case 2:
                time = `${hour}:${minute}:${second}`;
                break;
            default:
                if (hour === 12) {
                    time = `${hour}:${minute} PM`;
                } else if (hour > 12) {
                    time = `${hour - 12}:${minute} PM`;
                } else {
                    if (hour === 0) {
                        hour = 12;
                    }
                    time = `${hour}:${minute} AM`;
                }
                break;
        }
        return `${data} ${time}`;
    },

    getElementPosition(targetElement) {
        const tmpWidth = window.innerWidth - targetElement.clientWidth;
        const tmpHeight = window.innerHeight - targetElement.clientHeight;
        let tmptop = parseInt(targetElement.style.top);
        tmptop = tmptop < 0 ? 0 : tmptop;
        tmptop = tmptop > tmpHeight ? tmpHeight : tmptop;
        let tmpleft = parseInt(targetElement.style.left);
        tmpleft = tmpleft < 0 ? 0 : tmpleft;
        tmpleft = tmpleft > tmpWidth ? tmpWidth : tmpleft;
        return {
            Left: tmpleft,
            Top: tmptop
        };
    },

    checkPoint(x, y, targetElement) {
        const tmpWidth = window.innerWidth - targetElement.clientWidth;
        const tmpHeight = window.innerHeight - targetElement.clientHeight;
        const limitX = EChat.Util.getMenuWidth();
        const limitY = EChat.Util.getHeaderHeight();

        x = x < limitX ? limitX : x;
        x = x > tmpWidth ? tmpWidth : x;
        y = y < limitY ? limitY : y;
        y = y > tmpHeight ? tmpHeight : y;
        return {
            Left: x,
            Top: y
        };
    },

    getMenuWidth() {
        let width = 0;
        const menu = document.getElementById("Menu");
        if (menu) {
            width = menu.offsetWidth;
        }
        return width;
    },

    getHeaderHeight() {
        let height = 0;
        const header = document.getElementById("Header");
        if (header) {
            height = header.offsetHeight;
        }
        return height;
    },

    windowResizeListener() {
        window.addEventListener("resize", () => {
            clearTimeout(EChat.MainPageController.windowChangeThread);
            EChat.MainPageController.windowChangeThread = requestIdleCallback(() => {
                // mainpage
                EChat.MainPageController.resizeMainPageWindow();
                // Task 1067218: DSDLink: eChat in the new Mobile Framework
                // messagewindow
                const messageWindowList = EChat.MainPageController.messageWindowList;
                if (EChat.MainPageController.ClientOS === "PC") {
                    for (let i = 0; i < messageWindowList.length; i++) {
                        messageWindowList[i].resizeMessageWindow();
                    }
                } else {
                    for (let i = 0; i < messageWindowList.length; i++) {
                        messageWindowList[i].resizeMobileMessageWindow();
                        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
                        EChat.Util.resizeDialogMessage();
                    }
                }
            });
        });
    },

    autoResizeImage(maxWidth, maxHeight, objImg) {
        let ratio = 1;
        let w = objImg.width;
        let h = objImg.height;
        const wRatio = maxWidth / w;
        const hRatio = maxHeight / h;
        if (maxWidth === 0 && maxHeight === 0) {
            ratio = 1;
        } else if (maxWidth === 0) {
            if (hRatio < 1) {
                ratio = hRatio;
            }
        } else if (maxHeight === 0) {
            if (wRatio < 1) {
                ratio = wRatio;
            }
        } else if (wRatio < 1 || hRatio < 1) {
            ratio = (wRatio <= hRatio ? wRatio : hRatio);
        }
        if (ratio < 1) {
            w *= ratio;
            h *= ratio;
        }
        objImg.height = h;
        objImg.width = w;
    },

    checkImage(fileName) {
        let result = false;
        if (fileName !== "") {
            switch (fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase()) {
                case "jpg":
                case "png":
                case "jpeg":
                case "gif":
                    result = true;
                    break;
                default:
                    result = false;
                    break;
            }
        }
        return result;
    },

    Loading(state) {
        if (EC_Fmt.isNull(state)) {
            state = EChat.Loading;
        } else {
            EChat.Loading = state;
        }

        const EChatLoadingList = document.getElementById("EChatLoadingList");
        if (EChatLoadingList) {
            if (state) {
                EChatLoadingList.style.display = "block";
            } else {
                EChatLoadingList.style.display = "none";
            }
        }
    },

    FileLoad(FileDom, WindowDom, SenderAuthenticationID, width, height) {
        if (!FileDom) {
            return;
        }

        FileDom.querySelectorAll("img").forEach((dom) => {
            const imageWidth = parseInt(dom.getAttribute("image-width"));
            const imageHeight = parseInt(dom.getAttribute("image-height"));
            const thumbnailHeight = parseInt(dom.getAttribute("thumbnai-height"));
            const thumbnailWidth = parseInt(dom.getAttribute("thumbnai-width"));
            const thumbnailUrl = dom.getAttribute("thumbnai-url");

            dom.setAttribute("title", EC_Fmt.Trn("Double-click to view full size"));
            dom.classList.add("eChat-Cursor");
            dom.setAttribute("image-url", dom.src);
            if (thumbnailUrl && thumbnailHeight > 0 && thumbnailWidth > 0) {
                dom.src = thumbnailUrl;
                dom.width = thumbnailWidth;
                dom.height = thumbnailHeight;
                EChat.Util.autoResizeImage(width, height, dom);
            } else if (imageWidth > 0 && imageHeight > 0) {
                dom.width = imageWidth;
                dom.height = imageHeight;
                EChat.Util.autoResizeImage(width, height, dom);
            } else {
                dom.addEventListener("load", function () {
                    EChat.Util.autoResizeImage(width, height, this);
                    if (WindowDom) {
                        const images = WindowDom.querySelectorAll("img");
                        if (images.length !== 0 && images[images.length - 1] === this) {
                            WindowDom.scrollTop = WindowDom.scrollHeight;
                        }
                    }
                });
            }

            let clickFlag = null;
            dom.addEventListener("dblclick", function () {
                if (clickFlag) {
                    clearTimeout(clickFlag);
                }
                window.open(this.getAttribute("image-url"));
            });

            dom.addEventListener("click", () => {
                if (clickFlag) {
                    clickFlag = clearTimeout(clickFlag);
                }

                clickFlag = requestIdleCallback(() => {
                    const oldDom = document.getElementById("ImageQuickPreview");
                    if (oldDom) {
                        oldDom.remove();
                    }
                    const preview = document.createElement("DIV");
                    preview.id = "ImageQuickPreview";
                    const viewImage = document.createElement("IMG");
                    viewImage.src = dom.src;
                    preview.appendChild(viewImage);

                    preview.setAttribute("title", EC_Fmt.Trn("Click to close the quick preview"));
                    preview.addEventListener("click", () => {
                        preview.remove();
                    });

                    const image_url = dom.getAttribute("image-url");
                    if (image_url !== dom.src) {
                        const source = document.createElement("IMG");
                        source.style.display = "none";
                        source.src = image_url;
                        source.addEventListener("load", () => {
                            viewImage.src = image_url;
                        });

                        preview.append(source);
                    }

                    document.body.append(preview);
                }, { timeout: 1000 });
            });
        });

        FileDom.querySelectorAll("video").forEach((dom) => {
            dom.style.maxWidth = `${width}px`;
            dom.style.maxHeight = `${height}px`;

            dom.style.width = "300px";
            dom.style.height = "200px";
        });

        FileDom.querySelectorAll("audio").forEach((dom) => {
            dom.style.maxWidth = `${width}px`;
        });
        FileDom.querySelectorAll("message").forEach((dom) => {
            const type = dom.getAttribute("type");
            const filename = dom.getAttribute("filename");
            const size = dom.getAttribute("size");
            const displaysize = dom.getAttribute("displaysize");
            const ext = dom.getAttribute("ext");
            const src = dom.getAttribute("src");
            const lng = dom.getAttribute("lng");
            const lat = dom.getAttribute("lat");
            const address = dom.getAttribute("address");

            dom.textContent = "";

            if (type === "file") {
                switch (ext) {
                    case "mp4":
                    case "m4v":
                    case "webm":
                    case "ogv":
                        const video = document.createElement("VIDEO");
                        video.controls = "controls";
                        video.setAttribute("src", src);
                        video.style.maxWidth = `${width}px`;
                        video.style.maxHeight = `${height}px`;
                        video.style.width = "300px";
                        video.style.height = "200px";
                        dom.append(video);
                        break;
                    case "wav":
                    case "mp3":
                        const audio = document.createElement("AUDIO");
                        audio.controls = "controls";
                        audio.setAttribute("src", src);
                        audio.style.maxWidth = `${width}px`;
                        dom.append(audio);
                        break;
                    default:
                        let FileClassName = "";
                        switch (ext) {
                            case "xls":
                            case "xlsx":
                            case "csv":
                                FileClassName = "ews-icon-emknowledgeXLS";
                                break;
                            case "txt":
                                FileClassName = "ews-icon-emknowledgeTXT";
                                break;
                            case "rtf":
                                FileClassName = "ews-icon-emknowledgeRTF";
                                break;
                            case "ppt":
                            case "pptx":
                            case "pptm":
                            case "ppsx":
                                FileClassName = "ews-icon-emknowledgePPT";
                                break;
                            case "pdf":
                                FileClassName = "ews-icon-emknowledgePDF";
                                break;
                            case "html":
                            case "htm":
                                FileClassName = "ews-icon-emknowledgeHTML";
                                break;
                            case "doc":
                            case "docx":
                            case "docm":
                                FileClassName = "ews-icon-emknowledgeDOC";
                                break;
                            case "tiff":
                            case "tif":
                            case "giff":
                                FileClassName = "ews-icon-emknowledgeImage";
                                break;
                            case "avi":
                            case "rmvb":
                            case "rm":
                            case "asf":
                            case "divx":
                            case "mpg":
                            case "mpeg":
                            case "mpe":
                            case "wmv":
                            case "mkv":
                            case "vob":
                                FileClassName = "ews-icon-emknowledgeVideo";
                                break;
                            case "wma":
                            case "ogg":
                            case "ape":
                            case "acc":
                                FileClassName = "ews-icon-emknowledgeAudio";
                                break;
                            default:
                                FileClassName = "ews-icon-emreport";
                                break;
                        }

                        const fileTable = document.createElement("TABLE");
                        const fileTr = document.createElement("TR");
                        const fileTd1 = document.createElement("TD");
                        fileTd1.classList.add("eChat-File-Icon");
                        fileTd1.style.width = "60px";
                        const fileTd2 = document.createElement("TD");
                        fileTd2.style.width = "150px";
                        const fileName = document.createElement("B");
                        const fileTip = document.createElement("DIV");
                        const fileStateIcon = document.createElement("SPAN");

                        fileTable.append(fileTr);
                        fileTr.append(fileTd1);
                        fileTr.append(fileTd2);
                        fileTd1.classList.add(FileClassName);
                        fileTip.style.color = "var(--neutral-50)";
                        fileTd2.append(fileName);
                        fileTd2.append(fileTip);
                        fileName.textContent = filename;
                        // Task 1015039: Server Task Edit: Echat copy Message to Task with attached .xlsx displayed in Task Edit -> Task Details Unable to support this type.

                        if (SenderAuthenticationID !== undefined) {
                            fileStateIcon.classList.add("ews-icon-balance");
                            fileStateIcon.style.color = "#15d22d";
                            if (EChat.DataProvider.IsCurrentUser(SenderAuthenticationID)) {
                                fileTip.textContent = `${displaysize} Has been sent `;
                            } else {
                                fileTip.textContent = `${displaysize} Has been received `;
                            }
                        } else {
                            fileTip.textContent = displaysize;
                        }

                        fileTip.append(fileStateIcon);

                        dom.append(fileTable);
                        dom.addEventListener("dblclick", () => {
                            if (FileClassName === "ews-icon-emknowledgeXLS") {
                                // Task 991575: Can not download large xlsx from eChat too large to view Document and then download.
                                const fileSize = size / 1024;
                                if (fileSize <= 300) {
                                    window.open(`Home?DashboardID=187482&URL=${encodeURIComponent(src)}&FileName=${encodeURIComponent(filename)}`);
                                } else if (fileSize > 300 && fileSize <= 1024) {
                                    const html = "<div style=font-size:16px;margin:auto;min-height:117px;display:flex;flex-direction:column;align-items:center;justify-content:center>The file is too large, please choose to continue browsing or download to view.</div>";
                                    const dialog = ECP.Dialog.ShowDialog("Message", html, {
                                        confirmButtonTitle: "Preview",
                                        confirmButtonAction: () => {
                                            window.open(`Home?DashboardID=187482&URL=${encodeURIComponent(src)}&FileName=${encodeURIComponent(filename)}`);
                                        }
                                    });
                                    const downloadBtn = document.createElement("Div");
                                    // Task 1135380: EChat: Remove all the old buttons, use the new ecp-btn instead
                                    // downloadBtn.innerHTML = ECP.HTML.Button("downloadFileBtn", "Download", ECP.HTML.Icons.Download);
                                    downloadBtn.innerHTML = `<ecp-btn id=ActionButtonDownloadFileBtn icon=ews-icon-download>Download</ecp-btn>`;
                                    const dialogFooter = dialog.querySelector(".ecp-dialog-footer");
                                    dialogFooter.insertBefore(downloadBtn.firstElementChild, dialogFooter.firstChild);
                                    dialogFooter.firstChild.addEventListener("click", () => {
                                        window.open(src);
                                        ECP.Dialog.CloseDialog(dialog);
                                    });
                                } else {
                                    window.open(src);
                                }
                            } else {
                                window.open(src);
                            }
                        });

                        dom.setAttribute("title", EC_Fmt.Trn("Double-click to download."));
                        dom.classList.add("eChat-Cursor");
                        break;
                }
            } else if (type === "location") {
                const location = EC_Fmt.HtmlStrToElement("<div style=cursor:pointer title='Open map.'></div>");
                const icon = document.createElement("span");
                icon.className = "eChat-Location-Icon ews-icon-location";

                location.append(icon);
                location.append(` ${address}`);
                location.addEventListener("click", (event) => {
                    EC_Fmt.OpenWithCtrlClickSupport(event, `api?APICommand=SalesComm_ShowLocationMap&lng=${lng}&lat=${lat}&zoom=16&address=${address}`);
                });
                dom.append(location);
            }
        });
    },

    PreventScroll(element) {
        if (element) {
            if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
                element.addEventListener("wheel", (e) => {
                    const delta = e.deltaY * 10;
                    if (delta !== 0) {
                        if (delta > 60 || delta < -60) element.scrollTop += delta > 0 ? 60 : -60;
                        else element.scrollTop += delta;
                    }
                    e.preventDefault();
                });
            } else {
                element.onmousewheel = function (e) {
                    if (e.wheelDelta !== 0) {
                        if (e.wheelDelta > 60 || e.wheelDelta < -60) element.scrollTop += e.wheelDelta > 0 ? -60 : 60;
                        else element.scrollTop -= e.wheelDelta;
                    }
                    e.preventDefault();
                    e.returnValue = false;
                };
            }
        }
        return element;
    },

    dragDialog({
        dialog, handle, start, stop, handleWidthFix, handleHeightFix, AllowSelection
    }) {
        if (dialog.getAttribute("isDialogDragAttached")) {
            return;
        }

        let currentDialog = null;
        let startX;
        let startY;
        let startX_Min;
        let startX_Max;
        let startY_Min;
        let startY_Max;
        let topMin;
        let leftMin;

        const mousedown = (event) => {
            if (!dialog.getAttribute("isDialogDragAttached") || EChat.FullWindowController.FullWindow) {
                return;
            }

            currentDialog = dialog;
            startX = event.clientX;
            startY = event.clientY;
            startX_Min = "";
            startX_Max = "";
            startY_Min = "";
            startY_Max = "";
            topMin = EChat.Util.getHeaderHeight();
            leftMin = EChat.Util.getMenuWidth();

            document.addEventListener("mousemove", MoveDialog);
            document.addEventListener("mouseup", MoveDone);

            if (handleWidthFix) {
                leftMin += handleWidthFix;
            }
            if (handleHeightFix) {
                topMin += handleHeightFix;
            }
            if (start) {
                start(dialog);
            }
        };

        const MoveDone = () => {
            if (currentDialog && !EChat.FullWindowController.FullWindow) {
                currentDialog = null;
                startX = 0;
                startY = 0;
                startX_Min = "";
                startX_Max = "";
                startY_Min = "";
                startY_Max = "";
                document.removeEventListener("mouseup", MoveDone);
                document.removeEventListener("mousemove", MoveDialog);

                if (document.body.style.webkitUserSelect !== "auto") {
                    document.body.style.webkitUserSelect = "auto";
                }

                setTimeout(() => {
                    EChat.eChatMoving = false;
                }, 1000);

                if (stop) {
                    stop(dialog);
                }
            }
        };

        const MoveDialog = (e) => {
            if (currentDialog && !EChat.FullWindowController.FullWindow) {
                EChat.eChatMoving = true;

                let top = (currentDialog.style.top ? parseInt(currentDialog.style.top.replace("px", "")) : currentDialog.getBoundingClientRect().y) + e.clientY - startY;
                let left = (currentDialog.style.left ? parseInt(currentDialog.style.left.replace("px", "")) : currentDialog.getBoundingClientRect().x) + e.clientX - startX;
                const topMaxLimit = window.innerHeight - currentDialog.clientHeight;
                const leftMaxLimit = window.innerWidth - currentDialog.clientWidth;

                if (!AllowSelection && document.body.style.webkitUserSelect !== "none" && startY !== e.clientY && startX !== e.clientX) {
                    document.body.style.webkitUserSelect = "none";
                }

                if (top < topMin) {
                    top = topMin;
                    // Task 954410: When there are too many DOM elements on the page. eChat minimizes the jam
                    if (document.body.style.webkitUserSelect !== "none") {
                        document.body.style.webkitUserSelect = "none";
                    }
                }

                if (top > topMaxLimit) {
                    if (topMaxLimit < topMin) {
                        top = topMin;
                    } else {
                        top = topMaxLimit;
                    }

                    if (document.body.style.webkitUserSelect !== "none") {
                        document.body.style.webkitUserSelect = "none";
                    }
                    if (startY_Max === "") {
                        startY_Max = e.clientY;
                    }
                }

                if (left < leftMin) {
                    left = leftMin;
                    if (document.body.style.webkitUserSelect !== "none") {
                        document.body.style.webkitUserSelect = "none";
                    }
                }

                if (left > leftMaxLimit) {
                    left = leftMaxLimit;
                    if (document.body.style.webkitUserSelect !== "none") {
                        document.body.style.webkitUserSelect = "none";
                    }
                    if (startX_Max === "") {
                        startX_Max = e.clientX;
                    }
                }

                currentDialog.style.top = `${top}px`;
                currentDialog.style.left = `${left}px`;

                if ((startY_Min === "" || e.clientY > startY_Min) && (startY_Max === "" || e.clientY < startY_Max)) {
                    startY = e.clientY;
                }
                if ((startX_Min === "" || e.clientX > startX_Min) && (startX_Max === "" || e.clientX < startX_Max)) {
                    startX = e.clientX;
                }

                if (top === topMin && startY_Min === "") {
                    startY_Min = e.clientY;
                }
                if (left === leftMin && startX_Min === "") {
                    startX_Min = e.clientX;
                }
            }
        };

        handle.addEventListener("mousedown", mousedown);
        dialog.querySelectorAll(".eChatDragTarget").forEach((dom) => {
            if (dom !== handle) {
                dom.addEventListener("mousedown", mousedown);
            }
        });

        dialog.setAttribute("isDialogDragAttached", "1");
    },

    dragResize({
        handle, start, move, end, resizeDirection
    }) {
        if (handle.getAttribute("isDialogDragAttached")) {
            return;
        }

        let currentHandle = null;
        let startX;
        let startY;
        let lastStartX;
        let lastStartY;
        let topMin;
        let leftMin;
        const MoveStart = (e) => {
            if (EChat.FullWindowController.FullWindow) {
                return;
            }
            currentHandle = handle;
            lastStartY = e.pageY;
            lastStartX = e.pageX;
            startY = e.pageY;
            startX = e.pageX;
            document.body.style.webkitUserSelect = "none";
            document.addEventListener("mousemove", Moveing);
            document.addEventListener("mouseup", MoveDone);
            topMin = EChat.Util.getHeaderHeight();
            leftMin = EChat.Util.getMenuWidth();
            if (start) {
                start();
            }
        };

        const Moveing = (e) => {
            if (Math.random() > 0.8 && !EChat.FullWindowController.FullWindow) {
                return;
            }
            if (currentHandle) {
                const resizeContext = {};
                EChat.eChatMoving = true;

                if (e.pageY > window.innerHeight || e.pageX > window.innerWidth) {
                    return;
                }

                let mouseY = e.pageY;
                let mouseX = e.pageX;

                if (mouseY < topMin) {
                    mouseY = topMin;
                }

                if (mouseX < leftMin) {
                    mouseX = leftMin;
                }

                if (resizeDirection === "s" || resizeDirection === "se") {
                    resizeContext.RelativeHeight = mouseY - lastStartY;
                    resizeContext.AbsoluteHeight = mouseY - startY;
                }

                if (resizeDirection === "e" || resizeDirection === "se") {
                    resizeContext.RelativeWidth = mouseX - lastStartX;
                    resizeContext.AbsoluteWidth = mouseX - startX;
                }

                lastStartY = mouseY;
                lastStartX = mouseX;

                if (move) {
                    move(resizeContext);
                }
            }
        };

        const MoveDone = () => {
            if (currentHandle && !EChat.FullWindowController.FullWindow) {
                currentHandle = null;
                lastStartX = 0;
                lastStartY = 0;
                startX = 0;
                startY = 0;
                document.removeEventListener("mouseup", MoveDone);
                document.removeEventListener("mousemove", Moveing);
                document.body.style.webkitUserSelect = "auto";
                setTimeout(() => {
                    EChat.eChatMoving = false;
                }, 1000);

                if (end) {
                    end();
                    // Task 1003469: The chat box size should not exceed the page size.
                    if (resizeDirection === "se") {
                        EChat.MainPageController.messageWindowList[0].changeOldMessageWin();
                    }
                }
            }
        };
        handle.addEventListener("mousedown", MoveStart);
        handle.setAttribute("isDialogDragAttached", "1");
    },

    WaitTime(time) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    },

    IsRecentSearchState() {
        const EChatSearchText = document.getElementById("EChatSearchText");
        const EChatRecentSwitchBtn = document.getElementById("EChatRecentSwitchBtn");
        return EChatSearchText && EChatRecentSwitchBtn?.classList.contains("eChat-CurrentTab") && (EChatSearchText.value || EChatSearchText.getAttribute("tab"));
    }
};

EChat.LocalStorage = (function () {
    const LocalStorageClass = function () {
        const _this = this;
        let localstorage;
        let sessionstorage;
        try {
            localstorage = window.localStorage;
            sessionstorage = window.sessionStorage;
        } catch (ex) {
            localstorage = null;
            sessionstorage = null;
        }
        this.isOpen = false;
        // this.isLocalOnStorage = false;

        this.check = function () {
            if (localstorage && sessionstorage) {
                return true;
            }
            return false;
        };

        this.startListen = function () {
            if (!_this.isOpen) {
                window.addEventListener("storage", localStorageListener);
                _this.isOpen = true;
            }
        };

        this.writeLocalStorage = function (key, value) {
            try {
                window.localStorage.setItem(key, value);
            } catch (e) {
                // Task 951021: JavaScript Error: includes/DefaultAll.min.js (1) - uncaught exception: QuotaExceededError. use 14.22KB
                if (e.name === "QuotaExceededError") {
                    EChat.Util.removeEChat();
                    if (!EChat.StorageError) {
                        EChat.StorageError = true;
                        // eslint-disable-next-line no-console
                        console.warn("eChat initialization failed. Error: local storage quota exceeded.");
                    }
                } else {
                    throw e;
                }
            }
        };

        this.readLocalStorage = function (key) {
            return window.localStorage.getItem(key);
        };

        this.removeLocalStorage = function (key) {
            window.localStorage.removeItem(key);
        };

        this.clearLocalStorage = function () {
            for (let i = 0; i < window.localStorage.length; i++) {
                const key = window.localStorage.key(i);
                if (key.indexOf("^") > -1) {
                    _this.removeLocalStorage(key);
                    i--;
                }
            }
        };

        this.writeSessionStorage = function (key, value) {
            _this.isSessionOnStorage = true;
            sessionstorage.setItem(key, value);
        };

        this.readSessionStorage = function (key) {
            return sessionstorage.getItem(key);
        };

        this.removeSessionStorage = function (key) {
            sessionstorage.removeItem(key);
        };

        const localStorageListener = function (origEvent) {
            const localStorageKey = origEvent.key;
            const localStorageNewValue = origEvent.newValue;
            const eChatDataProvider = EChat.DataProvider;
            const currentAuthID = eChatDataProvider.CurrentUserInfo.AuthenticationID;
            if (localStorageNewValue && localStorageNewValue !== origEvent.oldValue) {
                switch (localStorageKey) {
                    case EChat.LocalStorageType.ECHATAUTHID:
                        const authID = Number(localStorageNewValue);
                        if (authID !== eChatDataProvider.CurrentUserInfo.AuthenticationID) {
                            eChatDataProvider.CurrentUserInfo.SenderAuthenticationID = authID;
                            EChat.eChatState = false;
                            EChat.MainPageController.removeEChatView();
                            EChat.Util.initEChat();
                        }
                        break;
                    case EChat.LocalStorageType.DBUPDATE:
                        requestIdleCallback(() => {
                            eChatDataProvider.DBUpdate(JSON.parse(localStorageNewValue));
                        });
                        break;
                    case EChat.LocalStorageType.DBDELETED:
                        eChatDataProvider.DBDeleted(JSON.parse(localStorageNewValue));
                        break;
                    case EChat.LocalStorageType.UNREADDATA:
                        EChat.MainPageController.unReadDataChange(JSON.parse(localStorageNewValue), true);
                        break;
                    case `${currentAuthID}^${EChat.LocalStorageType.ECHATSTARTSESSION}`:
                        eChatDataProvider.StartSessionReceive(JSON.parse(localStorageNewValue), true);
                        break;
                    case EChat.LocalStorageType.CLOSTSCREENSHARECONFIRM:
                        ECP.Dialog.CloseDialog(ScreenShareRequestDialog);
                        break;
                    case EChat.LocalStorageType.RECEIVETASKDETAIL:
                        EChat.MainPageController.receiveTaskDetail(JSON.parse(localStorageNewValue), true);
                        break;
                }
            }
            return true;
        };
    };
    return new LocalStorageClass();
}());

EChat.WebSocket = (function () {
    const WebSocketClass = function () {
        const _this = this;
        let isInit = false;
        this.check = function () {
            return !(window.WebSocket === undefined);
        };

        this.WebSocketInit = function () {
            if (!isInit) {
                if (SocketUtil.checkConnected()) {
                    EChat.MainPageController.updateUnreadSumCount("Socket connected");
                    EChat.IndexedDB.UpdateSetting("ConnectionTime", EChat.Util.getTimeStamp()).then(() => {
                        if (EChat.eChatState && EChat.PageActive) {
                            EChat.IndexedDB.InitDBData();
                        }
                    });
                }
                SocketUtil.on("message", webSocketMessage);
                SocketUtil.on("connect", (data, isStorage) => {
                    _this.UpdateEChatState("connect");
                    if (!isStorage) {
                        setTimeout(() => {
                            EChat.MainPageController.updateUnreadSumCount("Socket connected");
                        }, 1000);
                        EChat.IndexedDB.UpdateSetting("ConnectionTime", EChat.Util.getTimeStamp());
                    }
                    if (EChat.eChatState && EChat.PageActive) {
                        setTimeout(() => {
                            EChat.IndexedDB.InitDBData(0, true);
                        }, 1000);
                    }
                });
                SocketUtil.on("disconnect", () => {
                    _this.UpdateEChatState("disconnect");
                });
                SocketUtil.on("reconnecting", () => {
                    _this.UpdateEChatState("reconnecting");
                });
                SocketUtil.on("reconnect", () => {
                    _this.UpdateEChatState("reconnect");
                });
                SocketUtil.on("expire", () => {
                    _this.UpdateEChatState("expire");
                });

                isInit = true;
            }
        };

        this.UpdateEChatState = function (State) {
            const EChatStateEle = document.createElement("DIV");
            let StateText = "";
            let Color = "";
            const EChatUserName = document.getElementById("EChatUserName");
            const EChatMsgTip = document.getElementById("EChatMsgTip");

            switch (State) {
                case SocketUtil.SocketState.Reconnect:
                    StateText = "Reconnect";

                    Color = "#0089ff";
                    if (EChatUserName) {
                        EChatUserName.style.display = "none";
                    }
                    break;
                case SocketUtil.SocketState.Connect:
                    StateText = "";

                    if (EChatUserName) {
                        EChatUserName.style.display = "block";
                    }

                    const EChatNewMsgNum = document.getElementById("EChatNewMsgNum");

                    if (EChatMsgTip && EChatNewMsgNum?.innerText !== "") {
                        EChatMsgTip.style.display = "block";
                    }
                    break;
                case SocketUtil.SocketState.Reconnecting:
                    StateText = "Reconnecting";

                    Color = "var(--red-50)";
                    if (EChatUserName) {
                        EChatUserName.style.display = "none";
                    }
                    if (EChatMsgTip) {
                        EChatMsgTip.style.display = "none";
                    }
                    break;
                case SocketUtil.SocketState.Disconnect:
                    StateText = "Disconnected";

                    Color = "var(--red-50)";
                    if (EChatUserName) {
                        EChatUserName.style.display = "none";
                    }
                    if (EChatMsgTip) {
                        EChatMsgTip.style.display = "none";
                    }
                    break;

                case SocketUtil.SocketState.Error:
                    StateText = "Error. Click Retry.";

                    Color = "var(--red-50)";
                    if (EChatUserName) {
                        EChatUserName.style.display = "none";
                    }
                    if (EChatMsgTip) {
                        EChatMsgTip.style.display = "none";
                    }
                    break;

                case SocketUtil.SocketState.Expire:
                    // Task 1047426: Change message from Session Expire to Session Expired
                    StateText = "Session Expired";
                    Color = "var(--red-50)";
                    if (EChatUserName) {
                        EChatUserName.style.display = "none";
                    }
                    if (EChatMsgTip) {
                        EChatMsgTip.style.display = "none";
                    }
                    break;
                default:
            }

            EChatStateEle.style.cursor = "pointer";
            EChatStateEle.addEventListener("click", () => {
                EWS.VerifySession(() => {
                    SocketUtil.Reconnect();
                });
            });

            EChatStateEle.textContent = StateText;
            EChatStateEle.setAttribute("title", "Click reconnect.");
            EChatStateEle.style.color = Color;

            const EChatStateTip = document.getElementById("EChatStateTip");
            if (EChatStateTip) {
                EChatStateTip.innerHTML = "";
                EChatStateTip.append(EChatStateEle);
            }
        };

        const webSocketMessage = function (data, isStorage) {
            const eChatDataProvider = EChat.DataProvider;
            switch (data.Command) {
                case SocketUtil.Command.Message:
                    const messageObj = {
                        MessageID: data.MessageID,
                        Message: data.MessageBody,
                        MessageGroupID: data.MessageGroupID,
                        SenderAuthenticationID: data.SenderAuthenticationID,
                        TimeCreated: data.TimeCreated,
                        DataInfo: data.DataInfo
                    };

                    eChatDataProvider.ReceiveMessage(messageObj, isStorage);
                    break;
                case SocketUtil.Command.ReadGroupMessage:
                    eChatDataProvider.SyncLocalLastReadTime({ MessageGroupID: data.MessageGroupID, DataInfo: data.DataInfo }, isStorage);
                    break;
                case SocketUtil.Command.GroupChange:
                    eChatDataProvider.UpdateGroupMessageReceive({ MessageGroupID: data.MessageGroupID, DataInfo: data.DataInfo }, isStorage);
                    break;
                case SocketUtil.Command.WriteState:
                    eChatDataProvider.WriteStateReceive({ MessageGroupID: data.MessageGroupID, SenderAuthenticationID: data.SenderAuthenticationID, DataInfo: data.DataInfo }, isStorage);
                    break;
                case SocketUtil.Command.UserAvailability:
                    eChatDataProvider.UpdateUserAvailability(data.DataInfo);
                    break;
                case SocketUtil.Command.SupportGroup:
                    break;
                case SocketUtil.Command.MessageRecalled:
                    eChatDataProvider.MessageRecalled({
                        MessageGroupID: data.MessageGroupID, MessageID: data.MessageID, SenderAuthenticationID: data.SenderAuthenticationID, MessageBody: data.MessageBody
                    }, isStorage);
                    break;
                case SocketUtil.Command.ReadTask:
                    eChatDataProvider.SyncLocalTaskRead(data.DataInfo.TaskID, data.DataInfo.TaskSourceEncompassID, isStorage);
                    break;
                case SocketUtil.Command.TaskChange:
                    eChatDataProvider.UpdateTaskGroup(data.MessageGroupID, data.DataInfo.TaskID, isStorage);
                    break;
            }
        };
    };
    return new WebSocketClass();
}());

EChat.DataProvider = (function () {
    const EChatDataProviderClass = function () {
        EChat.EventDispatcher.call(this);

        const _this = this;

        this.CurrentUserInfo = null;
        this.EncompassID = null;
        this.LastMessageTime = {};
        this.SendWriteStateTime = {};
        let lastUpdateSessionTime = 0;
        let createdGrouping = false;
        let RefreshHandle = -1;
        let missUserInfoHandle = -1;
        this.UserDict = {}; // index AuthenticationID
        this.MissUserInfo = [];

        this.DBUpdate = function (UpdateInfo) {
            if (UpdateInfo?.TableName) {
                const keyList = UpdateInfo.Key;
                const tableName = UpdateInfo.TableName;
                switch (tableName) {
                    case EChat.DBTableName.GROUPINFO:
                        EChat.IndexedDB.GetTableDataByKeyList(EChat.DBTableName.GROUPINFO, keyList).then(async (newGroupList) => {
                            const values = Object.values(newGroupList);
                            for (let i = 0; i < values.length; i++) {
                                const newGroup = values[i];
                                await EChat.MainPageController.redrawGroupEvent(newGroup);
                                const msgGroupID = newGroup.MessageGroupID;
                                EChat.MainPageController.updatePromptIcon({ groupID: msgGroupID, taskID: newGroup.TaskID, prompt: newGroup.Prompt });
                                if (EChat.MainPageController.checkMessageWindowExist(msgGroupID)) {
                                    const chatTab = EChat.MainPageController.getMessageWindow(msgGroupID).chatTabList[msgGroupID];
                                    if (chatTab) {
                                        chatTab.GroupInfo = newGroup;
                                        chatTab.updateGroupName();
                                        chatTab.refreshMessageList(newGroup.Messages);
                                    }
                                }
                            }
                        });
                        break;
                    case EChat.DBTableName.SETTINGS:
                        const values = Object.values(keyList);
                        for (let i = 0; i < values.length; i++) {
                            switch (values[i]) {
                                case "InitUser":
                                    EChat.IndexedDB.GetSetting("InitUser").then((SettingValue) => {
                                        if (SettingValue) {
                                            SetCurrPageUserInfo(SettingValue);
                                            EChat.MainPageController.updateUserSetting("AudioAlert", SettingValue.AudioAlert, true);
                                        }
                                    });
                                    break;
                                case "EChatState":
                                    EChat.IndexedDB.GetSetting("EChatState").then((SettingValue) => {
                                        if (SettingValue) {
                                            EChat.WebSocket.UpdateEChatState(SettingValue.State, SettingValue.Tittle);
                                        }
                                    });
                                    break;
                                case "Notify":
                                    EChat.IndexedDB.GetSetting("Notify").then((SettingValue) => {
                                        if (SettingValue && EChat.MainPageController.messageWindowList) {
                                            const messageValues = Object.values(EChat.MainPageController.messageWindowList);
                                            for (let k = 0; k < messageValues.length; k++) {
                                                const switchBtn = messageValues[i].notifySwitch;
                                                if (switchBtn && SettingValue.Notify) {
                                                    switchBtn.Open();
                                                } else if (switchBtn) {
                                                    switchBtn.Close();
                                                }
                                            }
                                        }
                                    });
                                    break;
                                case "RefreshBtnColor":
                                    EChat.IndexedDB.GetSetting("RefreshBtnColor").then((SettingValue) => {
                                        if (SettingValue) {
                                            EChat.MainPageController.RefreshBtnColor(SettingValue.Color, true);
                                        }
                                    });
                                    break;
                                case "UnreadGroup":
                                    EChat.MainPageController.unreadSumCountChange();
                                    break;
                                case "ChatSize":
                                    EChat.IndexedDB.GetSetting("ChatSize").then((SettingValue) => {
                                        if (SettingValue && EChat.MainPageController) {
                                            EChat.MainPageController.chatWindowSize = SettingValue;
                                        }
                                    });
                                    break;
                                case "MainSize":
                                    EChat.IndexedDB.GetSetting("MainSize").then((SettingValue) => {
                                        if (SettingValue && EChat.MainPageController) {
                                            EChat.MainPageController.mainWindowSize = SettingValue;
                                            EChat.MainPageController.resizeDialog();
                                        }
                                    });
                                    break;
                                case "SavedMessages":
                                    EChat.IndexedDB.GetSetting("SavedMessages").then((SettingValue) => {
                                        if (SettingValue) {
                                            EChat.DataProvider.SavedMessage = SettingValue;
                                            EChat.MainPageController.refreshSavedMessage();
                                            EChat.SavedMessageChange = true;
                                        }
                                    });
                                    break;
                            }
                        }
                        break;
                    case EChat.DBTableName.TABLEALERTS:
                        _this.dispatch(EChat.CustomEvent.REDRAWTABLEALERTS, _this.createHandlerArgument(null, null));
                        break;
                    default:
                }
            }
        };

        this.DBDeleted = function (DeleteInfo) {
            if (DeleteInfo?.TableName) {
                const keyList = DeleteInfo.Key;
                const tableName = DeleteInfo.TableName;
                switch (tableName) {
                    // Task 438700
                    case EChat.DBTableName.GROUPINFO:
                        const values = Object.values(keyList);
                        for (let i = 0; i < values.length; i++) {
                            _this.dispatch(EChat.CustomEvent.DELETEGROUP, _this.createHandlerArgument(null, values[i]));
                        }
                        break;
                }
            }
        };

        this.api = function (commmand, data, ReturnText) {
            return new Promise(((resolve, reject) => {
                EWS.VerifySession(() => {
                    const myRequest = new ECP.EC_Request(commmand);
                    if (data) {
                        const keys = Object.keys(data);
                        for (let i = 0; i < keys.length; i++) {
                            myRequest.AddRequestVariable(keys[i], data[keys[i]], ECP.EC_Verb.Post);
                        }
                    }
                    if (ReturnText) {
                        myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                        myRequest.Submit().then((text) => {
                            if (text.indexOf("{") === 0) {
                                try {
                                    const jsonObj = JSON.parse(text);
                                    if (!jsonObj.errors) {
                                        resolve(text);
                                    } else {
                                        reject(`ajax error. ${jsonObj.errors[0].detail}`);
                                    }
                                } catch (e) {
                                    resolve(text);
                                }
                            } else {
                                resolve(text);
                            }
                        });
                    } else {
                        myRequest.SetReturnType(ECP.EC_ReturnType.Json);
                        myRequest.Submit().then((jsonObj) => {
                            if (!jsonObj.errors) {
                                resolve(jsonObj);
                            } else {
                                reject(`ajax error. ${jsonObj.errors[0].detail}`);
                            }
                        }).catch((ex) => {
                            // eslint-disable-next-line no-console
                            console.error(ex);
                            reject(`ajax error. ${ex}`);
                        });
                    }
                });
            }
            ));
        };

        // Task 1033867: eChat: User icons are different on Recent view vs. Directory view
        this.GetMissUserInfo = function () {
            clearTimeout(missUserInfoHandle);
            missUserInfoHandle = setTimeout(async () => {
                const userInfoArr = await EChat.DataProvider.api("SalesComm_EChat_GetUsers", {
                    UserList: EC_Fmt.Null2EmptyStr(_this.MissUserInfo.join())
                });

                _this.MissUserInfo = [];
                for (let i = 0; i < userInfoArr.Users.length; i++) {
                    const userInfo = userInfoArr.Users[i];
                    const userDom = document.querySelector(`.eChat-Miss-Avatar[authid='${userInfo.AuthenticationID}']`);
                    if (userDom && userInfo.Icon) {
                        userDom.style.backgroundImage = `url(${userInfo.Icon})`;
                        _this.UserDict[userInfo.AuthenticationID] = userInfo;
                        userDom.classList.remove("eChat-Miss-Avatar");
                        userDom.removeAttribute("authid");
                    }
                }
            }, 1000);
        };

        this.GetTaskStatusElementByObjectiveID = function (ObjectiveID, TaskStatusID) {
            return new Promise(((resolve, reject) => {
                _this.api(`GetTaskStatusElementByObjectiveID&ObjectiveID=${ObjectiveID}&TaskStatusID=${TaskStatusID}`).then((data) => {
                    if (data?.ele) {
                        resolve(data.ele);
                    } else {
                        reject();
                    }
                }).catch(() => {
                    reject();
                });
            }));
        };

        this.GetTaskPublicMessageGroupID = async function (groupId) {
            const postData = {
                TaskSourceEncompassID: groupId.split("_")[0],
                TaskID: groupId.split("_")[1]
            };
            const result = await SocketUtil.api("GetTaskPublicMessageGroupID", postData);
            return result;
        };

        this.GetGroupInfoByGroupID = async function (groupId, Refresh, ExcludeMessage) {
            let groupInfo = await EChat.IndexedDB.GetTableDataByKey(EChat.DBTableName.GROUPINFO, groupId);
            if (!groupInfo || Refresh === true) {
                const postData = { MessageGroupID: groupId };
                if (ExcludeMessage) {
                    postData.ExcludeMessage = true;
                }

                let result;
                try {
                    if (groupId.split("_").length === 2) {
                        postData.TaskID = groupId.split("_")[1];
                        postData.TaskSourceEncompassID = groupId.split("_")[0];
                        result = await SocketUtil.api("GetTaskGroupInfo2010", postData);
                    } else {
                        result = await SocketUtil.api("GetGroupInfo2006", postData);
                    }
                } catch (e) {
                    if (e.ErrorCode === SocketUtil.ErrorCode.NoPermission || e.ErrorCode === SocketUtil.ErrorCode.NoGroup) {
                        await EChat.DataProvider.deleteGroupData(groupId, true, true);
                        return null;
                    }
                    // eslint-disable-next-line no-console
                    console.error(e.ErrorCode + e.ErrorMessage);
                    return null;
                }

                await _this.WriteGroupInfo(result);
                const messageGroupID = result.MessageGroup.MessageGroupID;
                groupInfo = await EChat.IndexedDB.GetTableDataByKey(EChat.DBTableName.GROUPINFO, messageGroupID);

                // Task 833748: Receive the first message of a new message group. Total unread messages not updated
                if (groupInfo.GroupType === SocketUtil.GroupType.Task || groupInfo.Prompt !== EChat.PromptType.DoNotDisturb) {
                    await EChat.IndexedDB.UpdateGroupUnread([groupInfo.MessageGroupID], groupInfo.UnReadCount, true);
                }

                await EChat.MainPageController.redrawGroupEvent(groupInfo);
                groupInfo.NewData = true;
            }

            return groupInfo;
        };

        this.WriteGroupInfo = async function (data) {
            const groupInfo = data.MessageGroup;
            groupInfo.Users = data.GroupUsers;
            groupInfo.Messages = data.Messages;
            if (data.GroupRead) {
                const groupRead = data.GroupRead;
                groupInfo.LastReadTime = groupRead.LastReadTime;
                groupInfo.ReadCount = groupRead.ReadCount;
                groupInfo.MessageCount = groupRead.MessageCount;
                groupInfo.UnReadCount = groupRead.UnReadCount;
                groupInfo.MessageUpdated = groupRead.MessageUpdated;
                groupInfo.Prompt = groupRead.Prompt;
                groupInfo.PostPermission = groupRead.PostPermission;
            }

            await EChat.IndexedDB.UpdateGroupInfo([groupInfo], true);
        };

        this.GetGroupInfoByAuthIDList = function (userList) {
            return new Promise((resolve) => {
                let groupData = null;
                EChat.Util.ShowLoading();
                EChat.IndexedDB.GetTableDataByIndex(EChat.DBTableName.GROUPINFO, "GroupType", SocketUtil.GroupType.Message).then((GroupDic) => {
                    if (GroupDic) {
                        const values = Object.values(GroupDic);
                        for (let i = 0; i < values.length; i++) {
                            if (_this.GetUserStrByGroupInfo(values[i]) === userList && EC_Fmt.isNull(values[i].GroupName)) {
                                groupData = values[i];
                                resolve(groupData);
                                break;
                            }
                        }
                    }
                    if (!groupData && !createdGrouping) {
                        createdGrouping = true;
                        _this.CreateGroup(userList, SocketUtil.GroupType.Message).then((jsonData) => {
                            ECP.Dialog.HideLoading();
                            createdGrouping = false;
                            if (jsonData) {
                                resolve(jsonData);
                            }
                        }).catch((e) => {
                            EChat.Util.errorAlert(e);
                            createdGrouping = false;
                        });
                    } else {
                        ECP.Dialog.HideLoading();
                    }
                }).catch(() => {
                    ECP.Dialog.HideLoading();
                });
            });
        };

        // Task 689770: Call Manager: Availability not working bases on the CallStatus.
        this.GetUserAvailabilityClassAndColor = function (Availability) {
            switch (Availability.toString()) {
                case "":
                    return null;
                case "0":
                    return null;
                case "1":
                    return { Class: "ews-icon-circle-closed", Color: "var(--primary-30)" };
                case "2":
                    return { Class: "ews-icon-half-circle", Color: "var(--primary-30)" };
                case "3":
                    return { Class: "ews-icon-minus", Color: "#ff9900" };
                case "4":
                    // Task 760966: Change color for In Call Availability status to blue
                    return { Class: "ews-icon-phone", Color: "#3851f2" };
                case "5":
                    return { Class: "ews-icon-circle-closed", Color: "var(--red-50)" };
                case "6":
                    return { Class: "ews-icon-half-circle", Color: "var(--red-50)" };
                case "7":
                    return { Class: "ews-icon-circl-eopen", Color: "#bfbfbf" };
                case "8":
                    return { Class: "ews-icon-audit", Color: "#d200ff" };
                default:
                    return { Class: "ews-icon-circle-closed", Color: "#bfbfbf" };
            }
        };

        // Task 930531: eChat Dashboard: Optimize the eChat dashboard, make it load faster
        this.GetGroupAvatarUrlAndAuthID = function (groupInfo, currentUserInfo) {
            let url = null;
            let chatAuthID = 0;
            if (groupInfo.GroupType === SocketUtil.GroupType.System) {
                url = EChat.Setting.DefaultAlertIcon;
            } else if (!EC_Fmt.isNull(groupInfo.Icon)) {
                url = groupInfo.Icon;
            } else if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                url = EChat.Setting.DefaultTaskIcon;
            } else if (groupInfo.Users?.length <= 2) {
                for (let i = 0; i < groupInfo.Users.length; i++) {
                    const userAuthID = parseInt(groupInfo.Users[i]);

                    if (userAuthID !== currentUserInfo.AuthenticationID || groupInfo.Users.length === 1) {
                        chatAuthID = userAuthID;
                        if (groupInfo.Messages) {
                            for (let j = 0; j < groupInfo.Messages.length; j++) {
                                if (userAuthID === parseInt(groupInfo.Messages[j].SenderAuthenticationID) && groupInfo.Messages[j].SenderUserAvatar) {
                                    url = groupInfo.Messages[j].SenderUserAvatar;
                                    break;
                                }
                            }
                        }
                    }
                }
                if (EC_Fmt.isNull(url)) {
                    url = EChat.Setting.DefaultUserIcon;
                }
            } else if (groupInfo.UserCount === 2) {
                // Super Seacher Result
                url = EChat.Setting.DefaultUserIcon;
            } else {
                url = EChat.Setting.DefaultGroupIcon;
            }
            return { Url: url, AuthID: chatAuthID };
        };

        this.GetUserInfo = async function (missUser) {
            if (missUser?.length !== 0) {
                try {
                    const data = await EChat.DataProvider.api("SalesComm_EChat_GetUsers", { UserList: missUser.toString() });
                    if (data?.Users) {
                        return data.Users;
                    }
                } catch (e) {
                    EChat.Util.errorAlert(e);
                }
            }
            return [];
        };

        this.CancelSavedMessage = async function ({
            TaskID, TaskDetailID, TaskSourceEncompassID, MessageGroupKey, MessageKey
        }) {
            let success = false;
            if (TaskDetailID || MessageKey) {
                try {
                    await SocketUtil.api("CancelSavedMessage", {
                        TaskID,
                        TaskDetailID,
                        TaskSourceEncompassID,
                        MessageGroupKey,
                        MessageKey
                    });
                    success = true;
                } catch (e) {
                    EChat.Util.errorAlert(e);
                }
            }
            return success;
        };

        this.AddSavedMessage = async function ({
            TaskID, TaskDetailID, TaskSourceEncompassID, MessageGroupKey, MessageKey
        }) {
            let success = false;
            if (TaskDetailID || MessageKey) {
                try {
                    await SocketUtil.api("AddSavedMessage", {
                        TaskID,
                        TaskDetailID,
                        TaskSourceEncompassID,
                        MessageGroupKey,
                        MessageKey
                    });
                    success = true;
                } catch (e) {
                    EChat.Util.errorAlert(e);
                }
            }

            return success;
        };

        this.GetGroupName = function (groupInfo, addTaskID) {
            let groupName = groupInfo.GroupName;
            if (!groupName || groupInfo.GroupType === SocketUtil.GroupType.Task) {
                groupName = groupInfo.DisplayName;
                if (!groupName) {
                    groupName = "None";
                } else {
                    groupName = groupName.replace(/<.*?>/g, "").replace(/[\r\n]/g, "");
                }
            }
            if (groupName.length > EChat.Setting.MaxCharacterGroupNameDisplay) {
                groupName = `${groupName.substr(0, EChat.Setting.MaxCharacterGroupNameDisplay)}...`;
            }
            if (addTaskID && groupInfo.GroupType === SocketUtil.GroupType.Task && groupInfo.TaskID) {
                groupName = `Task ${groupInfo.TaskID}: ${groupName}`;
            }
            return groupName;
        };
        this.Update_Session = function () {
            const now = EChat.Util.getTimeStamp();
            // Task 990979: Interacting with eChat does not extend browser session
            if (now - lastUpdateSessionTime > 1000 * 60 * 5) {
                lastUpdateSessionTime = now;
                _this.api("Update_Session", "", true).catch(() => { });
            }
        };

        const GetInitUserDataByAjax = function () {
            return _this.api("SalesComm_EChat_InitUser");
        };

        this.IsCurrentUser = function (AuthID) {
            let currentAuthenticationID;
            if (_this.CurrentUserInfo?.AuthenticationID) {
                currentAuthenticationID = _this.CurrentUserInfo.AuthenticationID;
            } else {
                currentAuthenticationID = AuthenticationID;
            }
            return parseInt(AuthID) === currentAuthenticationID;
        };

        // Task 1184633: SalesComm_EChat_InitUser to slow on CCD
        this.initUser = async function () {
            const DBUserData = await EChat.IndexedDB.GetSetting("InitUser");
            return new Promise(((resolve, reject) => {
                if (!DBUserData || !DBUserData.ExpireDate || DBUserData.ExpireDate <= EChat.Util.getTimeStamp()) {
                    GetInitUserDataByAjax().then((jsonData) => {
                        jsonData.ExpireDate = new Date((new Date()).setHours((new Date()).getHours() + 6)).getTime();
                        SetInitUserData(jsonData).then(() => {
                            resolve();
                        });
                    }).catch(() => {
                        EWS.VerifySession(() => {
                            ECP.Dialog.Alert("eChat initialization failed. Please refresh the page and try again.");
                        });
                        reject();
                    });
                } else {
                    SetInitUserData(DBUserData).then(() => {
                        resolve();
                    });
                }
            }));
        };

        const SetCurrPageUserInfo = function (jsonData) {
            _this.EncompassID = jsonData.EncompassID;

            _this.CurrentUserInfo = {
                UserID: jsonData.UserID,
                EncompassID: jsonData.EncompassID,
                AuthenticationID: parseInt(jsonData.AuthenticationID),
                UserName: jsonData.UserName,
                FullName: jsonData.FullName,
                CrossLocalPerm: jsonData.CrossLocalPerm,
                LocationIDStr: jsonData.LocationIDStr,
                DateFormat: jsonData.DateFormat,
                TimeFormat: jsonData.TimeFormat,
                AudioAlert: parseInt(jsonData.AudioAlert),
                UserAvatar: jsonData.UserAvatar || null,
                EnableEChat: jsonData.EnableEChat,
                PrimaryEncompassID: jsonData.PrimaryEncompassID
            };

            if (!jsonData.EnableEChat) {
                document.getElementById("EChatButton").style.display = "none";
            } else {
                EChat.WebSocket.WebSocketInit();
                document.getElementById("EChatButton").style.display = "block";
            }
            if (jsonData.IsCustomer) {
                EChat.IsCustomer = 1;
            } else {
                EChat.IsCustomer = 0;
            }

            if (_this.CurrentUserInfo.UserAvatar) {
                const eChatUserAvatarDisplays = document.getElementsByClassName("eChatUserAvatarDisplay");
                for (let i = 0, len = eChatUserAvatarDisplays.length; i < len; i++) {
                    eChatUserAvatarDisplays[i].style.backgroundImage = `url(${_this.CurrentUserInfo.UserAvatar})`;
                }
            }
        };

        const SetInitUserData = function (jsonData) {
            return new Promise(((resolve) => {
                SetCurrPageUserInfo(jsonData);

                EChat.IndexedDB.CheckCurrentDBAuthID(jsonData.AuthenticationID).then(() => {
                    EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.ECHATAUTHID, _this.CurrentUserInfo.AuthenticationID);
                    if (!EChat.ReLoginEventIsBind) {
                        EChat.ReLoginEventIsBind = true;
                        EWS.ReLogin(() => {
                            if (EChat.MainPageController) {
                                EChat.MainPageController.closeAllWindow();
                            }
                            EChat.Util.initEChat(true);
                        });

                        EWS.VerifySessionFail(() => {
                            EChat.Util.removeEChat();
                        });
                    }

                    EChat.IndexedDB.UpdateSetting("InitUser", jsonData, true).then(() => {
                        EChat.InitState.InitUser = true;
                        resolve();
                    });
                });
            }));
        };

        this.SyncData = function () {
            return new Promise(((resolve, reject) => {
                EWS.VerifySession(() => {
                    EChat.IndexedDB.GetSetting("LastSyncDate").then((LastSyncDate) => {
                        if (EC_Fmt.isNull(LastSyncDate)) {
                            LastSyncDate = -1;
                        }
                        const promise1 = SocketUtil.api("SyncData2010", { LastSyncDate });
                        promise1.then((result) => {
                            resolve(result);
                        }).catch(() => {
                            reject();
                        });
                    });
                });
            }));
        };

        // Task 1144583: eChat: Certain tasks show up with the title of None in the recent eChats section
        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
        this.SendMessage = function ({
            messageGroupID, messageMark, messageBody, imgData, delayedSendTime, taskID, ghost, notify, isPublic, taskSourceEncompassID, notifyInternal, taskTitle
        }) {
            return new Promise(((resolve) => {
                EWS.VerifySession(() => {
                    const socketSessionID = SocketUtil.getSessionID();
                    const dataInfo = { SessionID: socketSessionID };

                    if (ghost) {
                        dataInfo.Ghost = ghost;
                    }

                    const messageRequest = {
                        MessageGroupID: messageGroupID,
                        MessageBody: messageBody,
                        Command: SocketUtil.Command.Message,
                        Push: true,
                        Save: true,
                        Transfer: SocketUtil.TransferType.All,
                        DataInfo: dataInfo
                    };

                    // DelayMessage
                    if (delayedSendTime) {
                        _this.api("SendDelayEChatMessage", {
                            MessageGroupKey: messageGroupID,
                            MessageBody: messageBody,
                            DelayedSendTime: delayedSendTime
                        }).then((data) => {
                            const msgObj = {
                                MessageGroupID: messageRequest.MessageGroupID,
                                MessageID: messageMark,
                                SenderAuthenticationID: _this.CurrentUserInfo.AuthenticationID,
                                Message: messageBody,
                                TimeCreated: data.TimeCreated
                            };

                            SendMessageSuccess(messageMark, msgObj, true);
                            resolve(msgObj);
                        }).catch((error) => {
                            SendMessageFail(messageRequest.MessageGroupID, messageMark, error.ErrorMessage);
                        });
                    } else if (taskID) {
                        const postData = {};
                        let TaskDetailIsPublic = false;
                        if (imgData && Array.isArray(imgData) && imgData.length !== 0) {
                            postData.FileData = JSON.stringify(imgData);
                            postData.SocketSessionID = socketSessionID;
                        } else if (imgData && typeof (imgData) === "object") {
                            postData.FileData = imgData;
                        } else {
                            postData.SocketSessionID = socketSessionID;
                        }
                        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
                        if (notify) {
                            if (isPublic) {
                                isPublic = true;
                                notify = true;
                                TaskDetailIsPublic = true;
                            }
                        } else if (notifyInternal) {
                            if (isPublic) {
                                isPublic = false;
                                notify = true;
                                TaskDetailIsPublic = true;
                            } else {
                                isPublic = false;
                                notify = true;
                                TaskDetailIsPublic = false;
                            }
                        } else if (isPublic) {
                            isPublic = true;
                            notify = false;
                            TaskDetailIsPublic = true;
                        } else {
                            isPublic = false;
                            notify = false;
                            TaskDetailIsPublic = false;
                        }

                        postData.TaskDetail = messageBody;
                        postData.TaskID = taskID;
                        postData.TaskSourceEncompassID = taskSourceEncompassID;
                        postData.Notify = notify;
                        postData.ReturnMessage = true;
                        postData.IsPublic = isPublic;
                        postData.TaskDetailIsPublic = TaskDetailIsPublic;
                        postData.TaskTitle = taskTitle;

                        SocketUtil.api("SendTaskDetail", postData).then(async (data) => {
                            const msgObj = {
                                MessageGroupID: data.MessageGroupID,
                                MessageID: data.MessageID,
                                SenderAuthenticationID: _this.CurrentUserInfo.AuthenticationID,
                                Message: messageBody,
                                TimeCreated: data.TimeCreated,
                                SenderFullName: _this.CurrentUserInfo.FullName,
                                SenderUserAvatar: _this.CurrentUserInfo.UserAvatar,
                                IsPublic: isPublic,
                                TaskID: taskID,
                                TaskSourceEncompassID: taskSourceEncompassID
                            };

                            if (data.Message) {
                                msgObj.Message = data.Message;
                            }

                            SendMessageSuccess(messageMark, msgObj, postData.ReturnMessage);
                            await EChat.IndexedDB.InsertTaskDetail(msgObj);
                            resolve(msgObj);
                        }).catch((error) => {
                            if (error.ErrorCode === SocketUtil.ErrorCode.NoGroup || error.ErrorCode === SocketUtil.ErrorCode.NoPermission) {
                                // eslint-disable-next-line no-console
                                console.error(error.ErrorMessage);
                                error.ErrorMessage = "The group does not exist.";
                            }
                            SendMessageFail(messageGroupID, messageMark, error.ErrorMessage);
                        });
                    } else if (imgData) { // SendFile
                        const postData = {};
                        if (Array.isArray(imgData) && imgData.length !== 0) {
                            postData.FileData = JSON.stringify(imgData);
                            postData.SocketSessionID = socketSessionID;
                        } else if (typeof (imgData) === "object") {
                            postData.FileData = imgData;
                        }

                        postData.MessageRequest = JSON.stringify(messageRequest);
                        postData.ReturnMessage = true;
                        SocketUtil.api("SendMessage", postData).then((data) => {
                            const msgObj = {
                                MessageGroupID: messageGroupID,
                                MessageID: data.MessageID,
                                SenderAuthenticationID: _this.CurrentUserInfo.AuthenticationID,
                                Message: messageBody,
                                TimeCreated: data.TimeCreated,
                                SenderFullName: _this.CurrentUserInfo.FullName,
                                SenderUserAvatar: _this.CurrentUserInfo.UserAvatar
                            };

                            if (data.Message) {
                                msgObj.Message = data.Message;
                            }

                            EChat.IndexedDB.InsertMessage(msgObj, false, true).then(() => {
                                SendMessageSuccess(messageMark, msgObj, true);
                                resolve(msgObj);
                            });
                        }).catch((error) => {
                            if (error.ErrorCode === SocketUtil.ErrorCode.NoGroup || error.ErrorCode === SocketUtil.ErrorCode.NoPermission) {
                                // eslint-disable-next-line no-console
                                console.error(error.ErrorMessage);
                                error.ErrorMessage = "The group does not exist.";
                            }
                            SendMessageFail(messageRequest.MessageGroupID, messageMark, error.ErrorMessage);
                            // Task 678780: JS error in sending message when session expires
                        });
                    } else { // SendMessage
                        SocketUtil.send(messageRequest, (data) => {
                            const msgObj = {
                                MessageGroupID: messageRequest.MessageGroupID,
                                MessageID: data.MessageID,
                                SenderAuthenticationID: _this.CurrentUserInfo.AuthenticationID,
                                // SenderEncompassID: _this.CurrentUserInfo.EncompassID,
                                Message: messageBody,
                                TimeCreated: data.TimeCreated,
                                SenderFullName: _this.CurrentUserInfo.FullName,
                                SenderUserAvatar: _this.CurrentUserInfo.UserAvatar
                            };

                            EChat.IndexedDB.InsertMessage(msgObj, false, true).then(() => {
                                SendMessageSuccess(messageMark, msgObj, false);
                                resolve(msgObj);
                            });
                        }, (data) => {
                            SendMessageFail(messageRequest.MessageGroupID, messageMark, data);
                            // Task 678780: JS error in sending message when session expires
                        });
                    }
                }, true, () => {
                    SendMessageFail(messageGroupID, messageMark, "Session expiration");
                }, () => {
                    SendMessageFail(messageGroupID, messageMark, "Session expiration");
                });
            }));
        };

        // Task 689770: Call Manager: Availability not working bases on the CallStatus.
        this.UpdateUserAvailability = (jsonData) => {
            if (jsonData.AuthenticationID && jsonData.Availability) {
                EChat.MainPageController.redrawUserAvailability(jsonData.AuthenticationID, jsonData.Availability);
            }

            // Task 1092124: Time Clock Shifts showing inflated shift hours
            try {
                if (UpdateCurrentStatus && typeof (UpdateCurrentStatus) === "function") {
                    UpdateCurrentStatus(parseInt(jsonData.Availability));
                }
            } catch (e) {
                return null;
            }
            return null;
        };

        this.ReceiveMessage = function (message, isStorage) {
            if (!message.Message || isStorage) {
                return;
            }
            const subStr = /(<[ ]*?script[^>]*?>)|(<\/script>)/ig;
            message.Message = message.Message.replace(subStr, "");

            const Filter = [];
            Filter.push("onclick");
            Filter.push("onclick");
            Filter.push("onload");
            Filter.push("ondrop");
            Filter.push("onerror");
            Filter.push("onkeydown");
            Filter.push("onkeyup");
            Filter.push("onbeforeunload");
            Filter.push("ondragenter");
            Filter.push("ondragover");
            Filter.push("onmousemove");
            Filter.push("onmouseup");
            Filter.push("onorientationchange");
            Filter.push("onpageshow");
            Filter.push("onresize");
            Filter.push("onstorage");
            Filter.push("ontouchmove");
            Filter.push("onunload");
            Filter.push("onvisibilitychange");
            const events = new RegExp(`<[\\s\\S]*?(${Filter.join("|")})=('|")([\\s\\S]*?)('|")>`, "ig");
            const messageList = message.Message.match(events);
            if (messageList) {
                for (let i = 0; i < messageList.length; i++) {
                    const mvalue = messageList[i];
                    let value = messageList[i];
                    for (let j = 0; j < Filter.length; j++) {
                        value = value.replace(Filter[j], "event");
                    }
                    message.Message = message.Message.replace(mvalue, value);
                }
            }

            const checkGroupType = (groupInfo) => {
                let check = false;
                if (groupInfo) {
                    if (groupInfo.GroupType === SocketUtil.GroupType.System || groupInfo.GroupType === SocketUtil.GroupType.Message || groupInfo.GroupType === SocketUtil.GroupType.Task) {
                        check = true;
                    }
                }
                return check;
            };

            if (message?.MessageGroupID) {
                _this.GetGroupInfoByGroupID(message.MessageGroupID).then((groupInfo) => {
                    if (checkGroupType(groupInfo)) {
                        let Ghost = false;
                        if (groupInfo.GroupType === SocketUtil.GroupType.Task && message.DataInfo?.Ghost) {
                            Ghost = true;
                        }

                        if (!messageExist(message, groupInfo)) {
                            groupInfo.Messages.splice(0, 0, message);
                            let addUnreadCount = false;

                            if (!_this.IsCurrentUser(message.SenderAuthenticationID) || groupInfo.GroupType === SocketUtil.GroupType.System) {
                                if (!Ghost) {
                                    addUnreadCount = true;
                                }
                            }

                            if (message.DataInfo) {
                                message.SenderFullName = message.DataInfo.SenderFullName;
                                message.SenderUserAvatar = message.DataInfo.SenderUserAvatar;
                            }

                            if (!_this.IsCurrentUser(message.SenderAuthenticationID) && groupInfo.Prompt !== EChat.PromptType.DoNotDisturb && !Ghost) {
                                EChat.MainPageController.playAudioAlters();
                            }

                            if (message.DataInfo?.TaskID) {
                                message.IsPublic = message.DataInfo.IsPublic;
                                message.TaskID = message.DataInfo.TaskID;
                                message.TaskSourceEncompassID = message.DataInfo.TaskSourceEncompassID;
                                message.GroupDisplayName = message.DataInfo.GroupDisplayName;
                                if (message.DataInfo.TaskDetailID) {
                                    message.MessageID = message.DataInfo.TaskDetailID;
                                }

                                EChat.IndexedDB.InsertTaskDetail(message);
                            } else {
                                EChat.IndexedDB.InsertMessage(message, addUnreadCount, true).then(() => {
                                    const messageGroupID = groupInfo.MessageGroupID;
                                    if (EChat.MainPageController.checkMessageWindowExist(messageGroupID)) {
                                        EChat.MainPageController.currentMessageWindow.receiveNewMessage(message, messageGroupID);
                                    }
                                }).catch();
                            }
                        } else if (groupInfo.NewData && !_this.IsCurrentUser(message.SenderAuthenticationID) && groupInfo.Prompt !== EChat.PromptType.DoNotDisturb && !Ghost) {
                            EChat.MainPageController.playAudioAlters();
                        }
                    }
                });
            }
        };

        const SendMessageSuccess = function (messageMark, msgObj, overMessage) {
            const msgElement = document.getElementById(`messageblock_${messageMark * -1}`);
            if (msgElement) {
                msgElement.setAttribute("messageid", msgObj.MessageID);
                msgElement.setAttribute("id", `messageblock_${msgObj.MessageID}`);
                const mgsBody = msgElement.querySelector(`#message_${messageMark * -1}`);

                // Task 1046811: eChat displays messages in incorrect order
                const sendTimeDom = document.querySelector(`.SendTime[messagemark='${messageMark}']`);
                if (sendTimeDom) {
                    sendTimeDom.innerHTML = EChat.Util.longToDataTime(msgObj.TimeCreated);
                    sendTimeDom.setAttribute("messagemark", msgObj.TimeCreated);
                }

                msgElement.setAttribute("messagemark", msgObj.TimeCreated);

                if (mgsBody) {
                    mgsBody.setAttribute("messageid", msgObj.MessageID);
                    mgsBody.setAttribute("id", `message_${msgObj.MessageID}`);
                }
                const savedIcon = msgElement.querySelector(".saved-message-icon");
                if (savedIcon) {
                    savedIcon.setAttribute("savedkey", msgObj.MessageID);
                    savedIcon.setAttribute("id", `SavedKey_${msgObj.MessageID}`);
                }

                if (overMessage) {
                    mgsBody.innerHTML = `<div>${msgObj.Message}</div>`;
                    const messageGroupID = msgObj.TaskID ? `${msgObj.TaskSourceEncompassID}_${msgObj.TaskID}` : msgObj.MessageGroupID;
                    const chatBoxElement = document.getElementById(`chatBox_${messageGroupID}`);
                    if (chatBoxElement) {
                        chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
                        EChat.Util.FileLoad(mgsBody, chatBoxElement, msgObj.SenderAuthenticationID, 423, 200);
                    }
                }
            }
        };

        const SendMessageFail = function (messageGroupID, messageMark, error) {
            const msgElement = document.getElementById(`messageblock_-${messageMark}`);
            if (msgElement) {
                const flexElement = msgElement.querySelector(".message-flex-box");

                const errorIcon = EC_Fmt.HtmlStrToElement(`<span class=send-error style=cursor:pointer groupid=${messageGroupID}>!</span>`);
                errorIcon.addEventListener("click", function () {
                    const messages = this.parentNode.querySelectorAll(".DialogBubbleHead > p");
                    for (let i = 0, len = messages.length; i < len; i++) {
                        const sendText = messages[i].innerHTML;
                        const groupid = this.getAttribute("groupid");
                        for (let j = 0, len2 = EChat.MainPageController.messageWindowList.length; j < len2; j++) {
                            if (EChat.MainPageController.messageWindowList[j].currentTab.ID === groupid) {
                                const MessageWindowTextArea = EChat.MainPageController.messageWindowList[j].element.querySelector(".eChat-MessageWindowTextArea");

                                if (MessageWindowTextArea) {
                                    MessageWindowTextArea.innerHTML = sendText;
                                }

                                const sendBtn = EChat.MainPageController.messageWindowList[j].element.querySelector("#EChat_Send_Btn");
                                if (sendBtn) {
                                    sendBtn.click();
                                }
                            }
                        }
                    }
                });
                flexElement.insertBefore(errorIcon, flexElement.firstChild);
                const tab = EChat.MainPageController.getMessageWindow(messageGroupID).chatTabList[messageGroupID];
                if (tab) {
                    const errorDiv = document.createElement("div");
                    errorDiv.innerHTML = error;
                    tab.AddTipElement(errorDiv);
                }
            }
        };

        this.CreateGroup = async function (userList, groupType) {
            const result = await SocketUtil.createGroup(userList, groupType);

            const groupUsers = {};
            const groupMessages = {};
            const messageGroupID = result.MessageGroup.MessageGroupID;
            groupUsers[messageGroupID] = result.GroupUsers;
            groupMessages[messageGroupID] = result.Messages;

            await EChat.IndexedDB.UpdateGroupObject({
                GroupInfos: [result.MessageGroup],
                GroupUsers: groupUsers,
                GroupMessages: groupMessages
            });

            const messageGroup = await EChat.IndexedDB.GetTableDataByKey(EChat.DBTableName.GROUPINFO, messageGroupID);
            EChat.IndexedDB.NoticeUpdate(EChat.DBTableName.GROUPINFO, [messageGroupID]);

            if (result.Messages.length !== 0) {
                await EChat.MainPageController.redrawGroupEvent(messageGroup);
            }
            return messageGroup;
        };

        this.SaveEChatMessageToTaskDetail = function (groupID, taskID, messageIDStr) {
            return _this.api("SalesComm_SaveMessageToTaskDetail", {
                MessageGroupKey: groupID,
                TaskID: taskID,
                MessageIDStr: messageIDStr
            });
        };

        this.CreateTask = function () {
            return _this.api("SalesComm_CreateSupportTask");
        };

        this.GetUserStrByGroupInfo = function (groupInfo) {
            if (groupInfo.GroupType === SocketUtil.GroupType.System) {
                return groupInfo.GroupName;
            }
            if (!groupInfo.Users) {
                return "";
            }
            const userList = [];
            for (let i = 0; i < groupInfo.Users.length; i++) {
                userList.push(groupInfo.Users[i]);
            }
            return _this.GetUserStrByUserList(userList);
        };

        this.GetUserStrByUserList = function (UsersList) {
            const sortUserList = UsersList.sort((a, b) => parseInt(a) - parseInt(b));
            return sortUserList.join(",");
        };

        this.SyncLocalTaskRead = async function (TaskID, TaskSourceEncompassID, isFromLocalStorage) {
            if (TaskID && !isFromLocalStorage) {
                const groupList = await EChat.IndexedDB.GetTableAllData(EChat.DBTableName.GROUPINFO);
                const groupReadInfoList = [];
                const groupIdArr = [];
                for (let i = 0; i < groupList.length; i++) {
                    let update = false;
                    const groupInfo = groupList[i];

                    if (groupInfo.MessageGroupID === `${TaskSourceEncompassID}_${TaskID}`) {
                        update = true;
                    }

                    if (update) {
                        groupReadInfoList.push({
                            MessageGroupID: groupInfo.MessageGroupID,
                            LastReadTime: EChat.Util.getTimeStamp(),
                            ReadCount: groupInfo.MessageCount,
                            MessageCount: groupInfo.MessageCount,
                            MessageUpdated: groupInfo.MessageUpdated,
                            UnReadCount: 0,
                            Prompt: EChat.PromptType.Normal,
                            PostPermission: EChat.PostPermissionType.Post
                        });
                        groupIdArr.push(groupInfo.MessageGroupID);
                    }
                }

                await EChat.IndexedDB.UpdateGroupUnread(groupIdArr, 0, true);
                await EChat.IndexedDB.UpdateGroupReads(groupReadInfoList, true);
                EChat.MainPageController.updateUnReadNumIcon("read SyncLocalTaskRead");
            }
        };

        this.UpdateTaskGroup = async function (MessageGroupID, TaskID, isFromLocalStorage) {
            if (MessageGroupID && TaskID && !isFromLocalStorage) {
                _this.GetGroupInfoByGroupID(`${MessageGroupID}_${TaskID}`, true, true);
            }
        };

        this.SyncLocalLastReadTime = function (data, isFromLocalStorage) {
            if (data?.DataInfo?.GroupReadInfo && !data.DataInfo.TaskID && !isFromLocalStorage) {
                EChat.IndexedDB.UpdateGroupUnread([data.DataInfo.GroupReadInfo.MessageGroupID], 0, true);
                EChat.IndexedDB.UpdateGroupReads([data.DataInfo.GroupReadInfo], true).then(() => {
                    EChat.MainPageController.updateUnReadNumIcon("read SyncLastReadTime");
                });
            }
        };

        this.SendWriteState = function (GroupID, ReceiverAuthID) {
            if (GroupID && ReceiverAuthID > 0) {
                const timeStamp = EChat.Util.getTimeStamp();
                const lastTime = _this.LastMessageTime[GroupID];
                const sendTime = _this.SendWriteStateTime[GroupID];
                if (!EC_Fmt.isNull(lastTime) && timeStamp - lastTime < 1000 * 60 && (EC_Fmt.isNull(sendTime) || timeStamp - sendTime > 5000)) {
                    SocketUtil.send({
                        MessageGroupID: GroupID,
                        Command: SocketUtil.Command.WriteState,
                        Push: false,
                        Save: false,
                        Transfer: SocketUtil.TransferType.Other
                    });

                    _this.SendWriteStateTime[GroupID] = timeStamp;
                }
            }
        };

        this.RecallMessage = function (messageGroupID, MessageID) {
            if (messageGroupID && MessageID) {
                const socketSessionID = SocketUtil.getSessionID();
                const dataInfo = {
                    SessionID: socketSessionID,
                    RecallMessageID: MessageID
                };
                const postData = {};

                const messageRequest = {
                    MessageGroupID: messageGroupID,
                    Command: SocketUtil.Command.MessageRecalled,
                    Push: true,
                    Save: false,
                    Transfer: SocketUtil.TransferType.All,
                    DataInfo: dataInfo
                };

                postData.MessageRequest = JSON.stringify(messageRequest);

                SocketUtil.api("SendMessage", postData).then((data) => {
                    _this.MessageRecalled({ MessageGroupID: messageGroupID, MessageID, MessageBody: data.Message }, false);
                }).catch((ex) => {
                    if (ex) {
                        ECP.Dialog.Alert(ex.ErrorMessage);
                    }
                });
            }
        };

        this.SyncLastReadTime = async function (groupId) {
            if (!groupId) {
                return;
            }
            try {
                const groupInfo = await _this.GetGroupInfoByGroupID(groupId);
                if (!groupInfo) {
                    return;
                }
                const UnreadGroup = await EChat.IndexedDB.GetSetting("UnreadGroup");

                if (groupInfo.UnReadCount || (UnreadGroup && UnreadGroup[groupInfo.MessageGroupID])) {
                    let GroupReadLockStr = EChat.LocalStorage.readLocalStorage(EChat.LocalStorageType.GROUPREADLOCK);
                    let GroupReadLock = {};
                    if (GroupReadLockStr) {
                        GroupReadLock = JSON.parse(GroupReadLockStr);
                    }
                    const TimeNow = EChat.Util.getTimeStamp();
                    if (GroupReadLock && GroupReadLock[groupInfo.MessageGroupID] && parseInt(TimeNow) - parseInt(GroupReadLock[groupInfo.MessageGroupID]) < 30000) {
                        return;
                    }

                    if (!GroupReadLock) {
                        GroupReadLock = {};
                    }
                    GroupReadLock[groupInfo.MessageGroupID] = TimeNow;
                    EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.GROUPREADLOCK, JSON.stringify(GroupReadLock));

                    let data;
                    try {
                        if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                            data = await SocketUtil.api("ReadTaskGroup2010", {
                                TaskID: groupInfo.MessageGroupID.split("_")[1],
                                TaskSourceEncompassID: groupInfo.MessageGroupID.split("_")[0]
                            });
                        } else {
                            data = await SocketUtil.api("ReadGroupMessage2006", { MessageGroupID: groupInfo.MessageGroupID });
                        }
                    } catch (e) {
                        if (e.ErrorCode === SocketUtil.ErrorCode.NoPermission) {
                            EChat.DataProvider.deleteGroupData(groupId, true, true);
                        } else {
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                        return;
                    }

                    GroupReadLockStr = EChat.LocalStorage.readLocalStorage(EChat.LocalStorageType.GROUPREADLOCK);
                    if (GroupReadLockStr) {
                        GroupReadLock = JSON.parse(GroupReadLockStr);
                        if (GroupReadLock) {
                            delete GroupReadLock[groupInfo.MessageGroupID];
                            EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.GROUPREADLOCK, JSON.stringify(GroupReadLock));
                        }
                    }

                    if (!data) {
                        return;
                    }

                    if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                        await EChat.IndexedDB.UpdateGroupReads(data.GroupReadInfos);
                        const groupIdArr = [];
                        if (data.GroupReadInfos.length !== 0) {
                            for (let i = 0; i < data.GroupReadInfos.length; i++) {
                                groupIdArr.push(data.GroupReadInfos[i].MessageGroupID);
                            }
                        }

                        if (groupIdArr.indexOf(groupInfo.MessageGroupID) === -1) {
                            groupInfo.UnReadCount = 0;
                            groupInfo.ReadCount = groupInfo.MessageCount;
                            groupIdArr.push(groupInfo.MessageGroupID);
                            await EChat.IndexedDB.UpdateGroupInfo([groupInfo]);
                        }

                        await EChat.IndexedDB.UpdateGroupUnread(groupIdArr, 0, true);
                    } else {
                        await EChat.IndexedDB.UpdateGroupReads([data.GroupReadInfo]);
                        await EChat.IndexedDB.UpdateGroupUnread([groupId], 0, true);
                    }
                } else {
                    await EChat.IndexedDB.UpdateGroupUnread([groupId], 0, true);
                    return;
                }

                EChat.MainPageController.updateUnReadNumIcon("read SyncLastReadTime");

                // Task 754035: eChat Notification won't go away
                clearTimeout(RefreshHandle);
                RefreshHandle = setTimeout(() => {
                    EChat.MainPageController.updateUnreadSumCount("Delay update");
                }, 7000);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        };

        this.ReadAllGroup = function () {
            EChat.Util.ShowLoading();
            SocketUtil.api("ReadAllGroupMessage2010").then((data) => {
                if (data?.GroupReadInfoList) {
                    EChat.IndexedDB.UpdateGroupReads(data.GroupReadInfoList).then(async () => {
                        const newGroupIDList = [];
                        const GroupList = await EChat.IndexedDB.GetTableAllData(EChat.DBTableName.GROUPINFO);
                        for (let i = 0; i < GroupList.length; i++) {
                            if (GroupList[i].UnReadCount !== 0) {
                                GroupList[i].ReadCount = GroupList[i].MessageCount;
                                GroupList[i].UnReadCount = 0;
                                await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.GROUPINFO, GroupList[i]);
                                newGroupIDList.push(GroupList[i].MessageGroupID);
                            }
                        }

                        EChat.IndexedDB.NoticeUpdate(EChat.DBTableName.GROUPINFO, newGroupIDList);
                        EChat.MainPageController.updateUnReadNumIcon("ReadAllGroup");
                        EChat.MainPageController.updateUnreadSumCount("ReadAllGroup");
                        ECP.Dialog.HideLoading();
                    }).cache(() => {
                        ECP.Dialog.HideLoading();
                    });
                } else {
                    ECP.Dialog.HideLoading();
                }
            }).catch((e) => {
                ECP.Dialog.HideLoading();
                if (e.ErrorCode === SocketUtil.ErrorCode.NoPermission) {
                    EChat.DataProvider.deleteGroupData(groupId, true, true);
                } else {
                    // eslint-disable-next-line no-console
                    console.error(e.ErrorCode + e.ErrorMessage);
                }
            });
        };

        this.UpdateTaskGroupByMessageGroup = async function (groupInfo) {
            const messageGroupID = groupInfo.MessageGroupID;

            const allTaskGroup = await EChat.IndexedDB.GetTableDataByIndex(EChat.DBTableName.GROUPINFO, "GroupType", SocketUtil.GroupType.Task);
            const updateGroupArr = [];
            for (let i = 0; i < allTaskGroup.length; i++) {
                if (allTaskGroup[i].MessageGroupID.indexOf(`${messageGroupID}_`) > -1) {
                    const taskGroup = allTaskGroup[i];
                    taskGroup.DisplayName = groupInfo.DisplayName;
                    taskGroup.GroupName = groupInfo.GroupName;
                    taskGroup.Icon = groupInfo.Icon;
                    taskGroup.UserUpdated = groupInfo.UserUpdated;
                    taskGroup.TimeUpdated = groupInfo.TimeUpdated;
                    await EChat.MainPageController.redrawGroupEvent(taskGroup);
                    updateGroupArr.push(taskGroup);

                    if (EChat.MainPageController.checkMessageWindowExist(taskGroup.MessageGroupID)) {
                        const messageWindow = EChat.MainPageController.getMessageWindow(taskGroup.MessageGroupID);
                        const chatTab = messageWindow.chatTabList[taskGroup.MessageGroupID];
                        if (chatTab) {
                            chatTab.GroupInfo = taskGroup;
                            chatTab.updateGroupName();
                        }
                    }
                }
            }

            if (updateGroupArr.length !== 0) {
                const newGroupIDList = await EChat.IndexedDB.UpdateGroupInfo(updateGroupArr, false);
                EChat.IndexedDB.NoticeUpdate(EChat.DBTableName.GROUPINFO, newGroupIDList);
            }
        };

        this.UpdateGroupMessageReceive = async function (messageObj, isFromLocalStorage) {
            if (isFromLocalStorage) {
                return;
            }

            const messageGroupID = messageObj.MessageGroupID;
            const dataInfo = messageObj.DataInfo;
            if (messageGroupID && dataInfo?.Change) {
                if (dataInfo.Change === "Deleted") {
                    await _this.deleteGroupData(messageGroupID, true, true);
                } else if (dataInfo.Change === "Updated") {
                    let ExcludeMessage = true;
                    if (dataInfo.MergeGroup) {
                        await EChat.IndexedDB.DeleteTableDataByKey(EChat.DBTableName.GROUPINFO, messageGroupID, false);
                        ExcludeMessage = false;
                    }

                    const groupInfo = await EChat.DataProvider.GetGroupInfoByGroupID(messageGroupID, true, ExcludeMessage);
                    if (!groupInfo) {
                        return;
                    }

                    await _this.UpdateTaskGroupByMessageGroup(groupInfo);
                    if (EChat.MainPageController.checkMessageWindowExist(messageGroupID)) {
                        const messageWindow = EChat.MainPageController.getMessageWindow(messageGroupID);
                        const chatTab = messageWindow.chatTabList[messageGroupID];
                        if (chatTab) {
                            chatTab.GroupInfo = groupInfo;
                            chatTab.updateGroupName();
                            chatTab.refreshMessageList(groupInfo.Messages);
                        }
                    }

                    // Task 833748: Receive the first message of a new message group. Total unread messages not updated
                    setTimeout(() => {
                        EChat.MainPageController.updateUnreadSumCount("Group update");
                    }, 3000);
                }
            }
        };

        this.WriteStateReceive = function (data) {
            if (data.MessageGroupID && EChat.PageActive) {
                const windowExist = EChat.MainPageController.checkMessageWindowExist(data.MessageGroupID);
                if (windowExist) {
                    let SenderName = "";

                    if (data.DataInfo?.SenderFullName) {
                        SenderName = data.DataInfo.SenderFullName;
                    }
                    const writeStateName = document.querySelector(".writeStateName");
                    if (writeStateName) {
                        writeStateName.innerText = `${SenderName} ${EC_Fmt.Trn("Typing...")}`;
                    }
                    const eChatWriteState = document.querySelector(".eChatWriteState");
                    if (eChatWriteState) {
                        eChatWriteState.style.display = "block";
                    }
                    setTimeout(() => {
                        if (writeStateName) {
                            writeStateName.innerText = "";
                        }
                        if (eChatWriteState) {
                            eChatWriteState.style.display = "none";
                        }
                    }, 3000);
                }
            }
        };

        this.MessageRecalled = function (Data, isFromLocalStorage) {
            if (Data.SenderAuthenticationID && Data.SenderAuthenticationID > 0) {
                return;
            }

            const RecalledText = Data.MessageBody;
            const messageDom = document.getElementById(`message_${Data.MessageID}`);
            if (messageDom) {
                messageDom.innerHTML = RecalledText;
            }

            if (isFromLocalStorage) {
                return;
            }

            EChat.DataProvider.GetGroupInfoByGroupID(Data.MessageGroupID).then((groupInfo) => {
                if (!groupInfo || !groupInfo.Messages) {
                    return;
                }

                for (let i = 0; i < groupInfo.Messages.length; i++) {
                    const message = groupInfo.Messages[i];
                    if (message.MessageID === Data.MessageID) {
                        if (message.Message !== RecalledText) {
                            message.Message = RecalledText;
                            EChat.IndexedDB.UpdateGroupInfo([groupInfo], true).then(() => {
                                EChat.MainPageController.redrawGroupEvent(groupInfo);
                            });
                        }
                        break;
                    }
                }
            });
        };

        const messageExist = function (newMessage, groupInfo) {
            for (let i = 0; i < groupInfo.Messages.length; i++) {
                if (groupInfo.Messages[i].MessageID === newMessage.MessageID) {
                    return true;
                }
            }
            return false;
        };

        this.getGroupHistory = async function (viewMoreLastMessageTimeCreated) {
            let syncDate = parseInt(await EChat.IndexedDB.GetSetting("GroupHistorySyncDate"));
            if (!EC_Fmt.isNumber(syncDate)) {
                syncDate = 0;
            }
            let result = await EChat.IndexedDB.GetRecentGroupList(viewMoreLastMessageTimeCreated, syncDate);

            if (result?.Groups.length !== 0) {
                return result;
            }

            let data;
            try {
                data = await SocketUtil.api("GetGroupHistory2010", { LastSyncDate: syncDate });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                return null;
            }

            await EChat.IndexedDB.UpdateGroupObject({
                GroupInfos: data.MessageGroups,
                GroupUsers: data.GroupUsers,
                GroupMessages: data.Messages,
                GroupReads: data.GroupReads
            });

            await EChat.IndexedDB.UpdateSetting("GroupHistorySyncDate", data.LastSyncDate);

            result = await EChat.IndexedDB.GetRecentGroupList(syncDate, data.LastSyncDate);

            return result;
        };

        this.getMessageHistory = function (groupId, syncDate, savedMessageKey, limit) {
            return new Promise(((resolve) => {
                SocketUtil.api("GetMessagesHistory2006", {
                    MessageGroupID: groupId,
                    StartDate: 0,
                    EndDate: syncDate,
                    Limit: limit || EChat.Setting.MessageNumPerShow,
                    SavedMessageKey: savedMessageKey
                }).then((result) => {
                    if (result?.Messages) {
                        if (EChat.eChatState) {
                            const messageDic = {};
                            messageDic[groupId] = result.Messages;
                            EChat.IndexedDB.UpdateGroupMessages(messageDic, false, false);
                        }
                        resolve(result.Messages);
                    }
                }).catch();
            }));
        };

        this.getTaskDetailHistory = function (taskID, taskSourceEncompassID, savedTaskDetailID, endTaskDetailID, showError) {
            return new Promise(((resolve) => {
                // Task 921200: Task Detail showing in Task View but not in Task eChat View
                SocketUtil.api("GetTaskDetails", {
                    TaskID: taskID,
                    TaskSourceEncompassID: taskSourceEncompassID,
                    SavedTaskDetailID: savedTaskDetailID,
                    EndTaskDetailID: endTaskDetailID,
                    Limit: 10
                }).then((data) => {
                    if (showError && data.NoExist) {
                        EWS.Alert(`<span>${data.TaskTitle}</span>`);
                    }
                    // Task 1009651: Tasks in eChat taking users to encompasstech.com.
                    if (Distributor === taskSourceEncompassID && data.TaskTitle) {
                        const pattern = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
                        data.TaskTitle = data.TaskTitle.replace(pattern, window.location.host);
                    }
                    resolve(data);
                }).catch((e) => {
                    // Task 1041344: eChat: Opening Task eChat is not linking me to the task.
                    EChat.Util.errorAlert(e);
                    resolve(null);
                });
            }));
        };

        this.getGroupMessages = function (groupId) {
            return new Promise(((resolve) => {
                let msgList = [];
                if (groupId) {
                    _this.GetGroupInfoByGroupID(groupId).then((groupInfo) => {
                        if (groupInfo && Array.isArray(groupInfo.Messages)) {
                            msgList = groupInfo.Messages;
                        }
                        resolve(msgList);
                    });
                } else {
                    resolve(msgList);
                }
            }));
        };

        this.uploadUserAvatar = function (imageData) {
            _this.api("SalesComm_UploadUserAvatar", { ImageData: imageData.toString() }).then((data) => {
                EChat.IndexedDB.GetSetting("InitUser").then((jsonData) => {
                    if (jsonData && AuthenticationID === parseInt(jsonData.AuthenticationID) && jsonData.EncompassID === Distributor) {
                        jsonData.UserAvatar = data.Url;
                        SetInitUserData(jsonData);
                    } else {
                        GetInitUserDataByAjax().then((serverJsonData) => {
                            SetInitUserData(serverJsonData);
                        });
                    }
                });
            });
        };

        this.uploadGroupSetting = async function (editGroup, userInfo) {
            const oldGroupInfo = await EChat.DataProvider.GetGroupInfoByGroupID(editGroup.MessageGroupID);
            let result;
            try {
                result = await SocketUtil.api("EditGroup2006", editGroup);
            } catch (e) {
                return oldGroupInfo;
            }
            let displayMessage = "";
            const messageGroupID = result.MessageGroup.MessageGroupID;

            if (result.RemoveGroup) {
                EChat.DataProvider.deleteGroupData(result.RemoveGroup.MessageGroupID, false, false);
                await EChat.DataProvider.deleteGroupData(messageGroupID, true, false);
                EChat.MainPageController.updateUnReadNumIcon("RemoveGroup");
            } else {
                await EChat.IndexedDB.UpdateGroupInfo([result.MessageGroup]);

                if (result.GroupUsers) {
                    const groupUsers = {};
                    groupUsers[messageGroupID] = result.GroupUsers;
                    await EChat.IndexedDB.UpdateGroupUsers(groupUsers);
                }
            }

            if (result.RemoveUsers && result.AddUsers) {
                if (result.RemoveUsers.indexOf(AuthenticationID) > -1) {
                    await _this.deleteGroupData(messageGroupID, true, true);
                    return oldGroupInfo;
                }

                // Send Message Tip
                let addName = "";
                let changeCount = 0;
                for (let i = 0; i < result.AddUsers.length; i++) {
                    const user = userInfo[result.AddUsers[i]];
                    if (user && user?.Name) {
                        if (addName) {
                            addName += ", ";
                        }
                        addName += user.Name;
                        changeCount++;
                    }
                }

                if (addName) {
                    const word = changeCount > 1 ? "have" : "has";
                    displayMessage = `${addName} ${word} been added to this group.`;
                }

                let removeName = "";
                changeCount = 0;
                for (let i = 0; i < result.RemoveUsers.length; i++) {
                    const user = userInfo[result.RemoveUsers[i]];
                    if (user?.Name) {
                        if (removeName) {
                            removeName += ", ";
                        }
                        removeName += user.Name;
                        changeCount++;
                    }
                }

                if (removeName) {
                    const word = changeCount > 1 ? "have" : "has";
                    displayMessage += `${removeName} ${word} been deleted from this group.`;
                }
            }

            const newGroup = await EChat.DataProvider.GetGroupInfoByGroupID(messageGroupID);
            let oldGroupName = oldGroupInfo.GroupName;
            if (oldGroupName !== newGroup.GroupName) {
                if (!oldGroupName) {
                    oldGroupName = "Temp group";
                }
                if (newGroup.GroupName !== "") {
                    displayMessage += `${oldGroupName} has been named as ${newGroup.GroupName}.`;
                } else {
                    displayMessage += `Group name ${oldGroupName} has been removed.`;
                }
            }

            if (displayMessage) {
                await EChat.DataProvider.SendMessage({
                    messageGroupID,
                    messageMark: EChat.Util.getTimeStamp(),
                    messageBody: displayMessage
                });
                const windowExist = EChat.MainPageController.checkMessageWindowExist(messageGroupID);
                if (windowExist) {
                    EChat.MainPageController.currentMessageWindow.chatTabList[messageGroupID].closeEvent();
                    const groupInfoNew = await EChat.DataProvider.GetGroupInfoByGroupID(messageGroupID);
                    if (groupInfoNew && windowExist) {
                        // Task 1028228: echat error when adding members to a group.
                        await EChat.MainPageController.getMessageWindow(messageGroupID).addRecentTab(groupInfoNew, true);
                    }
                }
            }
            await EChat.MainPageController.redrawGroupEvent(newGroup);
            await _this.UpdateTaskGroupByMessageGroup(newGroup);

            return newGroup;
        };

        this.deleteGroupData = async function (groupId, close, updateUnRead) {
            await EChat.IndexedDB.DeleteTableDataByKey(EChat.DBTableName.GROUPINFO, groupId, close);
            if (close) {
                _this.dispatch(EChat.CustomEvent.DELETEGROUP, _this.createHandlerArgument(null, groupId));
            }

            if (groupId.indexOf("_") === -1) {
                const allTaskGroup = await EChat.IndexedDB.GetTableDataByIndex(EChat.DBTableName.GROUPINFO, "GroupType", SocketUtil.GroupType.Task);
                const taskGroupArr = [];
                for (let i = 0; i < allTaskGroup.length; i++) {
                    if (allTaskGroup[i].MessageGroupID.indexOf(`${groupId}_`) > -1) {
                        taskGroupArr.push(allTaskGroup[i].MessageGroupID);
                    }
                }
                if (taskGroupArr.length !== 0) {
                    for (let i = 0, len = taskGroupArr.length; i < len; i++) {
                        _this.dispatch(EChat.CustomEvent.DELETEGROUP, _this.createHandlerArgument(null, taskGroupArr[i]));
                        await EChat.IndexedDB.DeleteTableDataByKey(EChat.DBTableName.GROUPINFO, taskGroupArr[i], close);
                    }
                }
            }

            const updateGroupIDArr = [groupId];
            const allTaskGroup = await EChat.IndexedDB.GetTableDataByIndex(EChat.DBTableName.GROUPINFO, "GroupType", SocketUtil.GroupType.Task);
            for (let i = 0; i < allTaskGroup.length; i++) {
                const taskGroup = allTaskGroup[i];
                if (taskGroup.MessageGroupID.indexOf(`${groupId}_`) > -1) {
                    updateGroupIDArr.push(taskGroup.MessageGroupID);
                }
            }

            await EChat.IndexedDB.UpdateGroupUnread(updateGroupIDArr, 0, true);
            if (updateUnRead) {
                EChat.MainPageController.updateUnReadNumIcon("group delete");
            }
        };

        this.subScribeAlert = function (subScribeType, alertId, deliveryMethodStr) {
            _this.api("SalesComm_SubScribeAlert", {
                SubScribeType: subScribeType,
                AlertID: alertId,
                DeliveryMethod: deliveryMethodStr
            }).then(() => {
                // Alert
                EChat.IndexedDB.GetTableDataByKey(EChat.DBTableName.TABLEALERTS, parseInt(alertId)).then((alertInfo) => {
                    for (let i = 0, len = alertInfo.DeliveryMethodList.length; i < len; i++) {
                        const DeliveryMethod = alertInfo.DeliveryMethodList[i];
                        const deliveryMethodArr = deliveryMethodStr.toString().split(",");
                        for (let j = 0, len2 = deliveryMethodArr.length; j < len2; j++) {
                            if (DeliveryMethod === deliveryMethodArr[j]) {
                                alertInfo.DeliveryMethodList.splice(i, 1);
                            }
                        }
                    }
                    if (subScribeType === 1) {
                        alertInfo.DeliveryMethodList.push(deliveryMethodStr);
                    }
                    EChat.IndexedDB.UpdateTableAlert([alertInfo], true);
                });
            });
        };

        this.editGroupPromptType = async function (update) {
            const groupID = update.groupID;
            const taskID = update.taskID;

            const groupInfo = await EChat.DataProvider.GetGroupInfoByGroupID(groupID);

            if (groupInfo) {
                let prompt;
                if (groupInfo.Prompt === EChat.PromptType.DoNotDisturb) {
                    prompt = EChat.PromptType.Normal;
                } else {
                    prompt = EChat.PromptType.DoNotDisturb;
                }

                await SocketUtil.api("EditGroupPromptType", {
                    MessageGroupID: groupID,
                    PromptType: prompt
                });

                await EChat.IndexedDB.UpdateGroupInfo([{
                    MessageGroupID: groupID,
                    Prompt: prompt
                }], true);

                groupInfo.Prompt = prompt;
                await EChat.MainPageController.updateUnreadSumCount("EditGroupPromptType");
                await EChat.MainPageController.redrawGroupEvent(groupInfo);
                EChat.MainPageController.updatePromptIcon({ taskID, groupID, prompt });
                return prompt;
            }
            return null;
        };

        this.GetUnreadMessageGroups = async function () {
            let result = [];
            try {
                result = await SocketUtil.api("GetUnreadMessageGroups2010", null);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(`${e.ErrorCode} ${e.ErrorMessage}`);
            }

            return result;
        };

        this.GetCustomerGroup = async function (Search) {
            let result = [];
            try {
                result = await SocketUtil.api("GetCustomGroup", { Search });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e.ErrorCode + e.ErrorMessage);
            }

            return result;
        };

        this.GetGroupUserInfo = async function (groupId) {
            let userInfoList = [];
            const groupInfo = await _this.GetGroupInfoByGroupID(groupId);
            if (!groupInfo) {
                return userInfoList;
            }
            // Task 716973: eChat Groups: Group does not list group members
            if (!groupInfo.Users || groupInfo.Users.length < parseInt(groupInfo.UserCount) || groupInfo.Users.length === 0) {
                const userList = await SocketUtil.api("GetGroupUsers", {
                    MessageGroupID: groupId,
                    SenderSessionID: SocketUtil.getSessionID()
                });
                const userDic = {};
                userDic[groupId] = userList;
                await EChat.IndexedDB.UpdateGroupUsers(userDic);
                groupInfo.Users = userList;
            }

            if (groupInfo?.Users?.length !== 0) {
                userInfoList = await _this.GetUserInfo(groupInfo.Users);
                if (userInfoList.length < groupInfo.Users.length) {
                    const missUser = [];
                    for (let i = 0; i < userInfoList.length; i++) {
                        const user = userInfoList[i];
                        let j;
                        for (j = 0; j < groupInfo.Users.length; j++) {
                            if (parseInt(groupInfo.Users[j]) === parseInt(user.AuthenticationID)) {
                                break;
                            }
                        }

                        if (j === groupInfo.Users.length) {
                            missUser.push(user.AuthenticationID);
                        }
                    }

                    for (let i = 0; i < missUser.length; i++) {
                        userInfoList.push({
                            AuthenticationID: missUser[i],
                            Name: `None ${missUser[i]}`
                        });
                    }
                }
            }
            return userInfoList;
        };
    };
    return new EChatDataProviderClass();
}());

EChat.MainPageController = (function () {
    const MainPageControllerClass = function () {
        const _this = this;
        const eChatPageUrl = `BI/EChatView2109.html?v=${ECPVersion}`;

        let userPageController = null;
        let recentPageController = null;
        let customGroupPageController = null;
        let settingsPageController = null;
        let savedPageController = null;
        let subscribePageController = null;
        let currentDisplayController = null;
        // Task 1067218: DSDLink: eChat in the new Mobile Framework
        this.ClientOS = "";
        this.messageWindowList = [];
        this.currentMessageWindow = null;
        this.mainPageViewType = null;
        this.mainPageTab = null;
        this.userSearchHandle = null;
        this.chatWindowSize = {
            height: 233,
            width: 600
        };
        this.mainWindowSize = {
            height: 385,
            currHeight: 0
        };
        this.windowChangeThread = 0;
        // Task 1067218: DSDLink: eChat in the new Mobile Framework
        const adjustClient = function () {
            const device = navigator.userAgent.toLowerCase();
            if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(device)) {
                _this.ClientOS = "Mobile";
            } else {
                _this.ClientOS = "PC";
            }
        };

        const openView = function () {
            const EChatMainPage = document.getElementById("EChatMainPage");
            adjustClient();

            if (EChatMainPage) {
                if (EChat.eChatMoving) {
                    EChat.eChatMoving = false;
                }
                if (_this.mainPageViewType !== EChat.ViewType.OpenView) {
                    EChatMainPage.style.display = "block";
                    document.getElementById("EChatMainPageHead").style.display = "block";
                    document.getElementById("EChatMinimizeBtn").style.display = "block";
                    document.getElementById("EChatRefreshBtn").style.display = "block";
                    // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
                    document.getElementById("MinButtonSwitch").style.display = "block";
                    document.getElementById("MinButtonMin").style.display = "block";
                    document.getElementById("MinButtonMax").style.display = "block";
                    const EChatMaximizeBtn = document.getElementById("EChatMaximizeBtn");
                    EChatMainPage.classList.remove("minimize");
                    // Task 1067218: DSDLink: eChat in the new Mobile Framework
                    if (_this.ClientOS === "PC") {
                        document.getElementById("EChatMainPageContent").style.display = "flex";
                        if (EChatMaximizeBtn) {
                            EChatMaximizeBtn.style.display = "block";
                            document.querySelector("#EChatCloseBtn ecp-btn").setAttribute("style", "font-size:16px;");
                            document.getElementById("EChatCloseBtn").classList.remove("MinCloseBtn");
                        }
                        EChatMainPage.style.top = `${window.innerHeight - EChatMainPage.offsetHeight}px`;

                        _this.resizeMainPageWindow();
                        _this.mainPageViewType = EChat.ViewType.OpenView;
                    } else {
                        EChat.FullWindowController.FullWindow = true;
                        EChat.FullWindowController.ResizeFullWindow();
                        EChat.FullWindowController.ResizeMobileFullWindow();
                        document.getElementById("EChatMainPageContent").style.display = "flex";
                        _this.mainPageViewType = EChat.ViewType.OpenView;
                    }
                }
            } else {
                EChat.Setting.showView = true;
            }
            gtag("event", "openEChat");
        };

        const minimizeView = function () {
            if (EChat.eChatMoving) {
                EChat.eChatMoving = false;
            }
            if (_this.mainPageViewType !== EChat.ViewType.MinimizeView) {
                const EChatMainPage = document.getElementById("EChatMainPage");
                if (EChatMainPage) {
                    EChatMainPage.style.display = "block";
                    document.getElementById("EChatMainPageHead").style.display = "block";
                    document.getElementById("EChatMinimizeBtn").style.display = "none";
                    document.getElementById("EChatRefreshBtn").style.display = "none";
                    document.getElementById("EChatMainPageContent").style.display = "none";
                    // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
                    document.getElementById("MinButtonSwitch").style.display = "none";
                    document.getElementById("MinButtonMin").style.display = "none";
                    document.getElementById("MinButtonMax").style.display = "none";
                    const EChatMaximizeBtn = document.getElementById("EChatMaximizeBtn");
                    if (EChatMaximizeBtn) {
                        EChatMaximizeBtn.style.display = "none";
                        document.getElementById("EChatCloseBtn").classList.add("MinCloseBtn");
                        document.querySelector(".MinCloseBtn ecp-btn").setAttribute("style", "font-size:16px;width:26px;height:26px;");
                    }
                    EChatMainPage.classList.add("minimize");
                    EChatMainPage.style.top = `${window.innerHeight - EChatMainPage.offsetHeight}px`;
                    EChatMainPage.style.left = `${window.innerWidth - EChatMainPage.offsetWidth}px`;
                }
                _this.mainPageViewType = EChat.ViewType.MinimizeView;
            }
        };

        const refreshView = async function () {
            EChat.DataProvider.initUser();
            await EChat.MainPageController.updateUnreadSumCount("refreshView");
            EChat.IndexedDB.InitDBData(0, true);
            if (SocketUtil.GetSocketState() !== SocketUtil.SocketState.Connect) {
                EWS.VerifySession(() => {
                    SocketUtil.Reconnect();
                });
            }
        };

        this.updatePromptIcon = function (update) {
            const groupID = update.groupID;
            const taskID = update.taskID;
            const prompt = update.prompt;

            if (taskID) {
                return;
            }

            let alertClass;
            // lset editPromptTitle = "";
            if (prompt === EChat.PromptType.DoNotDisturb) {
                alertClass = "ews-icon-DisablesVoice";
                // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
                // editPromptTitle = "Unmute eChat Group";
            } else {
                alertClass = "ews-icon-alert";
                // editPromptTitle = "Mute eChat Group";
            }

            for (let i = 0, len = EChat.MainPageController.messageWindowList.length; i < len; i++) {
                const mainWindow = EChat.MainPageController.messageWindowList[i];
                const promptDom = mainWindow.editPrompt;
                const currentTab = mainWindow.currentTab;
                if (promptDom && currentTab?.GroupInfo?.MessageGroupID === groupID) {
                    // Task 1149732: Update 'eChat' page to new button component
                    promptDom.setAttribute("icon", "");
                    promptDom.setAttribute("icon", alertClass);
                }
                if (EChat.FullWindowController.FullWindow) {
                    const OldIcon = mainWindow.element.querySelector(`.mce-tinymce .ews-icon-alert`);
                    const NewIcon = mainWindow.element.querySelector(`.mce-tinymce .ews-icon-DisablesVoice`);
                    if (prompt === EChat.PromptType.DoNotDisturb) {
                        if (OldIcon) {
                            OldIcon.parentElement.parentElement.classList.add("hidden");
                        }
                        if (NewIcon) {
                            NewIcon.parentElement.parentElement.classList.remove("hidden");
                        }
                    } else {
                        if (OldIcon) {
                            OldIcon.parentElement.parentElement.classList.remove("hidden");
                        }
                        if (NewIcon) {
                            NewIcon.parentElement.parentElement.classList.add("hidden");
                        }
                    }
                }
            }

            const echatDom = document.getElementById(`eChatPrompt_echat_${groupID}`);
            if (echatDom) {
                echatDom.classList.remove("ews-icon-alert", "ews-icon-DisablesVoice");
                echatDom.classList.add(alertClass);
                echatDom.setAttribute("title", editPromptTitle);
            }
        };

        const closeView = function () {
            if (EChat.eChatMoving) {
                EChat.eChatMoving = false;
            }
            if (_this.mainPageViewType !== EChat.ViewType.CloseView) {
                document.getElementById("EChatMainPage").style.display = "none";
                _this.resizeMainPageWindow();
                _this.mainPageViewType = EChat.ViewType.CloseView;
            }
            if (EChat.FullWindowController.FullWindow) {
                if (EChat.MainPageController.messageWindowList.length) {
                    EChat.MainPageController.messageWindowList[0].closeMessageWindow();
                }
                EChat.FullWindowController.Destroy();
            }
            gtag("event", "closeEChat");
        };

        this.RefreshBtnColor = function (color, isFromLocalStorage) {
            if (color) {
                const EChatRefreshBtn = document.getElementById("EChatRefreshBtn");
                if (EChatRefreshBtn) {
                    EChatRefreshBtn.style.color = color;
                }

                if (!isFromLocalStorage) {
                    EChat.IndexedDB.UpdateSetting("RefreshBtnColor", { Color: color }, true);
                }
            }
        };

        this.loadEChatViewHtml = function () {
            return new Promise((resolve, reject) => {
                ECP.Tools.Ajax(eChatPageUrl, {
                    method: "GET"
                }).then((response) => {
                    response.text().then((htmlData) => {
                        if (document.getElementById("EChatMainPage")) {
                            reject();
                            return;
                        }

                        resolve(htmlData);
                    });
                }).catch((e) => {
                    EWS.VerifySession(() => {
                        EChat.eChatState = false;
                        reject(e);
                    });
                });
            });
        };

        this.ReloadEChatData = async function (alertText) {
            if (EChat.MainPageController) {
                EChat.MainPageController.closeAllWindow();
            }

            EChat.Util.removeEChat();

            await EChat.IndexedDB.ClearDateBase();
            await EChat.IndexedDB.UpdateSetting("EChatV2010", EChat.Util.getTimeStamp(), false);

            await EChat.Util.initEChat();
            if (alertText) {
                ECP.Dialog.Alert(alertText);
            }
            await EChat.IndexedDB.InitDBData(0, true);
        };

        this.initMainPage = function () {
            return new Promise((resolve, reject) => {
                _this.loadEChatViewHtml().then((htmlData) => {
                    const htmlDom = EC_Fmt.HtmlStrToElement(htmlData);
                    const htmlDomChildren = htmlDom.children.length;
                    for (let i = 0; i < htmlDomChildren; i++) {
                        document.querySelector("html > body").append(htmlDom.children[0]);
                    }

                    // Task 1031971: Server eChat strings are not Localized all in English
                    const transChar = document.querySelectorAll("body .eChatTrn");
                    const transPlaceholders = document.querySelectorAll(".inputTrn");
                    transChar.forEach((item) => {
                        item.innerText = EC_Fmt.Trn(item.innerText.trim());
                    });
                    transPlaceholders.forEach((t) => {
                        t.setAttribute("placeholder", EC_Fmt.Trn(t.getAttribute("placeholder")));
                    });

                    // Task 666790: eChat: Clearing Data on eChat clears all groups
                    EChat.eChatState = true;
                    if (EChat.Setting.showView) {
                        openView();
                    } else {
                        closeView();
                        EChat.Setting.showView = true;
                    }

                    EChat.Util.dragDialog({
                        dialog: document.getElementById("EChatMainPage"),
                        handle: document.getElementById("EChatMainPageHead"),
                        handleWidthFix: 0,
                        handleHeightFix: 0,
                        AllowSelection: true,
                        // scroll: false,
                        start(dom) {
                            dom.style.zIndex = EChat.Util.draggableZIndex();
                        },
                        stop(dom) {
                            dom.style.height = "auto";
                        }
                    });

                    // Navigation Button
                    document.getElementById("EChatButton").addEventListener("click", (e) => {
                        openView();
                        e.stopPropagation();
                    });

                    // MainPageHead
                    document.getElementById("EChatMainPageHead").addEventListener("click", () => {
                        if (EChat.eChatMoving) {
                            EChat.eChatMoving = false;
                        } else {
                            openView();
                        }
                    });

                    // Minimize Button
                    document.getElementById("EChatMinimizeBtn").parentNode.addEventListener("click", (e) => {
                        minimizeView();
                        e.stopPropagation();
                    });

                    // Maximize Button
                    const maxBtnParent = document.getElementById("EChatMaximizeBtn");
                    maxBtnParent.addEventListener("click", () => {
                        EChat.FullWindowController.SwichWindow();
                    });

                    // EChatRefresh Button
                    document.getElementById("EChatRefreshBtn").addEventListener("click", (e) => {
                        EChat.MainPageController.RefreshBtnColor("var(--neutral-70)");
                        refreshView();
                        e.stopPropagation();
                    });
                    // Close Button
                    document.getElementById("EChatCloseBtn").parentNode.addEventListener("click", (e) => {
                        closeView();
                        e.stopPropagation();
                    });
                    // Click to view Unread Message.
                    document.getElementById("EChatNewMsgNum").addEventListener("click", () => {
                        const EChatSearchText = document.getElementById("EChatSearchText");
                        EChatSearchText.value = "Unread";
                        EC_Fmt.TriggerEvent(EChatSearchText, "keyup");
                    });

                    // searchPanel
                    const EChatSearchDom = document.getElementById("EChatSearchText");
                    const SearchClearDom = document.querySelector("#EChatMainPageContent .eChat-SearchClear");
                    const searchFun = function (e) {
                        currentDisplayController.searchPanelKeyupEvent(e, EChatSearchDom, false);
                        if (EChatSearchDom.value) {
                            SearchClearDom.classList.remove("hidden");
                        } else {
                            SearchClearDom.classList.add("hidden");
                        }
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    };
                    EChatSearchDom.addEventListener("keyup", searchFun);
                    SearchClearDom.addEventListener("click", () => {
                        EChatSearchDom.value = "";
                        searchFun();
                    });

                    const EChatAlertSearchDom = document.getElementById("EChatAlertSearchText");
                    EChatAlertSearchDom.addEventListener("keyup", searchFun);
                    // switch tab
                    const clickTabEvent = function (e) {
                        clearTimeout(_this.userSearchHandle);

                        const tab = e.currentTarget.getAttribute("switch-tab");
                        e.currentTarget.classList.add("eChat-CurrentTab");
                        const children = document.querySelectorAll(".EChatMainPageHeadTop2 #EChatTabHead > .eChat-CurrentTab");
                        for (let i = 0; i < children.length; i++) {
                            if (children[i] !== e.currentTarget) {
                                children[i].classList.remove("eChat-CurrentTab");
                            }
                        }

                        const EChatDirectorySwitch = document.getElementById("EChatDirectorySwitch");
                        if (tab === "EChatDirectoryTab" || tab === "EChatGroupTab" || tab === "EChatUserTab") {
                            EChatDirectorySwitch.style.display = "flex";
                        } else {
                            EChatDirectorySwitch.style.display = "none";
                        }

                        if (tab === "EChatSavedTab") {
                            document.querySelector(".eChat-saved-sort-div").classList.remove("hidden");
                        } else {
                            document.querySelector(".eChat-saved-sort-div").classList.add("hidden");
                        }

                        const tabDiv = document.querySelectorAll("#EChatTabBody > div");
                        for (let i = 0; i < tabDiv.length; i++) {
                            if (tabDiv[i].getAttribute("tab") === tab) {
                                tabDiv[i].style.display = tabDiv[i].getAttribute("old-display");
                            } else {
                                tabDiv[i].style.display = "none";
                            }
                        }

                        const SearchClear = document.getElementById("EChatUserSearchClear");
                        if (SearchClear) {
                            EC_Fmt.TriggerEvent(SearchClear, "click");
                        }

                        EChat.MainPageController.ShowCreateGroupButton();
                    };
                    const listItems = document.querySelectorAll(".eChat-tab-head");
                    for (let i = 0, len = listItems.length; i < len; i++) {
                        listItems[i].addEventListener("click", clickTabEvent);
                    }

                    const EChatSearchText = document.getElementById("EChatSearchText");
                    const searchImage = document.querySelector("#EChatMainPageContent > .eChat-Search");
                    const EChatRecentSwitchBtn = document.getElementById("EChatRecentSwitchBtn");
                    EChatRecentSwitchBtn.addEventListener("click", (e) => {
                        // Task 649483: We should hide eChat Tasks until we can Chat from Tasks and view previous eChat Tasks
                        if (currentDisplayController !== recentPageController) {
                            currentDisplayController = recentPageController;
                        }

                        searchImage.style.display = "block";
                        EChatSearchText.value = "";
                        SearchClearDom.classList.add("hidden");
                        EChatSearchText.setAttribute("placeholder", EC_Fmt.Trn("Search Users, Groups, Messages, Tasks ..."));
                        EChatSearchText.removeAttribute("tab");
                        EChatSearchText.removeAttribute("selected");
                        document.getElementById("EChatRecentList").removeAttribute("tab");
                        document.getElementById("EChatRecentList").innerHTML = "";

                        if (typeof e.isTrigger === "undefined") {
                            EChatSearchText.focus();
                        }

                        currentDisplayController.searchPanelKeyupEvent(null, EChatSearchText, true);
                        document.getElementById("EChatRecentList").scrollTop = 0;
                        _this.mainPageTab = "Recents";
                    });

                    document.getElementById("EChatDirectoryTab").addEventListener("click", () => {
                        EC_Fmt.TriggerEvent(document.getElementById("EChatUserSwitchBtn"), "click");
                    });

                    document.getElementById("EChatUserSwitchBtn").addEventListener("click", async () => {
                        document.getElementById("EChatDirectoryTab").classList.add("eChat-CurrentTab");
                        document.getElementById("EChatGroupSwitchBtn").classList.remove("active");
                        document.getElementById("EChatUserSwitchBtn").classList.add("active");

                        if (currentDisplayController !== userPageController) {
                            currentDisplayController = userPageController;
                        } else {
                            return;
                        }
                        _this.mainPageTab = "Users";

                        EChatSearchText.value = "";
                        SearchClearDom.classList.add("hidden");
                        EChatSearchText.setAttribute("placeholder", EC_Fmt.Trn("Search Users, Job Title, Department ..."));

                        searchImage.style.display = "block";
                        EChatSearchText.focus();

                        // SetDefaultUser
                        if (!EChatSearchText.value) {
                            const recentList = await EChat.IndexedDB.GetTableAllData(EChat.DBTableName.GROUPINFO);
                            const groupList = [];

                            for (let i = 0; i < recentList.length; i++) {
                                if (recentList[i].UserCount === 2 && recentList[i].Users && recentList[i].Users.length === 2 && recentList[i].Messages && recentList[i].Messages.length !== 0) {
                                    groupList.push(recentList[i]);
                                }
                            }

                            if (groupList?.length !== 0) {
                                groupList.sort((a, b) => EChat.IndexedDB.GetGroupSortTime(b) - EChat.IndexedDB.GetGroupSortTime(a));
                            }

                            const userArr = [];
                            for (let i = 0; i < groupList.length; i++) {
                                const authID1 = groupList[i].Users[0];
                                const authID2 = groupList[i].Users[1];
                                if (!EChat.DataProvider.IsCurrentUser(authID1) && !userArr.includes(authID1)) {
                                    userArr.push(authID1);
                                } else if (!EChat.DataProvider.IsCurrentUser(authID2) && !userArr.includes(authID1)) {
                                    userArr.push(authID2);
                                }

                                if (userArr.length >= 10) {
                                    break;
                                }
                            }

                            EChatSearchText.setAttribute("default-user", userArr.join(","));
                            userPageController.searchPanelKeyupEvent(null, null, true);
                        }
                    });

                    document.getElementById("EChatGroupSwitchBtn").addEventListener("click", async (e) => {
                        document.getElementById("EChatDirectoryTab").classList.add("eChat-CurrentTab");
                        e.currentTarget.classList.add("active");
                        document.getElementById("EChatUserSwitchBtn").classList.remove("active");

                        if (currentDisplayController !== customGroupPageController) {
                            currentDisplayController = customGroupPageController;
                        } else {
                            return;
                        }
                        _this.mainPageTab = "Groups";

                        EChatSearchText.setAttribute("placeholder", EC_Fmt.Trn("Search Groups"));
                        EChatSearchText.value = "";
                        SearchClearDom.classList.add("hidden");
                        searchImage.style.display = "block";

                        if (typeof e.isTrigger === "undefined") {
                            EChatSearchText.focus();
                        }
                        if (currentDisplayController) {
                            currentDisplayController.searchPanelKeyupEvent(null, "", true);
                        }
                        document.getElementById("EChatGroupList").scrollTop = 0;
                    });

                    document.getElementById("EChatSettingSwitchBtn").addEventListener("click", () => {
                        if (currentDisplayController !== settingsPageController) {
                            currentDisplayController = settingsPageController;
                        } else {
                            return;
                        }
                        const EChatSettingsTab = document.getElementById("EChatSettingsList");
                        if (!EChatSettingsTab) {
                            return;
                        }

                        EChatSettingsTab.style.display = "block";
                        searchImage.style.display = "none";
                        EChat.Util.Loading(true);
                        EChat.DataProvider.api("SalesComm_EChat_GetTableAlertsData").then((data) => {
                            EChat.IndexedDB.UpdateTableAlert(data.TableAlert, true).then(() => {
                                // Task 744404: JavaScript Error: includes/DefaultAll.min.js (1) - Uncaught TypeError: Cannot read property 'style' of null
                                if (subscribePageController) {
                                    subscribePageController.drawTableAlerts(data.TableAlert);
                                }
                                EChat.Util.Loading(false);
                            });
                        }).catch(() => {
                            EChat.Util.Loading(false);
                        });
                    });

                    document.getElementById("EChatSavedTab").addEventListener("click", (e) => {
                        if (currentDisplayController !== savedPageController) {
                            currentDisplayController = savedPageController;
                        } else {
                            return;
                        }
                        const EChatSavedTab = document.getElementById("EChatSavedList");
                        if (!EChatSavedTab) {
                            return;
                        }

                        EChatSavedTab.style.display = "block";
                        searchImage.style.display = "block";

                        _this.mainPageTab = "Saved";

                        EChatSearchText.setAttribute("placeholder", EC_Fmt.Trn("Search Saved Messages"));
                        EChatSearchText.value = "";

                        if (typeof e.isTrigger === "undefined") {
                            EChatSearchText.focus();
                        }
                        if (currentDisplayController) {
                            currentDisplayController.searchPanelKeyupEvent(null, "", true);
                        }
                        document.getElementById("EChatSavedList").scrollTop = 0;
                    });

                    document.querySelectorAll(".eChat-Settings-Title").forEach((dom) => {
                        dom.addEventListener("click", () => {
                            const className = dom.getAttribute("content");
                            document.querySelectorAll(`#EChatSettingsList .${className}`).forEach((content) => {
                                if (content.classList.contains("hidden")) {
                                    content.classList.remove("hidden");
                                } else {
                                    content.classList.add("hidden");
                                }
                            });
                        });
                    });

                    // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
                    EWS.Command.AddMenu("eChat-advanced-search", async (control, name, menu, callback) => {
                        await EChat.CustomComponent.InitUserSearchMenu(menu);
                        callback(control, menu);
                    }, (control, name, menu, arg) => {
                        let searchBtn = menu.querySelector("#EChatUserSearchBtn");
                        EC_Fmt.RemoveAllEventListeners(searchBtn);
                        searchBtn = menu.querySelector("#EChatUserSearchBtn");
                        searchBtn.addEventListener("click", () => {
                            const searchDom = arg.SearchDom;
                            let searchKey = "";
                            if (searchDom) {
                                if (searchDom === "eChat-advanced-search-btn") {
                                    searchKey = EChatSearchDom.value;
                                } else if (searchDom === "advancedBtn") {
                                    searchKey = document.getElementById("EChatGroupUserSearchText").value;
                                }
                            }
                            EChat.CustomComponent.UserSearch({
                                All: false,
                                UserTypeID: menu.querySelector("#EChatSelectUserType input[type='hidden']").value,
                                LocationID: menu.querySelector("#EChatSelectLocation input[type='hidden']").value,
                                RoleID: menu.querySelector("#EChatSelectRole input[type='hidden']").value,
                                Search: searchKey || "",
                                Container: arg.Container,
                                ClickCallBack: arg.ClickCallBack,
                                Mark: arg.Mark,
                                NotInArr: arg.NotInArr,
                                ShowUserType: arg.ShowUserType,
                                ShowFilters: arg.ShowFilters,
                                HiddenCreateGroupBtn: false
                            });
                            EWS.Command.HideMenu("eChat-advanced-search");
                        });
                    });

                    // InitWindowResize
                    oldmainpageW = window.innerWidth;
                    oldmainpageH = window.innerHeight;
                    EChat.Util.windowResizeListener();

                    // Init Controller
                    userPageController = new EChat.UserController();
                    recentPageController = new EChat.RecentController();
                    customGroupPageController = new EChat.CustomGroupController();
                    settingsPageController = new EChat.SettingsController();
                    savedPageController = new EChat.SavedController();
                    subscribePageController = new EChat.SubscribeController();
                    currentDisplayController = recentPageController;

                    // Bind Event
                    userPageController.InitSearch();

                    EChat.DataProvider.bind(EChat.CustomEvent.REDRAWTABLEALERTS, redrawTableAlerts);
                    EChat.DataProvider.bind(EChat.CustomEvent.DELETEGROUP, deleteGroupEvent);
                    resolve();

                    const stateStr = EChat.LocalStorage.readLocalStorage("SocketState");
                    if (stateStr?.split("_")[0]) {
                        EChat.WebSocket.UpdateEChatState(stateStr.split("_")[0]);
                    }

                    EChat.IndexedDB.GetSetting("RefreshBtnColor").then((SettingValue) => {
                        if (SettingValue) {
                            EChat.MainPageController.RefreshBtnColor(SettingValue.Color, true);
                        }
                    });

                    EChat.IndexedDB.GetSetting("ChatSize").then((SettingValue) => {
                        if (SettingValue && EChat.MainPageController) {
                            EChat.MainPageController.chatWindowSize = SettingValue;
                        }
                    });
                    // Task 1067218: DSDLink: eChat in the new Mobile Framework
                    adjustClient();
                    if (EChat.FullWindowController.FullWindow && _this.ClientOS === "PC") {
                        EChat.FullWindowController.ResizeTextArea();
                    } else {
                        EChat.IndexedDB.GetSetting("MainSize").then((SettingValue) => {
                            if (SettingValue && EChat.MainPageController) {
                                EChat.MainPageController.mainWindowSize = SettingValue;
                                let height = parseInt(SettingValue.height);
                                if (!EC_Fmt.isNumber(height)) {
                                    height = EChat.__height;
                                }
                                EChatMainPage.style.setProperty("--height", `${height}px`);
                                _this.resizeDialog();
                            }
                        });
                    }

                    let oldHeight;
                    let oldTop;
                    const mainPage = document.getElementById("EChatMainPage");

                    EChat.Util.dragResize({
                        resizeDirection: "s",
                        handle: document.querySelector(".eChat-ResizeHandle.eChat-Main-S"),
                        start: () => {
                            oldHeight = parseInt(mainPage.style.getPropertyValue("--height").replace("px", ""));
                            if (!EC_Fmt.isNumber(oldHeight)) {
                                oldHeight = EChat.MainPageController.mainWindowSize.height;
                            }
                            if (!EC_Fmt.isNumber(oldHeight)) {
                                oldHeight = EChat.__height;
                            }

                            oldTop = mainPage.getBoundingClientRect().top;
                        },
                        move: ({ AbsoluteHeight }) => {
                            const minHeight = EChat.__height;
                            if (oldHeight - AbsoluteHeight <= minHeight) {
                                AbsoluteHeight = oldHeight - minHeight;
                            }

                            EChat.MainPageController.mainWindowSize.height = oldHeight - AbsoluteHeight;
                            EChat.MainPageController.mainWindowSize.currHeight = 0;

                            if (AbsoluteHeight) {
                                mainPage.style.top = `${oldTop + AbsoluteHeight}px`;
                                _this.resizeDialog();
                            }
                        },
                        end: () => {
                            EChat.IndexedDB.UpdateSetting("MainSize", {
                                height: EChat.MainPageController.mainWindowSize.height
                            });
                        }
                    });
                }).catch((e) => {
                    reject(e);
                });
            });
        };

        this.ShowCreateGroupButton = function (itemid) {
            const selectArr = [];
            if (itemid) {
                document.querySelectorAll(`#${itemid} input:checked`).forEach((dom) => {
                    selectArr.push(dom.getAttribute("authid"));
                });
            }

            const EChatCreateGroup = document.getElementById("EChatCreateGroup");
            const EChatMainPageContent = document.getElementById("EChatMainPageContent");

            const selectAuthID = document.getElementById("EChatSearchText").getAttribute("selected");
            if (selectAuthID) {
                const arr = selectAuthID.split(",");
                for (let i = 0; i < arr.length; i++) {
                    if (!selectArr.includes(arr[i])) {
                        selectArr.push(arr[i]);
                    }
                }
            }
            const selectLength = selectArr.length;
            if (selectLength > 0) {
                EChatCreateGroup.textContent = selectLength === 1 ? EC_Fmt.Trn("Create Message") : EC_Fmt.Trn("Create Group");
                EChatCreateGroup.setAttribute("itemid", itemid);
                EChatMainPageContent.classList.add("UserSelected");
            } else {
                EChatMainPageContent.classList.remove("UserSelected");
                EChatCreateGroup.removeAttribute("itemid");
            }
        };

        const deleteGroupEvent = function (data) {
            const MessageGroupID = data.data;
            if (EChat.MainPageController.checkMessageWindowExist(MessageGroupID)) {
                _this.currentMessageWindow.chatTabList[MessageGroupID].closeEvent();
            }
            recentPageController.deleteGroup(MessageGroupID);
            customGroupPageController.deleteGroup(MessageGroupID);
        };

        this.redrawGroupEvent = async function (groupData) {
            if (!recentPageController) {
                return;
            }

            let flag;
            if (groupData) {
                if (EChat.MainPageController.checkMessageWindowExist(groupData.MessageGroupID)) {
                    const groupID = _this.currentMessageWindow.currentTab.GroupInfo.MessageGroupID;
                    if (groupID === groupData.MessageGroupID) {
                        flag = true;
                    } else {
                        flag = false;
                    }
                    if (_this.currentMessageWindow.messageWindowViewType !== EChat.ViewType.OpenView) {
                        flag = false;
                    }
                } else {
                    flag = false;
                }

                if (groupData.GroupType === SocketUtil.GroupType.Message || groupData.GroupType === SocketUtil.GroupType.Task || groupData.GroupType === SocketUtil.GroupType.System) {
                    await recentPageController.redrawGroup(groupData, flag);
                    if (groupData.GroupName) {
                        customGroupPageController.redrawCustomGroup(groupData);
                    } else {
                        const customGroup = document.getElementById(`CustomGroup${groupData.MessageGroupID}`);
                        if (customGroup) {
                            customGroup.remove();
                        }
                    }
                }
                EChat.MainPageController.updateUnReadNumIcon("redrawGroupEvent");
            }
        };

        this.dataCompleteEvent = async function (data) {
            if (!EChat.InitDataing) {
                EChat.Util.Loading(false);
            }

            if (EChat.eChatState && userPageController && customGroupPageController && recentPageController) {
                await recentPageController.initViewMore(data.Recent);
            }
            EChat.MainPageController.updateUnReadNumIcon("dataCompleteEvent");
            await EChat.MainPageController.refreshSavedMessage();
        };

        const redrawTableAlerts = function () {
            const dataList = document.querySelector("#EChatSubscribeList .eChat-DataList");
            if (dataList) {
                dataList.remove();
            }
            EChat.IndexedDB.GetTableAllData(EChat.DBTableName.TABLEALERTS).then((alertInfoList) => {
                subscribePageController.drawTableAlerts(alertInfoList);
            });
        };
        // Task 689770: Call Manager: Availability not working bases on the CallStatus.
        this.redrawUserAvailability = function (AuthID, Availability) {
            if (AuthID && parseInt(AuthID) > 0) {
                const ClassAndColor = EChat.DataProvider.GetUserAvailabilityClassAndColor(Availability);
                if (ClassAndColor && parseInt(AuthID) === AuthenticationID) {
                    const icon = document.querySelector("#ews-status-display .ews-icon-phone");
                    if (icon) {
                        icon.style.color = ClassAndColor.Color;
                    }
                }
            }
        };

        this.removeEChatView = function () {
            EChat.DataProvider.unbind(EChat.CustomEvent.DELETEGROUP, deleteGroupEvent);
            // Task 717267: EChat.js:3498 Uncaught (in promise) TypeError: Cannot read property 'drawTableAlerts' of null
            EChat.DataProvider.unbind(EChat.CustomEvent.REDRAWTABLEALERTS, redrawTableAlerts);

            userPageController = null;
            recentPageController = null;
            customGroupPageController = null;
            settingsPageController = null;
            savedPageController = null;
            subscribePageController = null;
            currentDisplayController = null;
            _this.currentMessageWindow = null;

            EChat.MainPageController.closeAllWindow();

            const EChatMainPage = document.getElementById("EChatMainPage");
            if (EChatMainPage) {
                EChatMainPage.remove();
            }
            changeBrowserImage("EChatLogo", "EncompassIcon");
            _this.mainPageIsShow = false;
            _this.mainPageViewType = EChat.ViewType.CloseView;
            EChat.eChatState = false;
            EChat.CopyMessageController.ClearCopyMessageDialog();
        };

        this.playAudioAlters = function () {
            if (EChat.DataProvider.CurrentUserInfo.AudioAlert === 1) {
                let audioElement = document.getElementById("eChatSoundAlert");
                if (!audioElement) {
                    audioElement = EChat.MainPageController.initSoundAlert();
                }

                audioElement.play().catch(() => {
                    // Task 663163: The play() request was interrupted by a call to pause()
                });
            }
        };

        this.addSavedMessage = function (SavedMessage) {
            savedPageController.addSavedMessage(SavedMessage);
        };

        this.cancelSavedMessage = function (SavedMessage) {
            savedPageController.cancelSavedMessage(SavedMessage);
        };

        this.refreshSavedMessage = async function () {
            if (!EChat.DataProvider.SavedMessage) {
                const settingSaved = await EChat.IndexedDB.GetSetting("SavedMessages");
                if (settingSaved) {
                    EChat.DataProvider.SavedMessage = settingSaved;
                } else {
                    return;
                }
            }

            document.querySelectorAll(".ChattingBox .saved-message-icon").forEach((dom) => {
                if (EChat.DataProvider.SavedMessage.includes(dom.getAttribute("savedkey"))) {
                    dom.style.display = "inline-block";
                    dom.classList.add("ews-icon-collection");
                    dom.classList.remove("ews-icon-uncollection");
                } else {
                    dom.style.display = "";
                    dom.classList.add("ews-icon-uncollection");
                    dom.classList.remove("ews-icon-collection");
                }
            });

            // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
            document.querySelectorAll(".UserUnit .recent-saved-btn ecp-btn").forEach((dom) => {
                if (EChat.DataProvider.SavedMessage.includes(dom.getAttribute("savedkey"))) {
                    dom.setAttribute("icon", "ews-icon-collection");
                } else {
                    dom.setAttribute("icon", "ews-icon-uncollection");
                }
            });
        };

        this.updateUserSetting = function (settingType, settingValue, isFromLocalStorage) {
            if (settingsPageController) {
                settingsPageController.updateSettings(settingType, settingValue, isFromLocalStorage);
            }
        };

        this.checkMessageWindowExist = function (groupId) {
            let tabExist = false;
            for (let i = 0; i < _this.messageWindowList.length; i++) {
                if (_this.messageWindowList[i].chatTabList[groupId]) {
                    _this.currentMessageWindow = _this.messageWindowList[i];
                    tabExist = true;
                    break;
                }
            }
            return tabExist;
        };

        this.getMessageWindow = function (groupId) {
            let needCreate = true;
            if (_this.currentMessageWindow) {
                if (_this.checkMessageWindowExist(groupId)) {
                    needCreate = false;
                } else if (EChat.FullWindowController.FullWindow && _this.messageWindowList.length !== 0) {
                    needCreate = false;
                    const messageWindow = _this.messageWindowList[0];
                    if (messageWindow.tabWidth < EChat.Setting.minTabWidth) {
                        let lastTabTime = 0;
                        let closeTab = null;
                        Object.keys(messageWindow.chatTabList).forEach((key) => {
                            const tab = messageWindow.chatTabList[key];
                            if (lastTabTime === 0 || tab.TabCreateTime < lastTabTime) {
                                lastTabTime = tab.TabCreateTime;
                                closeTab = tab;
                            }
                        });
                        if (closeTab) {
                            closeTab.closeEvent();
                        }
                    }
                    _this.currentMessageWindow = _this.messageWindowList[0];
                } else if (!EChat.FullWindowController.FullWindow) {
                    for (let i = 0; i < _this.messageWindowList.length; i++) {
                        if (_this.messageWindowList[i].chatTabListCount < EChat.Setting.TabNumPerWindow) {
                            _this.currentMessageWindow = _this.messageWindowList[i];
                            needCreate = false;
                            break;
                        }
                    }
                }
            }

            if (needCreate) {
                _this.addMessageWindow();
            }
            return _this.currentMessageWindow;
        };

        this.addMessageWindow = function () {
            _this.currentMessageWindow = new EChat.MessageWindowController();
            _this.currentMessageWindow.createMessageWindow();
            _this.messageWindowList.push(_this.currentMessageWindow);
            changeBrowserImage("EncompassIcon", "EChatLogo");
            if (typeof (EChat.MainPageController.NewWindowEvent) === "function") {
                EChat.MainPageController.NewWindowEvent(_this.currentMessageWindow);
            }
        };

        this.removeMessageWindow = function (msgWindowController) {
            for (let i = 0; i < _this.messageWindowList.length; i++) {
                if (_this.messageWindowList[i] === msgWindowController) {
                    _this.messageWindowList[i] = null;
                    _this.messageWindowList.splice(i, 1);
                    _this.currentMessageWindow = _this.messageWindowList[_this.messageWindowList.length - 1];
                    break;
                }
            }
            if (_this.messageWindowList.length === 0) {
                changeBrowserImage("EChatLogo", "EncompassIcon");
            }
        };

        const changeBrowserImage = function (oldName, newName) {
            // shortcut icon is currently base64 This feature is affected
            const browserImage = document.querySelector("link[rel='shortcut icon']");
            if (browserImage) {
                const imgLink = browserImage.getAttribute("href").replace(oldName, newName);
                browserImage.remove();

                const newLinkElement = EC_Fmt.HtmlStrToElement(`<link rel='shortcut icon'href='${imgLink}'>`);
                document.querySelector("head").append(newLinkElement);
            }
        };

        this.removeGroupsTabView = function (groupId) {
            if (customGroupPageController) {
                customGroupPageController.deleteGroup(groupId);
            }
        };

        this.openUserWindowByUserArr = function (userArr) {
            const userStr = EChat.DataProvider.GetUserStrByUserList(userArr);
            EChat.DataProvider.GetGroupInfoByAuthIDList(userStr).then((groupInfo) => {
                EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, false);
            }).catch(() => {
            });
        };

        let oldmainpageW = window.innerWidth;
        let oldmainpageH = window.innerHeight;
        this.resizeMainPageWindow = function () {
            const mainpage = document.getElementById("EChatMainPage");
            if (!mainpage || !mainpage.clientWidth) {
                return;
            }

            if (!EChat.FullWindowController.FullWindow) {
                const limitLeft = EChat.Util.getMenuWidth();
                const limitTop = EChat.Util.getHeaderHeight();
                let rect = mainpage.getBoundingClientRect();
                let changeHeight = oldmainpageH - window.innerHeight;

                if (rect.bottom >= window.innerHeight) {
                    changeHeight = rect.bottom - window.innerHeight;
                }

                if (rect.top - changeHeight < limitTop) {
                    changeHeight = rect.top - limitTop;
                }
                mainpage.style.top = `${rect.top - changeHeight}px`;

                let changeWidth = oldmainpageW - window.innerWidth;
                if (rect.left - changeWidth < limitLeft) {
                    changeWidth = rect.left - limitLeft;
                }

                rect = mainpage.getBoundingClientRect();
                mainpage.style.left = `${Math.min(rect.left - changeWidth, window.innerWidth - rect.width)}px`;
                oldmainpageH = window.innerHeight;
                oldmainpageW = window.innerWidth;

                _this.resizeDialog();
            } else {
                EChat.FullWindowController.ResizeFullWindow();
            }
        };

        this.receiveTaskDetail = async function (message) {
            const key = `${message.TaskSourceEncompassID}_${message.TaskID}`;
            const groupInfo = await EChat.DataProvider.GetGroupInfoByGroupID(key);
            if (!groupInfo) {
                return;
            }

            if (EChat.PageActive) {
                if (EChat.MainPageController.checkMessageWindowExist(key)) {
                    const messageWindow = EChat.MainPageController.getMessageWindow(key);
                    const chatTab = messageWindow.chatTabList[key];
                    if (chatTab && messageWindow.currentTab === chatTab) {
                        chatTab.GroupInfo = groupInfo;
                        chatTab.updateGroupName();
                        chatTab.refreshMessageList([message]);
                    }
                }
            }

            if (EChat.eChatState && !EChat.Util.IsRecentSearchState()) {
                _this.redrawGroupEvent(groupInfo);
            }
        };

        this.unReadDataChange = function (unReadData) {
            const updateUI = function (MessageGroupID, UnReadCount, Prompt, GroupType) {
                if (EChat.eChatState) {
                    // Task 1052118: Better distinguish whether the messages of the Echat Saved page belong to a group or a task.
                    document.querySelectorAll(`#EChatRecentList #Unread_${MessageGroupID}, #EChatSavedList #Unread_${MessageGroupID}`).forEach((unReadElement) => {
                        if (GroupType === SocketUtil.GroupType.Task) {
                            unReadElement.setAttribute("new", "true");
                        } else {
                            unReadElement.innerText = UnReadCount;
                            unReadElement.setAttribute("new", "true");
                            if (parseInt(Prompt) === EChat.PromptType.DoNotDisturb) {
                                unReadElement.style.background = "var(--neutral-50)";
                            } else {
                                unReadElement.style.background = "";
                            }
                        }
                        if (UnReadCount) {
                            unReadElement.style.display = "block";
                        } else {
                            unReadElement.style.display = "none";
                        }
                    });
                }
            };

            document.querySelectorAll("#EChatTabBody .echat-unread-count").forEach((dom) => {
                dom.setAttribute("new", "false");
            });

            if (unReadData.RecentGroup) {
                Object.keys(unReadData.RecentGroup).forEach((MessageGroupID) => {
                    const readInfo = unReadData.RecentGroup[MessageGroupID];
                    updateUI(MessageGroupID, readInfo.UnReadCount, readInfo.Prompt, readInfo.GroupType);
                });
            }

            EChat.IndexedDB.GetSetting("UnreadGroup").then((unreadMessageGroups) => {
                if (!unreadMessageGroups) {
                    return;
                }
                const redRecentDotElement = document.querySelector("#EChatRecentSwitchBtn .MessageTip");
                if (redRecentDotElement) {
                    if (Object.keys(unreadMessageGroups).length !== 0) {
                        redRecentDotElement.style.display = "block";
                    } else {
                        redRecentDotElement.style.display = "none";
                    }
                }
            });

            const unreadCounts = document.querySelectorAll("#EChatTabBody .echat-unread-count");
            for (let i = 0, len = unreadCounts.length; i < len; i++) {
                const unreadCount = unreadCounts[i];
                if (unreadCount.getAttribute("new") === "false") {
                    unreadCount.innerText = "";
                    unreadCount.style.display = "none";
                }
                unreadCount.removeAttribute("new");
            }
        };

        this.updateUnReadNumIcon = function (memo) {
            if (SocketUtil.debug) {
                // eslint-disable-next-line no-console
                console.log(`Update Unread Count. ${memo}`);
            }
            EChat.IndexedDB.GetTableAllData(EChat.DBTableName.GROUPINFO).then((groupList) => {
                EChat.IndexedDB.GetSetting("UnreadGroup").then((unreadMessageGroups) => {
                    if (!unreadMessageGroups) {
                        return;
                    }
                    const RecentGroup = {};
                    for (let i = 0; i < groupList.length; i++) {
                        const groupInfo = groupList[i];
                        let unReadCount = parseInt(groupInfo.UnReadCount);
                        if (unReadCount === 0 && unreadMessageGroups && unreadMessageGroups[groupInfo.MessageGroupID]) {
                            unReadCount = parseInt(unreadMessageGroups[groupInfo.MessageGroupID]);
                        }

                        delete unreadMessageGroups[groupInfo.MessageGroupID];

                        if (unReadCount > 0) {
                            const Prompt = !EC_Fmt.isNumber(parseInt(groupInfo.Prompt)) ? EChat.PromptType.Normal : parseInt(groupInfo.Prompt);
                            RecentGroup[groupInfo.MessageGroupID] = {
                                UnReadCount: unReadCount,
                                Prompt,
                                GroupType: groupInfo.GroupType
                            };
                        }
                    }

                    // Task 955166: eChat: Viewing one unread eChat is removing the unread notification from other eChats
                    const groupIdArr = Object.keys(unreadMessageGroups);
                    for (let i = 0; i < groupIdArr.length; i++) {
                        const groupId = groupIdArr[i];
                        RecentGroup[groupId] = {
                            UnReadCount: unreadMessageGroups[groupId],
                            Prompt: EChat.PromptType.Normal,
                            GroupType: groupId.split("_").length === 2 ? SocketUtil.GroupType.Task : SocketUtil.GroupType.Message
                        };
                    }

                    const unReadData = {
                        RecentGroup
                    };

                    _this.unReadDataChange(unReadData);
                    EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.UNREADDATA, JSON.stringify(unReadData));
                });
            });
        };

        this.updateUnreadSumCount = async function (memo) {
            if (SocketUtil.debug) {
                // eslint-disable-next-line no-console
                console.log(`Update Unread Sum Count. ${memo}`);
            }

            const unreadMessageGroups = await EChat.DataProvider.GetUnreadMessageGroups();
            await EChat.IndexedDB.UpdateSetting("UnreadGroup", unreadMessageGroups, true);
            _this.unreadSumCountChange(unreadMessageGroups);
        };

        this.unreadSumCountChange = async function (unreadMessageGroups) {
            if (!unreadMessageGroups) {
                unreadMessageGroups = await EChat.IndexedDB.GetSetting("UnreadGroup");
            }

            let num = 0;
            if (unreadMessageGroups) {
                num = Object.keys(unreadMessageGroups).length;
            }

            num = num > 99 ? "99+" : num;
            const EChatTitleNewMsgNum = document.getElementById("EChatTitleNewMsgNum");
            const EChatMsgTip = document.getElementById("EChatMsgTip");
            const EChatNewMsgNum = document.getElementById("EChatNewMsgNum");
            const EChatNewMsgTip = document.getElementById("EChatNewMsgTip");

            if (num > 0 || num === "99+") {
                if (EChatTitleNewMsgNum) {
                    EChatTitleNewMsgNum.style.display = "block";
                }
                if (EChatNewMsgTip) {
                    EChatNewMsgTip.innerText = EC_Fmt.Trn(` new eChat${(num > 1 ? "s" : "")}`);
                }
                if (EChatNewMsgNum) {
                    EChatNewMsgNum.innerText = ` ${num} `;
                }
                if (EChatTitleNewMsgNum) {
                    EChatTitleNewMsgNum.innerText = num;
                }
                if (EChatMsgTip) {
                    EChatMsgTip.style.display = "block";
                }
                if (_this.mainPageViewType === EChat.ViewType.CloseView) {
                    minimizeView();
                }
                if (document.title.match(/\([0-9]*\+?\)$/)) {
                    document.title = document.title.replace(/\([0-9]*\)$/, `(${num})`);
                } else {
                    document.title = `${document.title}(${num})`;
                }
            } else {
                document.title = document.title.replace(/\([0-9]*\)$/, "");
                if (EChatTitleNewMsgNum) {
                    EChatTitleNewMsgNum.style.display = "none";
                }
                if (EChatMsgTip) {
                    EChatMsgTip.style.display = "none";
                }

                if (EChatNewMsgTip) {
                    EChatNewMsgTip.innerText = "";
                }

                if (EChatNewMsgNum) {
                    EChatNewMsgNum.innerText = "";
                }
            }
        };

        this.initSoundAlert = function () {
            let audioElement = document.getElementById("eChatSoundAlert");
            if (!audioElement) {
                audioElement = document.createElement("AUDIO");
                audioElement.id = "eChatSoundAlert";
                audioElement.innerHTML = "<source src='./includes/Resource/eChatSoundAlert.mp3'type='audio/mpeg'></source>";
                const EChatButton = document.getElementById("EChatButton");
                if (EChatButton) {
                    EChatButton.append(audioElement);
                    audioElement.load();
                }
            }

            return audioElement;
        };

        this.closeAllWindow = function () {
            if (EChat.MainPageController && EChat.MainPageController.messageWindowList) {
                for (let i = 0; i < EChat.MainPageController.messageWindowList.length; i++) {
                    const windowclose = EChat.MainPageController.messageWindowList[i];
                    if (windowclose) {
                        windowclose.closeMessageWindow();
                    }
                }
            }
        };

        this.GetEditPromptButton = function (groupData) {
            let alertClass;
            if (parseInt(groupData.Prompt) === EChat.PromptType.DoNotDisturb) {
                alertClass = "ews-icon-DisablesVoice";
            } else {
                alertClass = "ews-icon-alert";
            }
            // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
            const promptEditBtn = document.createElement("ecp-btn");
            promptEditBtn.id = "eChatAlertBtn";
            promptEditBtn.setAttribute("groupid", groupData.MessageGroupID);
            promptEditBtn.setAttribute("icon", alertClass);
            promptEditBtn.setAttribute("type", "ghost");
            promptEditBtn.style.fontSize = "16px";
            promptEditBtn.style.width = "30px";
            promptEditBtn.style.height = "30px";
            promptEditBtn.addEventListener("click", (e) => {
                EChat.DataProvider.editGroupPromptType({ groupID: groupData.MessageGroupID }).catch(EChat.Util.errorAlert);
                e.stopPropagation();
            });

            return promptEditBtn;
        };

        // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
        this.GetMinEditPromptButton = function (groupData) {
            let alertClass;
            if (parseInt(groupData.Prompt) === EChat.PromptType.DoNotDisturb) {
                alertClass = "ews-icon-DisablesVoice";
            } else {
                alertClass = "ews-icon-alert";
            }
            // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
            const promptEditBtn = document.createElement("ecp-btn");
            promptEditBtn.id = "ewsIconAlert";
            promptEditBtn.setAttribute("groupid", groupData.MessageGroupID);
            promptEditBtn.setAttribute("icon", alertClass);
            promptEditBtn.setAttribute("type", "ghost");
            promptEditBtn.style.fontSize = "16px";
            promptEditBtn.style.marginTop = "3px";
            promptEditBtn.style.height = "26px";
            promptEditBtn.style.width = "26px";
            promptEditBtn.addEventListener("click", (e) => {
                EChat.DataProvider.editGroupPromptType({ groupID: groupData.MessageGroupID }).catch(EChat.Util.errorAlert);
                e.stopPropagation();
            });

            return promptEditBtn;
        };

        this.GetLastMessage = function (groupData) {
            let lastMessage = null;
            // Search message
            if (groupData.SortTime) {
                lastMessage = {
                    TimeCreated: groupData.SortTime,
                    TimeUpdated: groupData.SortTime,
                    SenderAuthenticationID: groupData.SenderAuthenticationID,
                    SenderFullName: groupData.SenderFullName,
                    SenderUserAvatar: groupData.SenderUserAvatar,
                    MessageID: groupData.MessageID,
                    ScrollToMessageID: groupData.MessageID,
                    Message: EC_Fmt.Null2EmptyStr(groupData.Message)
                };
            }

            // Task message
            if (groupData.LastSenderAuthenticationID) {
                lastMessage = {
                    TimeCreated: groupData.MessageUpdated,
                    TimeUpdated: groupData.MessageUpdated,
                    SenderAuthenticationID: groupData.LastSenderAuthenticationID,
                    SenderFullName: groupData.LastSenderFullName,
                    MessageID: groupData.LastMessageID,
                    SenderUserAvatar: groupData.LastSenderUserAvatar,
                    Message: EC_Fmt.Null2EmptyStr(groupData.LastMessageBody)
                };
            }

            // Saved message
            if (groupData.SavedTime) {
                lastMessage = {
                    TimeCreated: groupData.MessageTime,
                    TimeUpdated: groupData.MessageTime,
                    SenderAuthenticationID: groupData.SenderAuthenticationID,
                    SenderFullName: groupData.SenderFullName,
                    SenderUserAvatar: groupData.SenderUserAvatar,
                    Message: EC_Fmt.Null2EmptyStr(groupData.Message)
                };
            }

            // Normal Message
            if (!lastMessage && groupData.Messages && groupData.Messages.length !== 0) {
                const newLastMessage = {};
                const keys = Object.keys(groupData.Messages[0]);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    newLastMessage[key] = groupData.Messages[0][key];
                }
                lastMessage = newLastMessage;
            }

            if (!lastMessage) {
                lastMessage = {
                    TimeCreated: groupData.MessageUpdated,
                    Message: ""
                };
            }

            const MessageDiv = document.createElement("DIV");
            lastMessage.Message = EC_Fmt.ReplaceAll(EC_Fmt.ReplaceAll(lastMessage.Message, "<br>", " "), "<br />", " ");
            MessageDiv.innerHTML = lastMessage.Message;
            MessageDiv.querySelectorAll("font[cc-display]").forEach((cc_display) => {
                if (cc_display) {
                    cc_display.remove();
                }
            });
            lastMessage.Message = MessageDiv.textContent;

            const searchText = EChat.Util.getSearchText();
            if (searchText) {
                const hightLight = EChat.Util.highLight(MessageDiv.textContent, searchText, "yellow", true);
                lastMessage.DisplayMessageDom = hightLight.dom;
                lastMessage.DisplayMessage = hightLight.text;
            } else {
                lastMessage.DisplayMessage = MessageDiv.textContent;
            }

            if (!lastMessage.SenderUserAvatar) {
                lastMessage.SenderUserAvatar = EChat.Setting.DefaultUserIcon;
            }

            const Message = MessageDiv.querySelector("message");
            if (Message) {
                lastMessage.DisplayMessage = Message.getAttribute("filename");
                if (!lastMessage.DisplayMessage) {
                    lastMessage.DisplayMessage = Message.getAttribute("type");
                }
                if (lastMessage.DisplayMessage) {
                    lastMessage.DisplayMessage = `[${lastMessage.DisplayMessage}]`;
                    lastMessage.Message = lastMessage.DisplayMessage;
                }
            } else if (!lastMessage.DisplayMessage.trim() && MessageDiv.querySelector("img")) {
                lastMessage.DisplayMessage = "[Image]";
                lastMessage.Message = lastMessage.DisplayMessage;
            }

            if (!lastMessage.SenderFullName) {
                lastMessage.SenderFullName = lastMessage.SenderAuthenticationID <= 0 ? "System" : `None_${lastMessage.SenderAuthenticationID}`;
            }

            return lastMessage;
        };

        this.SavedButtonEvent = function (msgObj, groupInfo) {
            const TaskSourceEncompassID = groupInfo.EncompassID;
            const SavedStatus = msgObj.MessageID && EChat.DataProvider.SavedMessage && EChat.DataProvider.SavedMessage.includes(msgObj.MessageID.toString());

            let TaskDetailID = "";
            let TaskID = "";
            let MessageGroupKey;
            let MessageKey = "";
            if (groupInfo.TaskID && parseInt(groupInfo.TaskID) > 0) {
                TaskDetailID = msgObj.MessageID;
                TaskID = parseInt(groupInfo.TaskID);
                MessageGroupKey = `${TaskSourceEncompassID}_${msgObj.TaskID}`;
            } else {
                MessageGroupKey = groupInfo.MessageGroupID;
                MessageKey = msgObj.MessageID;
            }

            if (SavedStatus) {
                EChat.MainPageController.cancelSavedMessage({
                    TaskID,
                    TaskDetailID,
                    TaskSourceEncompassID,
                    MessageGroupKey,
                    MessageGroupID: MessageGroupKey,
                    MessageKey
                });
            } else {
                EChat.MainPageController.addSavedMessage({
                    TaskID,
                    TaskDetailID,
                    TaskSourceEncompassID,
                    MessageGroupKey,
                    MessageGroupID: MessageGroupKey,
                    MessageKey,
                    SavedTime: EChat.Util.getTimeStamp(),
                    MessageTime: msgObj.TimeUpdated,
                    GroupType: groupInfo.GroupType,
                    SenderAuthenticationID: msgObj.SenderAuthenticationID,
                    SenderUserAvatar: msgObj.SenderUserAvatar,
                    SenderFullName: msgObj.SenderFullName,
                    Message: msgObj.Message
                });
            }
        };

        this.resizeDialog = function () {
            if (_this.mainPageViewType === EChat.ViewType.OpenView) {
                const EChatMainPage = document.getElementById("EChatMainPage");
                if (EChatMainPage) {
                    const height = EChat.MainPageController.mainWindowSize.height;
                    let currHeight = EChat.MainPageController.mainWindowSize.currHeight > 0 ? EChat.MainPageController.mainWindowSize.currHeight : height;
                    let EChatMainPageRect = EChatMainPage.getBoundingClientRect();
                    let EChatMainPageTop = EChatMainPageRect.top;
                    let topHeight = EChatMainPageTop - EChat.Util.getHeaderHeight();
                    let bottomHeight = EChatMainPageRect.bottom - window.innerHeight;

                    if (bottomHeight > 0) {
                        if (topHeight > 0) {
                            if (topHeight > bottomHeight) {
                                EChatMainPage.style.top = `${EChatMainPageTop - bottomHeight}px`;
                                bottomHeight = 0;
                            } else {
                                EChatMainPage.style.top = `${EChatMainPageTop - topHeight}px`;
                                bottomHeight -= topHeight;
                            }

                            EChatMainPageRect = EChatMainPage.getBoundingClientRect();
                            EChatMainPageTop = EChatMainPageRect.top;
                            topHeight = EChatMainPageTop - EChat.Util.getHeaderHeight();
                        }
                        currHeight -= bottomHeight;
                        currHeight = Math.max(currHeight, EChat.__height);
                    }

                    if (height > currHeight && topHeight > 0) {
                        let changeHeght = height - currHeight; // change > 0
                        changeHeght = Math.min(changeHeght, topHeight);
                        currHeight += changeHeght;
                        EChatMainPage.style.top = `${EChatMainPageTop - changeHeght}px`;
                    }

                    EChat.MainPageController.mainWindowSize.currHeight = currHeight;
                    EChatMainPage.style.setProperty("--height", `${currHeight}px`);
                }
            }
        };
    };

    return new MainPageControllerClass();
}());

EChat.RecentController = function () {
    EChat.EventDispatcher.call(this);
    this.viewMoreLastMessageTimeCreated_Message = 0;

    const _this = this;
    let canEnter = true;
    let timeOutThread;
    let searchIng = false;
    let searchTextOld = "";

    const createRecentGroupElement = async function ({
        groupData, filterEmptyMessage, hideGroupButton, hideLastMessage, hideUnreadCount
    }) {
        if (groupData) {
            if (filterEmptyMessage && groupData.GroupType !== SocketUtil.GroupType.Task && (!groupData.Messages || groupData.Messages.length === 0)) {
                return false;
            }
            const eChatDataProvider = EChat.DataProvider;
            const searchText = EChat.Util.getSearchText();

            const lastMessageObj = EChat.MainPageController.GetLastMessage(groupData);
            const RecentGroupTemplate = EC_Fmt.HtmlStrToElement(document.getElementById("RecentGroupTemplate").innerHTML);
            const LastMessageDiv = RecentGroupTemplate.querySelector(".LastMessage");

            const LastMessageMultiLine = (groupData.GroupType === SocketUtil.GroupType.Task || groupData.UserCount > 2) && lastMessageObj.DisplayMessage && !hideLastMessage;
            // Task 997223: eChat: Please include timestamps when filtered to unread.
            let NoLastMessage = false;
            if (LastMessageMultiLine) {
                const userNameDiv = LastMessageDiv.querySelector(".eChat-LastMessageUserName");
                userNameDiv.textContent = lastMessageObj.SenderFullName;
                userNameDiv.setAttribute("title", lastMessageObj.SenderFullName);
                userNameDiv.setAttribute("data-user-name", lastMessageObj.SenderFullName);
                const userImg = LastMessageDiv.querySelector(".eChat-User-Img");
                if (lastMessageObj.SenderUserAvatar) {
                    userImg.style.backgroundImage = `url(${lastMessageObj.SenderUserAvatar})`;
                    userImg.classList.add("eChat-ico-GroupIcon");
                } else {
                    userImg.classList.add("eChat-ico-DefaultUser");
                }
                LastMessageDiv.querySelector(".eChat-LastMessageTime").textContent = EChat.Util.longToDataTime(lastMessageObj.TimeCreated);
                LastMessageDiv.querySelector(".eChat-LastMessageInfo").classList.remove("hidden");
                if (lastMessageObj.DisplayMessageDom) {
                    LastMessageDiv.querySelector(".eChat-LastMessageBody").append(lastMessageObj.DisplayMessageDom);
                } else {
                    LastMessageDiv.querySelector(".eChat-LastMessageBody").textContent = lastMessageObj.DisplayMessage;
                }
                LastMessageDiv.querySelector(".eChat-LastMessageBody").setAttribute("title", lastMessageObj.Message);
            } else if (groupData.GroupType !== SocketUtil.GroupType.Task && !hideLastMessage) {
                const LastMessageTime = RecentGroupTemplate.querySelector(".recent-group-top .eChat-LastMessageTime");
                LastMessageTime.textContent = EChat.Util.longToDataTime(lastMessageObj.TimeCreated);
                if (lastMessageObj.DisplayMessageDom) {
                    LastMessageDiv.querySelector(".eChat-LastMessageBody").append(lastMessageObj.DisplayMessageDom);
                } else {
                    LastMessageDiv.querySelector(".eChat-LastMessageBody").textContent = lastMessageObj.DisplayMessage;
                }
                LastMessageDiv.querySelector(".eChat-LastMessageBody").setAttribute("title", lastMessageObj.Message);
            } else {
                const LastMessageTime = RecentGroupTemplate.querySelector(".recent-group-top .eChat-LastMessageTime");
                LastMessageDiv.querySelector(".eChat-LastMessageBody").classList.add("hidden");
                LastMessageTime.textContent = EChat.Util.longToDataTime(lastMessageObj.TimeCreated);
                NoLastMessage = true;
            }

            RecentGroupTemplate.setAttribute("id", `UserUnit${groupData.MessageGroupID}`);
            RecentGroupTemplate.setAttribute("groupid", groupData.MessageGroupID);
            RecentGroupTemplate.setAttribute("lastmsgtime", lastMessageObj.TimeCreated);
            RecentGroupTemplate.setAttribute("messageid", EC_Fmt.Null2EmptyStr(lastMessageObj.MessageID));
            if (lastMessageObj.ScrollToMessageID) {
                RecentGroupTemplate.setAttribute("scroll-to-messageid", EC_Fmt.Null2EmptyStr(lastMessageObj.ScrollToMessageID));
            }
            if (groupData.GroupType === SocketUtil.GroupType.Message && filterEmptyMessage) {
                if (!groupData.Users || (groupData.UserCount === 2 && groupData.Users.length === 0)) {
                    try {
                        const userList = await SocketUtil.api("GetGroupUsers", {
                            MessageGroupID: groupData.MessageGroupID,
                            SenderSessionID: SocketUtil.getSessionID()
                        });
                        const userDic = {};
                        userDic[groupData.MessageGroupID] = userList;
                        groupData.Users = userList;
                        await EChat.IndexedDB.UpdateGroupUsers(userDic);
                    } catch (e) {
                        EChat.Util.errorAlert(e);
                    }
                }
            }

            const groupIconUrlAndAuthID = EChat.DataProvider.GetGroupAvatarUrlAndAuthID(groupData, EChat.DataProvider.CurrentUserInfo);
            let groupIconUrl = groupIconUrlAndAuthID.Url;
            const userIcoSpan = RecentGroupTemplate.querySelector(".user-ico-span");

            if (groupIconUrl === EChat.Setting.DefaultAlertIcon) {
                userIcoSpan.classList.add("ews-icon-warning");
                userIcoSpan.classList.add("eChat-ico-Group");
            } else if (groupIconUrl === EChat.Setting.DefaultTaskIcon) {
                userIcoSpan.classList.add("ews-icon-task");
                userIcoSpan.classList.add("eChat-ico-Group");
            } else {
                if (groupIconUrl === EChat.Setting.DefaultUserIcon) {
                    if (EChat.DataProvider.UserDict[groupIconUrlAndAuthID.AuthID]) {
                        groupIconUrl = EChat.DataProvider.UserDict[groupIconUrlAndAuthID.AuthID].Icon;
                    } else if (!EChat.DataProvider.MissUserInfo.includes(groupIconUrlAndAuthID.AuthID)) {
                        EChat.DataProvider.MissUserInfo.push(groupIconUrlAndAuthID.AuthID);
                        userIcoSpan.classList.add("eChat-Miss-Avatar");
                        userIcoSpan.setAttribute("authid", groupIconUrlAndAuthID.AuthID);
                        EChat.DataProvider.GetMissUserInfo();
                    }
                }

                userIcoSpan.style.backgroundImage = `url(${groupIconUrl})`;
                userIcoSpan.classList.add("eChat-ico-GroupIcon");
            }

            // Task 762589: The Task title is enclosed in single quotes. EChat Task Group displays abnormally
            const groupName = eChatDataProvider.GetGroupName(groupData);
            const nameSpan = RecentGroupTemplate.querySelector(".recent-group-name");
            const includeUserSpan = RecentGroupTemplate.querySelector(".recent-group-include-user");
            if (searchText) {
                const groupNameDisplay = EChat.Util.highLight(groupName, searchText, "yellow", false).text;
                nameSpan.innerHTML = groupNameDisplay;
                includeUserSpan.classList.remove("hidden");
                if (groupData.IncludeUser) {
                    includeUserSpan.setAttribute("title", `(Includes ${groupData.IncludeUser})`);
                    const IncludeUser = EChat.Util.highLight(groupData.IncludeUser, searchText, "yellow", false).text;
                    includeUserSpan.innerHTML = `(Includes ${IncludeUser})`;
                    nameSpan.style.maxWidth = `calc(100% - 200px)`;
                }
            } else {
                includeUserSpan.classList.add("hidden");
                includeUserSpan.innerHTML = "";
                nameSpan.textContent = groupName;
            }
            if (groupData.GroupType === SocketUtil.GroupType.Task || groupData.GroupType === SocketUtil.GroupType.Message) {
                nameSpan.classList.add("eChat-task-group-title");
            }
            nameSpan.setAttribute("title", groupName);
            nameSpan.setAttribute("data-user-name", groupName);
            if (NoLastMessage) {
                nameSpan.style.maxWidth = "calc(100% - 160px)";
            }

            const groupEditBtn = RecentGroupTemplate.querySelector(".recent-group-edit-btn");

            if (groupData.GroupType === SocketUtil.GroupType.Task) {
                groupEditBtn.addEventListener("mousedown", (e) => {
                    const url = `Home?DashboardID=${ECP.CommonDashboards.TaskEdit}&Action=Add&TableEdit=TaskDetails&&FieldName=TaskID&FieldValue=${groupData.TaskID}&CurValue=${groupData.TaskID}&TableName=Tasks&SubTableJoinID=TaskDetails_Tasks&Search=TaskID~${groupData.TaskID}`;
                    EChat.Util.nav(url, e);
                });
            } else {
                groupEditBtn.addEventListener("click", (e) => {
                    EChat.GroupSettingController.openGroupSettingWindow(groupData.MessageGroupID);
                    e.stopPropagation();
                });
            }
            const alertInfoBtn = RecentGroupTemplate.querySelector(".eChat-AlertDetail");
            alertInfoBtn.addEventListener("mousedown", (e) => {
                const url = EChat.CustomComponent.GetAlertDetailUrl(groupData.GroupName, groupData.MessageGroupID);
                EChat.Util.nav(url, e);
            });

            if (!hideUnreadCount) {
                const UnReadNumDiv = RecentGroupTemplate.querySelector(".echat-unread-count");
                UnReadNumDiv.setAttribute("id", `Unread_${groupData.MessageGroupID}`);
                UnReadNumDiv.classList.add(groupData.GroupType === SocketUtil.GroupType.Task ? "unread-task" : "unread-messages");
                if (groupData.UnreadCount) {
                    UnReadNumDiv.style.display = "block";
                    if (groupData.GroupType !== SocketUtil.GroupType.Task) {
                        UnReadNumDiv.innerText = groupData.UnreadCount;
                    }
                }
                if (parseInt(groupData.Prompt) === EChat.PromptType.DoNotDisturb) {
                    UnReadNumDiv.style.background = "var(--neutral-50)";
                }
            }

            // Task 729634: eChat: Uncaught Type Error: Cannot read property 'query Selector' of null Error message when clicking pencil icon to delete a message on echat.
            if (groupData.GroupType === SocketUtil.GroupType.Message && groupData.PostPermission !== EChat.PostPermissionType.ReadOnly) {
                groupEditBtn.classList.remove("hidden");
            }

            if (groupData.GroupType === SocketUtil.GroupType.Task && groupData.EncompassID === Distributor) {
                groupEditBtn.classList.remove("hidden");
            }

            const TaskSourceEncompassID = groupData.GroupType === SocketUtil.GroupType.Task ? groupData.EncompassID : "";
            const isCurrTask = EChat.DataProvider.CurrentUserInfo && EChat.DataProvider.CurrentUserInfo.PrimaryEncompassID === TaskSourceEncompassID;
            if (TaskSourceEncompassID === "" || isCurrTask) {
                if (lastMessageObj.MessageID && !hideLastMessage) {
                    // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
                    const recentSavedBtn = RecentGroupTemplate.querySelector(".recent-saved-btn ecp-btn");
                    recentSavedBtn.classList.remove("hidden");
                    recentSavedBtn.setAttribute("savedkey", lastMessageObj.MessageID);
                    if (EChat.DataProvider.SavedMessage && EChat.DataProvider.SavedMessage.includes(lastMessageObj.MessageID.toString())) {
                        recentSavedBtn.setAttribute("icon", "ews-icon-collection");
                    }

                    recentSavedBtn.addEventListener("click", (e) => {
                        EChat.MainPageController.SavedButtonEvent(lastMessageObj, groupData);
                        e.stopPropagation();
                    });
                }
            }

            if (groupData.GroupType === SocketUtil.GroupType.Message) {
                const groupButton = RecentGroupTemplate.querySelector(".recnet-group-button");
                groupButton.append(EChat.MainPageController.GetEditPromptButton(groupData));
            }

            if (groupData.GroupType === SocketUtil.GroupType.System) {
                // Task 1160151: 'i' icon in eChat for alerts from the system takes you to a page that says 'Deprecated in 22.07'- Delete this icon
                const LoadEmployeesAlertsType = [
                    "Day Close",
                    "ASN Receipt",
                    "New Customer Account",
                    "PO Receipt",
                    "REMIT Receipt",
                    "Import Conflict",
                    "Supplier Comm Warnings",
                    "EDI Download Reminder",
                    "Account Mis-Mapping"
                ];
                for (let i = 0; i < LoadEmployeesAlertsType.length; i++) {
                    if (groupData.GroupName === LoadEmployeesAlertsType[i]) {
                        alertInfoBtn.classList.remove("hidden");
                    }
                }
                // Task 1134294: Encompass Mobile Picker Cut Alert Detail
                groupEditBtn.classList.add("hidden");
            }

            RecentGroupTemplate.addEventListener("click", (e) => {
                const groupId = groupData.MessageGroupID;
                if (groupId) {
                    EChat.DataProvider.GetGroupInfoByGroupID(groupId).then((groupInfo) => {
                        const messageid = RecentGroupTemplate.getAttribute("scroll-to-messageid");
                        EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, true, true, messageid);
                    });
                }
                e.stopPropagation();
            });

            if (!hideGroupButton) {
                RecentGroupTemplate.addEventListener("mouseover", () => {
                    RecentGroupTemplate.querySelector(".recnet-group-button").classList.remove("hidden");
                });
                RecentGroupTemplate.addEventListener("mouseleave", () => {
                    RecentGroupTemplate.querySelector(".recnet-group-button").classList.add("hidden");
                });
            }

            return { TargetElement: RecentGroupTemplate, LastMsgTime: lastMessageObj.TimeCreated };
        }
        return false;
    };

    this.redrawGroup = async function (groupData) {
        if (EChat.Util.IsRecentSearchState()) {
            return;
        }

        const listEle = document.getElementById("EChatRecentList");
        const exist = document.getElementById(`UserUnit${groupData.MessageGroupID}`);
        let TargetElement = null;

        const EChatRecentSection = document.getElementById("EChatRecentSection");
        const searchKey = EChat.Util.getSearchText();
        // Task 962388: eChats: eChats sent to a user do not show in the recent list until I refresh
        if (searchKey && EChatRecentSection?.clientWidth > 0) {
            if (exist) {
                TargetElement = document.createElement("SPAN");
                exist.after(TargetElement);
            } else {
                return;
            }
        }

        if (exist) {
            exist.remove();
        }

        const groupElement = await createRecentGroupElement({ groupData, filterEmptyMessage: !searchKey });
        if (groupElement?.TargetElement) {
            if (!TargetElement) {
                const LastMsgTime = groupElement.LastMsgTime;
                let TargetLastMsgTime = -1;

                const UserUnits = document.querySelectorAll("#EChatRecentList .UserUnit");
                for (let i = 0, len = UserUnits.length; i < len; i++) {
                    const UserUnit = UserUnits[i];
                    const tmpLastMsgTime = parseInt(UserUnit.getAttribute("lastmsgtime"));
                    if (tmpLastMsgTime > LastMsgTime && (TargetLastMsgTime === -1 || TargetLastMsgTime >= tmpLastMsgTime)) {
                        TargetElement = UserUnit;
                        TargetLastMsgTime = tmpLastMsgTime;
                    }
                }
            }

            if (!TargetElement) {
                listEle.prepend(groupElement.TargetElement);
            } else {
                TargetElement.after(groupElement.TargetElement);
            }
            groupElement.TargetElement.style.display = "block";
        }
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        _this.reviseEchatGroupProperties(groupElement.TargetElement, groupData);
    };

    // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
    this.reviseEchatGroupProperties = function (groupElement, groupData) {
        const eCahtGroupList = groupElement;
        const Number = groupData.MessageGroupID;

        if (!EC_Fmt.isNull(eCahtGroupList)) {
            const eChatSavedBtn = eCahtGroupList.querySelector("[id ^= eChatSavedBtn]");
            if (eChatSavedBtn) {
                if (eChatSavedBtn.id !== `eChatSavedBtn${Number}`) {
                    eChatSavedBtn.setAttribute("id", `eChatSavedBtn${Number}`);
                }
            }

            const eChatGroupEditBtn = eCahtGroupList.querySelector("[id ^= eChatGroupEditBtn]");
            if (eChatGroupEditBtn) {
                if (eChatGroupEditBtn.id !== `eChatGroupEditBtn${Number}`) {
                    eChatGroupEditBtn.setAttribute("id", `eChatGroupEditBtn${Number}`);
                }
            }

            const eChatAlertDetailBtn = eCahtGroupList.querySelector("[id ^= eChatAlertDetailBtn]");
            if (eChatAlertDetailBtn) {
                if (eChatAlertDetailBtn.id !== `eChatAlertDetailBtn${Number}`) {
                    eChatAlertDetailBtn.setAttribute("id", `eChatAlertDetailBtn${Number}`);
                }
            }

            const eChatAlertBtn = eCahtGroupList.querySelector("[id ^= eChatAlertBtn]");
            if (eChatAlertBtn) {
                if (eChatAlertBtn.id !== `eChatAlertBtn${Number}`) {
                    eChatAlertBtn.setAttribute("id", `eChatAlertBtn${Number}`);
                }
            }

            const eChatTooltipDiv = document.getElementById(`eChatTooltip${Number}`);
            if (!EC_Fmt.isNull(eChatTooltipDiv)) {
                eChatTooltipDiv.remove();
            }

            _this.createEchatGroupTooltip(Number, eChatAlertBtn);
        }
    };

    // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
    this.createEchatGroupTooltip = function (Number, eChatAlert) {
        const eChatTooltip = document.getElementById("EchatTooltip");
        let eChatTooltipJs = document.getElementById("EchatJSTooltip");

        if (EC_Fmt.isNull(eChatTooltipJs)) {
            eChatTooltipJs = document.createElement("div");
            eChatTooltipJs.id = "EchatJSTooltip";
            eChatTooltip.append(eChatTooltipJs);
        }

        let eChatTooltipDiv = document.getElementById(`eChatTooltip${Number}`);
        if (EC_Fmt.isNull(eChatTooltipDiv)) {
            eChatTooltipDiv = document.createElement("div");
            eChatTooltipDiv.id = `eChatTooltip${Number}`;
            eChatTooltipJs.append(eChatTooltipDiv);

            const eChatSavedBtn = document.createElement("ecp-tooltip");
            eChatSavedBtn.setAttribute("for", `eChatSavedBtn${Number}`);
            eChatSavedBtn.setAttribute("placement", "top");
            eChatSavedBtn.textContent = "Recent Saved";

            const eChatGroupEditBtn = document.createElement("ecp-tooltip");
            eChatGroupEditBtn.setAttribute("for", `eChatGroupEditBtn${Number}`);
            eChatGroupEditBtn.setAttribute("placement", "top");
            eChatGroupEditBtn.textContent = "Group Edit";

            const eChatAlertDetailBtn = document.createElement("ecp-tooltip");
            eChatAlertDetailBtn.setAttribute("for", `eChatAlertDetailBtn${Number}`);
            eChatAlertDetailBtn.setAttribute("placement", "top");
            eChatAlertDetailBtn.textContent = "Alert Detail";

            const eChatAlertBtn = document.createElement("ecp-tooltip");
            eChatAlertBtn.setAttribute("for", `eChatAlertBtn${Number}`);
            eChatAlertBtn.setAttribute("placement", "top");
            eChatAlertBtn.textContent = "Mute/Unmute eChat Group";

            if (eChatAlert) {
                eChatTooltipDiv.append(eChatSavedBtn, eChatGroupEditBtn, eChatAlertDetailBtn, eChatAlertBtn);
            }
            eChatTooltipDiv.append(eChatSavedBtn, eChatGroupEditBtn, eChatAlertDetailBtn);
        }
    };

    this.deleteGroup = function (groupId) {
        document.querySelectorAll(`#EChatRecentSection #UserUnit${groupId}`).forEach((target) => {
            target.remove();
        });
    };

    this.initViewMore = async function (groupList) {
        if (groupList?.length !== 0) {
            groupList.sort((a, b) => EChat.IndexedDB.GetGroupSortTime(b) - EChat.IndexedDB.GetGroupSortTime(a));

            // Message
            let count = 0;
            const limitGroup_Message = [];

            const checkGroup = (groupInfo) => {
                if (groupInfo.GroupType === SocketUtil.GroupType.Message && groupInfo.Messages && groupInfo.Messages.length !== 0) {
                    return true;
                }
                if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                    return true;
                }
                if (groupInfo.GroupType === SocketUtil.GroupType.System) {
                    return true;
                }
                return false;
            };

            for (let i = 0; i < groupList.length; i++) {
                if (checkGroup(groupList[i])) {
                    limitGroup_Message.push(groupList[i]);
                    count++;
                    if (count >= 20) {
                        break;
                    }
                }
            }

            if (limitGroup_Message.length !== 0) {
                _this.viewMoreLastMessageTimeCreated_Message = EChat.IndexedDB.GetGroupSortTime(limitGroup_Message[limitGroup_Message.length - 1]);
                await _this.drawGroups(limitGroup_Message);
            }
        }
    };

    this.drawGroups = async function (groupList) {
        if (groupList) {
            for (let i = 0; i < groupList.length; i++) {
                await _this.redrawGroup(groupList[i]);
                // New Message
                // Task 448559
                const msgGroupID = groupList[i].MessageGroupID;
                if (EChat.MainPageController.checkMessageWindowExist(msgGroupID)) {
                    if (EChat.MainPageController.currentMessageWindow.chatTabList[msgGroupID]) {
                        EChat.MainPageController.currentMessageWindow.chatTabList[msgGroupID].refreshMessageList(groupList[i].Messages);
                        if (EChat.MainPageController.currentMessageWindow.messageWindowViewType === EChat.ViewType.OpenView) {
                            EChat.DataProvider.SyncLastReadTime(msgGroupID);
                        }
                    }
                }
            }
            // View More Groups
            document.getElementById("EChatRecentList").addEventListener("scroll", function () {
                const searchText = EChat.Util.getSearchText();
                if (this.scrollTop + this.clientHeight >= (this.scrollHeight - 1) && canEnter) {
                    if (!searchText) {
                        canEnter = false;
                        EChat.DataProvider.getGroupHistory(_this.viewMoreLastMessageTimeCreated_Message).then(async function (result) {
                            if (result) {
                                const recentList = result.Groups;
                                _this.viewMoreLastMessageTimeCreated_Message = result.LastMessageTimeCreated;
                                canEnter = true;
                                if (recentList?.length !== 0) {
                                    let count = 0;
                                    for (let i = 0; i < recentList.length; i++) {
                                        count++;
                                        await _this.redrawGroup(recentList[i]);
                                    }

                                    if (searchText && count === 0) {
                                        this.scrollTop -= 40;
                                    }
                                    EChat.MainPageController.updateUnReadNumIcon("scroll");
                                }
                            } else {
                                canEnter = true;
                            }
                        }).catch(() => {
                            canEnter = true;
                        });
                    }
                }
            });

            document.querySelectorAll("#EChatRecentSection .eChat-SupuerSearchList").forEach((dom) => {
                dom.addEventListener("scroll", function () {
                    if (this.scrollTop + this.clientHeight >= (this.scrollHeight - 1) && canEnter) {
                        const searchObj = document.getElementById("EChatSearchText");
                        const tab = searchObj.getAttribute("tab");
                        if (tab && EChat.Util.getSearchText()) {
                            const viewMoreElement = document.querySelector(`#EChatRecentList #EChatSuperSearch${tab}Tab .eChat-SuperViewMore`);
                            const NoRecords = document.querySelector(`#EChatRecentList #EChatSuperSearch${tab}List .eChat-SupuerSearchNoRecords`);
                            if (NoRecords.clientWidth === 0) {
                                const limit = 10;
                                const startIndex = EC_Fmt.Null2ZeroInt(viewMoreElement.getAttribute("startIndex")) + limit;
                                const tabElement = document.querySelector(`#EChatRecentList #EChatSuperSearch${tab}Tab`);
                                const listElement = document.querySelector(`#EChatRecentList #EChatSuperSearch${tab}List`);

                                switch (tab) {
                                    case "User":
                                        canEnter = false;
                                        searchUser({
                                            searchText, limit, startIndex, listElement, tabElement, only: true
                                        }).then(() => {
                                            canEnter = true;
                                        }).catch(() => {
                                            canEnter = true;
                                        });
                                        break;
                                    case "MessageAndTask":
                                        canEnter = false;
                                        searchMessageAndTask({
                                            searchText, limit, startIndex, listElement, tabElement, only: true
                                        }).then(() => {
                                            canEnter = true;
                                        }).catch(() => {
                                            canEnter = true;
                                        });
                                        break;
                                    case "Group":
                                        canEnter = false;
                                        searchGroup({
                                            searchText, limit, startIndex, listElement, tabElement, only: true
                                        }).then(() => {
                                            canEnter = true;
                                        }).catch(() => {
                                            canEnter = true;
                                        });
                                        break;
                                }
                            }
                        }
                    }
                });
            });
        }
    };

    const searchUnread = function ({
        searchText, listElement, tabElement
    }) {
        return new Promise((resolve) => {
            const loading = listElement.querySelector(".eChat-SuperLoading");
            loading.style.display = "block";

            const noRecordsElement = listElement.querySelector(".eChat-SupuerSearchNoRecords");
            SocketUtil.api("SuperSearchByUnread2010", {
                Search: searchText
            }).then(async (data) => {
                loading.style.display = "none";
                noRecordsElement.style.display = "block";
                if (data.length === 0) {
                    tabElement.style.display = "block";
                    listElement.style.display = "block";
                }

                for (let i = 0, len = data.length; i < len; i++) {
                    const searchInfo = data[i];
                    if (searchInfo.DisplayName && EChat.DataProvider.CurrentUserInfo && searchInfo.DisplayName !== EChat.DataProvider.CurrentUserInfo.FullName) {
                        searchInfo.DisplayName = searchInfo.DisplayName.replace(`${EChat.DataProvider.CurrentUserInfo.FullName}, `, "").replace(`, ${EChat.DataProvider.CurrentUserInfo.FullName}`, "");
                    }
                    const groupItem = await createRecentGroupElement({ groupData: searchInfo });
                    if (groupItem && !listElement.querySelector(`#UserUnit${searchInfo.MessageGroupID}`)) {
                        listElement.querySelector(".eChat-SuperItem").append(groupItem.TargetElement);
                    }
                }
                resolve(data.length);
            }).catch((ex) => {
                noRecordsElement.style.display = "block";
                loading.style.display = "none";
                EChat.Util.errorAlert(ex);
                resolve(0);
            });
        });
    };

    const searchMessageAndTask = function ({
        searchText, limit, startIndex, listElement, tabElement, only, animationLoading
    }) {
        return new Promise((resolve) => {
            const loading = listElement.querySelector(".eChat-SuperLoading");
            loading.style.display = "block";
            const noRecordsElement = listElement.querySelector(".eChat-SupuerSearchNoRecords");
            SocketUtil.api("SuperSearchByMessageAndTask", {
                Search: searchText,
                Limit: limit,
                StartIndex: startIndex
            }).then(async (data) => {
                loading.style.display = "none";
                const viewMoreElement = tabElement.querySelector(".eChat-SuperViewMore");
                viewMoreElement.setAttribute("startIndex", startIndex);

                if (data.length !== 0 || only) {
                    tabElement.style.display = "block";
                    listElement.style.display = "block";
                } else {
                    listElement.style.display = "none";
                    tabElement.style.display = "none";
                }

                if (data.length < limit) {
                    viewMoreElement.style.display = "none";
                    if (only) {
                        noRecordsElement.style.display = "block";
                    } else {
                        noRecordsElement.style.display = "none";
                    }
                } else {
                    viewMoreElement.style.display = "flex";
                    const viewMore = function () {
                        this.removeEventListener("click", viewMore);
                        switchSearchUI("MessageAndTask");
                        searchMessageAndTask({
                            searchText, limit: 10, startIndex: startIndex + limit, listElement, tabElement, only: true, animationLoading: true
                        });
                    };
                    viewMoreElement.addEventListener("click", viewMore);
                }

                for (let i = 0, len = data.length; i < len; i++) {
                    const searchInfo = data[i];
                    if (searchInfo.DisplayName && EChat.DataProvider.CurrentUserInfo && searchInfo.DisplayName !== EChat.DataProvider.CurrentUserInfo.FullName) {
                        searchInfo.DisplayName = searchInfo.DisplayName.replace(`${EChat.DataProvider.CurrentUserInfo.FullName}, `, "").replace(`, ${EChat.DataProvider.CurrentUserInfo.FullName}`, "");
                    }
                    searchInfo.DisplayName = EChat.Util.highLight(searchInfo.DisplayName, searchText, "yellow", false).text;

                    const groupItem = await createRecentGroupElement({ groupData: searchInfo, hideUnreadCount: true });
                    if (groupItem && !listElement.querySelector(`#UserUnit${searchInfo.MessageGroupID}`)) {
                        listElement.querySelector(".eChat-SuperItem").append(groupItem.TargetElement);
                    }
                }
                if (animationLoading) {
                    document.getElementById("EChatRecentList").setAttribute("tab", "viewmore");
                }
                resolve(data.length);
            }).catch((ex) => {
                noRecordsElement.style.display = "block";
                loading.style.display = "none";
                EChat.Util.errorAlert(ex);
                resolve(0);
            });
        });
    };

    const searchGroup = function ({
        searchText, limit, startIndex, listElement, tabElement, only, animationLoading
    }) {
        return new Promise((resolve) => {
            const loading = listElement.querySelector(".eChat-SuperLoading");
            loading.style.display = "block";

            const noRecordsElement = listElement.querySelector(".eChat-SupuerSearchNoRecords");
            SocketUtil.api("SuperSearchByGroup", {
                Search: searchText,
                Limit: limit,
                StartIndex: startIndex
            }).then(async (data) => {
                loading.style.display = "none";
                const viewMoreElement = tabElement.querySelector(".eChat-SuperViewMore");
                viewMoreElement.setAttribute("startIndex", startIndex);

                if (data.length !== 0 || only) {
                    tabElement.style.display = "block";
                    listElement.style.display = "block";
                } else {
                    listElement.style.display = "none";
                    tabElement.style.display = "none";
                }

                if (data.length < limit) {
                    viewMoreElement.style.display = "none";
                    if (only) {
                        noRecordsElement.style.display = "block";
                    } else {
                        noRecordsElement.style.display = "none";
                    }
                } else {
                    viewMoreElement.style.display = "flex";
                    const viewMore = function () {
                        this.removeEventListener("click", viewMore);
                        switchSearchUI("Group");
                        searchGroup({
                            searchText, limit: 10, startIndex: startIndex + limit, listElement, tabElement, only: true, animationLoading: true
                        });
                    };
                    viewMoreElement.addEventListener("click", viewMore);
                }

                for (let i = 0, len = data.length; i < len; i++) {
                    const searchInfo = data[i];
                    if (searchInfo.DisplayName && EChat.DataProvider.CurrentUserInfo && searchInfo.DisplayName !== EChat.DataProvider.CurrentUserInfo.FullName) {
                        searchInfo.DisplayName = searchInfo.DisplayName.replace(`${EChat.DataProvider.CurrentUserInfo.FullName}, `, "").replace(`, ${EChat.DataProvider.CurrentUserInfo.FullName}`, "");
                    }

                    searchInfo.SortTime = "None";
                    searchInfo.Message = "";
                    const groupItem = await createRecentGroupElement({ groupData: searchInfo, hideLastMessage: true, hideUnreadCount: true });
                    if (groupItem && !listElement.querySelector(`#UserUnit${searchInfo.MessageGroupID}`)) {
                        listElement.querySelector(".eChat-SuperItem").append(groupItem.TargetElement);
                    }
                }
                if (animationLoading) {
                    document.getElementById("EChatRecentList").setAttribute("tab", "viewmore");
                }
                resolve(data.length);
            }).catch((ex) => {
                noRecordsElement.style.display = "block";
                loading.style.display = "none";
                EChat.Util.errorAlert(ex);
                resolve(0);
            });
        });
    };

    const searchUser = function ({
        searchText, limit, startIndex, listElement, tabElement, only, selectedUser, animationLoading
    }) {
        return new Promise((resolve) => {
            const loading = listElement.querySelector(".eChat-SuperLoading");
            loading.style.display = "block";
            const noRecordsElement = listElement.querySelector(".eChat-SupuerSearchNoRecords");
            EChat.DataProvider.api("EChat_SearchUser", {
                Search: searchText,
                Limit: limit,
                StartIndex: startIndex,
                AuthenticationIDArr: EC_Fmt.Null2EmptyStr(selectedUser)
            }).then(async (data) => {
                loading.style.display = "none";
                const viewMoreElement = tabElement.querySelector(".eChat-SuperViewMore");
                viewMoreElement.setAttribute("startIndex", startIndex);

                if (data.length !== 0 || only) {
                    tabElement.style.display = "block";
                    listElement.style.display = "block";
                } else {
                    listElement.style.display = "none";
                    tabElement.style.display = "none";
                }

                if (data.length < limit || selectedUser) {
                    viewMoreElement.style.display = "none";
                    if (only && !selectedUser) {
                        noRecordsElement.style.display = "block";
                    } else {
                        noRecordsElement.style.display = "none";
                    }
                } else {
                    viewMoreElement.style.display = "flex";
                    const viewMore = function () {
                        this.removeEventListener("click", viewMore);
                        switchSearchUI("User");
                        searchUser({
                            searchText, limit: 10, startIndex: startIndex + limit, listElement, tabElement, only: true, animationLoading: true
                        });
                    };
                    viewMoreElement.addEventListener("click", viewMore);
                    document.getElementById("EChatRecentList");
                }

                let selectAuthIDArr = [];
                const selectAuthID = document.getElementById("EChatSearchText").getAttribute("selected");
                if (selectAuthID) {
                    selectAuthIDArr = selectAuthID.split(",");
                }

                for (let i = 0, len = data.length; i < len; i++) {
                    const userInfo = data[i];
                    userInfo.DisplayName = EChat.Util.highLight(userInfo.Name, searchText, "yellow", false).text;
                    userInfo.DisplayDepartment = EChat.Util.highLight(userInfo.Department, searchText, "yellow", false).text;
                    userInfo.DisplayJobTitle = EChat.Util.highLight(userInfo.JobTitle, searchText, "yellow", false).text;

                    const userItemDisplay = EChat.CustomComponent.UserItemDisplay(userInfo, true, false);
                    if (userItemDisplay && !listElement.querySelector(`.eChatUserItem[authid='${userInfo.AuthenticationID}']`)) {
                        listElement.querySelector(".eChat-SuperItem").append(userItemDisplay);
                        userItemDisplay.addEventListener("click", function (e) {
                            EChat.CustomComponent.UserSelectEvnet(e, userItemDisplay, "EChatSuperSearchUserList", () => {
                                const authID = parseInt(this.getAttribute("authid"));
                                const userArr = [authID, EChat.DataProvider.CurrentUserInfo.AuthenticationID];
                                EChat.MainPageController.openUserWindowByUserArr(userArr);
                            }, false);
                        });

                        if (selectAuthIDArr.includes(userInfo.AuthenticationID.toString())) {
                            userItemDisplay.querySelector("input").checked = true;
                            userItemDisplay.querySelector(".eChatCheckBoxSpan").style.backgroundPosition = "-30px -25px";
                            userItemDisplay.setAttribute("select", "true");
                        }
                    }
                }
                if (animationLoading) {
                    document.getElementById("EChatRecentList").setAttribute("tab", "viewmore");
                }
                resolve(data.length);
            }).catch((ex) => {
                noRecordsElement.style.display = "block";
                loading.style.display = "none";
                EChat.Util.errorAlert(ex);
                resolve(0);
            });
        });
    };

    const switchSearchUI = function (tab) {
        document.querySelectorAll("#EChatRecentList .eChat-SupuerSearchTab, .eChat-SupuerSearchList, .eChat-SupuerSearchTab .eChat-SuperViewMore").forEach((dom) => {
            if (tab) {
                dom.classList.add("hidden");
            } else {
                dom.classList.remove("hidden");
            }
        });

        document.querySelectorAll("#EChatRecentList .eChat-SupuerSearchTab .ews-icon-back").forEach((dom) => {
            if (tab) {
                dom.classList.remove("hidden");
            } else {
                dom.classList.add("hidden");
            }
        });

        document.querySelectorAll("#EChatRecentList .SuperViewMoreTab").forEach((dom) => {
            dom.classList.add("SuperViewMoreTab");
        });

        if (tab) {
            const listDom = document.querySelector(`#EChatRecentList #EChatSuperSearch${tab}List`);
            const tabDom = document.querySelector(`#EChatRecentList #EChatSuperSearch${tab}Tab`);
            const viewMore = tabDom.querySelector("#EChatRecentList .eChat-SuperViewMore");
            const backDom = tabDom.querySelector("#EChatRecentList .ews-icon-back");
            const searchObj = document.getElementById("EChatSearchText");

            listDom.classList.remove("hidden");
            tabDom.classList.remove("hidden");
            tabDom.classList.add("SuperViewMoreTab");
            if (viewMore) {
                viewMore.classList.add("hidden");
            }
            if (backDom) {
                backDom.classList.remove("hidden");
            }

            searchObj.setAttribute("tab", tab);
            backDom.removeEventListener("click", backSearch);
            backDom.addEventListener("click", backSearch);
            searchTextOld = `${searchObj.value}_${tab}`;
        } else {
            EChat.MainPageController.ShowCreateGroupButton("EChatSuperSearchUserList");
        }
    };

    const backSearch = function () {
        const searchObj = document.getElementById("EChatSearchText");
        searchObj.removeAttribute("tab");
        document.getElementById("EChatRecentList").removeAttribute("tab");
        document.querySelectorAll("#EChatRecentList .eChat-SupuerSearchTab .ews-icon-back").forEach((dom) => {
            dom.classList.add("hidden");
        });
        RecentSearch(searchObj);
    };

    // RecentController
    this.searchPanelKeyupEvent = function (e, searchObj, noWait) {
        const listDom = document.getElementById("EChatRecentList");
        EChat.CustomComponent.KeyCodeEvent({
            KeyCode: e ? e.keyCode : 0,
            ListDom: listDom,
            ItemClassArr: ["UserUnit", "eChatUserItem"],
            SelectClass: "eChatSelectItem",
            EnterOpenItem: !searchIng,
            InputEvent: async () => {
                searchIng = true;
                clearTimeout(timeOutThread);
                timeOutThread = setTimeout(async () => {
                    await RecentSearch(searchObj);
                    searchIng = false;
                }, noWait ? 0 : 750);
            }
        });
    };

    const ChineseCharacterPattern = /[\u4E00-\u9FA5]+/;

    const RecentSearch = async function (searchObj) {
        let searchText = EC_Fmt.Null2EmptyStr(searchObj.value);
        const tab = searchObj.getAttribute("tab");
        if (`${searchText}_${tab}` === searchTextOld && searchText) {
            return;
        }

        searchTextOld = `${searchText}_${tab}`;

        if (ChineseCharacterPattern.test(searchText)) {
            if (searchText.length < 2 && searchText.length !== 0) {
                return;
            }
        } else if (searchText.length < 3 && searchText.length !== 0) {
            return;
        }

        if (searchText.length > 50) {
            searchText = searchText.substr(0, 50);
            if (searchObj) {
                searchObj.Value = searchText;
            }
        }

        let selectAuthIDArr = [];
        if (!tab || tab === "User") {
            const EChatSearchText = document.getElementById("EChatSearchText");
            const selectedStr = EChatSearchText.getAttribute("selected");
            if (selectedStr) {
                selectAuthIDArr = selectedStr.split(",");
            }

            document.querySelectorAll("#EChatSuperSearchUserList input:checked").forEach((dom) => {
                const authid = dom.getAttribute("authid");
                if (!selectAuthIDArr.includes(authid)) {
                    selectAuthIDArr.push(authid);
                }
            });

            if (selectAuthIDArr.length !== 0) {
                EChatSearchText.setAttribute("selected", selectAuthIDArr.join(","));
            }
        }

        const EChatRecentList = document.getElementById("EChatRecentList");
        if (searchText) {
            EChatRecentList.innerHTML = document.getElementById("EChatSuperSearch").innerHTML;
            const EChatSuperSearchUnreadTab = EChatRecentList.querySelector("#EChatSuperSearchUnreadTab");
            const EChatSuperSearchUnreadList = EChatRecentList.querySelector("#EChatSuperSearchUnreadList");

            const EChatSuperSearchMessageAndTaskTab = EChatRecentList.querySelector("#EChatSuperSearchMessageAndTaskTab");
            const EChatSuperSearchMessageAndTaskList = EChatRecentList.querySelector("#EChatSuperSearchMessageAndTaskList");

            const EChatSuperSearchGroupTab = EChatRecentList.querySelector("#EChatSuperSearchGroupTab");
            const EChatSuperSearchGroupList = EChatRecentList.querySelector("#EChatSuperSearchGroupList");

            const EChatSuperSearchUserTab = EChatRecentList.querySelector("#EChatSuperSearchUserTab");
            const EChatSuperSearchUserList = EChatRecentList.querySelector("#EChatSuperSearchUserList");

            EChatRecentList.querySelectorAll(".eChat-SupuerSearchNoRecords").forEach((dom) => {
                dom.style.display = "none";
            });
            const promiseArr = [];

            if (searchText.toLowerCase() === "unread") {
                EChatSuperSearchUnreadTab.style.display = "block";
                EChatSuperSearchUnreadList.style.display = "block";
                promiseArr.push(searchUnread({
                    searchText, listElement: EChatSuperSearchUnreadList, tabElement: EChatSuperSearchUnreadTab
                }));
            } else {
                EChatSuperSearchUnreadTab.style.display = "none";
                EChatSuperSearchUnreadList.style.display = "none";
            }

            const startIndex = 0;
            const limit = tab ? 20 : 3;

            switchSearchUI(tab);
            EChat.MainPageController.ShowCreateGroupButton("EChatSuperSearchUserList");

            if (!tab || tab === "User") {
                promiseArr.push(searchUser({
                    searchText, limit, startIndex, listElement: EChatSuperSearchUserList, tabElement: EChatSuperSearchUserTab, only: !!tab
                }));
            }

            if (!tab || tab === "MessageAndTask") {
                promiseArr.push(searchMessageAndTask({
                    searchText, limit, startIndex, listElement: EChatSuperSearchMessageAndTaskList, tabElement: EChatSuperSearchMessageAndTaskTab, only: !!tab
                }));
            }

            if (!tab || tab === "Group") {
                promiseArr.push(searchGroup({
                    searchText, limit, startIndex, listElement: EChatSuperSearchGroupList, tabElement: EChatSuperSearchGroupTab, only: !!tab
                }));
            }
            const dataCountArr = await Promise.all(promiseArr);
            // Show No Records
            if (!tab) {
                let hasResult = false;
                for (let i = 0; i < dataCountArr.length; i++) {
                    if (dataCountArr[i] > 0) {
                        hasResult = true;
                        break;
                    }
                }

                if (!hasResult) {
                    const noMore = EChatRecentList.querySelector(".EChatSuperSearch.eChat-SupuerSearchNoRecords");
                    noMore.style.display = "block";
                }
            }

            document.querySelectorAll("#EChatRecentSection .eChat-SupuerSearchList").forEach((dom) => {
                dom.addEventListener("scroll", function () {
                    if (this.scrollTop + this.clientHeight >= (this.scrollHeight - 1) && canEnter) {
                        const searchDom = document.getElementById("EChatSearchText");
                        const tabName = searchDom.getAttribute("tab");
                        const searchValue = EC_Fmt.Null2EmptyStr(searchDom.value);
                        if (tabName && searchValue) {
                            const viewMoreElement = document.querySelector(`#EChatRecentList #EChatSuperSearch${tabName}Tab .eChat-SuperViewMore`);
                            const NoRecords = document.querySelector(`#EChatRecentList #EChatSuperSearch${tabName}List .eChat-SupuerSearchNoRecords`);
                            if (NoRecords.clientWidth === 0) {
                                const limitCount = 10;
                                const nextStartIndex = EC_Fmt.Null2ZeroInt(viewMoreElement.getAttribute("startIndex")) + limitCount;
                                const tabElement = document.querySelector(`#EChatRecentList #EChatSuperSearch${tabName}Tab`);
                                const listElement = document.querySelector(`#EChatRecentList #EChatSuperSearch${tabName}List`);

                                switch (tabName) {
                                    case "User":
                                        canEnter = false;
                                        searchUser({
                                            searchText: searchValue, limit: limitCount, startIndex: nextStartIndex, listElement, tabElement, only: true
                                        }).then(() => {
                                            canEnter = true;
                                        }).catch(() => {
                                            canEnter = true;
                                        });
                                        break;
                                    case "MessageAndTask":
                                        canEnter = false;
                                        searchMessageAndTask({
                                            searchText: searchValue, limit: limitCount, startIndex: nextStartIndex, listElement, tabElement, only: true
                                        }).then(() => {
                                            canEnter = true;
                                        }).catch(() => {
                                            canEnter = true;
                                        });
                                        break;
                                    case "Group":
                                        canEnter = false;
                                        searchGroup({
                                            searchText: searchValue, limit: limitCount, startIndex: nextStartIndex, listElement, tabElement, only: true
                                        }).then(() => {
                                            canEnter = true;
                                        }).catch(() => {
                                            canEnter = true;
                                        });
                                        break;
                                }
                            }
                        }
                    }
                });
            });
        } else if (selectAuthIDArr.length > 0 && (!tab || tab === "User")) {
            const EChatSuperSearchUserTab = EChatRecentList.querySelector("#EChatSuperSearchUserTab");
            const EChatSuperSearchUserList = EChatRecentList.querySelector("#EChatSuperSearchUserList");

            const ItemList = EChatRecentList.querySelector("#EChatSuperSearchUserList .eChat-SuperItem");
            ItemList.innerHTML = "";

            const clearAll = EC_Fmt.HtmlStrToElement("<span class=eChat-Clear style=padding-left:10px>Clear All</span>");
            ItemList.append(clearAll);
            clearAll.addEventListener("click", () => {
                EC_Fmt.TriggerEvent(document.getElementById("EChatRecentSwitchBtn"), "click");
            });

            EChatRecentList.querySelectorAll(".eChat-SupuerSearchTab, .eChat-SupuerSearchList").forEach((dom) => {
                if (dom.id !== "EChatSuperSearchUserTab" && dom.id !== "EChatSuperSearchUserList") {
                    dom.remove();
                }
            });

            await searchUser({
                searchText: "", limit: 0, startIndex: 0, listElement: EChatSuperSearchUserList, tabElement: EChatSuperSearchUserTab, only: !!tab, selectedUser: selectAuthIDArr.join(",")
            });

            EChat.MainPageController.ShowCreateGroupButton("EChatSuperSearchUserList");
        } else if (tab) {
            EChatRecentList.querySelector(`#EChatSuperSearch${tab}List .eChat-SuperItem`).innerHTML = "";
            EChat.MainPageController.ShowCreateGroupButton("EChatSuperSearchUserList");
        } else {
            switchSearchUI("");
            EChatRecentList.innerHTML = "";
            document.getElementById("EChatSearchText").removeAttribute("selected");
            EChat.MainPageController.ShowCreateGroupButton();
            await EChat.IndexedDB.GetTableAllData(EChat.DBTableName.GROUPINFO).then(async (groupInfoList) => {
                await _this.initViewMore(groupInfoList);
                EChat.MainPageController.updateUnReadNumIcon("search cancel");
            });
        }
    };
};

EChat.CustomGroupController = function () {
    const _this = this;
    let searchIng = false;
    let timeOutThread = 0;

    this.customGroupElement = EChat.Util.PreventScroll(document.getElementById("EChatGroupList"));

    const createCustomGroupElement = function (groupData) {
        const divElement = document.createElement("div");
        divElement.className = "eChatCustomGroupItem";
        divElement.id = `CustomGroup${groupData.MessageGroupID}`;
        divElement.setAttribute("groupid", groupData.MessageGroupID);
        const userIcoSpan = document.createElement("SPAN");
        userIcoSpan.classList.add("Left");
        const groupIconUrl = EChat.DataProvider.GetGroupAvatarUrlAndAuthID(groupData, EChat.DataProvider.CurrentUserInfo).Url;
        userIcoSpan.style.marginRight = "5px";
        userIcoSpan.style.backgroundImage = `url(${groupIconUrl})`;
        userIcoSpan.classList.add("eChat-ico-GroupIcon");

        divElement.append(userIcoSpan);

        const nameSpan = document.createElement("span");
        nameSpan.className = "eChatUserName eChat-TextHidden";
        nameSpan.textContent = groupData.GroupName;
        nameSpan.setAttribute("title", groupData.GroupName);

        const includeUserSpan = document.createElement("SPAN");
        const searchText = EChat.Util.getSearchText();
        const members = document.createElement("span");
        members.className = "eChat-Custom-group-member Right";
        members.textContent = `${groupData.UserCount} members`;

        if (searchText) {
            const groupNameDisplay = EChat.Util.highLight(groupData.GroupName, searchText, "yellow", false).text;
            nameSpan.innerHTML = groupNameDisplay;
            if (groupData.IncludeUser) {
                nameSpan.setAttribute("title", `${groupData.GroupName} (Includes ${groupData.IncludeUser})`);
                const IncludeUser = EChat.Util.highLight(groupData.IncludeUser, searchText, "yellow", false).text;
                nameSpan.innerHTML += ` (Includes ${IncludeUser})`;
            }
        } else {
            nameSpan.textContent = groupData.GroupName;
            divElement.append(members);
        }

        divElement.append(nameSpan);
        divElement.append(includeUserSpan);

        const groupToolBtn = document.createElement("span");
        groupToolBtn.className = "Right padding-right-5 custom-group-btn";
        groupToolBtn.setAttribute("groupid", groupData.MessageGroupID);
        if (groupData.PostPermission !== EChat.PostPermissionType.ReadOnly) {
            // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
            const editButton = EC_Fmt.HtmlStrToElement("<ecp-btn icon='ews-icon-edit' type='ghost' style='margin-top:3px;margin-right:-5px;width:26px;height:26px;font-size:16px'></span>");
            editButton.addEventListener("click", (e) => {
                EChat.GroupSettingController.openGroupSettingWindow(groupData.MessageGroupID);
                e.stopPropagation();
            });
            groupToolBtn.append(editButton);
        }
        groupToolBtn.append(EChat.MainPageController.GetMinEditPromptButton(groupData));
        divElement.append(groupToolBtn);

        divElement.addEventListener("click", function (e) {
            const groupId = this.getAttribute("groupid");
            if (groupId) {
                EChat.DataProvider.GetGroupInfoByGroupID(groupId).then((groupInfo) => {
                    EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, true);
                });
            }
            e.stopPropagation();
        });

        return divElement;
    };

    // Task 994745: Directory -> Groups. Add group member search
    this.CustomGroupSearch = async function (Search) {
        const EChatGroupList = document.getElementById("EChatGroupList");
        EChatGroupList.innerHTML = "";
        EChat.Util.ShowLoading(EChatGroupList, Search ? "Searching" : "");
        const groupList = await EChat.DataProvider.GetCustomerGroup(Search);
        if (groupList) {
            for (let i = 0; i < groupList.length; i++) {
                const item = createCustomGroupElement(groupList[i]);
                _this.customGroupElement.append(item);
            }
        }
        ECP.Dialog.HideLoading();
    };

    this.redrawCustomGroup = function (groupData) {
        if (!EChat.Util.IsRecentSearchState()) {
            return;
        }

        const customGroup = document.getElementById(`CustomGroup${groupData.MessageGroupID}`);
        if (customGroup) {
            customGroup.remove();
        }
        if (groupData.GroupName) {
            const groupElement = createCustomGroupElement(groupData);
            const EChatGroupList = document.getElementById("EChatGroupList");
            if (groupElement && EChatGroupList) {
                EChatGroupList.prepend(groupElement);
            }
        }
    };

    this.deleteGroup = function (groupId) {
        const customGroup = document.getElementById(`CustomGroup${groupId}`);
        if (customGroup) {
            customGroup.remove();
        }
    };

    // CustomGroupController
    this.searchPanelKeyupEvent = function (e, searchObj, noWait) {
        const listDom = document.getElementById("EChatGroupList");
        EChat.CustomComponent.KeyCodeEvent({
            KeyCode: e ? e.keyCode : 0,
            ListDom: listDom,
            ItemClassArr: ["eChatCustomGroupItem"],
            SelectClass: "eChatSelectItem",
            EnterOpenItem: !searchIng,
            InputEvent: () => {
                searchIng = true;
                clearTimeout(timeOutThread);
                timeOutThread = setTimeout(async () => {
                    await _this.CustomGroupSearch(searchObj.value);
                    searchIng = false;
                }, noWait ? 0 : 750);
            }
        });
    };
};

EChat.UserController = function () {
    const _this = this;
    let searchIng = false;
    let timeOutThread;

    this.userListElement = document.getElementById("EChatUserList");

    const userClickEvent = function (element) {
        const authID = element.getAttribute("authid");
        const userArr = [authID, EChat.DataProvider.CurrentUserInfo.AuthenticationID];
        EChat.MainPageController.openUserWindowByUserArr(userArr);
    };

    const createGroupClickEvent = function () {
        const userArr = [];
        const userListElement = _this.userListElement;
        const EChatCreateGroup = document.getElementById("EChatCreateGroup");
        const itemid = EChatCreateGroup.getAttribute("itemid");
        if (!itemid) {
            return;
        }

        document.querySelectorAll(`#${itemid} input:checked`).forEach((dom) => {
            userArr.push(parseInt(dom.getAttribute("authid")));
        });

        // Task :996408 eChat: When searching for multiple users and selecting 'Create Group' the group only contains the last user selected.
        const selected = document.getElementById("EChatSearchText").getAttribute("selected");
        if (selected) {
            const selectedArr = selected.split(",");
            for (let i = 0; i < selectedArr.length; i++) {
                const authid = parseInt(selectedArr[i]);
                if (!userArr.includes(authid)) {
                    userArr.push(authid);
                }
            }
        }

        if (userArr.length) {
            const userStr = EChat.DataProvider.GetUserStrByUserList(userArr);
            EChat.DataProvider.GetGroupInfoByAuthIDList(userStr).then((groupInfo) => {
                EC_Fmt.TriggerEvent(document.getElementById("EChatRecentSwitchBtn"), "click");
                EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, false);
            }).catch((ex) => {
                // eslint-disable-next-line no-console
                console.error(ex);
            });

            userListElement.querySelector("#EChatUserListItems").innerHTML = "";
            document.getElementById("EChatSearchText").value = "";
        } else {
            const userElement = userListElement.querySelector("#EChatUserListItems .eChatSelectItem input");
            if (userElement) {
                userListElement.querySelector("#EChatUserListItems").innerHTML = "";
                document.getElementById("EChatSearchText").value = "";

                const userStr = EChat.DataProvider.GetUserStrByUserList([parseInt(userElement.getAttribute("authid"))]);
                EChat.DataProvider.GetGroupInfoByAuthIDList(userStr).then((groupInfo) => {
                    EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, false);
                    EC_Fmt.TriggerEvent(document.getElementById("EChatRecentSwitchBtn"), "click");
                }).catch(EChat.Util.errorAlert);
            }
        }
    };

    const UserSearch = function () {
        const listDom = document.getElementById("EChatUserListItems");
        const SearchDom = document.getElementById("EChatSearchText");
        const SearchText = EChat.Util.getSearchText();
        const userFilters = document.getElementById("ews-eChat-advanced-search-menu");
        return EChat.CustomComponent.UserSearch({
            All: false,
            UserTypeID: !EC_Fmt.isNull(userFilters) ? EC_Fmt.Null2NullStr(userFilters.querySelector("#EChatSelectUserType input[type='hidden']").value) : "Null",
            LocationID: !EC_Fmt.isNull(userFilters) ? EC_Fmt.Null2NullStr(userFilters.querySelector("#EChatSelectLocation input[type='hidden']").value) : "Null",
            RoleID: !EC_Fmt.isNull(userFilters) ? EC_Fmt.Null2NullStr(userFilters.querySelector("#EChatSelectRole input[type='hidden']").value) : "Null",
            Search: SearchText,
            Container: listDom,
            ClickCallBack: userClickEvent,
            Mark: document.getElementById("EChatUserList"),
            SearchDom,
            SearchIcon: false,
            ShowUserType: true,
            ShowFilters: true,
            HiddenCreateGroupBtn: false
        }).then(() => {
            EChat.MainPageController.ShowCreateGroupButton("EChatUserListItems");
        }).catch();
    };

    // UserController
    this.searchPanelKeyupEvent = function (e, searchObj, noWait) {
        const listDom = document.getElementById("EChatUserList");
        EChat.CustomComponent.KeyCodeEvent({
            KeyCode: e ? e.keyCode : 0,
            ListDom: listDom,
            ItemClassArr: ["eChatUserItem"],
            SelectClass: "eChatSelectItem",
            EnterEvent: () => {
                if (!searchIng) {
                    createGroupClickEvent();
                }
            },
            InputEvent: async () => {
                searchIng = true;
                clearTimeout(timeOutThread);
                timeOutThread = setTimeout(async () => {
                    await UserSearch();
                    searchIng = false;
                }, noWait ? 0 : 750);
            }
        });
    };

    this.InitSearch = function () {
        const createGroupBtn = document.getElementById("EChatCreateGroup");
        createGroupBtn.removeEventListener("click", createGroupClickEvent);
        createGroupBtn.addEventListener("click", createGroupClickEvent);
    };
};

EChat.SubscribeController = function () {
    const _this = this;

    const createTableAlertElement = function (tableAlertInfo) {
        if (!tableAlertInfo) {
            return null;
        }

        const element = document.createElement("div");
        element.id = `SubscribeAlertID_${tableAlertInfo.AlertID}`;
        element.className = "eChat-DataList eChat-NoTextSelect";
        element.setAttribute("AlertID", tableAlertInfo.AlertID);
        element.title = tableAlertInfo.Description;
        const topElement = document.createElement("div");
        topElement.className = "eChat-AlertTitle";
        const alertNameElement = document.createElement("span");
        alertNameElement.className = "Left eChat-TextHidden";
        alertNameElement.style.width = "230px";
        alertNameElement.textContent = tableAlertInfo.Alert;

        let allCheck = false;
        let eChatCheck = false;
        let eMailCheck = false;
        let textCheck = false;

        if (Array.isArray(tableAlertInfo.DeliveryMethodList)) {
            if (tableAlertInfo.DeliveryMethodList.length > 0) {
                allCheck = true;
                for (let i = 0; i < tableAlertInfo.DeliveryMethodList.length; i++) {
                    switch (tableAlertInfo.DeliveryMethodList[i]) {
                        case EChat.DeliveryMethod.eChat:
                            eChatCheck = true;
                            break;
                        case EChat.DeliveryMethod.Email:
                            eMailCheck = true;
                            break;
                        case EChat.DeliveryMethod.TextMessage:
                            textCheck = true;
                            break;
                    }
                }
            }
        }

        const switchButton = EChat.CustomComponent.SwichButton({
            id: `AlertSetting_${tableAlertInfo.AlertID}`,
            checked: allCheck,
            changeEvent(value) {
                if (parseInt(value) === 0) {
                    subScribeAlert(value, tableAlertInfo.AlertID, `${EChat.DeliveryMethod.eChat.toString()},${EChat.DeliveryMethod.Email.toString()},${EChat.DeliveryMethod.TextMessage.toString()}`);
                    eChatCheckBox.Close();
                    eMailCheckBox.Close();
                    textCheckBox.Close();
                }
            }
        }, topElement);

        topElement.append(alertNameElement);
        const bottomElement = document.createElement("div");
        bottomElement.className = "eChat-AlertCheckList";

        const checkCondition = function () {
            return switchButton.Checked();
        };

        const eChatCheckBox = EChat.CustomComponent.TextCheckBox({
            id: null,
            checked: eChatCheck,
            changeEvent(value) {
                subScribeAlert(value, tableAlertInfo.AlertID, EChat.DeliveryMethod.eChat);
            },
            checkCondition,
            text: EC_Fmt.Trn("eChat")
        }, bottomElement);

        const eMailCheckBox = EChat.CustomComponent.TextCheckBox({
            id: null,
            checked: eMailCheck,
            changeEvent(value) {
                subScribeAlert(value, tableAlertInfo.AlertID, EChat.DeliveryMethod.Email);
            },
            checkCondition,
            text: EC_Fmt.Trn("Email")
        }, bottomElement);

        const textCheckBox = EChat.CustomComponent.TextCheckBox({
            id: null,
            checked: textCheck,
            changeEvent(value) {
                subScribeAlert(value, tableAlertInfo.AlertID, EChat.DeliveryMethod.TextMessage);
            },
            checkCondition,
            text: EC_Fmt.Trn("Text")
        }, bottomElement);

        element.append(topElement);
        element.append(bottomElement);
        return element;
    };

    const subScribeAlert = function (subScribeType, alertId, deliveryMethodStr) {
        EChat.DataProvider.subScribeAlert(subScribeType, alertId, deliveryMethodStr);
    };

    this.drawTableAlerts = function (tableAlertList) {
        this.subscribeListElement = EChat.Util.PreventScroll(document.querySelector("#EChatSubscribeList .eChat-List"));
        if (Array.isArray(tableAlertList)) {
            tableAlertList.sort((a, b) => (b.DeliveryMethodList.length - a.DeliveryMethodList.length));
            for (let i = 0; i < tableAlertList.length; i++) {
                const SubscribeAlert = document.getElementById(`SubscribeAlertID_${tableAlertList[i].AlertID}`);
                if (SubscribeAlert) {
                    SubscribeAlert.remove();
                }

                const targetElement = createTableAlertElement(tableAlertList[i]);
                if (targetElement) {
                    _this.subscribeListElement.append(targetElement);
                }
            }
        }
    };
};

EChat.SettingsController = function () {
    const _this = this;
    const SettingType = {
        AudioAlert: "AudioAlert"
    };

    EChat.Util.PreventScroll(document.getElementById("EChatSettingsList"));

    const initEChatAudioAlert = function () {
        const eChatAudioAlertElement = document.querySelector("#EChatAudioAlert input");
        if (EChat.DataProvider.CurrentUserInfo.AudioAlert === 0) {
            eChatAudioAlertElement.checked = false;
        } else {
            eChatAudioAlertElement.checked = true;
        }

        eChatAudioAlertElement.addEventListener("change", () => {
            if (eChatAudioAlertElement.checked) {
                _this.updateSettings(SettingType.AudioAlert, 1, false);
            } else {
                _this.updateSettings(SettingType.AudioAlert, 0, false);
            }
        });
    };

    this.updateSettings = function (settingType, settingValue, isFromLocalStorage) {
        settingValue = parseInt(settingValue);
        const eChatDataProvider = EChat.DataProvider;
        switch (settingType) {
            case SettingType.AudioAlert:
                eChatDataProvider.CurrentUserInfo.AudioAlert = settingValue;
                const checkBox = document.getElementById("EChatAlertCheckBox");
                if (checkBox) {
                    checkBox.checked = settingValue === 1;
                }

                if (!isFromLocalStorage) {
                    const data = {
                        AudioAlert: settingValue
                    };
                    EChat.DataProvider.api("SalesComm_EChatAudioSetting", data).then(() => {
                        EChat.IndexedDB.GetSetting("InitUser").then((setting) => {
                            if (setting) {
                                setting.AudioAlert = settingValue;
                                EChat.IndexedDB.UpdateSetting("InitUser", setting, true);
                            }
                        });
                    });
                }
                break;
        }
    };

    this.searchPanelKeyupEvent = function (e, searchObj) {
        const key = searchObj.value;
        const subscribeListDiv = document.querySelectorAll("#EChatSubscribeList .eChat-DataList");
        if (subscribeListDiv.length === 0) {
            return;
        }
        let emptyDiv = document.getElementById("EChatSubEmptyMsg");
        if (!emptyDiv) {
            emptyDiv = EC_Fmt.HtmlStrToElement("<di id=EChatSubEmptyMsg style=font-size:14px;padding-left:10px>No Subscribe Found</div>");
            document.getElementById("EChatSubscribeList").append(emptyDiv);
        }
        let showEmpty = true;
        if (key !== "") {
            subscribeListDiv.forEach((dom) => {
                dom.style.display = "none";
                const nameSpans = dom.querySelectorAll(".eChat-AlertTitle span");
                let subScribeNameStr = "";
                if (nameSpans.length > 2) {
                    subScribeNameStr = nameSpans[2].innerHTML.toLowerCase();
                }

                if (subScribeNameStr.indexOf(key.toLowerCase()) > -1) {
                    dom.style.display = "block";
                    showEmpty = false;
                }
            });
        } else {
            showEmpty = false;
            document.querySelectorAll("#EChatSubscribeList .eChat-DataList").forEach((dom) => {
                dom.style.display = "block";
            });
        }
        if (showEmpty) {
            emptyDiv.style.display = "block";
        } else {
            emptyDiv.style.display = "none";
        }
    };

    const initEChatLoadingGif = function () {
        const pElement = EC_Fmt.HtmlStrToElement("<div class=\"donutSpinner eChatAbsolute eChat-MessagesLoading\"id=EChatLoadingList><div class=loader></div></div>");
        const EChatMainPage = document.getElementById("EChatMainPage");
        if (EChatMainPage) {
            EChatMainPage.prepend(pElement);
        }
    };

    const initEChatUserAvatar = function () {
        document.getElementById("EChatUserName").textContent = EChat.DataProvider.CurrentUserInfo.UserName;

        const UserIconDiv = document.getElementById("UserIconDiv");
        UserIconDiv.classList.add("eChat-User-Img");
        // Task 1108551: Editing eChat Group Image updates User image.
        EChat.CustomComponent.UserAvaterDisplay(UserIconDiv, EChat.DataProvider.CurrentUserInfo.UserAvatar, 1, 50, 50, true);
    };

    const initEChatDBButton = function () {
        document.getElementById("ClearDBButton").addEventListener("click", () => {
            EChat.MainPageController.ReloadEChatData("Clear Success");
        });

        document.getElementById("ClearUnreadButton").addEventListener("click", () => {
            EChat.DataProvider.ReadAllGroup();
        });
    };
    initEChatLoadingGif();
    initEChatAudioAlert();
    initEChatUserAvatar();
    initEChatDBButton();
};

EChat.MessageWindowController = function () {
    const _this = this;
    // Data
    this.chatTabList = {};
    this.chatTabListCount = 0;
    this.currentTab = null;

    // View
    this.minimizeIsMoved = true;
    this.messageWindowViewType = null;
    this.minimizeTwinkle = false;
    this.isPublicSwitch = null;
    this.notifySwitch = null;
    // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
    this.notifyInternalSwitch = null;
    this.editPrompt = null;
    this.tabWidth = 150;

    const originalPoint = {
        Left: 0,
        Top: 0
    };

    this.getOriginalPoint = function () {
        return originalPoint;
    };

    this.element = null;
    let inputArea = null;
    let windowElement = null;
    let headerElement = null;
    let minimizeElement = null;
    let dialogElement = null;
    let sendElement = null;
    let handleElement = null;
    let resizeElement = null;
    let taskTitleElement = null;
    let searchElement = null;

    // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
    const createFloatLinkElement = function () {
        removeSearchElement();
        removeFloatFileElement();
        let element = null;
        if (sendElement) {
            // element = sendElement.querySelector(".eChat-FloatLinkTool");
            element = document.querySelector(".eChat-FloatLinkTool");
        }

        if (!element) {
            element = document.createElement("div");
            element.className = "eChat-FloatLinkTool eChat-NoTextSelect";

            const textInput = document.createElement("div");
            textInput.style.height = "30px";
            textInput.style.display = "flex";
            textInput.style.margin = "10px 20px 0";
            textInput.style.alignItems = "center";

            const textLabel = document.createElement("div");
            textLabel.style.width = "118px";
            textLabel.style.fontSize = "14px";
            textLabel.textContent = "Text to display";

            const textInputField = document.createElement("input");
            textInputField.className = "link-display";
            textInputField.style.width = "306px";
            textInputField.style.height = "32px";

            textInput.appendChild(textLabel);
            textInput.appendChild(textInputField);

            if (inputArea) {
                const tmpText = inputArea.getSelectValue();
                if (typeof tmpText === "string" && tmpText) {
                    textInputField.value = tmpText;
                    textInputField.setAttribute("id", "haveValue");
                }
            }
            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            const topDiv = document.createElement("div");
            topDiv.className = "top-div";
            topDiv.style.height = "35px";
            topDiv.style.padding = "0 10px";
            topDiv.style.fontSize = "11pt";
            topDiv.textContent = "Insert link";

            const centreDiv = document.createElement("div");
            centreDiv.className = "centre-div";

            const urlContainer = document.createElement("div");
            urlContainer.style.height = "30px";
            urlContainer.style.display = "flex";
            urlContainer.style.margin = "20px 20px 0";
            urlContainer.style.alignItems = "center";

            const urlLabel = document.createElement("div");
            urlLabel.style.width = "118px";
            urlLabel.style.fontSize = "14px";
            urlLabel.textContent = "Url";

            const urlInput = document.createElement("input");
            urlInput.className = "link-url";
            urlInput.style.width = "306px";
            urlInput.style.height = "32px";

            urlContainer.appendChild(urlLabel);
            urlContainer.appendChild(urlInput);
            centreDiv.appendChild(urlContainer);
            centreDiv.appendChild(textInput);

            const titleContainer = document.createElement("div");
            titleContainer.style.height = "30px";
            titleContainer.style.display = "flex";
            titleContainer.style.margin = "10px 20px 0";
            titleContainer.style.alignItems = "center";

            const titleLabel = document.createElement("div");
            titleLabel.style.width = "118px";
            titleLabel.style.fontSize = "14px";
            titleLabel.textContent = "Title";

            const titleInput = document.createElement("input");
            titleInput.className = "link-title";
            titleInput.style.width = "306px";
            titleInput.style.height = "32px";

            titleContainer.appendChild(titleLabel);
            titleContainer.appendChild(titleInput);
            centreDiv.appendChild(titleContainer);

            const targetContainer = document.createElement("div");
            targetContainer.style.height = "30px";
            targetContainer.style.display = "flex";
            targetContainer.style.margin = "10px 20px 0";
            targetContainer.style.alignItems = "center";

            const targetLabel = document.createElement("div");
            targetLabel.style.width = "118px";
            targetLabel.style.fontSize = "14px";
            targetLabel.textContent = "Target";

            const selectContainer = document.createElement("div");
            selectContainer.className = "ecp-select full-width";
            selectContainer.style.width = "306px";
            selectContainer.style.height = "32px";

            const targetSelect = document.createElement("select");
            targetSelect.className = "ecp-select full-width link-targer";
            targetSelect.style.fontSize = "14px";
            targetSelect.style.height = "32px";

            const noneOption = document.createElement("option");
            noneOption.value = "None";
            noneOption.textContent = "None";

            const newWindowOption = document.createElement("option");
            newWindowOption.value = "NewWindow";
            newWindowOption.textContent = "New window";

            targetSelect.appendChild(noneOption);
            targetSelect.appendChild(newWindowOption);
            selectContainer.appendChild(targetSelect);
            targetContainer.appendChild(targetLabel);
            targetContainer.appendChild(selectContainer);
            centreDiv.appendChild(targetContainer);

            const bottomDiv = document.createElement("div");
            bottomDiv.className = "bottom-div";
            bottomDiv.style.display = "flex";
            bottomDiv.style.height = "50px";
            bottomDiv.style.alignItems = "flex-end";
            bottomDiv.style.flexDirection = "row";
            bottomDiv.style.justifyContent = "flex-end";
            bottomDiv.style.marginTop = "10px";

            const cancelButton = document.createElement("ecp-btn");
            cancelButton.setAttribute("type", "secondary");
            cancelButton.textContent = "Cancel";

            const okButton = document.createElement("ecp-btn");
            okButton.setAttribute("type", "primary");
            okButton.textContent = "OK";

            bottomDiv.appendChild(cancelButton);
            bottomDiv.appendChild(okButton);

            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            cancelButton.addEventListener("click", () => {
                removeFloatLinkElement();
            });
            document.addEventListener("keydown", (e) => {
                if (e.keyCode === 27) {
                    removeFloatLinkElement();
                } else if (e.keyCode === 13) {
                    calculateFloatLinkElement();
                    e.preventDefault();
                }
            });
            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            okButton.addEventListener("click", (e) => {
                calculateFloatLinkElement();
                e.stopPropagation();
            });

            element.append(topDiv);
            element.append(centreDiv);
            element.append(bottomDiv);

            element.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        }
        return element;
    };

    // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
    const calculateFloatLinkElement = function () {
        let linkUrl = document.querySelector(".link-url").value;
        const linkDisplay = document.querySelector(".link-display").value;
        const linkTitle = document.querySelector(".link-title").value;
        const linkTarger = document.querySelector(".link-targer").value;

        if (EC_Fmt.isNull(linkUrl)) {
            removeFloatLinkElement();
            return;
        }
        if (linkUrl) {
            const urlRegex = "^(http|ftp|https)\\:\\/\\/";
            const reg = new RegExp(urlRegex, "i");
            if (!reg.test(linkUrl)) {
                linkUrl = `https://${linkUrl}`;
            }
            const linkText = document.querySelector(".link-display");
            if (linkText.id === "haveValue") {
                if (linkTarger === "NewWindow") {
                    inputArea.replaceLinkNew(linkDisplay, linkUrl, linkTitle);
                } else if (linkTarger === "None") {
                    inputArea.replaceLink(linkDisplay, linkUrl, linkTitle);
                }
            } else if (linkTarger === "NewWindow") {
                inputArea.insertLinkNew(linkDisplay, linkUrl, linkTitle);
            } else if (linkTarger === "None") {
                inputArea.insertLink(linkDisplay, linkUrl, linkTitle);
            }
        }
        _this.currentTab.PreMessage = inputArea.getValue();
        removeFloatLinkElement();
    };

    const removeFloatLinkElement = function () {
        if (sendElement) {
            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            // const element = sendElement.querySelector(".eChat-FloatLinkTool");
            const element = document.querySelector(".eChat-FloatLinkTool");
            if (element) {
                element.remove();
            }
        }
    };

    // dialog for set send time
    const createDelayedSendTimeElement = function () {
        removeSearchElement();
        removeFloatLinkElement();
        removeFloatFileElement();
        removeSearchDisplayElement();
        removeDelayedSendTimeElement();
        const element = EC_Fmt.HtmlStrToElement("<div class='eChat-SetTimeTool eChat-NoTextSelect'title='Delayed Send Time'></div>");
        // Task 1149732: Update 'eChat' page to new button component
        const table = EC_Fmt.HtmlStrToElement("<table aligin=center class=DatePickerField><tbody><tr></tr></tbody></table>");
        const dateTimehtml = document.createElement("TD");
        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
        dateTimehtml.append(EC_Fmt.HtmlStrToElement(ECP.HTML.DateTimeInput("echat_DelayedTime", "echat_DelayedTime", true, Date(), "Date", "", "")));
        dateTimehtml.setAttribute("width", "157");

        const delayTip = function (e) {
            const echat_DelayedTime_Display = document.getElementById("echat_DelayedTime_Display");
            if (echat_DelayedTime_Display) {
                const DelayedTime = echat_DelayedTime_Display.value;
                if (!EC_Fmt.isNull(DelayedTime)) {
                    const DisplaySendMessage = document.getElementById("DisplaySendMessage");
                    DisplaySendMessage.innerHTML = `Message will send at <span style=color:var(--text-secondary)>${DelayedTime}</span>`;
                }
            }
            e.stopPropagation();
        };
        const display = dateTimehtml.querySelector("#echat_DelayedTime");
        if (display) {
            display.addEventListener("blur", delayTip);
            display.addEventListener("focus", delayTip);
        }
        // Task 1149732: Update 'eChat' page to new button component
        const Delaybutton = EC_Fmt.HtmlStrToElement("<td style='padding: 2px 0 2px 0;' valign=top></td>");
        // const delayInput = EC_Fmt.HtmlStrToElement("<input type=submit value=OK class=Button>");
        const delayInput = EC_Fmt.HtmlStrToElement("<ecp-btn>OK</ecp-btn>");
        delayInput.addEventListener("click", (e) => {
            // Task 1132060: echat: Future Send is not working
            const displayDom = dateTimehtml.querySelector("#echat_DelayedTime");
            if (displayDom && !EC_Fmt.isNull(displayDom.value)) {
                sendingMessage();
            }
            removeDelayedSendTimeElement();
            e.stopPropagation();
        });
        Delaybutton.append(delayInput);

        const tableTr = table.querySelector("tr");
        tableTr.append(dateTimehtml);
        tableTr.append(Delaybutton);
        const delayTipDiv = EC_Fmt.HtmlStrToElement("<div id=DisplaySendMessage class=DataChangeDisplayInfo></div>");
        element.append(table);
        element.append(delayTipDiv);
        element.addEventListener("click", (e) => {
            e.stopPropagation();
        });
        return element;
    };

    const removeDelayedSendTimeElement = function () {
        if (sendElement) {
            const element = sendElement.querySelector(".eChat-SetTimeTool");
            if (element) {
                element.remove();
            }
        }
    };

    const removeFloatFileElement = function () {
        if (sendElement) {
            const element = sendElement.querySelector(".eChat-FloatFileTool");
            if (element) {
                element.remove();
            }
        }
    };

    const uploadFiles = function (files) {
        const Tab = _this.currentTab;
        let MessageGroupID = Tab.GroupInfo.MessageGroupID;
        if (Tab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
            MessageGroupID = MessageGroupID.split("_")[0];
        }

        let isPublic = false;
        if (_this.isPublicSwitch && _this.isPublicSwitch.Checked()) {
            isPublic = true;
        }

        let Notify = true;
        if (_this.notifySwitch && !_this.notifySwitch.Checked()) {
            Notify = false;
        }

        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
        let NotifyInternal = true;
        if (_this.notifyInternalSwitch && !_this.notifyInternalSwitch.Checked()) {
            NotifyInternal = false;
        }

        for (let i = 0; i < files.length; i++) {
            const fileObj = files[i];
            const tipDom = document.createElement("DIV");
            tipDom.textContent = `Uploading File: ${fileObj.name}`;
            Tab.AddTipElement(tipDom);
            const chatBoxElement = document.getElementById(`chatBox_${Tab.ID}`);
            if (chatBoxElement) {
                chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
            }

            EChat.DataProvider.SendMessage({
                messageGroupID: MessageGroupID,
                messageMark: EChat.Util.getTimeStamp(),
                messageBody: "",
                imgData: fileObj,
                taskID: Tab.GroupInfo.TaskID,
                isPublic,
                notify: Notify,
                taskSourceEncompassID: Tab.GroupInfo.EncompassID,
                notifyInternal: NotifyInternal
            }).then((msgObj) => {
                EChat.MainPageController.currentMessageWindow.receiveNewMessage(msgObj, Tab.GroupInfo.MessageGroupID);
            }).catch(() => {
                const tipDivDom = document.createElement("DIV");
                tipDivDom.textContent = `Upload failed: ${fileObj.name}`;
                Tab.AddTipElement(tipDivDom);
            });
        }
    };
    const createFloatFileElement = function () {
        removeSearchElement();
        removeFloatLinkElement();
        let element = null;
        if (sendElement) {
            element = sendElement.querySelector(".eChat-FloatFileTool");
        }
        if (!element) {
            element = EC_Fmt.HtmlStrToElement("<div class='eChat-FloatFileTool eChat-NoTextSelect'></div>");
            const div = document.createElement("DIV");
            div.setAttribute("style", "display:flex;");
            const BrowseBtn = EC_Fmt.HtmlStrToElement("<ecp-btn style=margin-right:0>Browse</ecp-btn>");
            BrowseBtn.addEventListener("click", () => {
                windowElement.querySelector("#EChat_File_Input").click();
            });
            div.append(BrowseBtn);
            div.append(EC_Fmt.HtmlStrToElement("<input type=text id=EChat_FileName_Input class=eChat-InputToolInput placeholder='Limit 500MB'>"));
            const EChat_File_Input = EC_Fmt.HtmlStrToElement("<input type=file id=EChat_File_Input multiple=multiple style=display:none>");
            EChat_File_Input.addEventListener("change", () => {
                const files = windowElement.querySelector("#EChat_File_Input").files;
                let FileName_Input = "";
                for (let i = 0; i < files.length; i++) {
                    const fileObj = files[i];
                    if (i > 0) {
                        FileName_Input += ", ";
                    }
                    FileName_Input += fileObj.name;
                }
                windowElement.querySelector("#EChat_FileName_Input").value = FileName_Input;
            });
            div.append(EChat_File_Input);
            const sendBtn = EC_Fmt.HtmlStrToElement("<ecp-btn>Send</ecp-btn>");
            sendBtn.addEventListener("click", (e) => {
                const files = windowElement.querySelector("#EChat_File_Input").files;
                uploadFiles(files);
                removeFloatFileElement();
                e.stopPropagation();
            });
            div.append(sendBtn);
            element.append(div);
            element.append(EC_Fmt.HtmlStrToElement("<span class=InputToolTriangle></span>"));
            element.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        }
        return element;
    };

    const createSearchElement = function () {
        removeFloatLinkElement();

        const rangeElement = document.createElement("select");
        rangeElement.setAttribute("name", "SearchRange");
        rangeElement.classList.add("eChat-SearchItem");
        rangeElement.innerHTML = "<option value=7>Past Week</option><option value=30>Last Month</option><option value=93>Past 3 Months</option><option value=0>All</option>";
        rangeElement.addEventListener("change", function () {
            _this.currentTab.SearchInfo.SearchDate = this.value;
        });

        const element = document.createElement("div");
        element.classList.add("eChat-SearchTool eChat-NoTextSelect");

        const searchBtnClickEvent = function () {
            const inputEle = element.querySelector("input");
            let inputValue = "";
            if (inputEle) {
                inputValue = inputEle.value;
            }

            if (inputValue) {
                inputValue = EC_Fmt.HtmlStrToElement(`<div>${inputValue}</div>`).innerHTML;
                dialogElement.append(createSearchDisplayElment());
                EChat.Util.ShowLoading(dialogElement);
                const selectValue = element.querySelector("select").value;
                if (_this.currentTab) {
                    _this.currentTab.SearchInfo.SearchDate = selectValue;
                    _this.currentTab.SearchInfo.Search = true;
                }
                const groupId = _this.currentTab.GroupInfo.MessageGroupID;
                let promiss;

                if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                    promiss = SocketUtil.api("SearchTaskDetail", { TaskID: _this.currentTab.GroupInfo.TaskID, SearchValue: inputValue, DateRange: selectValue });
                } else {
                    promiss = SocketUtil.api("SearchMessages2006", { MessageGroupID: groupId, SearchValue: inputValue, DateRange: selectValue });
                }

                promiss.then((result) => {
                    ECP.Dialog.HideLoading();
                    displaySearchMessageList(result.Messages, inputValue);
                }).catch(() => {
                    ECP.Dialog.HideLoading();
                    if (dialogElement) {
                        const display = dialogElement.querySelector(".eChat-SearchDisplay");
                        if (display) {
                            display.append(EC_Fmt.HtmlStrToElement("<div style=text-align:center;width:100%>Search Error</div>"));
                        }
                    }
                });
            }
        };
        const div = document.createElement("div");
        div.id = "eChat-SearchToolInside";
        div.innerHTML = "<span class=eChat-SearchItem>Search</span>";
        const SearchItem = document.createElement("input");
        SearchItem.classList.add("eChat-SearchItem", "eChat-InputToolInput");
        SearchItem.addEventListener("keyup", function (e) {
            if (e.keyCode === 13) {
                searchBtnClickEvent();
            } else if (_this.currentTab) {
                _this.currentTab.SearchInfo.SearchText = this.value;
            }
        });

        div.append(SearchItem);

        div.append(rangeElement);

        const SearchButton = EC_Fmt.HtmlStrToElement("<ecp-btn type=primary class=eChat-SearchButton>Search</ecp-btn>");
        SearchButton.addEventListener("click", (e) => {
            searchBtnClickEvent();
            e.stopPropagation();
        });
        div.append(SearchButton);

        const BackButton = EC_Fmt.HtmlStrToElement("<ecp-btn class=eChat-SearchBackButton>Back</ecp-btn>");
        BackButton.addEventListener("click", (e) => {
            removeSearchElement();
            e.stopPropagation();
        });

        div.append(BackButton);
        element.append(div);
        element.addEventListener("click", (e) => {
            e.stopPropagation();
        });
        return element;
    };

    const removeSearchElement = function () {
        if (searchElement) {
            searchElement.innerHTML = "";
            removeSearchDisplayElement();
        }

        if (_this.currentTab) {
            _this.currentTab.SearchInfo = null;
        }
        _this.resizeDialog();
    };

    const createSearchDisplayElment = function () {
        let element = dialogElement.querySelector(".eChat-SearchDisplay");
        if (!element) {
            element = document.createElement("div");
            element.classList.add("eChat-SearchDisplay");
            EChat.Util.PreventScroll(element);
        }
        return element;
    };

    const removeSearchDisplayElement = function () {
        if (dialogElement) {
            const element = dialogElement.querySelector(".eChat-SearchDisplay");
            if (element) {
                element.remove();
            }
        }
    };

    const displaySearchMessageList = function (messageList, inputValue) {
        if (dialogElement) {
            const element = dialogElement.querySelector(".eChat-SearchDisplay");
            if (element) {
                element.innerHTML = "";
                if (messageList.length > 0) {
                    for (let i = messageList.length - 1; i >= 0; i--) {
                        const item = messageList[i];
                        item.Message = item.Message.replace(new RegExp(`(?![^<]*>)(${inputValue})`, "gi"), txt => `<span class='eChat-Highlight'>${txt}</span>`);
                        displaySearchMessageItem(element, item);
                    }
                    element.scrollTop = element.scrollHeight;
                } else {
                    element.append(EC_Fmt.HtmlStrToElement("<div style=text-align:center;width:100%>Message Not Found</div>"));
                }
            }
        }
    };

    const displaySearchMessageItem = function (targetElement, msgObj) {
        const eChatDataProvider = EChat.DataProvider;
        if (msgObj.Message) {
            let senderName;
            if (eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                senderName = eChatDataProvider.CurrentUserInfo.FullName;
            } else {
                senderName = msgObj.SenderFullName;
            }
            let itemElement;
            let msgElement;
            let headImgElement;
            const spaceElement = document.createElement("SPAN");
            spaceElement.classList.add("eChatAbsolute");
            spaceElement.classList.add("ArrHead");
            const senderNameElement = EC_Fmt.HtmlStrToElement(`<div>${senderName}</div>`);
            const textElement = document.createElement("DIV");
            textElement.classList.add("Left");
            textElement.classList.add("DialogBubbleHead");
            if (senderName !== eChatDataProvider.CurrentUserInfo.FullName) {
                itemElement = EC_Fmt.HtmlStrToElement(`<div id='messageblock_${msgObj.MessageID}'class='LeftDialog eChatRelative Left'messageMark='${msgObj.TimeCreated}' messageid='${msgObj.MessageID}'></div>`);
                msgElement = EC_Fmt.HtmlStrToElement("<div class='LeftBubble eChatRelative'></div>");
                senderNameElement.classList.add("MemberName");
                if (msgObj.SenderAuthenticationID !== -1) {
                    headImgElement = EC_Fmt.HtmlStrToElement("<img class='eChat-UserHeadImg Left'stype=cursor:pointer>");
                } else {
                    headImgElement = EC_Fmt.HtmlStrToElement("<img class='eChat-UserHeadImg Left'>");
                }
            } else {
                itemElement = EC_Fmt.HtmlStrToElement(`<div id='messageblock_${msgObj.MessageID}'class='RightDialog eChatRelative Righ'messageMark='${msgObj.TimeCreated}' messageid='${msgObj.MessageID}'></div>`);
                msgElement = EC_Fmt.HtmlStrToElement("<div class='RightBubble eChatRelative'></div>");
                headImgElement = EC_Fmt.HtmlStrToElement("<img class='eChat-UserHeadImg Right'>");
                senderNameElement.classList.add("MemberNameRight");
            }
            if (msgObj.SenderUserAvatar) {
                headImgElement.setAttribute("src", msgObj.SenderUserAvatar);
            } else {
                headImgElement.setAttribute("src", EChat.Setting.DefaultUserIcon);
            }

            if (!eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                headImgElement.addEventListener("click", () => {
                    headImgClickEvent(msgObj.SenderAuthenticationID, userMemberCount);
                });
            }

            if (msgObj.SenderAuthenticationID <= 0) {
                headImgElement.style.cursor = "default";
            }

            const pElement = EC_Fmt.HtmlStrToElement(`<p id='message_${msgObj.MessageID}'messageid='${msgObj.MessageID}'></p>`);

            // Task:208316 Task Edit: eChat messages sent from Task Edit do not display the Return Characters.when the message is first displayed. Very ugly to read in eChat
            msgObj.Message = msgObj.Message.replace(/\n/g, "<br>");
            pElement.append(EC_Fmt.HtmlStrToElement(`<div class=echat_message_base>${msgObj.Message}</div>`));
            EChat.Util.FileLoad(pElement, targetElement, msgObj.SenderAuthenticationID, 423, 200);
            EChat.Util.CopyFormat(pElement);

            textElement.append(pElement);

            msgElement.append(headImgElement);
            msgElement.append(spaceElement);

            if (parseInt(msgObj.SenderAuthenticationID) !== -1) {
                msgElement.append(senderNameElement);
                msgElement.append(document.createElement("DIV"));
            } else {
                msgElement.append(senderNameElement);
            }

            const message_flex = EC_Fmt.HtmlStrToElement(`<div class=message-flex-box></div>`);
            message_flex.append(textElement);
            msgElement.append(message_flex);
            itemElement.append(msgElement);
            const timeElement = EC_Fmt.HtmlStrToElement(`<div class=SendTime messagemark='${msgObj.TimeCreated}'>${EChat.Util.longToDataTime(msgObj.TimeCreated)}</div>`);
            targetElement.append(timeElement);
            targetElement.append(itemElement);
        }
    };

    this.createMessageWindow = function () {
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        windowElement = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindow eChatDraggable' id='eChatMessageWindow'></div>");
        headerElement = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowHead eChatDragTarget'></div>");
        minimizeElement = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowMinimize eChatDragTarget'></div>");
        dialogElement = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowDialog></div>");
        sendElement = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowSend></div>");
        taskTitleElement = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowTitleBox><div class=eChat-MessageWindowTitle></div></div>");
        searchElement = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowSearch></div>");
        handleElement = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowHandle eChatZoom'></div>");
        resizeElement = EC_Fmt.HtmlStrToElement("<div class='eChat-ResizeHandle eChat-Dialog-SE'></div>");

        const Number = document.querySelectorAll("#eChatMessageWindow").length;

        // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
        // Task 1149732: Update 'eChat' page to new button component
        const closeBtn = EC_Fmt.HtmlStrToElement(`<div class='eChat_Frame_Icon_Close' ><div class='eChat-CloseButton'><ecp-btn id='ewsIconCloseMessage${Number}' icon='ews-icon-close' class='echat-MessageBoxButton' type='ghost' style='font-size:16px;'></ecp-btn></div></div>`);

        const closeEvent = (e) => {
            if (e.button === 0) {
                _this.closeMessageWindow();
                e.stopPropagation();
            }
        };

        closeBtn.addEventListener("click", closeEvent);
        closeBtn.addEventListener("mousedown", closeEvent);

        // Task 1149732: Update 'eChat' page to new button component
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const miniziseBtn = EC_Fmt.HtmlStrToElement(`<div class='eChat_Frame_Icon_Minizise'><div class='eChat-MinimizeButton'><ecp-btn id='ewsIconRuleMessage${Number}' icon='ews-icon-rule' type='ghost' class='echat-MessageBoxButton' style='font-size:16px;'></ecp-btn></div></div>`);
        const miniziseEvent = (e) => {
            if (e.button === 0) {
                const tmpPoint = EChat.Util.getElementPosition(windowElement);
                originalPoint.Left = tmpPoint.Left;
                originalPoint.Top = tmpPoint.Top;
                _this.minimizeView();
                minimizeMessageWindow();
                e.stopPropagation();
            }
        };
        miniziseBtn.addEventListener("click", miniziseEvent);
        miniziseBtn.addEventListener("mousedown", miniziseEvent);

        // Task 1149732: Update 'eChat' page to new button component
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const openDashboardBtn = EC_Fmt.HtmlStrToElement(`<div class='eChat_Frame_Icon_Maximize'><div class=eChat-MaximizeButton><ecp-btn id='ewsIconBreakOutMessage${Number}' icon='ews-icon-break-out' class='echat-MessageBoxButton' type='ghost' style='font-size:16px;'></ecp-btn></div></div></div>`);
        openDashboardBtn.addEventListener("click", () => {
            EChat.FullWindowController.SwichWindow();
        });

        headerElement.append(closeBtn);
        headerElement.append(openDashboardBtn);
        headerElement.append(miniziseBtn);
        headerElement.addEventListener("click", (e) => {
            if (EChat.eChatMoving) {
                EChat.eChatMoving = false;
            }
            e.stopPropagation();
        });

        // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
        const displayText = EC_Fmt.HtmlStrToElement("<span class='eChat-TabText eChat-TextHidden eChat-NoTextSelect' id='eChat-MinTable'style='padding:0 10px;position:absolute;width:70%;'></span>");
        const minimizeCloseBtn = EC_Fmt.HtmlStrToElement("<div style='float:right;'></div>");
        const CloseButton = EC_Fmt.HtmlStrToElement("<div class='eChat-minCloseButton'><ecp-btn icon='ews-icon-close' type='ghost' style='font-size:16px;width:26px;height:26px;'></ecp-btn></div>");
        minimizeCloseBtn.append(CloseButton);
        minimizeCloseBtn.addEventListener("click", (e) => {
            _this.closeMessageWindow();
            e.stopPropagation();
        });
        minimizeElement.addEventListener("click", (e) => {
            if (EChat.eChatMoving) {
                EChat.eChatMoving = false;
            } else {
                openView();
            }
            e.stopPropagation();
        });
        minimizeElement.append(displayText);
        minimizeElement.append(minimizeCloseBtn);

        const textAreaDiv = document.createElement("DIV");
        textAreaDiv.classList.add("echat-small-text-area");

        const inputTool = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowInputTool></div>");
        const linkTool = EC_Fmt.HtmlStrToElement(`<ecp-btn id='LinkToolMessage${Number}' class='eChat-MessageWindowLinkTool' icon='ews-icon-link' type='ghost' style='font-size:18px;'></ecp-btn>`);
        linkTool.addEventListener("click", (e) => {
            const linkElement = createFloatLinkElement();
            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            document.querySelector("body").append(linkElement);

            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            const linkDisplayValue = document.querySelector(".link-display").value;
            if (EC_Fmt.isNull(linkDisplayValue)) {
                const linkUrlKey = document.querySelector(".link-url");
                linkUrlKey.addEventListener("keyup", () => {
                    document.querySelector(".link-display").value = document.querySelector(".link-url").value;
                });
            }

            EChat.Util.SetWindowLocation(linkElement);

            EChat.Util.dragDialog({
                dialog: document.querySelector(".eChat-FloatLinkTool"),
                handle: document.querySelector(".top-div"),
                handleWidthFix: 0,
                handleHeightFix: 0,
                start(dom) {
                    dom.style.zIndex = EChat.Util.draggableZIndex();
                },
                stop(dom) {
                    dom.style.height = "auto";
                }
            });

            const temInput = linkElement.querySelector("input");
            if (temInput) {
                temInput.focus();
            }
            windowElement.style.zIndex = EChat.Util.draggableZIndex();
            e.stopPropagation();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // const clearFmtTool = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowFmtTool eChat-Cursor ews-icon-clearformat'title='Clear Format'></div>");
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const clearFmtTool = EC_Fmt.HtmlStrToElement(`<ecp-btn id='FmtToolMessage${Number}' class='eChat-MessageWindowFmtTool' icon='ews-icon-clearformat' type='ghost' style='font-size:18px;'></ecp-btn>`);
        clearFmtTool.addEventListener("click", (e) => {
            removeFloatLinkElement();
            removeFloatFileElement();
            removeSearchElement();
            inputArea.clearSelectFmt();
            _this.updateCharaterCounter();
            _this.currentTab.PreMessage = inputArea.getValue();
            windowElement.style.zIndex = EChat.Util.draggableZIndex();
            e.stopPropagation();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const openEChatTool = EC_Fmt.HtmlStrToElement(`<ecp-btn id='OpenEChatToolMessage${Number}'class=eChat-MessageWindowOpenEChatTool icon=ews-icon-echat type=ghost style=font-size:18px></ecp-btn>`);
        openEChatTool.addEventListener("click", async (e) => {
            if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                try {
                    const messageGroupID = await EChat.DataProvider.GetTaskPublicMessageGroupID(_this.currentTab.GroupInfo.MessageGroupID);
                    const groupInfo = await EChat.DataProvider.GetGroupInfoByGroupID(messageGroupID);
                    EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, true);
                } catch (ex) {
                    EChat.Util.errorAlert(ex);
                }
            }
            e.stopPropagation();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const searchTool = EC_Fmt.HtmlStrToElement(`<ecp-btn id='SearchToolMessage${Number}'class=eChat-MessageWindowSearchTool icon=ews-icon-chatshistory type=ghost style=font-size:18px></ecp-btn>`);
        searchTool.addEventListener("click", () => {
            removeSearchElement();
            searchElement.append(createSearchElement());
            const temInput = searchElement.querySelector("input");
            if (temInput) {
                temInput.focus();
            }
            if (_this.currentTab) {
                _this.currentTab.SearchInfo = {
                    Search: false,
                    SearchDate: "7",
                    SearchText: ""
                };
                _this.resizeDialog();
                _this.currentTab.scrollToBotton();
            }

            windowElement.style.zIndex = EChat.Util.draggableZIndex();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // const copyTool = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowCopyTool eChat-Cursor ews-icon-copy'title='Copy or Create New Task'></div>");
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const copyTool = EC_Fmt.HtmlStrToElement(`<ecp-btn id='CopyToolMessage${Number}' class='eChat-MessageWindowCopyTool' icon='ews-icon-copy' type='ghost' style='font-size:18px;'></ecp-btn>`);
        copyTool.addEventListener("click", (e) => {
            EChat.CopyMessageController.ShowCopyMessageDialog(_this.currentTab.GroupInfo.MessageGroupID, "CopyToSpecifiedTask", (MessageIDStr) => {
                const TaskID = document.getElementById("EChat_CopyTaskID_InputHidden").value;
                if (MessageIDStr) {
                    if (TaskID) {
                        EChat.DataProvider.SaveEChatMessageToTaskDetail(_this.currentTab.GroupInfo.MessageGroupID, TaskID, MessageIDStr).then(() => {
                            EChat.CopyMessageController.ClearCopyMessageDialog();
                            ECP.Dialog.Alert("Copy Succesfully!");
                        });
                    } else if (Distributor.indexOf("Support") === 0) {
                        EChat.Util.ShowLoading("All");
                        EChat.DataProvider.CreateTask().then((data) => {
                            if (data?.TaskID) {
                                EChat.DataProvider.SaveEChatMessageToTaskDetail(_this.currentTab.GroupInfo.MessageGroupID, data.TaskID, MessageIDStr).then(() => {
                                    const url = `Home?DashboardID=${ECP.CommonDashboards.TaskEdit}&Action=Add&TableEdit=TaskDetails&&FieldName=TaskID&FieldValue=${data.TaskID}&CurValue=${data.TaskID}&TableName=Tasks&SubTableJoinID=TaskDetails_Tasks&Search=TaskID~${data.TaskID}`;
                                    EWS.HideLoading();
                                    window.open(url);
                                    EChat.CopyMessageController.ClearCopyMessageDialog();
                                }).catch(EChat.Util.errorAlert);
                            } else {
                                EWS.HideLoading();
                            }
                        }).catch(EChat.Util.errorAlert);
                    }
                }
            });
            e.stopPropagation();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // const sendDelay = EC_Fmt.HtmlStrToElement("<div title='Delay Send'class='eChat-MessageWindowSendDelayTool eChat-Cursor ews-icon-senddelay'></div>");
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const sendDelay = EC_Fmt.HtmlStrToElement(`<ecp-btn id='SendDelayToolMessage${Number}' class='eChat-MessageWindowSendDelayTool' icon='ews-icon-senddelay' type='ghost' style='font-size:18px;'></ecp-btn>`);
        sendDelay.addEventListener("click", (e) => {
            if (inputArea.processImgData().htmlString) {
                const DelayDataElement = createDelayedSendTimeElement();
                windowElement.querySelector(".echat-small-text-area").append(DelayDataElement);
                e.stopPropagation();
            } else {
                ECP.Dialog.Alert("Please enter message before setting delay time.");
            }
            windowElement.style.zIndex = EChat.Util.draggableZIndex();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // const fileTool = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowFileTool eChat-Cursor ews-icon-uploadfiles' title='Upload Files'></div>");
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const fileTool = EC_Fmt.HtmlStrToElement(`<ecp-btn id='FileToolMessage${Number}' class='eChat-MessageWindowFileTool' icon='ews-icon-uploadfiles' type='ghost' style='font-size:18px;'></ecp-btn>`);
        fileTool.addEventListener("click", (e) => {
            const imageElement = createFloatFileElement();
            windowElement.querySelector(".echat-small-text-area").append(imageElement);
            e.stopPropagation();
            windowElement.style.zIndex = EChat.Util.draggableZIndex();
        });

        // Task 1149732: Update 'eChat' page to new button component
        // _this.editPrompt = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowAlertTool eChat-Cursor'></div>");
        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        _this.editPrompt = EC_Fmt.HtmlStrToElement(`<ecp-btn id='AlertToolMessage${Number}' class='eChat-MessageWindowAlertTool' type='ghost' style='font-size:18px;'></ecp-btn>`);
        _this.editPrompt.addEventListener("click", (e) => {
            let editMessageGroupID = null;
            let editTaskID = null;
            if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                editTaskID = _this.currentTab.GroupInfo.TaskID;
            } else {
                editMessageGroupID = _this.currentTab.GroupInfo.MessageGroupID;
            }
            EChat.DataProvider.editGroupPromptType({ groupID: editMessageGroupID, taskID: editTaskID }).then((prompt) => {
                _this.currentTab.GroupInfo.Prompt = prompt;
            }).catch(EChat.Util.errorAlert);
            e.stopPropagation();
            windowElement.style.zIndex = EChat.Util.draggableZIndex();
        });

        const createTask = EC_Fmt.HtmlStrToElement("<div class='eChat-MessageWindowTaskTool eChat-Cursor ews-icon-emcreatetask' title='Create New Task'></div>");
        createTask.addEventListener("click", (e) => {
            EChat.DataProvider.GetGroupInfoByGroupID(_this.currentTab.GroupInfo.MessageGroupID).then((groupInfo) => {
                EChat.TaskController.AddTask(groupInfo).then((newMessageGroupID) => {
                    EChat.Util.ShowLoading("All");
                    EChat.DataProvider.GetGroupInfoByGroupID(newMessageGroupID).then((taskGroup) => {
                        if (taskGroup) {
                            EChat.MainPageController.getMessageWindow(taskGroup.MessageGroupID).addRecentTab(taskGroup, true);
                            ECP.Dialog.HideLoading();
                        } else {
                            EChat.Util.errorAlert("The task was created successfully, but failed to open.");
                        }
                    }).catch(EChat.Util.errorAlert);
                }).catch(EChat.Util.errorAlert);
            }).catch(EChat.Util.errorAlert);

            e.stopPropagation();
        });

        const publicDiv = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowPubicTool></div>");
        publicDiv.append(EC_Fmt.HtmlStrToElement("<span style=margin-right:5px>Is Public</span>"));

        _this.isPublicSwitch = EChat.CustomComponent.SwichButton({
            id: "EChatIsPublic",
            checked: true,
            changeEvent() {
            }
        }, publicDiv);

        const notifyDiv = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowNotifyTool></div>");
        notifyDiv.append(EC_Fmt.HtmlStrToElement("<span style=margin-right:5px>Notify All</span>"));

        _this.notifySwitch = EChat.CustomComponent.SwichButton({
            id: "EChatNotify",
            checked: true,
            changeEvent(value) {
                for (let i = 0, len = EChat.MainPageController.messageWindowList.length; i < len; i++) {
                    const switchBtn = EChat.MainPageController.messageWindowList[i].notifySwitch;
                    // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
                    // const NotifyInterDOM = document.querySelector(".eChat-MessageWindowNotifyInternalTool");
                    if (switchBtn) {
                        if (switchBtn.Checked() && value) {
                            switchBtn.Open();
                            EChat.MainPageController.messageWindowList[i].notifyInternalSwitch.Close();
                            // NotifyInterDOM.classList.add("disabled");
                            EChat.MainPageController.messageWindowList[i].isPublicSwitch.Open();
                            publicDiv.classList.add("disabled");
                        } else if (!switchBtn.Checked() && !value) {
                            switchBtn.Close();
                            publicDiv.classList.remove("disabled");
                            // NotifyInterDOM.classList.remove("disabled");
                        }
                    }
                }

                EChat.IndexedDB.GetSetting("Notify").then((setting) => {
                    const Notify = !!value;
                    if (setting?.Notify !== Notify) {
                        EChat.IndexedDB.UpdateSetting("Notify", { Notify }, true);
                    }
                });
            }
        }, notifyDiv);

        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
        const notifyInternalDiv = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowNotifyInternalTool></div>");
        notifyInternalDiv.append(EC_Fmt.HtmlStrToElement("<span style=margin-right:5px>Notify Internal</span>"));
        // notifyInternalDiv.classList.add("disabled");

        _this.notifyInternalSwitch = EChat.CustomComponent.SwichButton({
            id: "EChatNotifyInternal",
            checked: false,
            changeEvent(value) {
                for (let i = 0, len = EChat.MainPageController.messageWindowList.length; i < len; i++) {
                    const switchBtn = EChat.MainPageController.messageWindowList[i].notifyInternalSwitch;
                    // const NotifyDOM = document.querySelector(".eChat-MessageWindowNotifyTool");
                    if (switchBtn) {
                        if (switchBtn.Checked() && value) {
                            EChat.MainPageController.messageWindowList[i].notifySwitch.Close();
                            switchBtn.Open();
                            publicDiv.classList.remove("disabled");
                            // NotifyDOM.classList.add("disabled");
                        } else if (!switchBtn.Checked() && !value) {
                            switchBtn.Close();
                            // NotifyDOM.classList.remove("disabled");
                        }
                    }
                }

                EChat.IndexedDB.GetSetting("NotifyInternal").then((setting) => {
                    const NotifyInternal = !!value;
                    if (setting?.NotifyInternalyInternal) {
                        EChat.IndexedDB.UpdateSetting("NotifyInternal", { NotifyInternal }, true);
                    }
                });
            }
        }, notifyInternalDiv);

        // Task 952514: Do not remember Public or Private in echat
        _this.isPublicSwitch.Open();
        const EChatIsPublic = publicDiv.querySelector("#EChatIsPublic");
        if (EChatIsPublic) {
            EChatIsPublic.style.display = "block";
        }

        EChat.IndexedDB.GetSetting("Notify").then((setting) => {
            if (setting?.Notify) {
                _this.notifySwitch.Open();
            } else if (setting) {
                _this.notifySwitch.Close();
            }

            const EChatNotify = publicDiv.querySelector("#EChatNotify");
            if (EChatNotify) {
                EChatNotify.style.display = "block";
            }
        });

        const NotifyInterDOM = document.querySelector(".eChat-MessageWindowNotifyInternalTool");
        if (NotifyInterDOM) {
            NotifyInterDOM.style.display = "block";
        }

        EChat.Util.dragResize({
            resizeDirection: "se",
            handle: resizeElement,
            move: ({
                RelativeHeight,
                RelativeWidth
            }) => {
                EChat.MainPageController.chatWindowSize.width = Math.max(EChat.MainPageController.chatWindowSize.width + RelativeWidth, 600);
                EChat.MainPageController.chatWindowSize.height = Math.max(EChat.MainPageController.chatWindowSize.height + RelativeHeight, 233);

                _this.resizeDialog();
            },
            end: () => {
                EChat.IndexedDB.UpdateSetting("ChatSize", EChat.MainPageController.chatWindowSize);
            }
        });

        inputTool.append(linkTool);
        inputTool.append(fileTool);
        inputTool.append(clearFmtTool);
        inputTool.append(openEChatTool);
        inputTool.append(searchTool);
        inputTool.append(copyTool);
        inputTool.append(sendDelay);
        inputTool.append(_this.editPrompt);
        textAreaDiv.append(publicDiv);
        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
        textAreaDiv.append(notifyInternalDiv);
        textAreaDiv.append(notifyDiv);
        textAreaDiv.append(inputTool);

        // Task 759412：Allow user send file by dragging into the input field
        windowElement.addEventListener("dragenter", (e) => {
            if (!e.dataTransfer || event.dataTransfer.types.indexOf("Files") === -1) {
                return;
            }
            const loading = EChat.Util.ShowLoading(windowElement, "Drop Send file");
            if (loading) {
                loading.addEventListener("dragleave", (event) => {
                    if (loading.querySelector("td") === event.target) {
                        ECP.Dialog.HideLoading(loading);
                    }

                    event.preventDefault();
                    event.stopPropagation();
                });

                loading.addEventListener("drop", (event) => {
                    ECP.Dialog.HideLoading();
                    uploadFiles(event.dataTransfer.files);
                    event.preventDefault();
                    event.stopPropagation();
                });

                loading.addEventListener("dragover", (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
            e.preventDefault();
            e.stopPropagation();
        });

        windowElement.addEventListener("paste", (e) => {
            if (e.clipboardData && e.clipboardData.files && e.clipboardData.files.length > 0) {
                const files = [];
                for (let i = 0; i < e.clipboardData.files.length; i++) {
                    const file = e.clipboardData.files[i];
                    if (!/image\/\w+/.test(file.type)) {
                        files.push(file);
                    }
                }
                if (files.length > 0) {
                    uploadFiles(files);
                }
            }
        });

        const inputAreaEle = EC_Fmt.HtmlStrToElement("<div class=eChat-MessageWindowTextArea></div>");
        inputAreaEle.addEventListener("selectstart", (e) => {
            e.stopPropagation();
        });

        inputArea = EChat.CustomComponent.InputArea(inputAreaEle);
        if (inputArea) {
            inputArea.bind(EChat.InputAreaComponentEvent.SendMessage, () => {
                sendingMessage();
            });

            inputAreaEle.addEventListener("paste", () => {
                setTimeout(() => {
                    for (let i = 0; i < inputAreaEle.children.length; i++) {
                        if (inputAreaEle.children[i].style && inputAreaEle.children[i].style.backgroundColor) {
                            inputAreaEle.children[i].style.background = "none";
                        }
                    }
                }, 300);
            });

            inputArea.bind(EChat.InputAreaComponentEvent.ValueChange, () => {
                // SendWriteState
                if (!_this.currentTab) {
                    return;
                }
                const groupInfo = _this.currentTab.GroupInfo;
                if (groupInfo.Users.length === 2) {
                    for (let i = 0, len = groupInfo.Users.length; i < len; i++) {
                        if (!EChat.DataProvider.IsCurrentUser(groupInfo.Users[i])) {
                            EChat.DataProvider.SendWriteState(groupInfo.MessageGroupID, groupInfo.Users[i]);
                        }
                    }
                }
                EChat.DataProvider.Update_Session();
                _this.updateCharaterCounter();
                _this.currentTab.PreMessage = inputArea.getValue();
            });
        }

        textAreaDiv.append(inputAreaEle);

        const sendDiv = EC_Fmt.HtmlStrToElement("<div class='eChatSendArea eChatZoom'></div>");

        const writeStateSpan = EC_Fmt.HtmlStrToElement("<span class='Left eChatWriteState'style=display:none></span>");
        const writeStateMsg = EC_Fmt.HtmlStrToElement("<span class='eChatMessageTip writeStateName'></span>");

        const sendSpan = EC_Fmt.HtmlStrToElement("<span class=Right></span>");
        // Task 1067218: DSDLink: eChat in the new Mobile Framework
        let tipMsg;
        if (EChat.MainPageController.ClientOS === "PC") {
            tipMsg = EC_Fmt.HtmlStrToElement("<span class='eChatMessageTip eChatWarning'>Available Characters Remaining:</span>");
        } else {
            tipMsg = EC_Fmt.HtmlStrToElement("<span class='eChatMessageTip eChatWarning'>Available Characters:</span>");
        }
        // const tipMsg = EC_Fmt.HtmlStrToElement("<span class='eChatMessageTip eChatWarning'>Available Characters Remaining:</span>");
        const numMsg = EC_Fmt.HtmlStrToElement("<span class='eChatMessageTip eChatNumber'>4000</span>");

        // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
        const sendBtn = EC_Fmt.HtmlStrToElement("<ecp-btn type=primary id=EChat_Send_Btn style='height:27px;padding:4px 8px;'>Send</ecp-btn>");
        sendBtn.addEventListener("click", (e) => {
            windowElement.style.zIndex = EChat.Util.draggableZIndex();
            sendingMessage();
            e.stopPropagation();
            e.preventDefault();
        });
        writeStateSpan.append(writeStateMsg);
        sendSpan.append(tipMsg);
        sendSpan.append(numMsg);
        sendSpan.append(sendBtn);
        sendDiv.append(writeStateSpan);
        sendDiv.append(sendSpan);

        sendElement.append(textAreaDiv);
        sendElement.append(sendDiv);

        const handleSpan = EC_Fmt.HtmlStrToElement("<span class=Right id='details'></span>");
        const handleButton = EC_Fmt.HtmlStrToElement("<ecp-btn type='primary' value='Details' style='margin-right: 15px;'>Details</ecp-btn>");
        handleButton.addEventListener("mousedown", (e) => {
            const groupData = _this.currentTab.GroupInfo;
            const url = EChat.CustomComponent.GetAlertDetailUrl(groupData.GroupName, groupData.MessageGroupID);
            EChat.Util.nav(url, e);
        });
        handleSpan.append(handleButton);
        handleElement.append(handleSpan);

        windowElement.append(headerElement);
        windowElement.append(minimizeElement);
        windowElement.append(dialogElement);
        windowElement.append(taskTitleElement);
        windowElement.append(searchElement);
        windowElement.append(sendElement);
        windowElement.append(handleElement);
        windowElement.append(resizeElement);
        // Task 1067218: DSDLink: eChat in the new Mobile Framework
        if (EChat.FullWindowController.FullWindow && EChat.MainPageController.ClientOS === "PC") {
            document.getElementById("EChatFullWindowContent").append(windowElement);
        } else {
            document.querySelector("html > body").append(windowElement);
        }

        closeView();

        EChat.Util.SetWindowLocation(windowElement);
        windowElement.addEventListener("click", function () {
            if (_this.currentTab) {
                _this.currentTab.hideMenu();
                _this.currentTab.syncGroupLastReadTime();
            }
            if (!EChat.eChatMoving) {
                this.style.zIndex = EChat.Util.draggableZIndex();
            }
            removeFloatLinkElement();
            removeFloatFileElement();
            removeDelayedSendTimeElement();
        });

        EChat.Util.dragDialog({
            dialog: windowElement,
            handle: windowElement.querySelector(".eChatDragTarget"),
            handleWidthFix: 0,
            handleHeightFix: 0,
            start(dom) {
                if (_this.messageWindowViewType === EChat.ViewType.MinimizeView) {
                    _this.minimizeIsMoved = true;
                }
                dom.style.zIndex = EChat.Util.draggableZIndex();
            },
            stop(dom) {
                dom.style.height = "auto";
            }
        });

        _this.element = windowElement;
    };

    const openView = function () {
        if (EChat.eChatMoving) {
            EChat.eChatMoving = false;
        }
        if (_this.messageWindowViewType === EChat.ViewType.MinimizeView) {
            twinkleOff();
            _this.currentTab.twinkleOff();
            windowElement.style.top = `${originalPoint.Top}px`;
            windowElement.style.left = `${originalPoint.Left}px`;
        }
        if (_this.messageWindowViewType !== EChat.ViewType.OpenView) {
            _this.messageWindowViewType = EChat.ViewType.OpenView;
            // Task 1067218: DSDLink: eChat in the new Mobile Framework
            if (EChat.MainPageController.ClientOS === "PC") {
                _this.resizeDialog();
                resizeElement.style.display = "block";
            } else {
                windowElement.classList.remove("eChat-ReadOnly");
                const limitTop = EChat.Util.getHeaderHeight();
                EChat.MainPageController.chatWindowSize.width = window.innerWidth;
                EChat.MainPageController.chatWindowSize.height = window.innerHeight - 164 - limitTop;
                dialogElement.style.height = `${EChat.MainPageController.chatWindowSize.height}px`;
                windowElement.style.width = `${EChat.MainPageController.chatWindowSize.width}px`;
                windowElement.style.top = `${limitTop}px`;
                windowElement.style.left = "0px";
                sendElement.childNodes[0].childNodes[3].style.height = "40px";

                if (windowElement.childNodes[0].childElementCount > 1) {
                    windowElement.childNodes[0].childNodes[2].remove();
                    windowElement.childNodes[0].childNodes[1].remove();
                }
                resizeElement.style.display = "none";
            }
            windowElement.style.display = "block";
            headerElement.style.display = "block";
            minimizeElement.style.display = "none";
            // resizeElement.style.display = "block";
            const group_unread_button = windowElement.querySelector(".group-unread-button-div");
            if (group_unread_button) {
                group_unread_button.style.display = "block";
            }

            if (_this.currentTab) {
                if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Message || _this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                    sendElement.style.display = "block";
                    handleElement.style.display = "none";
                    if (taskTitleElement && _this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                        taskTitleElement.style.display = "flex";
                    }
                    dialogElement.style.display = "block";
                    inputArea.focus();
                } else {
                    handleElement.style.display = "block";
                    sendElement.style.display = "none";
                    dialogElement.style.display = "block";
                }
                _this.currentTab.setScrollTop();
            }
            _this.minimizeIsMoved = true;

            oldwinpageW = window.innerWidth - parseInt(EChat.MainPageController.chatWindowSize.width);
            oldwinpageH = window.innerHeight - (parseInt(EChat.MainPageController.chatWindowSize.height) + 178);
            oldwinpageW = oldwinpageW <= 0 ? 1 : oldwinpageW;
            oldwinpageH = oldwinpageH <= 0 ? 1 : oldwinpageH;
        }
    };

    this.resizeDialog = function () {
        windowElement.classList.remove("eChat-ReadOnly");
        if (_this.messageWindowViewType === EChat.ViewType.OpenView) {
            if (_this.currentTab) {
                let height;
                if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task || _this.currentTab.SearchInfo) {
                    height = `${EChat.MainPageController.chatWindowSize.height}px`;
                } else if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.System) {
                    // Task 1134294: Encompass Mobile Picker Cut Alert Detail
                    const detail = document.getElementById("details");
                    if (detail.style.display === "none") {
                        height = `${EChat.MainPageController.chatWindowSize.height + 180}px`;
                    } else {
                        height = `${EChat.MainPageController.chatWindowSize.height + 148}px`;
                    }
                } else if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Message && _this.currentTab.GroupInfo.PostPermission === EChat.PostPermissionType.ReadOnly) {
                    windowElement.classList.add("eChat-ReadOnly");
                    height = `${EChat.MainPageController.chatWindowSize.height + 173}px`;
                } else {
                    height = `${EChat.MainPageController.chatWindowSize.height + 25}px`;
                }

                dialogElement.style.height = height;
            }
            windowElement.style.width = `${EChat.MainPageController.chatWindowSize.width}px`;
        }
        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
        EChat.Util.resizeDialogMessage();
    };

    this.minimizeView = function () {
        if (EChat.eChatMoving) {
            EChat.eChatMoving = false;
        }
        if (_this.messageWindowViewType !== EChat.ViewType.MinimizeView) {
            _this.messageWindowViewType = EChat.ViewType.MinimizeView;
            let groupName = "";
            if (_this.currentTab) {
                _this.currentTab.getScrollTop();
                groupName = EChat.DataProvider.GetGroupName(_this.currentTab.GroupInfo);
            }
            minimizeElement.querySelectorAll("#eChat-MinTable").forEach((dom) => {
                dom.setAttribute("title", groupName);
                dom.textContent = groupName;
            });

            windowElement.style.width = "150px";
            windowElement.style.display = "block";
            headerElement.style.display = "none";
            minimizeElement.style.display = "block";
            dialogElement.style.display = "none";
            sendElement.style.display = "none";
            handleElement.style.display = "none";
            resizeElement.style.display = "none";
            const group_unread_button = windowElement.querySelector(".group-unread-button-div");
            if (group_unread_button) {
                group_unread_button.style.display = "none";
            }

            _this.minimizeIsMoved = false;
            if (taskTitleElement) {
                taskTitleElement.style.display = "none";
            }

            oldwinpageW = window.innerWidth - 150;
            oldwinpageH = window.innerHeight - 30;
            oldwinpageW = oldwinpageW <= 0 ? 1 : oldwinpageW;
            oldwinpageH = oldwinpageH <= 0 ? 1 : oldwinpageH;
        }
    };

    const closeView = function () {
        if (EChat.eChatMoving) {
            EChat.eChatMoving = false;
        }
        if (_this.messageWindowViewType !== EChat.ViewType.CloseView) {
            _this.messageWindowViewType = EChat.ViewType.CloseView;
            windowElement.style.display = "none";
        }
    };

    const headImgClickEvent = function (authID, userMemberCount) {
        if (parseInt(userMemberCount) === 2) {
            window.open(`./Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=Users&Search=AuthenticationID~${authID}`);
        } else {
            const eChatDataProvider = EChat.DataProvider;
            const userStr = eChatDataProvider.GetUserStrByUserList([authID, eChatDataProvider.CurrentUserInfo.AuthenticationID]);
            EChat.DataProvider.GetGroupInfoByAuthIDList(userStr).then((groupInfo) => {
                EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, false);
            });
        }
    };

    const minimizeMessageWindow = function () {
        const EChatMainPage = document.getElementById("EChatMainPage");
        const EChatTabHead = document.getElementById("EChatTabHead");
        const EChatMainPageWidth = EChatMainPage ? EChatMainPage.clientWidth : 280;
        const EChatTabHeadWidth = EChatTabHead ? EChatTabHead.clientWidth : 55;
        if (windowElement && _this.messageWindowViewType === EChat.ViewType.MinimizeView) {
            removeSearchElement();
            const elementWidth = windowElement.clientWidth + 5;
            const mainPageWidth = EChatMainPageWidth + EChatTabHeadWidth + 10;
            const maxCount = Math.floor((window.innerWidth - mainPageWidth) / elementWidth);
            let windowCount = 0;
            const windowList = EChat.MainPageController.messageWindowList;
            for (let i = 0; i < windowList.length; i++) {
                if (!windowList[i].minimizeIsMoved) {
                    windowCount++;
                    let tmpTop;
                    let tmpLeft;
                    if (windowCount < maxCount) {
                        tmpTop = window.innerHeight - windowElement.clientHeight;
                        tmpLeft = window.innerWidth - elementWidth * windowCount - mainPageWidth;
                    } else {
                        const floor = Math.floor(windowCount / maxCount);
                        tmpTop = window.innerHeight - windowElement.clientHeight * floor;
                        tmpLeft = window.innerWidth - elementWidth * windowCount - mainPageWidth;
                    }
                    windowList[i].element.style.top = `${tmpTop}px`;
                    windowList[i].element.style.left = `${tmpLeft}px`;
                }
            }
        }
    };

    this.resizeTab = function () {
        // Task 1119771: Echat chat window Tab bar position is misplaced.
        let maxWidth = 600;
        const head = windowElement.querySelector(".eChat-MessageWindowHead");
        if (head) {
            // Task 1149732: Update 'eChat' page to new button component
            maxWidth = head.clientWidth - 105;
        }
        const ulwidth = maxWidth / _this.chatTabListCount;

        // Task 1133270: eChat: Full screen eChat does not display full messages when too many eChat tabs are open and unable to click second row of eChat tabs
        headerElement.querySelectorAll("li").forEach((dom) => {
            dom.style.maxWidth = `${ulwidth}px`;
        });
        _this.tabWidth = ulwidth;
    };

    this.switchWindowType = function (groupType, focusFlag) {
        if (groupType === SocketUtil.GroupType.Message || groupType === SocketUtil.GroupType.Task) {
            sendElement.style.display = "block";
            handleElement.style.display = "none";

            if (!focusFlag) {
                inputArea.focus();
            }
        } else {
            handleElement.style.display = "block";
            sendElement.style.display = "none";
        }

        dialogElement.style.display = "block";
        _this.resizeDialog();

        if (groupType === SocketUtil.GroupType.Task) {
            taskTitleElement.style.display = "flex";
            // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
            windowElement.querySelectorAll(".eChat-MessageWindowPubicTool, .eChat-MessageWindowNotifyTool, .eChat-MessageWindowOpenEChatTool, .eChat-MessageWindowNotifyInternalTool").forEach((dom) => {
                dom.style.display = "inline-block";
            });
            windowElement.querySelectorAll(".eChat-MessageWindowSendDelayTool, .eChat-MessageWindowAlertTool, .eChat-MessageWindowCopyTool, .eChat-MessageWindowSearchTool").forEach((dom) => {
                dom.style.display = "none";
            });

            if (EChat.FullWindowController.FullWindow) {
                if (EChat.FullWindowController.TextArea) {
                    const mceDom = EChat.FullWindowController.TextArea.editorContainer;
                    mceDom.querySelectorAll(".ews-icon-echat").forEach((dom) => {
                        dom.parentElement.parentElement.classList.remove("hidden");
                    });
                    mceDom.querySelectorAll(".ews-icon-senddelay, .ews-icon-copy, .ews-icon-DisablesVoice, .ews-icon-alert, .ews-icon-chatshistory").forEach((dom) => {
                        dom.parentElement.parentElement.classList.add("hidden");
                    });
                }

                document.getElementById("EChatFullWindowContent").classList.add("eChat-FullWindowTask");
            }

            if (_this.isPublicSwitch) {
                _this.isPublicSwitch.Open();
            }
        } else {
            taskTitleElement.style.display = "none";

            windowElement.querySelectorAll(".eChat-MessageWindowSendDelayTool, .eChat-MessageWindowAlertTool, .eChat-MessageWindowCopyTool, .eChat-MessageWindowSearchTool").forEach((dom) => {
                dom.style.display = "inline-block";
            });
            // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
            windowElement.querySelectorAll(".eChat-MessageWindowPubicTool, .eChat-MessageWindowNotifyTool, .eChat-MessageWindowOpenEChatTool, .eChat-MessageWindowNotifyInternalTool").forEach((dom) => {
                dom.style.display = "none";
            });

            if (EChat.FullWindowController.TextArea) {
                const mceDom = EChat.FullWindowController.TextArea.editorContainer;
                mceDom.querySelectorAll(".ews-icon-echat").forEach((dom) => {
                    dom.parentElement.parentElement.classList.add("hidden");
                });
                mceDom.querySelectorAll(".ews-icon-senddelay, .ews-icon-copy, .ews-icon-DisablesVoice, .ews-icon-alert, .ews-icon-chatshistory").forEach((dom) => {
                    dom.parentElement.parentElement.classList.remove("hidden");
                });
                document.getElementById("EChatFullWindowContent").classList.remove("eChat-FullWindowTask");
            }
        }

        if (_this.currentTab && _this.currentTab.GroupInfo) {
            const GroupInfo = _this.currentTab.GroupInfo;
            EChat.MainPageController.updatePromptIcon({ groupID: GroupInfo.MessageGroupID, taskID: GroupInfo.TaskID, prompt: GroupInfo.Prompt });
        }

        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
        _this.resizeDialog();
        _this.HideUnreadButton(true);
    };

    let twinkleHandle = null;
    const twinkleOn = function (isPlay) {
        if (minimizeElement) {
            if (isPlay) {
                if (!twinkleHandle) {
                    twinkleHandle = setInterval(() => {
                        minimizeElement.classList.toggle("TwinkleOn");
                    }, 600);

                    setTimeout(() => {
                        if (twinkleHandle) {
                            minimizeElement.classList.add("TwinkleOn");
                            clearInterval(twinkleHandle);
                            twinkleHandle = null;
                        }
                    }, 3000);
                }
            } else {
                minimizeElement.classList.add("TwinkleOn");
            }
            _this.minimizeTwinkle = true;
        }
    };

    const twinkleOff = function () {
        if (minimizeElement) {
            minimizeElement.classList.remove("TwinkleOn");
            if (twinkleHandle) {
                clearInterval(twinkleHandle);
                twinkleHandle = null;
            }
            _this.minimizeTwinkle = false;
        }
    };

    this.twinkleClose = function () {
        twinkleOff();
    };

    this.closeMessageWindow = function () {
        let isOpenView = false;
        if (_this.messageWindowViewType === EChat.ViewType.OpenView) {
            isOpenView = true;
        }
        Object.keys(_this.chatTabList).forEach((tab) => {
            if (_this.chatTabList[tab] === _this.currentTab && isOpenView) {
                _this.chatTabList[tab].closeTab();// true
            } else {
                _this.chatTabList[tab].closeTab();// false
            }
            delete _this.chatTabList[tab];
            _this.chatTabListCount--;
        });

        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        const number = (windowElement.querySelector(`[id^="ewsIconCloseMessage"]`).id).substr(-1);
        document.getElementById(`messageWindowTooltip${number}`).remove();

        windowElement.remove();
        EChat.MainPageController.removeMessageWindow(_this);
    };

    // Task 1003469: The chat box size should not exceed the page size.
    let oldwinpageW = window.innerWidth - parseInt(EChat.MainPageController.chatWindowSize.width);
    let oldwinpageH = window.innerHeight - (parseInt(EChat.MainPageController.chatWindowSize.height) + 178);
    let oldMessageWinH = 1;
    let oldMessageWinW = 1;
    let overedPartH = 0;
    let overedPartW = 0;
    this.resizeMessageWindow = function () {
        let winpageW;
        let winpageH;
        const limitLeft = EChat.Util.getMenuWidth();
        const limitTop = EChat.Util.getHeaderHeight();
        let winpageLeft = parseInt(windowElement.style.left);
        let winpageTop = parseInt(windowElement.style.top);
        let MessageWinH = parseInt(dialogElement.style.height);
        let MessageWinW = parseInt(EChat.MainPageController.chatWindowSize.width);

        if (_this.messageWindowViewType === EChat.ViewType.MinimizeView) {
            winpageW = window.innerWidth - 150;
            winpageH = window.innerHeight - 30;
            windowElement.style.top = `${winpageH}px`;
            windowElement.style.left = `${winpageW}px`;
        } else {
            winpageW = window.innerWidth - parseInt(EChat.MainPageController.chatWindowSize.width);
            winpageH = window.innerHeight - (parseInt(EChat.MainPageController.chatWindowSize.height) + 178);

            const moveHeight = winpageH - oldwinpageH;
            const moveWidth = winpageW - oldwinpageW;
            if (moveHeight < 0) {
                if (Math.abs(moveHeight) > (winpageTop - limitTop)) {
                    winpageTop = limitTop;
                    MessageWinH = MessageWinH - (Math.abs(moveHeight) - (winpageTop - limitTop)) > 260 ? (MessageWinH - (Math.abs(moveHeight) - (winpageTop - limitTop))) : 260;
                } else {
                    winpageTop -= Math.abs(moveHeight);
                }
            } else if (moveHeight > 0) {
                if (window.innerHeight > MessageWinH + 178 + limitTop) {
                    if (overedPartH < 0) {
                        if (moveHeight > Math.abs(overedPartH)) {
                            if (moveHeight - Math.abs(overedPartH) > oldMessageWinH - MessageWinH) {
                                winpageTop += (moveHeight - Math.abs(overedPartH) - (oldMessageWinH - MessageWinH));
                                MessageWinH = oldMessageWinH;
                            } else {
                                MessageWinH += moveHeight - Math.abs(overedPartH);
                            }
                        }
                    } else if (overedPartH > 0) {
                        if (moveHeight > (oldMessageWinH - MessageWinH)) {
                            winpageTop += (moveHeight - (oldMessageWinH - MessageWinH));
                            MessageWinH = oldMessageWinH;
                        } else {
                            MessageWinH += moveHeight;
                        }
                    }
                }
            }

            if (moveWidth < 0) {
                if (Math.abs(moveWidth) > (winpageLeft - limitLeft)) {
                    winpageLeft = limitLeft;
                    MessageWinW = MessageWinW - (Math.abs(moveWidth) - (winpageLeft - limitLeft)) > 600 ? (MessageWinW - (Math.abs(moveWidth) - (winpageLeft - limitLeft))) : 600;
                } else {
                    winpageLeft -= Math.abs(moveWidth);
                }
            } else if (moveWidth > 0) {
                if (overedPartW < 0) {
                    if (moveWidth > Math.abs(overedPartW)) {
                        if (moveWidth - Math.abs(overedPartW) > oldMessageWinW - MessageWinW) {
                            winpageLeft += (moveWidth - Math.abs(overedPartW) - (oldMessageWinW - MessageWinW));
                            MessageWinW = oldMessageWinW;
                        } else {
                            MessageWinW += moveWidth - Math.abs(overedPartW);
                        }
                    }
                } else if (overedPartW > 0) {
                    if (moveWidth > (oldMessageWinW - MessageWinW)) {
                        winpageLeft += (moveWidth - (oldMessageWinW - MessageWinW));
                        MessageWinW = oldMessageWinW;
                    } else {
                        MessageWinW += moveWidth;
                    }
                }
            }

            dialogElement.style.height = `${MessageWinH}px`;
            EChat.MainPageController.chatWindowSize.width = MessageWinW;
            windowElement.style.width = `${MessageWinW}px`;
            windowElement.style.top = `${winpageTop}px`;
            windowElement.style.left = `${winpageLeft}px`;
            oldwinpageW = window.innerWidth - parseInt(EChat.MainPageController.chatWindowSize.width);
            oldwinpageH = window.innerHeight - (parseInt(EChat.MainPageController.chatWindowSize.height) + 178);
            overedPartH = window.innerHeight - (MessageWinH + 178) - parseInt(windowElement.style.top);
            overedPartW = window.innerWidth - MessageWinW - parseInt(windowElement.style.left);
        }
    };

    // Task 1003469: The chat box size should not exceed the page size.
    this.initMessageWindowPosition = function () {
        let winpageLeft = parseInt(windowElement.style.left);
        let winpageTop = parseInt(windowElement.style.top);
        let MessageWinH = parseInt(dialogElement.style.height);
        let MessageWinW = parseInt(EChat.MainPageController.chatWindowSize.width);
        const limitLeft = EChat.Util.getMenuWidth();
        const limitTop = EChat.Util.getHeaderHeight();

        oldMessageWinH = parseInt(dialogElement.style.height);
        oldMessageWinW = parseInt(EChat.MainPageController.chatWindowSize.width);

        if (window.innerHeight < MessageWinH + 178 + limitTop) {
            winpageTop = limitTop;
            MessageWinH = window.innerHeight - limitTop - 178 < 260 ? 260 : window.innerHeight - limitTop - 178;
        }

        if (window.innerWidth < MessageWinW + limitLeft) {
            winpageLeft = limitLeft;
            MessageWinW = window.innerWidth - limitLeft < 600 ? 600 : window.innerWidth - limitLeft;
        }

        dialogElement.style.height = `${MessageWinH}px`;
        EChat.MainPageController.chatWindowSize.width = MessageWinW;
        windowElement.style.width = `${MessageWinW}px`;
        windowElement.style.top = `${winpageTop}px`;
        windowElement.style.left = `${winpageLeft}px`;
    };

    // Task 1003469: The chat box size should not exceed the page size.
    this.changeOldMessageWin = function () {
        oldMessageWinH = parseInt(EChat.MainPageController.chatWindowSize.height);
        oldMessageWinW = parseInt(EChat.MainPageController.chatWindowSize.width);
        oldwinpageW = window.innerWidth - parseInt(EChat.MainPageController.chatWindowSize.width);
        oldwinpageH = window.innerHeight - (parseInt(EChat.MainPageController.chatWindowSize.height) + 178);
    };

    // Task 1067218: DSDLink: eChat in the new Mobile Framework
    this.resizeMobileMessageWindow = function () {
        const limitTop = EChat.Util.getHeaderHeight();
        const newDialogHeight = window.innerHeight - limitTop - 137;
        const newDialogWidth = window.innerWidth;

        dialogElement.style.height = `${newDialogHeight}px`;
        windowElement.style.width = `${newDialogWidth}px`;
        windowElement.style.top = `${limitTop}px`;
        windowElement.style.left = "0px";
    };

    // Data
    const addTab = function (key, tab) {
        _this.chatTabList[key] = tab;
        _this.chatTabListCount++;
    };

    this.deleteTab = function (key) {
        delete _this.chatTabList[key];
        _this.chatTabListCount--;
    };

    this.addRecentTab = async function (groupInfo, sync, showUnreadButton, savedKey) {
        const twinkle = false;
        const focusFlag = false;
        if (_this.messageWindowViewType !== EChat.ViewType.OpenView) {
            openView();
        }
        const key = groupInfo.MessageGroupID;
        const unreadCount = groupInfo.UnReadCount;
        if (!_this.chatTabList[key]) {
            const chatTabController = new EChat.ChatTabController(groupInfo, _this);

            headerElement.append(chatTabController.createHeadElement());
            dialogElement.append(chatTabController.createContentElement());
            addTab(key, chatTabController);
            _this.resizeTab();

            await EChat.FullWindowController.ResizeTextArea();
            _this.topTab(_this.chatTabList[key], sync, twinkle, focusFlag);

            if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                EChat.Util.ShowLoading(windowElement);
                let data;
                try {
                    data = await EChat.DataProvider.getTaskDetailHistory(groupInfo.TaskID, groupInfo.EncompassID, EC_Fmt.Null2ZeroInt(savedKey), 0, true);
                    ECP.Dialog.HideLoading();
                    if (data) {
                        chatTabController.drawHistoryMessages(data.TaskDetails, !!savedKey);
                        chatTabController.scorllToMessage(_this, groupInfo, savedKey);
                        chatTabController.disablePublic(data.IsCustomer);
                        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
                        chatTabController.disableNotifyInternal(data.IsCustomer);
                        chatTabController.windowScroll();
                        chatTabController.showTaskTitle(data.TaskTitle);
                    }
                } catch (e) {
                    EChat.Util.errorAlert(e);
                    return _this.chatTabList[key];
                }
            } else {
                if (savedKey && (!groupInfo.Messages || groupInfo.Messages.filter(x => x.MessageKey === savedKey).length === 0)) {
                    groupInfo.Messages = await EChat.DataProvider.getMessageHistory(groupInfo.MessageGroupID, 0, savedKey, null);
                }
                chatTabController.drawHistoryMessages(groupInfo.Messages, !!savedKey);
                chatTabController.scorllToMessage(_this, groupInfo, savedKey);
                chatTabController.windowScroll(groupInfo.Messages && groupInfo.Messages.length < 10 && groupInfo.Messages.length < groupInfo.MessageCount);
            }
            chatTabController.updateGroupName();
        } else {
            _this.chatTabList[key].GroupInfo = groupInfo;
            await EChat.FullWindowController.ResizeTextArea();
            _this.topTab(_this.chatTabList[key], sync, twinkle, focusFlag);

            if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                EChat.Util.ShowLoading(windowElement);
                let data;
                try {
                    data = await EChat.DataProvider.getTaskDetailHistory(groupInfo.TaskID, groupInfo.EncompassID, EC_Fmt.Null2ZeroInt(savedKey), 0, true);
                } catch (e) {
                    EChat.Util.errorAlert(e);
                    return _this.chatTabList[key];
                }

                ECP.Dialog.HideLoading();
                if (data) {
                    _this.chatTabList[key].clearMessage();
                    _this.chatTabList[key].drawHistoryMessages(data.TaskDetails, !!savedKey);
                    _this.chatTabList[key].scorllToMessage(_this, groupInfo, savedKey);
                    _this.chatTabList[key].disablePublic(data.IsCustomer);
                    // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
                    _this.chatTabList[key].disableNotifyInternal(data.IsCustomer);
                    _this.chatTabList[key].showTaskTitle(data.TaskTitle);
                }
            } else {
                if (savedKey && (!groupInfo.Messages || groupInfo.Messages.filter(x => x.MessageKey === savedKey).length === 0)) {
                    groupInfo.Messages = await EChat.DataProvider.getMessageHistory(groupInfo.MessageGroupID, 0, savedKey, null);
                }
                _this.chatTabList[key].refreshMessageList(groupInfo.Messages);
            }

            _this.chatTabList[key].updateGroupName();
        }
        EChat.MainPageController.updatePromptIcon({ groupID: groupInfo.MessageGroupID, taskID: groupInfo.TaskID, prompt: groupInfo.Prompt });

        // Task 1134294: Encompass Mobile Picker Cut Alert Detail
        const LoadEmployeesAlertsType = [
            "Day Close",
            "ASN Receipt",
            "New Customer Account",
            "PO Receipt",
            "REMIT Receipt",
            "Import Conflict",
            "Supplier Comm Warnings",
            "EDI Download Reminder",
            "Account Mis-Mapping"
        ];
        // Task 1201832: eChat window sticking
        const DetailsButton = document.getElementById("details");
        if (LoadEmployeesAlertsType.indexOf(groupInfo.GroupName) >= 0) {
            DetailsButton.style.display = "block";
        } else {
            DetailsButton.style.display = "none";
        }
        _this.resizeDialog();
        _this.currentTab.scrollToBotton();

        if (showUnreadButton && unreadCount > 0 && groupInfo.GroupType !== SocketUtil.GroupType.Task) {
            _this.ShowUnreadButton(groupInfo.MessageGroupID, unreadCount);
        }
        // Task 1067218: DSDLink: eChat in the new Mobile Framework
        if (EChat.MainPageController.ClientOS === "PC") {
            this.initMessageWindowPosition();
        }

        // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
        _this.createMessageWindowTooltip();
        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
        _this.resizeDialog();
        return _this.chatTabList[key];
    };

    // Task 1160492: Changing title attributes on icon-only buttons to use tooltip instead
    this.createMessageWindowTooltip = function () {
        const frequency = document.querySelectorAll("#eChatMessageWindow").length;
        const Number = frequency - 1;

        let messageWindowTooltip = document.getElementById("messageWindowTooltip");

        if (EC_Fmt.isNull(messageWindowTooltip)) {
            messageWindowTooltip = EC_Fmt.HtmlStrToElement(`<div id='messageWindowTooltip'></div>`);
            document.body.append(messageWindowTooltip);
        }

        let messageWindowTooltipDiv = document.getElementById(`messageWindowTooltip${Number}`);
        if (EC_Fmt.isNull(messageWindowTooltipDiv)) {
            messageWindowTooltipDiv = EC_Fmt.HtmlStrToElement(`<div id='messageWindowTooltip${Number}'></div>`);
            messageWindowTooltip = document.getElementById("messageWindowTooltip");
            messageWindowTooltip.append(messageWindowTooltipDiv);

            const ewsIconRuleMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='ewsIconRuleMessage${Number}' placement='top'>Minimize Window</ecp-tooltip>`);
            const ewsIconBreakOutMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='ewsIconBreakOutMessage${Number}' placement='top'>Maximize Window</ecp-tooltip>`);
            const ewsIconCloseMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='ewsIconCloseMessage${Number}' placement='top'>Close Window</ecp-tooltip>`);

            const LinkToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='LinkToolMessage${Number}' placement='top'>Insert Link</ecp-tooltip>`);
            const FileToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='FileToolMessage${Number}' placement='top'>Upload Files</ecp-tooltip>`);
            const FmtToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='FmtToolMessage${Number}' placement='top'>Clear Format</ecp-tooltip>`);
            const SearchToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='SearchToolMessage${Number}' placement='top'>Search History</ecp-tooltip>`);
            const CopyToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='CopyToolMessage${Number}' placement='top'>Copy or Create New Task</ecp-tooltip>`);
            const SendDelayToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='SendDelayToolMessage${Number}' placement='top'>Delay Send</ecp-tooltip>`);
            const AlertToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='AlertToolMessage${Number}' placement='top'>Mute/Unmute eChat Group</ecp-tooltip>`);
            const OpenEChatToolMessage = EC_Fmt.HtmlStrToElement(`<ecp-tooltip for='OpenEChatToolMessage${Number}' placement='top'>Open eChat</ecp-tooltip>`);

            messageWindowTooltipDiv.append(ewsIconRuleMessage, ewsIconCloseMessage, ewsIconBreakOutMessage, LinkToolMessage, FileToolMessage,
                FmtToolMessage, SearchToolMessage, CopyToolMessage, SendDelayToolMessage, AlertToolMessage, OpenEChatToolMessage);
        }
    };

    this.ShowUnreadButton = function (MessageGroupID, UnreadCount) {
        const unreadButton = windowElement.querySelector(".group-unread-button-div");
        if (unreadButton) {
            unreadButton.remove();
        }

        let headRect = windowElement.querySelector(".eChat-MessageWindowHead").getBoundingClientRect();
        let limitY = headRect.y + headRect.height;
        let messageArr = windowElement.querySelectorAll(`#chatBox_${MessageGroupID} .echat-message-block.Left`);
        let addButton = true;
        if (messageArr.length >= UnreadCount) {
            const messageDom = messageArr[messageArr.length - UnreadCount];
            addButton = limitY > messageDom.getBoundingClientRect().y;
        }

        if (!addButton) {
            return;
        }
        const button = EC_Fmt.HtmlStrToElement(`<div class=group-unread-button-div unread-count=${UnreadCount}><span class=ews-icon-prevnotesicon></span>Scroll to unread</div>`);
        button.addEventListener("click", async () => {
            messageArr = windowElement.querySelectorAll(`#chatBox_${MessageGroupID} .echat-message-block.Left`);
            if (messageArr.length < UnreadCount) {
                let noMessage = false;
                EChat.Util.ShowLoading(windowElement);
                while (!noMessage && messageArr.length < UnreadCount) {
                    noMessage = await _this.chatTabList[MessageGroupID].windowScroll(true);
                    messageArr = windowElement.querySelectorAll(`#chatBox_${MessageGroupID} .echat-message-block.Left`);
                }
                ECP.Dialog.HideLoading();
            }

            headRect = windowElement.querySelector(".eChat-MessageWindowHead").getBoundingClientRect();
            limitY = headRect.y + headRect.height;
            UnreadCount = Math.min(messageArr.length, UnreadCount);
            const messageDom = messageArr[messageArr.length - UnreadCount];
            const moveHight = limitY - messageDom.getBoundingClientRect().y;
            const chatBoxElement = document.getElementById(`chatBox_${MessageGroupID}`);
            if (chatBoxElement) {
                chatBoxElement.scrollTop = chatBoxElement.scrollTop - moveHight - 20;
            }

            _this.HideUnreadButton(true);
        });

        windowElement.append(button);
    };

    this.HideUnreadButton = function (force) {
        const unreadButton = windowElement.querySelector(".group-unread-button-div");
        if (unreadButton) {
            const UnreadCount = parseInt(unreadButton.getAttribute("unread-count"));
            if (force || !UnreadCount) {
                unreadButton.remove();
            } else {
                const headRect = windowElement.querySelector(".eChat-MessageWindowHead").getBoundingClientRect();
                const limitY = headRect.y + headRect.height;

                let hideButton = false;
                const messageArr = windowElement.querySelectorAll(".echat-message-block.Left");
                if (messageArr.length >= UnreadCount) {
                    const messageDom = messageArr[messageArr.length - UnreadCount];
                    hideButton = limitY <= messageDom.getBoundingClientRect().y;
                }

                if (hideButton) {
                    unreadButton.remove();
                }
            }
        }
    };

    this.DisabledInputArr = function (disabled) {
        const MessageWindowTextArea = document.querySelector(".eChat-MessageWindowTextArea");
        if (disabled) {
            if (MessageWindowTextArea) {
                MessageWindowTextArea.setAttribute("contenteditable", "false");
            }
            dialogElement.style.paddingBottom = "0px";
        } else if (MessageWindowTextArea) {
            MessageWindowTextArea.setAttribute("contenteditable", "true");
        }
    };

    this.addAlertTab = function (groupInfo, sync, twinkle) {
        if (_this.messageWindowViewType !== EChat.ViewType.OpenView) {
            openView();
        }
        const key = groupInfo.MessageGroupID;
        let chatTabController = _this.chatTabList[key];
        if (!chatTabController) {
            chatTabController = new EChat.ChatTabController(groupInfo, _this);
            headerElement.append(chatTabController.createHeadElement());
            dialogElement.append(chatTabController.createContentElement());
            addTab(key, chatTabController);
            _this.resizeTab();
            _this.switchWindowType(groupInfo.GroupType);
            chatTabController.drawHistoryMessages(groupInfo.Messages);
            chatTabController.windowScroll();
        }
        _this.topTab(chatTabController, sync, twinkle);
    };

    this.topTab = function (chatTabController, sync, twinkle, focusFlag) {
        if (_this.currentTab !== chatTabController) {
            removeFloatLinkElement();
            removeFloatFileElement();
            windowElement.style.zIndex = EChat.Util.draggableZIndex();

            if (_this.currentTab) {
                _this.currentTab.hideTab();
            }
            chatTabController.showTab(sync, twinkle);
            _this.currentTab = chatTabController;
            // Task 689566: eChat: Bell Icon gets messed up when opening eChat Groups with both muted and unmuted notifications

            if (_this.messageWindowViewType === EChat.ViewType.OpenView) {
                _this.switchWindowType(chatTabController.GroupInfo.GroupType, focusFlag);
            }

            if (!_this.currentTab.PreMessage) {
                _this.currentTab.PreMessage = "";
            }
            if (_this.currentTab.SearchInfo) {
                searchRestore(_this.currentTab.SearchInfo);
            } else if (_this.messageWindowViewType === EChat.ViewType.OpenView) {
                removeSearchElement();
            }
            inputArea.setValue(_this.currentTab.PreMessage);
            _this.updateCharaterCounter();

            _this.DisabledInputArr(false);

            _this.currentTab.bottomScroll();
            _this.currentTab.showTaskTitle();
        }
    };

    this.updateCharaterCounter = function () {
        const count = inputArea.getValueCount();
        const charatersLeft = 4000 - Number(count);

        const msgWarning = sendElement.querySelector(".eChatWarning");
        const msgNumber = sendElement.querySelector(".eChatNumber");
        if (!msgWarning || !msgNumber) {
            return;
        }

        if (charatersLeft >= 0) {
            // Task 1067218: DSDLink: eChat in the new Mobile Framework
            if (EChat.MainPageController.ClientOS === "PC") {
                msgWarning.innerHTML = "Available Characters Remaining:";
            } else {
                msgWarning.innerHTML = "Available Characters:";
            }
            msgWarning.style.color = "var(--neutral-50)";
            msgNumber.innerHTML = charatersLeft;
        } else {
            msgWarning.style.color = "var(--red-50)";
            msgWarning.innerHTML = "Message is too long, the message will not be sent:";
            msgNumber.innerHTML = "";
        }
    };

    const sendingMessage = function () {
        removeFloatFileElement();
        removeFloatLinkElement();
        removeSearchElement();
        const eChatDataProvider = EChat.DataProvider;
        let orignalText = inputArea.getValue();
        orignalText = EChat.Util.urlConverter(orignalText);
        const imgObj = inputArea.processImgData();
        imgObj.htmlString = EChat.Util.urlConverter(imgObj.htmlString);
        // Task 1132060: echat: Future Send is not working
        const delayedSendTime = document.getElementById("echat_DelayedTime") ? document.getElementById("echat_DelayedTime").value : "";
        const TimeCreated = EChat.Util.getTimeStamp();
        const MessageGroupID = _this.currentTab.GroupInfo.MessageGroupID;
        const EncompassID = _this.currentTab.GroupInfo.EncompassID;
        let IsPublic = true;
        let Notify = true;
        // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
        let NotifyInternal = true;
        // Task 1144583: eChat: Certain tasks show up with the title of None in the recent eChats section
        const TaskTitleDom = document.querySelector(".eChat-MessageWindowTitle").innerHTML;
        const taskTitle = TaskTitleDom.split("</a>: ")[1];

        if (_this.currentTab.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
            if (_this.isPublicSwitch && !_this.isPublicSwitch.Checked()) {
                IsPublic = false;
            }

            if (_this.notifySwitch && !_this.notifySwitch.Checked()) {
                Notify = false;
            }

            if (_this.notifyInternalSwitch && !_this.notifyInternalSwitch.Checked()) {
                NotifyInternal = false;
            }
        }

        const messageObj = {
            MessageID: `-${TimeCreated}`,
            Message: orignalText,
            MessageGroupID,
            SenderAuthenticationID: eChatDataProvider.CurrentUserInfo.AuthenticationID,
            GroupType: _this.currentTab.GroupInfo.GroupType,
            TimeCreated,
            DelayedSendTime: delayedSendTime,
            IsPublic,
            SenderFullName: eChatDataProvider.CurrentUserInfo.FullName,
            SenderUserAvatar: eChatDataProvider.CurrentUserInfo.UserAvatar,
            TaskID: _this.currentTab.GroupInfo.TaskID
        };

        if (imgObj.htmlString !== "" && imgObj.htmlString !== "<br>" && inputArea.getValueCount() <= EChat.Setting.CharactersOfMessage) {
            inputArea.setValue("");
            if (EChat.FullWindowController.FullWindow && EChat.FullWindowController.TextArea) {
                setTimeout(() => {
                    inputArea.setValue("");
                }, 10);
            }
            _this.updateCharaterCounter();
            _this.currentTab.PreMessage = "";
            // Task 1046811: eChat displays messages in incorrect order
            _this.currentTab.drawNewMessage(messageObj, true);

            if (imgObj.imgList.length === 0) {
                imgObj.imgList = null;
            }
            eChatDataProvider.SendMessage({
                messageGroupID: messageObj.MessageGroupID,
                messageMark: TimeCreated,
                messageBody: imgObj.htmlString,
                imgData: imgObj.imgList,
                delayedSendTime: (new Date(delayedSendTime)).getTime(),
                taskID: messageObj.TaskID,
                taskSourceEncompassID: EncompassID,
                isPublic: IsPublic,
                notify: Notify,
                notifyInternal: NotifyInternal,
                // Task 1144583: eChat: Certain tasks show up with the title of None in the recent eChats section
                taskTitle: !EC_Fmt.isNull(taskTitle) ? taskTitle : ""
            });
        }
    };

    this.receiveNewMessage = function (msg, groupId) {
        const chatTab = _this.chatTabList[groupId];
        if (chatTab && !document.getElementById(`messageblock_${msg.MessageID}`)) {
            if (_this.messageWindowViewType === EChat.ViewType.OpenView) {
                if (chatTab === _this.currentTab) {
                    setTimeout(() => {
                        _this.currentTab.syncGroupLastReadTime();
                    }, 3000);
                    _this.currentTab.drawNewMessage(msg);
                } else {
                    if (parseInt(msg.SenderAuthenticationID) !== EChat.DataProvider.CurrentUserInfo.AuthenticationID) {
                        chatTab.twinkleOn(true);
                    }
                    chatTab.drawNewMessage(msg);
                }
            } else if (_this.messageWindowViewType === EChat.ViewType.MinimizeView) {
                if (chatTab !== _this.currentTab) {
                    const minimizeElementSpan = minimizeElement.querySelector("span");
                    if (minimizeElementSpan) {
                        minimizeElementSpan.setAttribute("title", chatTab.TabName);
                        minimizeElementSpan.textContent = chatTab.TabName;
                    }
                    _this.topTab(chatTab, false, false);
                }
                if (parseInt(msg.SenderAuthenticationID) !== EChat.DataProvider.CurrentUserInfo.AuthenticationID) {
                    twinkleOn(true);
                    chatTab.twinkleOn(false);
                }
                chatTab.drawNewMessage(msg);
            }
        }
    };

    const searchRestore = function (searchInfo) {
        if (searchInfo) {
            searchElement.innerHTML = "";
            searchElement.append(createSearchElement());
            const InputToolInput = document.querySelector(".eChat-InputToolInput");
            if (InputToolInput) {
                InputToolInput.value = searchInfo.SearchText;
            }
            const SearchItem = document.querySelector("select.eChat-SearchItem");
            if (SearchItem) {
                SearchItem.value = searchInfo.SearchDate;
            }
            if (searchInfo.Search === true) {
                const SearchButton = document.querySelector(".eChat-SearchButton");
                if (SearchButton) {
                    SearchButton.click();
                }
            } else {
                removeSearchDisplayElement();
            }
        }
    };
};

EChat.ChatTabController = function (messageGroup, messageWindowController) {
    const _this = this;

    this.GroupInfo = messageGroup;
    this.ID = messageGroup.MessageGroupID;
    this.TabName = EChat.DataProvider.GetGroupName(messageGroup);
    this.targetWindowController = messageWindowController;
    this.isTwinkle = false;
    this.PreMessage = "";
    this.TaskTitle = "";
    this.TabCreateTime = EChat.Util.getTimeStamp();
    let viewMoreCount = 0;
    let syncDate = 0;
    let lastMessageID = "";
    let lastScrollTop = 0;
    let isScrollBottom = false;
    let tabMenu = null;

    this.updateGroupName = function () {
        _this.TabName = EChat.DataProvider.GetGroupName(_this.GroupInfo);
        const tabDom = document.getElementById(`span_${_this.ID}`);
        if (tabDom) {
            tabDom.innerText = _this.TabName;
        }
    };

    const createMenuElement = async function () {
        let result = null;
        if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Message || _this.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
            result = EC_Fmt.HtmlStrToElement("<div class=eChatDialogTabMenu style=display:none></div>");
            result.addEventListener("mousedown", (e) => {
                e.stopPropagation();
            });
            EChat.Util.PreventScroll(result);

            let userList = [];
            let error = "";
            if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                const messageGroupID = await EChat.DataProvider.GetTaskPublicMessageGroupID(_this.GroupInfo.MessageGroupID);
                if (messageGroupID) {
                    userList = await EChat.DataProvider.GetGroupUserInfo(messageGroupID);
                } else {
                    error = "The group does not exist.";
                }
            } else {
                userList = await EChat.DataProvider.GetGroupUserInfo(_this.GroupInfo.MessageGroupID);
            }

            let topTxt = `Members ${userList.length}`;
            if (error) {
                topTxt = error;
            }

            const topElement = EC_Fmt.HtmlStrToElement(`<div class=eChatDialogTabMenuTitle>${topTxt}</div>`);
            if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Message && _this.GroupInfo.PostPermission !== EChat.PostPermissionType.ReadOnly) {
                // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
                const groupEditBtn = EC_Fmt.HtmlStrToElement("<ecp-btn type=ghost icon=ews-icon-edit style=font-size:16px;width:26px;height:26px;float:right;margin:0></ecp-btn>");
                groupEditBtn.addEventListener("click", () => {
                    EChat.GroupSettingController.openGroupSettingWindow(_this.GroupInfo.MessageGroupID);
                });
                topElement.append(groupEditBtn);
            }

            result.append(topElement);
            for (let i = 0; i < userList.length; i++) {
                const userInfo = userList[i];
                if (userInfo) {
                    const divElement = EC_Fmt.HtmlStrToElement("<div style='margin:5px 2px 0 2px;width:100%;display:inline-block'></div>");

                    let iconUrl;
                    if (!userInfo.Icon) {
                        iconUrl = EChat.Setting.DefaultUserIcon;
                    } else {
                        iconUrl = userInfo.Icon;
                    }

                    const nameSpan = EC_Fmt.HtmlStrToElement(`<span class=eChat-TextHidden style=margin-left:8px;float:left;width:135px>${userInfo.Name}</span>`);
                    const iconImgSpan = EC_Fmt.HtmlStrToElement("<span class='Left eChat-User-Img'></span>");
                    const iconSpan = EC_Fmt.HtmlStrToElement(`<span class=eChatUserIcon style=background-image:url(${iconUrl});border-radius:12px></span>`);
                    iconImgSpan.append(iconSpan);
                    divElement.append(iconImgSpan);
                    divElement.append(nameSpan);
                    result.append(divElement);
                }
            }
        }
        return result;
    };

    this.closeEvent = function () {
        if (EChat.eChatMoving) {
            EChat.eChatMoving = false;
        }
        if (_this.targetWindowController.chatTabListCount > 1) {
            if (_this.GroupInfo.GroupType === SocketUtil.GroupType.System) {
                _this.targetWindowController.deleteTab(_this.GroupInfo.MessageGroupID);
            } else {
                _this.targetWindowController.deleteTab(_this.GroupInfo.MessageGroupID);
            }

            _this.targetWindowController.resizeTab();
            // Task 941875: Task title was not updated correctly when echat closed chat tab
            if (_this === _this.targetWindowController.currentTab) {
                const tabList = Object.keys(_this.targetWindowController.chatTabList);
                for (let i = tabList.length - 1; i >= 0; i--) {
                    const openedTab = _this.targetWindowController.chatTabList[tabList[i]];
                    if (openedTab?.GroupInfo) {
                        _this.targetWindowController.addRecentTab(openedTab.GroupInfo, false, false);
                        break;
                    }
                }
                _this.closeTab();// true
            } else {
                _this.closeTab();// false
            }
        } else {
            _this.targetWindowController.closeMessageWindow();
        }
        _this.targetWindowController = null;
    };

    this.createHeadElement = function () {
        const msgItem = EC_Fmt.HtmlStrToElement(`<li class='DialogHeadTab Left CurrentHead eChatRelative'id=header_${_this.ID} data=OneByOne></li>`);
        const msgItemInner = EC_Fmt.HtmlStrToElement("<div class=TabName></div>");

        // Task 1149732: Update 'eChat' page to new button component
        const nameDisplayElement = EC_Fmt.HtmlStrToElement(`<span class=eChat-TextHidden id=span_${_this.ID} style=width:100%;display:block;margin-right:37px;>${_this.TabName}</span>`);
        nameDisplayElement.setAttribute("title", _this.TabName);

        // Task 1074079: eChat: Close window buttons do not use the standard UI Kit
        // Task 1149732: Update 'eChat' page to new button component
        // const closeElement = EC_Fmt.HtmlStrToElement("<span class='CloseDialog eChatAbsolute eChatDisplayNone' style='display:none;'></span>");
        const closeElement = EC_Fmt.HtmlStrToElement("<ecp-btn type=ghost icon=ews-icon-close class='echat-MessageBoxClose CloseDialog' style='display:none;font-size: 16px;'></ecp-btn>");
        closeElement.addEventListener("click", (e) => {
            _this.closeEvent();
            e.stopPropagation();
        });

        msgItemInner.append(nameDisplayElement);
        msgItemInner.append(closeElement);
        msgItem.append(msgItemInner);

        msgItem.addEventListener("click", async () => {
            if (_this === _this.targetWindowController.currentTab) {
                if (!tabMenu || (tabMenu?.clientWidth === 0)) {
                    tabMenu = await createMenuElement(msgItem);
                    if (tabMenu) {
                        msgItem.append(tabMenu);
                        tabMenu.style.display = "block";
                    }
                }
            } else {
                _this.targetWindowController.topTab(_this, true, false);
            }
        });

        msgItem.addEventListener("mouseenter", function () {
            this.querySelectorAll(".CloseDialog").forEach((dom) => {
                dom.style.display = "block";
            });
        });

        msgItem.addEventListener("mouseleave", function () {
            this.querySelectorAll(".CloseDialog").forEach((dom) => {
                dom.style.display = "none";
            });
        });

        return msgItem;
    };

    const headImgClickEvent = function (authID, userName, userMemberCount) {
        if (parseInt(userMemberCount) === 2 && authID > 0) {
            window.open(`./Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=Users&Search=AuthenticationID~${authID}`);
        } else {
            const eChatDataProvider = EChat.DataProvider;
            const userStr = eChatDataProvider.GetUserStrByUserList([authID, eChatDataProvider.CurrentUserInfo.AuthenticationID]);
            EChat.DataProvider.GetGroupInfoByAuthIDList(userStr).then((groupInfo) => {
                EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID).addRecentTab(groupInfo, false);
            });
        }
    };

    this.createContentElement = function () {
        const chattingBoxElement = EC_Fmt.HtmlStrToElement(`<div class=ChattingBox id='chatBox_${_this.ID}'></div>`);
        EChat.Util.PreventScroll(chattingBoxElement);
        chattingBoxElement.addEventListener("scroll", scrollCheck);
        return chattingBoxElement;
    };

    const createSendTimeElement = function (sendTime) {
        return EC_Fmt.HtmlStrToElement(`<div class=SendTime messagemark='${sendTime}'>${EChat.Util.longToDataTime(sendTime)}</div>`);
    };

    const createMessageElement = function (msgObj) {
        const eChatDataProvider = EChat.DataProvider;

        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
        if (EChat.MainPageController.ClientOS === "Mobile") {
            if (EC_App) {
                const filterATag = /<a [^>]*href=['"]([^'"]+)[^"]*/gi;
                const ATag = msgObj.Message;
                const aTagResult = ATag.match(filterATag);
                if (!EC_Fmt.isNull(aTagResult)) {
                    for (let i = 0; i < aTagResult.length; i++) {
                        const URL_ID = EC_Fmt.HtmlStrToElement(`<div id='URL_ID'></div>`);
                        document.body.append(URL_ID);
                        URL_ID.innerHTML = ATag;
                        const aTag = URL_ID.querySelectorAll("a");
                        for (let j = 0; j < aTag.length; j++) {
                            const href = aTag[j].href;
                            // const filterUrl = /https?:\/\/(\w+\.)?(\w+\.)+(com"|cn"|)/gi;
                            // const urlAddress = aTagResult[i].match(filterUrl);
                            msgObj.Message = msgObj.Message.replace(`${aTagResult[j]}`, `<a titile="" href="javascript:EC_App.Open('${href}')`);
                        }
                        URL_ID.remove();
                    }
                }
            }
        }

        if (msgObj.Message) {
            let senderName;
            if (eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                senderName = eChatDataProvider.CurrentUserInfo.FullName;
            } else if (msgObj.SenderFullName) {
                senderName = msgObj.SenderFullName;
            } else {
                senderName = msgObj.SenderAuthenticationID <= 0 ? "System" : `None_${msgObj.SenderAuthenticationID}`;
            }

            let itemElement;
            let delayimgElement;
            let delaymessge;
            let msgElement;
            let headImgElement;
            const senderNameElement = EC_Fmt.HtmlStrToElement(`<div>${senderName}</div>`);
            const textElement = document.createElement("DIV");
            const flexElement = EC_Fmt.HtmlStrToElement("<div class=message-flex-box></div>");
            if (!eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                itemElement = EC_Fmt.HtmlStrToElement(`<div class='LeftDialog eChatRelative Left echat-message-block'messageMark='${msgObj.TimeCreated}'messageid=${msgObj.MessageID} id=messageblock_${msgObj.MessageID} sender='${msgObj.SenderAuthenticationID}'></div>`);
                msgElement = EC_Fmt.HtmlStrToElement("<div class='LeftBubble eChatRelative clear-fix'></div>");
                headImgElement = EC_Fmt.HtmlStrToElement("<img class='eChat-UserHeadImg Left' style=cursor:pointer/>");
                senderNameElement.classList.add("MemberName");
                textElement.classList.add("DialogBubbleHead");
                textElement.classList.add("Left");
            } else {
                itemElement = EC_Fmt.HtmlStrToElement(`<div class='RightDialog eChatRelative Right echat-message-block' messageMark='${msgObj.TimeCreated}' messageid=${msgObj.MessageID} id=messageblock_${msgObj.MessageID} sender='${msgObj.SenderAuthenticationID}'></div>`);
                delayimgElement = EC_Fmt.HtmlStrToElement("<span class='ews-icon-senddelay echat-message'></span>");
                msgElement = EC_Fmt.HtmlStrToElement("<div class='RightBubble eChatRelative clear-fix'></div>");
                delaymessge = EC_Fmt.HtmlStrToElement(`<div class='Messagedelaymessage'>This message will be delivered on  ${msgObj.DelayedSendTime}</div>`);
                headImgElement = EC_Fmt.HtmlStrToElement("<img class='eChat-UserHeadImg Right'/>");
                senderNameElement.classList.add("MemberNameRight");
                textElement.classList.add("Left");
                textElement.classList.add("DialogBubbleHead");
            }

            // MessageUserHeadImg
            const userMemberCount = _this.GroupInfo.Users.length;
            if (msgObj.SenderUserAvatar) {
                headImgElement.setAttribute("src", msgObj.SenderUserAvatar);
            } else {
                headImgElement.setAttribute("src", EChat.Setting.DefaultUserIcon);
            }

            if (!eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                headImgElement.addEventListener("click", () => {
                    headImgClickEvent(msgObj.SenderAuthenticationID, userMemberCount);
                });
            }

            if (msgObj.SenderAuthenticationID <= 0) {
                headImgElement.style.cursor = "default";
            }

            const pElement = EC_Fmt.HtmlStrToElement(`<p id=message_${msgObj.MessageID} messageid=${msgObj.MessageID}></p>`);

            // Task:208316 Task Edit: eChat messages sent from Task Edit do not display the Return Characters.when the message is first displayed. Very ugly to read in eChat
            msgObj.Message = msgObj.Message.replace(/\n/g, "<br>");
            pElement.append(EC_Fmt.HtmlStrToElement(`<div class="echat_message_base">${msgObj.Message}</div>`));
            EChat.Util.CopyFormat(pElement);

            const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
            EChat.Util.FileLoad(pElement, chatBoxElement, msgObj.SenderAuthenticationID, 423, 200);
            textElement.append(pElement);
            flexElement.append(textElement);
            msgElement.append(headImgElement);
            msgElement.append(senderNameElement);
            msgElement.append(document.createElement("DIV"));
            msgElement.append(flexElement);
            itemElement.append(msgElement);

            if (msgObj.IsPublic === false || parseInt(msgObj.IsPublic) === 0) {
                const privateLabelContainer = document.createElement("DIV");
                const privateLabel = EC_Fmt.HtmlStrToElement("<span class=PrivateLabel>Private</span>");
                if (!eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                    privateLabelContainer.classList.add("PrivateLeft");
                    privateLabelContainer.classList.add("Left");
                } else {
                    privateLabelContainer.classList.add("Right");
                    privateLabelContainer.classList.add("PrivateRight");
                }
                privateLabelContainer.append(privateLabel);
                itemElement.append(privateLabelContainer);
            }

            if (msgObj.DelayedSendTime) {
                itemElement.append(delaymessge);
                flexElement.prepend(delayimgElement);
            }

            const TaskSourceEncompassID = _this.GroupInfo.GroupType === SocketUtil.GroupType.Task ? _this.GroupInfo.EncompassID : "";
            const isCurrTask = EChat.DataProvider.CurrentUserInfo && EChat.DataProvider.CurrentUserInfo.PrimaryEncompassID === TaskSourceEncompassID;
            if (TaskSourceEncompassID === "" || isCurrTask) {
                const SavedStatus = msgObj.MessageID && EChat.DataProvider.SavedMessage && EChat.DataProvider.SavedMessage.includes(msgObj.MessageID.toString());
                const SavedMessageIcon = EC_Fmt.HtmlStrToElement(`<span class=saved-message-icon id='SavedKey_${msgObj.MessageID}'></span>`);
                if (SavedStatus) {
                    SavedMessageIcon.style.display = "inline-block";
                    SavedMessageIcon.classList.add("ews-icon-collection");
                } else {
                    SavedMessageIcon.classList.add("ews-icon-uncollection");
                }

                SavedMessageIcon.setAttribute("savedkey", msgObj.MessageID);
                SavedMessageIcon.addEventListener("click", () => {
                    // Sent message . savedkey updated asynchronously
                    msgObj.MessageID = SavedMessageIcon.getAttribute("savedkey");
                    EChat.MainPageController.SavedButtonEvent(msgObj, _this.GroupInfo);
                });

                if (eChatDataProvider.IsCurrentUser(msgObj.SenderAuthenticationID)) {
                    flexElement.prepend(SavedMessageIcon);
                } else {
                    flexElement.append(SavedMessageIcon);
                }
            }

            itemElement.addEventListener("click", function (e) {
                const messageid = this.getAttribute("messageid");
                const sender = this.getAttribute("sender");

                if (e.altKey && messageid && messageid[0] !== "-" && document.getElementById(`message_${messageid}`).innerText !== "[Recalled a message]") {
                    if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Message && eChatDataProvider.IsCurrentUser(sender)) {
                        EWS.Confirm("Recall this message ?", () => {
                            eChatDataProvider.RecallMessage(_this.ID, messageid);
                        });
                    }
                }
            });

            return itemElement;
        }
        return null;
    };

    const createFloatMessageElement = function () {
        let floatDiv = document.getElementById(`EChatFloatMessage_${_this.ID}`);
        if (floatDiv) {
            if (floatDiv.children.length > 0) {
                const msgSpan = floatDiv.children[0];
                if (EC_Fmt.Trn(msgSpan.textContent) === EC_Fmt.Trn("You have a new message")) {
                    msgSpan.innerHTML = `${EC_Fmt.Trn("You have")} <span>2</span> ${EC_Fmt.Trn("new messages")}`;
                } else if (msgSpan.children.length > 0) {
                    const numSpan = msgSpan.children[0];
                    numSpan.textContent = Number(numSpan.textContent) + 1;
                }
            }
        } else {
            floatDiv = EC_Fmt.HtmlStrToElement(`<div class='DialogNewMessageTips' id='EChatFloatMessage_${_this.ID}' groupid='${_this.ID}'></div>`);
            floatDiv.append(EC_Fmt.HtmlStrToElement("<span>You have a new message</span>"));
            floatDiv.append(EC_Fmt.HtmlStrToElement("<span class='DialogTriangle'></span>"));

            floatDiv.addEventListener("click", function () {
                scrollToBottom(this.getAttribute("groupid"));
            });
        }
        return floatDiv;
    };

    this.bottomScroll = function () {
        if (isScrollBottom) {
            scrollToBottom(_this.ID);
        }
    };

    const scrollToBottom = function (messageGroupID) {
        const chatBoxElement = document.getElementById(`chatBox_${messageGroupID}`);
        if (chatBoxElement) {
            chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
        }
        chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
        isScrollBottom = true;
    };

    const removeFloatMessageElement = function () {
        const floatMessage = document.getElementById(`EChatFloatMessage_${_this.ID}`);
        if (floatMessage) {
            floatMessage.remove();
        }
    };

    // Not called anywhere
    // this.createBottomMessageElement = function (message, callback) {
    //     _this.removeBottomMessageElement();
    //     const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
    //     const link = EC_Fmt.HtmlStrToElement(`<div id='EChatBottomLink${_this.ID}'class=EChat_Bottom_Link>${message}</div>`);
    //     link.addEventListener("click", callback);
    //     chatBoxElement.append(link);
    // };

    this.removeBottomMessageElement = function () {
        const bootom = document.getElementById(`EChatBottomLink${_this.ID}`);
        if (bootom) {
            bootom.remove();
        }
    };

    this.AddTipElement = function (TipElement) {
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (TipElement && chatBoxElement) {
            TipElement.classList.add("EChatChatTip");
            chatBoxElement.append(TipElement);
            _this.setScrollTop();
        }
    };

    const scrollCheck = function () {
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBoxElement) {
            if (chatBoxElement.offsetHeight + chatBoxElement.scrollTop >= chatBoxElement.scrollHeight - 1) {
                isScrollBottom = true;
                removeFloatMessageElement();
            } else {
                isScrollBottom = false;
            }
        }
    };

    // Task 998916: Task information does not update when pulling up many eChats and clicking on eChat tabs.
    this.showTaskTitle = function (taskTitle) {
        if (taskTitle) {
            _this.TaskTitle = taskTitle;
        } else {
            taskTitle = _this.TaskTitle;
        }

        if (_this.targetWindowController && _this.targetWindowController.element && taskTitle) {
            const titleDom = _this.targetWindowController.element.querySelector(".eChat-MessageWindowTitle");
            if (titleDom) {
                titleDom.innerHTML = taskTitle;
            }
        }
        // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
        EChat.Util.resizeDialogMessage();
    };

    this.disablePublic = function (disable) {
        if (_this.targetWindowController && _this.targetWindowController.element) {
            const PubicTool = _this.targetWindowController.element.querySelector(".eChat-MessageWindowPubicTool");
            if (PubicTool) {
                if (disable) {
                    PubicTool.style.display = "none";
                    _this.targetWindowController.isPublicSwitch.Open();
                } else {
                    PubicTool.style.display = "inline-block";
                }
            }
        }
    };

    // Task 947307: Ensuring that the eChat and Task Edit interface encourages users to create Public Task Details.
    this.disableNotifyInternal = function (disable) {
        if (_this.targetWindowController && _this.targetWindowController.element) {
            const NotifyInternal = _this.targetWindowController.element.querySelector(".eChat-MessageWindowNotifyInternalTool");
            if (NotifyInternal) {
                if (disable) {
                    NotifyInternal.style.display = "none";
                    _this.targetWindowController.notifyInternalSwitch.Close();
                } else {
                    NotifyInternal.style.display = "inline-block";
                }
            }
        }
    };

    this.drawHistoryMessages = function (jsonObj, showAll) {
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (jsonObj && chatBoxElement) {
            let scrollTopNum = 0;
            const showMsgNum = jsonObj.length > EChat.Setting.MessageNumPerShow && !showAll ? EChat.Setting.MessageNumPerShow : jsonObj.length;
            for (let i = 0; i < showMsgNum; i++) {
                if (!chatBoxElement.querySelector(`#messageblock_${jsonObj[i].MessageID}`)) {
                    const msgElement = createMessageElement(jsonObj[i]);
                    if (msgElement) {
                        chatBoxElement.prepend(msgElement);
                        scrollTopNum += msgElement.offsetHeight;
                        const timeElement = createSendTimeElement(jsonObj[i].TimeCreated);
                        chatBoxElement.prepend(timeElement);
                        scrollTopNum += timeElement.offsetHeight;

                        if (!lastMessageID) {
                            syncDate = jsonObj[i].TimeCreated;
                            lastMessageID = jsonObj[i].MessageID;
                        } else if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Task && parseInt(jsonObj[i].MessageID) < parseInt(lastMessageID)) {
                            lastMessageID = jsonObj[i].MessageID;
                            syncDate = jsonObj[i].TimeCreated;
                        } else if (_this.GroupInfo.GroupType !== SocketUtil.GroupType.Task && jsonObj[i].TimeCreated < syncDate) {
                            syncDate = jsonObj[i].TimeCreated;
                        }
                    }
                }
            }

            if (viewMoreCount === 0) {
                chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
                chatBoxElement.querySelectorAll("img").forEach((dom) => {
                    dom.addEventListener("load", () => {
                        lastScrollTop = chatBoxElement.scrollTop;
                    });
                });
                isScrollBottom = true;
            } else {
                chatBoxElement.scrollTop += scrollTopNum;
            }
            lastScrollTop = chatBoxElement.scrollTop;
        }
    };

    this.scorllToMessage = function (messsageWindow, groupInfo, MessageKey) {
        if (!MessageKey) {
            return;
        }
        const windowElement = messsageWindow.element;
        const messageDom = windowElement.querySelector(`#message_${MessageKey}`);
        if (!messageDom) {
            return;
        }

        // Task 996524: Move the task link back to the bottom of the eChat window
        const headRect = windowElement.querySelector(".eChat-MessageWindowHead").getBoundingClientRect();

        const limitY = headRect.y + headRect.height;
        const moveHight = limitY - messageDom.getBoundingClientRect().y;
        const chatBoxElement = document.getElementById(`chatBox_${groupInfo.MessageGroupID}`);
        if (chatBoxElement) {
            chatBoxElement.scrollTop = chatBoxElement.scrollTop - moveHight - 70;
        }
    };

    const scrollEvent = async function () {
        scrollCheck();
        let noMessage = false;
        if (this.scrollTop === 0 && this.scrollHeight > 0) {
            noMessage = await scrollPage();
        }
        _this.targetWindowController.HideUnreadButton(noMessage);
    };

    const scrollPage = async function () {
        if (viewMoreCount >= 0) {
            viewMoreCount++;
            const showCount = EChat.Setting.MessageNumPerShow * viewMoreCount;
            const moreMessageElement = document.createElement("DIV");

            const messageList = await EChat.DataProvider.getGroupMessages(_this.GroupInfo.MessageGroupID);
            if (messageList.length > showCount) {
                const showMsgList = messageList.splice(showCount, EChat.Setting.MessageNumPerShow);
                _this.drawHistoryMessages(showMsgList);
                if (showMsgList.length > 0) {
                    syncDate = showMsgList[showMsgList.length - 1].TimeCreated;
                    lastMessageID = showMsgList[showMsgList.length - 1].MessageID;
                }
            } else {
                if (messageList.length > 0) {
                    syncDate = messageList[messageList.length - 1].TimeCreated;
                    lastMessageID = messageList[messageList.length - 1].MessageID;
                }
                viewMoreCount = -1;
                await getServerMessageHistory();
            }

            const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
            if (chatBoxElement) {
                chatBoxElement.prepend(moreMessageElement);
            }
        } else if (viewMoreCount === -1) {
            await getServerMessageHistory();
        }

        const noMessage = viewMoreCount < -1;
        return noMessage;
    };

    this.windowScroll = async function (TriggerOnce) {
        // Task 996347: Some issues with the new version of Web UI eChat
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (!chatBoxElement) {
            return true;
        }
        chatBoxElement.removeEventListener("scroll", scrollEvent);

        let result = true;
        if (TriggerOnce) {
            result = await scrollPage();
        }

        chatBoxElement.addEventListener("scroll", scrollEvent);

        return result;
    };

    const getServerMessageHistory = async function () {
        if (parseInt(syncDate) !== 0) {
            let data;
            if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                data = await EChat.DataProvider.getTaskDetailHistory(_this.GroupInfo.TaskID, _this.GroupInfo.EncompassID, 0, lastMessageID, false);
            } else {
                data = await EChat.DataProvider.getMessageHistory(_this.GroupInfo.MessageGroupID, syncDate, null);
            }

            let messageList = [];
            if (data) {
                if (_this.GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                    messageList = data.TaskDetails;
                } else {
                    messageList = data;
                }
            }

            if (messageList.length > 0) {
                syncDate = messageList[messageList.length - 1].TimeCreated;
                lastMessageID = messageList[messageList.length - 1].MessageID;
                _this.drawHistoryMessages(messageList);
            } else {
                viewMoreCount = -2;// end
            }
        }
    };

    // Task 1046811: eChat displays messages in incorrect order
    this.drawNewMessage = function (msgObj, isAddToBottom) {
        if (msgObj) {
            const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
            if (chatBoxElement) {
                if (!chatBoxElement.querySelector(`#messageblock_${msgObj.MessageID}`)) {
                    const msgElement = createMessageElement(msgObj);
                    if (msgElement) {
                        const timeElement = createSendTimeElement(msgObj.TimeCreated);
                        // Task 1035772: Echat chat messages are displayed in incorrect order
                        let lastDom = null;
                        let lastDomTime = -1;

                        chatBoxElement.querySelectorAll(".SendTime").forEach((dom) => {
                            const messagemark = parseInt(dom.getAttribute("messagemark"));
                            if (!EC_Fmt.isNumber(messagemark) && msgObj.TimeCreated < messagemark && (messagemark < lastDomTime || lastDomTime === -1)) {
                                lastDomTime = messagemark;
                                lastDom = dom;
                            }
                        });

                        if (!isAddToBottom && lastDom) {
                            chatBoxElement.insertBefore(msgElement, lastDom);
                            chatBoxElement.insertBefore(timeElement, msgElement);
                        } else {
                            chatBoxElement.append(timeElement);
                            chatBoxElement.append(msgElement);
                            if (!isScrollBottom && parseInt(msgObj.SenderAuthenticationID) !== EChat.DataProvider.CurrentUserInfo.AuthenticationID) {
                                const floatElement = createFloatMessageElement(msgObj);
                                chatBoxElement.append(floatElement);
                            } else {
                                chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
                            }
                        }
                    }

                    const timeStamp = EChat.Util.getTimeStamp();
                    EChat.DataProvider.LastMessageTime[msgObj.MessageGroupID] = timeStamp;
                }
            }
        }
    };

    this.scrollToBotton = function () {
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBoxElement) {
            chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
        }
    };

    this.refreshMessageList = function (MessageObjList) {
        MessageObjList = MessageObjList.sort((a, b) => a.TimeCreated - b.TimeCreated);
        for (let i = 0, len = MessageObjList.length; i < len; i++) {
            const msg = MessageObjList[i];
            if (msg.TimeCreated > syncDate) {
                _this.targetWindowController.receiveNewMessage(msg, _this.ID);
            }
        }
    };

    this.clearMessage = function () {
        const chatBox = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBox) {
            chatBox.innerHTML = "";
        }
        viewMoreCount = 0;
        syncDate = 0;
        lastMessageID = "";
        lastScrollTop = 0;
    };

    this.closeTab = function () {
        const header = document.getElementById(`header_${_this.ID}`);
        if (header) {
            header.remove();
        }

        const chatBox = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBox) {
            chatBox.remove();
        }
    };

    this.showTab = function (sync, twinkle) {
        if (sync) {
            _this.syncGroupLastReadTime();
        }
        if (twinkle) {
            _this.twinkleOn(false);
        } else {
            _this.twinkleOff();
        }
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBoxElement) {
            chatBoxElement.scrollTop = lastScrollTop;
            chatBoxElement.style.display = "block";
        }
        document.getElementById(`header_${_this.ID}`).classList.add("CurrentHead");
    };

    this.syncGroupLastReadTime = function () {
        if (_this.GroupInfo && (_this.GroupInfo.GroupType === SocketUtil.GroupType.Message
            || _this.GroupInfo.GroupType === SocketUtil.GroupType.Task
            || _this.GroupInfo.GroupType === SocketUtil.GroupType.System)) {
            EChat.DataProvider.SyncLastReadTime(_this.GroupInfo.MessageGroupID);
        }
    };

    let twinkleHandle = null;

    this.twinkleOn = function (isPlay) {
        const target = document.getElementById(`header_${_this.ID}`);
        if (target) {
            if (isPlay) {
                if (!twinkleHandle) {
                    twinkleHandle = setInterval(() => {
                        target.classList.toggle("TwinkleOn");
                    }, 600);

                    setTimeout(() => {
                        if (twinkleHandle) {
                            target.classList.add("TwinkleOn");
                            clearInterval(twinkleHandle);
                            twinkleHandle = null;
                        }
                    }, 3000);
                }
            } else {
                target.classList.add("TwinkleOn");
            }
            _this.isTwinkle = true;
        }
    };

    this.twinkleOff = function () {
        const target = document.getElementById(`header_${_this.ID}`);
        if (target) {
            target.classList.remove("TwinkleOn");
            if (twinkleHandle) {
                clearInterval(twinkleHandle);
                twinkleHandle = null;
            }
            _this.isTwinkle = false;
        }
    };

    this.hideTab = function () {
        _this.hideMenu();
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBoxElement) {
            lastScrollTop = chatBoxElement.scrollTop;
            chatBoxElement.style.display = "none";
        }

        const header = document.getElementById(`header_${_this.ID}`);
        if (header) {
            header.classList.remove("CurrentHead");
        }
    };

    this.setScrollTop = function () {
        const chatBoxElement = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBoxElement) {
            if (isScrollBottom) {
                chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
            } else {
                chatBoxElement.scrollTop = lastScrollTop;
            }
        }
    };

    this.getScrollTop = function () {
        const chatBox = document.getElementById(`chatBox_${_this.ID}`);
        if (chatBox) {
            lastScrollTop = chatBox.scrollTop;
        }
    };

    this.hideMenu = function () {
        const eChatDialogTabMenus = document.getElementsByClassName("eChatDialogTabMenu");
        for (let i = 0; i < eChatDialogTabMenus.length; i++) {
            eChatDialogTabMenus[i].remove();
        }
    };
    return _this;
};

EChat.CopyMessageController = (function () {
    const CopyMessageControllerClass = function () {
        const _this = this;
        this.Type = null;
        this.GroupInfo = null;
        let syncDate = 0;
        let SaveCallBack = null;
        let Scrolling = false;
        let lastClickElement = null;

        this.ShowCopyMessageDialog = function (MessageGroupID, Type, CallBack) {
            SaveCallBack = CallBack;
            _this.Type = Type;
            const echat_CopyMessageList = document.getElementById("echat_CopyMessageList");
            if (echat_CopyMessageList) {
                _this.ClearCopyMessageDialog();
                const echat_CopyMessage_Dialog = document.getElementById("echat_CopyMessage_Dialog");
                const cpoy_Window = echat_CopyMessage_Dialog.querySelector(".eChat-MessageWindow");
                echat_CopyMessage_Dialog.style.display = "block";
                echat_CopyMessage_Dialog.querySelector(".eChat-CloseButton").addEventListener("click", _this.ClearCopyMessageDialog);
                echat_CopyMessage_Dialog.querySelector("#SaveSelectMessageBtn").addEventListener("click", SaveMessageToTaskDetail);
                cpoy_Window.style.zIndex = EChat.Util.draggableZIndex();
                EChat.Util.ShowLoading(cpoy_Window);

                echat_CopyMessage_Dialog.addEventListener("click", () => {
                    document.querySelector("#echat_CopyMessage_Dialog > .eChat-MessageWindow").style.zIndex = EChat.Util.draggableZIndex();
                });

                EChat.Util.dragDialog({
                    dialog: echat_CopyMessage_Dialog.querySelector(".eChat-MessageWindow"),
                    handle: document.querySelector(".eChatDragTarget"),
                    handleWidthFix: 0,
                    handleHeightFix: 0,
                    start(dom) {
                        dom.style.zIndex = EChat.Util.draggableZIndex();
                    },
                    stop(dom) {
                        dom.style.height = "auto";
                    }
                });

                const initMessage = function () {
                    EChat.DataProvider.GetGroupInfoByGroupID(MessageGroupID).then((GroupInfo) => {
                        _this.GroupInfo = GroupInfo;
                        if (GroupInfo.Messages.length > 0) {
                            GroupInfo.Messages = GroupInfo.Messages.sort((a, b) => b.TimeCreated - a.TimeCreated);
                            const chatBoxElement = document.getElementById("echat_CopyMessageList");
                            DrawHistoryCopyMessages(GroupInfo.Messages, chatBoxElement);
                        }
                        echat_CopyMessageList.scrollTop = echat_CopyMessageList.scrollHeight;
                        EWS.HideLoading();
                    });
                };

                const SaveSelectMessageBtn = document.getElementById("SaveSelectMessageBtn");
                SaveSelectMessageBtn.classList.add("CopyToNewTask");

                const EChat_Copy_Select_Div = document.getElementById("EChat_Copy_Select_Div");
                switch (_this.Type) {
                    case "CopyToSpecifiedTask":
                        SaveSelectMessageBtn.classList.remove("CopyToNewTask");
                        EChat_Copy_Select_Div.style.display = "block";

                        let placeholder = "Task";
                        if (Distributor.indexOf("Support") === 0) {
                            placeholder = "New Task";
                        }

                        ECP.HTML.FillWithAutoComplete(EChat_Copy_Select_Div, {
                            InputName: "EChat_CopyTaskID_Input",
                            CurValue: "",
                            IsSearch: false,
                            Width: 0,
                            RefTable: "Tasks",
                            RefField: "TaskID",
                            RefFieldDisplay: "Task",
                            DataType: ECP.DataType._Integer,
                            RefFieldDisplayDataType: ECP.DataType._Text,
                            Required: false,
                            RandomID: false,
                            Translate: false,
                            LimitToRefList: true,
                            Placeholder: placeholder
                        }).then(() => {
                            initMessage();
                        });
                        break;
                    default:
                }
            } else {
                ECP.Dialog.Alert("Please click the EChat icon to initialize the interface.");
            }
        };

        const CreateCopyMessageElement = function (msgObj, listDom) {
            if (msgObj.MessageID) {
                const messagesgElement = listDom.querySelector(`#copy_message_${msgObj.MessageID}`);
                if (messagesgElement) {
                    return null;
                }
            }
            if (msgObj.Message) {
                const senderName = msgObj.SenderFullName;
                const headImgElement = EC_Fmt.HtmlStrToElement("<img class='eChat-UserHeadImg Left'/>");
                const senderNameElement = EC_Fmt.HtmlStrToElement(`<div>${senderName}</div>`);
                const textElement = document.createElement("DIV");
                const flexElement = EC_Fmt.HtmlStrToElement("<div class=EChat_CopyMessage_Message-flex-box></div>");
                const itemElement = EC_Fmt.HtmlStrToElement(`<div class='LeftDialog eChatRelative Left'messageMark='${msgObj.TimeCreated}'messageid=${msgObj.MessageID} id=messageblock_${msgObj.MessageID}></div>`);
                const msgElement = EC_Fmt.HtmlStrToElement("<div class='LeftBubble eChatRelative clear-fix'></div>");
                textElement.classList.add("Left");
                senderNameElement.classList.add("EChat_CopyMessage_MemberName");
                textElement.classList.add("EChat_CopyMessage_DialogBubbleHead");

                if (msgObj.SenderUserAvatar) {
                    headImgElement.setAttribute("src", msgObj.SenderUserAvatar);
                } else {
                    headImgElement.setAttribute("src", EChat.Setting.DefaultUserIcon);
                }
                headImgElement.style.cursor = "default";
                headImgElement.style.marginLeft = "5px";

                const pElement = EC_Fmt.HtmlStrToElement(`<p id=copy_message_${msgObj.MessageID} messageid=${msgObj.MessageID}></p>`);

                msgObj.Message = msgObj.Message.replace(/\n/g, "<br>");
                pElement.append(EC_Fmt.HtmlStrToElement(`<div class="echat_message_base">${msgObj.Message}</div>`));
                EChat.Util.CopyFormat(pElement);

                const copyBoxElement = document.getElementById(`copyBox_${_this.GroupInfo.MessageGroupID}`);
                EChat.Util.FileLoad(pElement, copyBoxElement, msgObj.SenderAuthenticationID, 180, 81);

                // CopySelect
                const selectElement = EC_Fmt.HtmlStrToElement(`<span><input class=EChat_CopyMessage_Select type=checkbox name='echat_copyselect_'${_this.GroupInfo.MessageGroupID} value='${msgObj.MessageID}' style='margin-top: 15px!important;'></span>`);
                selectElement.querySelector("input").addEventListener("change", (e) => {
                    if (e.currentTarget.checked) {
                        itemElement.classList.add("eChat-copy-message-select");
                    } else {
                        itemElement.classList.remove("eChat-copy-message-select");
                    }
                    // Task 1007704: eChat copy to Task not responding.
                    const count = document.querySelectorAll("#echat_CopyMessageList input:checked").length;
                    document.querySelector("#echat_CopyMessage_Dialog .selectNum").innerHTML = count;
                });

                itemElement.addEventListener("click", (e) => {
                    let input = selectElement.querySelector("input");
                    if (e.target !== input) {
                        input.checked = !input.checked;
                        EC_Fmt.TriggerEvent(input, "change");
                    }

                    if (e.shiftKey && lastClickElement && lastClickElement !== itemElement) {
                        let startDom = itemElement;
                        let endDom = lastClickElement;

                        if (lastClickElement.getBoundingClientRect().y > itemElement.getBoundingClientRect().y) {
                            startDom = lastClickElement;
                            endDom = itemElement;
                        }

                        let count = 0;
                        let currDom = startDom.previousSibling;
                        while (currDom && count < 100) {
                            if (currDom !== endDom) {
                                input = currDom.querySelector("input");
                                input.checked = true;
                                EC_Fmt.TriggerEvent(input, "change");
                            } else {
                                break;
                            }
                            currDom = currDom.previousSibling;
                            count++;
                        }
                        window.getSelection().removeAllRanges();
                    } else {
                        lastClickElement = itemElement;
                    }
                });

                flexElement.append(textElement);

                textElement.append(pElement);
                msgElement.append(selectElement);
                msgElement.append(headImgElement);

                msgElement.append(senderNameElement);
                msgElement.append(flexElement);
                itemElement.append(msgElement);

                return itemElement;
            }

            return null;
        };

        this.ClearCopyMessageDialog = function () {
            // Task 744404: JavaScript Error: includes/DefaultAll.min.js (1) - Uncaught TypeError: Cannot read property 'style' of null
            if (document.getElementById("echat_CopyMessage_Dialog")) {
                document.getElementById("echat_CopyMessage_Dialog").style.display = "none";
            }

            if (document.getElementById("echat_CopyMessageList")) {
                document.getElementById("echat_CopyMessageList").innerHTML = "";
            }

            const echat_CopyMessage_Dialog = document.getElementById("echat_CopyMessage_Dialog");
            if (echat_CopyMessage_Dialog) {
                echat_CopyMessage_Dialog.click = null;
                echat_CopyMessage_Dialog.querySelector(".eChat-CloseButton").click = null;
                echat_CopyMessage_Dialog.querySelector("#SaveSelectMessageBtn").click = null;
            }
            const ChattingBox = document.querySelector("#echat_CopyMessage_Dialog .ChattingBox");
            if (ChattingBox) {
                EC_Fmt.RemoveAllEventListeners(ChattingBox);
            }

            syncDate = 0;
        };

        this.GetCheckMessageIDStr = function () {
            let MessageIDStr = "";
            document.querySelectorAll(".EChat_CopyMessage_Select[type='checkbox']").forEach((dom) => {
                if (dom.checked) {
                    if (MessageIDStr) {
                        MessageIDStr += ",";
                    }
                    MessageIDStr += dom.value;
                }
            });
            return MessageIDStr;
        };

        const SaveMessageToTaskDetail = function (e) {
            const MessageIDStr = _this.GetCheckMessageIDStr();
            if (MessageIDStr) {
                document.querySelector("#echat_CopyMessage_Dialog #SaveSelectMessageBtn").click = null;
                if (SaveCallBack) {
                    SaveCallBack(MessageIDStr, e);
                } else {
                    _this.ClearCopyMessageDialog();
                }
            }
        };

        const getDBGroupHistoryMessage = function (limit) {
            limit = limit || EChat.Setting.MessageNumPerShow;
            return new Promise(((resolve) => {
                const groupInfo = _this.GroupInfo;
                let msgList = [];
                if (groupInfo && Array.isArray(groupInfo.Messages)) {
                    msgList = groupInfo.Messages;
                }

                let count = 0;
                const messageList = [];
                let nextSyncDate = parseInt(syncDate);

                for (let i = 0, len = msgList.length; i < len; i++) {
                    if ((syncDate === 0 || parseInt(msgList[i].TimeCreated) < syncDate) && count < limit) {
                        messageList.push(msgList[i]);
                        count++;
                        if (msgList[i].TimeCreated < nextSyncDate || nextSyncDate === 0) {
                            nextSyncDate = parseInt(msgList[i].TimeCreated);
                        }
                    }
                }

                if (count === 0) {
                    EChat.DataProvider.getMessageHistory(groupInfo.MessageGroupID, syncDate, null, limit).then((messageArr) => {
                        resolve(messageArr);
                    });
                } else {
                    syncDate = parseInt(nextSyncDate);
                    resolve(messageList);
                }
            }));
        };

        this.GetCopyMessageListDom = function (GroupInfo, chatBoxElement) {
            syncDate = 0;
            _this.GroupInfo = GroupInfo;
            return DrawHistoryCopyMessages(GroupInfo.Messages, chatBoxElement);
        };

        const DrawHistoryCopyMessages = function (messageList, chatBoxElement) {
            if (messageList) {
                chatBoxElement.scroll = null;
                let scrollTopNum = 0;
                let showMsgNum;
                let isFirst = false;
                if (syncDate === 0) {
                    isFirst = true;
                    showMsgNum = messageList.length > EChat.Setting.MessageNumPerShow ? EChat.Setting.MessageNumPerShow : messageList.length;
                } else {
                    showMsgNum = messageList.length;
                }

                for (let i = 0; i < showMsgNum; i++) {
                    const msgElement = CreateCopyMessageElement(messageList[i], chatBoxElement);
                    if (msgElement) {
                        chatBoxElement.prepend(msgElement);
                        scrollTopNum += msgElement.offsetHeight;
                        if (messageList[i].TimeCreated < syncDate || syncDate === 0) {
                            syncDate = messageList[i].TimeCreated;
                        }
                    }
                }
                // Task 1007704: eChat copy to Task not responding.
                const selectAllBtn = document.querySelector("#echat_CopyMessage_Dialog .selectAll");
                const clearCopyMessageDialogSelected = document.querySelector("#echat_CopyMessage_Dialog .clear");
                let copyMessageInput = chatBoxElement.querySelectorAll("input");
                const selectNum = document.querySelector("#echat_CopyMessage_Dialog .selectNum");
                selectNum.innerHTML = document.querySelectorAll("#echat_CopyMessage_Dialog .eChat-copy-message-select").length;
                const SelectAllEvent = async function () {
                    copyMessageInput = chatBoxElement.querySelectorAll("input");
                    if (copyMessageInput.length !== 0) {
                        if (copyMessageInput.length >= 50) {
                            copyMessageInput.forEach((item) => {
                                item.checked = true;
                                item.parentElement.parentElement.parentElement.classList.add("eChat-copy-message-select");
                            });

                            selectNum.innerHTML = copyMessageInput.length;
                        } else {
                            if (copyMessageInput.length < 50 && copyMessageInput.length >= 10 && loadCount < 1) {
                                await getDBGroupHistoryMessage(40).then((result) => {
                                    DrawHistoryCopyMessages(result, chatBoxElement);
                                    Scrolling = false;
                                    copyMessageInput = chatBoxElement.querySelectorAll("input");
                                }).catch(() => {
                                    Scrolling = false;
                                    EChat.Util.errorAlert();
                                });
                            }
                            if (copyMessageInput.length < 50) {
                                copyMessageInput.forEach((item) => {
                                    item.checked = true;
                                    item.parentElement.parentElement.parentElement.classList.add("eChat-copy-message-select");
                                });
                                selectNum.innerHTML = copyMessageInput.length;
                            } else {
                                for (let i = copyMessageInput.length - 50; i < copyMessageInput.length; i++) {
                                    copyMessageInput[i].checked = true;
                                    copyMessageInput[i].parentElement.parentElement.parentElement.classList.add("eChat-copy-message-select");
                                }
                                selectNum.innerHTML = document.querySelectorAll("#echat_CopyMessage_Dialog .eChat-copy-message-select").length;
                            }
                        }
                    }
                };
                if (!isFirst) {
                    const _selectAllBtn = EC_Fmt.RemoveAllEventListeners(selectAllBtn);
                    _selectAllBtn.addEventListener("click", SelectAllEvent);
                } else {
                    selectAllBtn.addEventListener("click", SelectAllEvent);
                }

                clearCopyMessageDialogSelected.addEventListener("click", () => {
                    if (copyMessageInput.length !== 0) {
                        copyMessageInput.forEach((item) => {
                            item.checked = false;
                            item.parentElement.parentElement.parentElement.classList.remove("eChat-copy-message-select");
                        });
                        selectNum.innerHTML = 0;
                    }
                });

                chatBoxElement.addEventListener("scroll", function () {
                    if (this.scrollTop === 0 && this.scrollHeight > 0) {
                        if (!Scrolling) {
                            Scrolling = true;
                            getDBGroupHistoryMessage(null).then((result) => {
                                DrawHistoryCopyMessages(result, chatBoxElement);
                                Scrolling = false;
                            }).catch(() => {
                                Scrolling = false;
                                EChat.Util.errorAlert();
                            });
                        }
                    }
                });

                if (isFirst) {
                    chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
                    chatBoxElement.querySelectorAll("img").forEach((dom) => {
                        dom.addEventListener("load", () => {
                            setTimeout(() => {
                                chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
                            }, 50);
                        });
                    });
                } else {
                    chatBoxElement.scrollTop = scrollTopNum;
                }
            }
        };
    };
    return new CopyMessageControllerClass();
}());

EChat.GroupSettingController = (function () {
    const GroupSettingController = function () {
        let eChatMask = null;
        let groupSettingWindow = null;
        let groupInfo = null;
        let userObj = { GroupMemberObj: [] };
        const userInfo = {};
        let groupSavedData = {};

        const createGroupSettingWindow = async function () {
            const eChatMaskHTML = `<div class='donutSpinner eChat-Mask'style=color:var(--text-onbg-action) z-index=${EChat.Util.draggableZIndex()}></div> `;
            eChatMask = EC_Fmt.HtmlStrToElement(eChatMaskHTML);
            document.querySelector("html > body").append(EC_Fmt.HtmlStrToElement(eChatMaskHTML));
            eChatMask = document.querySelector(".donutSpinner.eChat-Mask");

            const dialogTitle = "Group Settings";

            groupSettingWindow = EChat.CustomComponent.BasicWindow({
                id: "EChatGroupSettings",
                height: 560,
                width: 600,
                draggable: true,
                headerTitle: EC_Fmt.Trn(dialogTitle),
                closeCallBack: removeGroupSettingWindow
            });

            const content = EC_Fmt.HtmlStrToElement("<div class=eChatWindowContent style=height:490px></div>");
            const leftContent = EC_Fmt.HtmlStrToElement("<div style=height:480px;width:135px;float:left;padding:5px></div>");
            const middleContent = EC_Fmt.HtmlStrToElement("<div style=height:480px;width:215px;float:left;padding:5px></div>");
            // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
            const rightContent = EC_Fmt.HtmlStrToElement("<div style=height:480px;width:215px;float:left;padding:5px;margin-top:-5px></div>");

            content.append(leftContent);
            content.append(middleContent);
            content.append(rightContent);

            const groupLeft = EC_Fmt.HtmlStrToElement("<div style=text-align:left;padding-left:5px></div>");

            const groupIconText = EC_Fmt.HtmlStrToElement(`<span class=light-color>${EC_Fmt.Trn("Group Icon")}</span>`);
            const groupIconImage = EC_Fmt.HtmlStrToElement("<div id=EChatGroupSettingIcon></div>");
            const groupIconBtn = EChat.CustomComponent.ChangePictureButton(saveImageEvent);
            groupIconBtn.style.margin = "5px 0 0 0";
            groupLeft.append(groupIconText);
            groupLeft.append(groupIconImage);
            groupLeft.append(groupIconBtn);

            leftContent.append(groupLeft);

            const groupNameDiv = EC_Fmt.HtmlStrToElement("<div style=text-align:left></div>");
            const groupNameText = EC_Fmt.HtmlStrToElement(`<span class=light-color>${EC_Fmt.Trn("Group Name")}</span>`);
            const groupNameInput = EC_Fmt.HtmlStrToElement("<input type=text id=EChatGroupSettingName class=inputTrn autocomplete=off placeholder='Please input group name' style=width:100%>");
            groupNameDiv.append(groupNameText);
            groupNameDiv.append(groupNameInput);
            middleContent.append(groupNameDiv);

            const groupMemberDiv = EC_Fmt.HtmlStrToElement("<div style=text-align:left></div>");
            const groupMemberText = EC_Fmt.HtmlStrToElement("<span class=light-color style=margin-top:5px>Members</span>");
            const groupMemberList = EC_Fmt.HtmlStrToElement("<div id=EChatGroupSettingMembers style='border:1px var(--neutral-30) solid;width:213px;overflow-y:auto'></div>");
            EChat.Util.PreventScroll(groupMemberList);
            groupMemberList.style.height = "364px";

            const groupMemberDeleteBtn = EChat.CustomComponent.BasicButton({
                blackButton: false,
                title: EC_Fmt.Trn("- Delete Member"),
                clickEvent: groupMemberDeleteEvent
            });
            groupMemberDeleteBtn.style.margin = "5px 0 0 0";
            // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
            groupMemberDeleteBtn.style.borderRadius = "4px";

            groupMemberDiv.append(groupMemberText);
            groupMemberDiv.append(groupMemberList);
            groupMemberDiv.append(groupMemberDeleteBtn);

            middleContent.append(groupMemberDiv);

            // right content
            const allUserDiv = EC_Fmt.HtmlStrToElement("<div style=text-align:left></div>");
            const allUserText = EC_Fmt.HtmlStrToElement(`<span class=light-color>${EC_Fmt.Trn("All Users")}</span>`);
            const allUserSearchInput = EC_Fmt.HtmlStrToElement("<div style=width:100%;display:inline-block></div>");
            const editGroupUserList = EC_Fmt.HtmlStrToElement("<div class=eChat-EditGroupUserList></div>");
            const allUserInputDiv = EC_Fmt.HtmlStrToElement(`<div class="eChat-Search eChatZoom"style=margin:0;position:relative;padding:0>`
                + ` <span class="eChat-SearchImg ews-icon-search"style=left:9px;top:8px></span>`
                + ` <input class=txt inputTrn id=EChatGroupUserSearchText autocomplete=off placeholder='Search Users'>`
                + ` <span class="eChat-SearchClear ews-icon-close hidden"style=right:13px;top:8px></span>`
                + `</div>`);
            // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
            const advancedBtn = EC_Fmt.HtmlStrToElement("<ecp-btn style='height:24px;margin:2px 0'dropdown>Advanced Search </ecp-btn>");

            // Task 694706: Echat on support: Is it intentional to see other distributors users
            let timeOuntId;
            const searchClear = allUserInputDiv.querySelector(".eChat-SearchClear");
            const allUserInput = allUserInputDiv.querySelector("#EChatGroupUserSearchText");
            allUserInput.addEventListener("keyup", function (e) {
                if (allUserInput.value) {
                    searchClear.classList.remove("hidden");
                } else {
                    searchClear.classList.add("hidden");
                }
                const listDom = document.querySelector(".eChat-EditGroupUserList");
                EChat.CustomComponent.KeyCodeEvent({
                    KeyCode: e ? e.keyCode : 0,
                    ListDom: listDom,
                    ItemClassArr: ["eChatUserItem"],
                    SelectClass: "eChatSelectItem",
                    EnterEvent: (dom) => {
                        dom.querySelector("input").checked = !dom.querySelector("input").checked;
                    },
                    InputEvent: () => {
                        clearTimeout(timeOuntId);
                        timeOuntId = setTimeout(() => {
                            const nameArr = Object.keys(userObj.GroupMemberObj);
                            const NotInArr = [];
                            for (let i = 0; i < nameArr.length; i++) {
                                NotInArr.push(parseInt(userObj.GroupMemberObj[nameArr[i]].AuthenticationID));
                            }
                            const userFilters = document.getElementById("ews-eChat-advanced-search-menu");
                            EChat.CustomComponent.UserSearch({
                                All: false,
                                UserTypeID: !EC_Fmt.isNull(userFilters) ? EC_Fmt.Null2NullStr(userFilters.querySelector("#EChatSelectUserType input[type='hidden']").value) : "Null",
                                LocationID: !EC_Fmt.isNull(userFilters) ? EC_Fmt.Null2NullStr(userFilters.querySelector("#EChatSelectLocation input[type='hidden']").value) : "Null",
                                RoleID: !EC_Fmt.isNull(userFilters) ? EC_Fmt.Null2NullStr(userFilters.querySelector("#EChatSelectRole input[type='hidden']").value) : "Null",
                                Search: this.value,
                                Container: editGroupUserList,
                                Mark: document.querySelector(".eChat-EditGroupUserList"),
                                NotInArr,
                                SearchDom: this,
                                ShowUserType: false,
                                ShowFilters: false,
                                HiddenCreateGroupBtn: true,
                                MessageGroupKey: groupInfo.MessageGroupID
                            }).then(() => {
                            }).catch();
                        }, 750);
                    }
                });
            });

            advancedBtn.addEventListener("click", () => {
                const nameArr = Object.keys(userObj.GroupMemberObj);
                const NotInArr = [];
                for (let i = 0; i < nameArr.length; i++) {
                    NotInArr.push(parseInt(userObj.GroupMemberObj[nameArr[i]].AuthenticationID));
                }

                EWS.Command.ShowMenu("eChat-advanced-search", advancedBtn, {
                    Container: editGroupUserList,
                    Mark: document.getElementById("EChatGroupSettings"),
                    NotInArr,
                    ShowUserType: false,
                    ShowFilters: false,
                    SearchDom: "advancedBtn"
                });
            });

            searchClear.addEventListener("click", () => {
                EChatGroupUserSearchText.value = "";
                EC_Fmt.TriggerEvent(EChatGroupUserSearchText, "keyup");
            });

            allUserSearchInput.append(allUserInputDiv);
            allUserSearchInput.append(advancedBtn);

            const groupMemberAddBtn = EChat.CustomComponent.BasicButton({
                title: EC_Fmt.Trn("+ Add Member to Group"),
                blackButton: false,
                clickEvent: () => {
                    EChat.Util.ShowLoading(document.getElementById("EChatGroupSettings"));
                    groupMemberAddEvent().then(() => {
                        ECP.Dialog.HideLoading();
                        editGroupUserList.innerHTML = "";
                        allUserInput.value = "";
                    }).catch(() => {
                        ECP.Dialog.HideLoading();
                    });
                }
            });
            groupMemberAddBtn.style.margin = "5px 0 0 0";
            // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
            // groupMemberAddBtn.style.border = "solid 1px var(--neutral-30)";
            groupMemberAddBtn.style.borderRadius = "4px";
            allUserDiv.append(allUserText);
            allUserDiv.append(allUserSearchInput);
            allUserDiv.append(editGroupUserList);
            allUserDiv.append(groupMemberAddBtn);

            rightContent.append(allUserDiv);

            const footer = EC_Fmt.HtmlStrToElement("<div class='eChatWindowFooter' style='text-align:right;'></div>");
            const bottomBtn = EChat.CustomComponent.BasicButton({
                title: EC_Fmt.Trn("Delete this Group"),
                // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
                icon: EC_Fmt.Trn("ews-icon-delete"),
                blackButton: false,
                clickEvent: delBtnEvent
            });

            const option = {
                title: EC_Fmt.Trn("OK"),
                // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
                type: EC_Fmt.Trn("primary"),
                blackButton: true,
                clickEvent: okBtnEvent
            };

            const okBtn = EChat.CustomComponent.BasicButton(option);
            okBtn.classList.add("btn-attention");
            footer.append(bottomBtn);
            footer.append(okBtn);
            groupSettingWindow.insertContent(content);
            groupSettingWindow.insertContent(footer);

            setGroupSettingData();
        };

        const removeGroupSettingWindow = function () {
            if (eChatMask) {
                eChatMask.remove();
                eChatMask = null;
                groupSettingWindow = null;
                groupInfo = null;
                userObj = { GroupMemberObj: [] };
                groupSavedData = {
                };
            }
        };

        const userObjToArray = function (targetObj) {
            const resultArr = [];
            const keys = Object.keys(targetObj).sort();
            for (let i = 0; i < keys.length; i++) {
                const item = targetObj[keys[i]];
                resultArr.push(item);
            }
            return resultArr;
        };

        const setGroupSettingData = function () {
            if (groupInfo) {
                if (eChatMask) {
                    const groupIconUrl = EChat.DataProvider.GetGroupAvatarUrlAndAuthID(groupInfo, EChat.DataProvider.CurrentUserInfo).Url;
                    // Task 1108551: Editing eChat Group Image updates User image.
                    EChat.CustomComponent.UserAvaterDisplay(document.getElementById("EChatGroupSettingIcon"), groupIconUrl, groupInfo.Users.length, 128, 128, false);
                    const EChatGroupSettingName = document.getElementById("EChatGroupSettingName");
                    EChatGroupSettingName.value = groupInfo.GroupName;
                    EChatGroupSettingName.select();
                    EChat.DataProvider.GetGroupUserInfo(groupInfo.MessageGroupID).then((groupMemberArray) => {
                        for (let i = 0; i < groupMemberArray.length; i++) {
                            const tmpUser = groupMemberArray[i];
                            userObj.GroupMemberObj[tmpUser.Name] = tmpUser;
                            userInfo[tmpUser.AuthenticationID] = tmpUser;
                        }
                        drawGroupMember(groupMemberArray);
                    });
                } else {
                    EChat.Util.throwError(EChat.ErrorType.DATA_ERROR, "eChatMask is null");
                }
            } else {
                EChat.Util.throwError(EChat.ErrorType.DATA_ERROR, "groupInfo is null");
            }
        };

        const drawGroupMember = function (groupMemberArray) {
            const parentElement = document.getElementById("EChatGroupSettingMembers");
            if (!parentElement) {
                return;
            }
            parentElement.innerHTML = "";
            for (let i = 0; i < groupMemberArray.length; i++) {
                if (groupMemberArray[i]) {
                    const UserItemDisplay = EChat.CustomComponent.UserItemDisplay(groupMemberArray[i], true, false);
                    UserItemDisplay.style.width = "95%";
                    UserItemDisplay.addEventListener("click", function () {
                        const input = this.querySelector("input");
                        const eChatCheckBoxSpan = this.querySelector(".eChatCheckBoxSpan");
                        if (input.checked) {
                            eChatCheckBoxSpan.style.backgroundPosition = "0px -25px";
                        } else {
                            eChatCheckBoxSpan.style.backgroundPosition = "-30px -25px";
                        }
                        input.checked = !input.checked;
                    });

                    parentElement.append(UserItemDisplay);
                }
            }
        };

        this.openGroupSettingWindow = function (groupId) {
            EChat.Util.ShowLoading("All");
            EChat.DataProvider.GetGroupInfoByGroupID(groupId, true, true).then((tmpGroupInfo) => {
                if (!tmpGroupInfo) {
                    ECP.Dialog.Alert(EC_Fmt.Trn("This Group has been deleted from server."));
                    EChat.DataProvider.deleteGroupData(groupId, true, false).then(() => {
                        ECP.Dialog.HideLoading();
                        EChat.MainPageController.updateUnReadNumIcon("group setting");
                    }).catch(EChat.Util.errorAlert);
                } else if (tmpGroupInfo.PostPermission === EChat.PostPermissionType.ReadOnly) {
                    ECP.Dialog.HideLoading();
                    ECP.Dialog.Alert("Read-only access. This group cannot be edited.");
                } else if (!eChatMask) {
                    ECP.Dialog.HideLoading();
                    groupInfo = tmpGroupInfo;
                    groupSavedData.MessageGroupID = tmpGroupInfo.MessageGroupID;
                    createGroupSettingWindow();
                }
            });
        };

        const okBtnEvent = function () {
            const groupName = document.getElementById("EChatGroupSettingName").value;
            if (groupInfo.DisplayName !== groupName || groupName === "") {
                groupSavedData.GroupName = groupName;
            }
            const newUsers = [];
            Object.keys(userObj.GroupMemberObj).forEach((item) => {
                if (!EC_Fmt.isNull(userObj.GroupMemberObj[item].AuthenticationID)) {
                    newUsers.push(userObj.GroupMemberObj[item].AuthenticationID);
                }
            });

            const oldUsersStr = EChat.DataProvider.GetUserStrByGroupInfo(groupInfo);
            const newUsersStr = EChat.DataProvider.GetUserStrByUserList(newUsers);
            if (newUsersStr !== oldUsersStr) {
                groupSavedData.UserList = newUsersStr;
            }

            if (eChatMask) {
                eChatMask.style.zIndex = 10000;
                EChat.DataProvider.uploadGroupSetting(groupSavedData, userInfo).then((group) => {
                    groupInfo = group;
                    groupSettingWindow.closeWindow();
                    EChat.IndexedDB.InitDBData(0, true);
                });
            }
        };
        const delBtnEvent = function () {
            EWS.Confirm("Are you sure to delete the EChat Group ?", () => {
                EChat.IndexedDB.GetTableDataByKey(EChat.DBTableName.GROUPINFO, groupSavedData.MessageGroupID).then((groupInfoNew) => {
                    if (groupInfoNew) {
                        SocketUtil.api("DeleteGroup", { MessageGroupID: groupSavedData.MessageGroupID }).then((messageGroupID) => {
                            groupSettingWindow.closeWindow();
                            if (messageGroupID) {
                                EChat.DataProvider.deleteGroupData(messageGroupID, true, true);
                            }
                        }).catch(() => {
                            // eslint-disable-next-line no-console
                            console.error("delete error");
                        });
                    } else {
                        groupSettingWindow.closeWindow();
                    }
                });
            }, () => {

            });
        };

        const saveImageEvent = function (imageData) {
            if (imageData) {
                const eChatUserAvatarDisplays = document.querySelectorAll("EChatGroupSettingIcon .eChatUserAvatarDisplay");
                for (let i = 0; i < eChatUserAvatarDisplays.length; i++) {
                    const Avatar = eChatUserAvatarDisplays[i];
                    Avatar.style.backgroundImage = `url(${imageData})`;
                    Avatar.style.backgroundRepeat = "no-repeat";
                    Avatar.style.backgroundSize = "cover";
                }
                groupSavedData.Icon = imageData;
            }
        };

        const groupMemberDeleteEvent = function () {
            const checkedList = document.querySelectorAll("#EChatGroupSettingMembers input[type='checkbox']");
            checkedList.forEach((dom) => {
                if (dom.checked) {
                    const checkBoxElement = dom;
                    const userName = checkBoxElement.getAttribute("fullname");
                    delete userObj.GroupMemberObj[userName];
                    checkBoxElement.parentNode.parentNode.remove();
                }
            });
        };

        const groupMemberAddEvent = async function () {
            const userArr = [];
            document.querySelectorAll(".eChat-EditGroupUserList input:checked").forEach((dom) => {
                userArr.push(parseInt(dom.getAttribute("authid")));
            });

            if (userArr.length) {
                const userInfoArr = await EChat.DataProvider.GetUserInfo(userArr);
                for (let i = 0; i < userInfoArr.length; i++) {
                    const tmpUser = userInfoArr[i];
                    userObj.GroupMemberObj[tmpUser.Name] = tmpUser;
                    userInfo[tmpUser.AuthenticationID] = tmpUser;
                }

                drawGroupMember(userObjToArray(userObj.GroupMemberObj));
            }
        };
    };
    return new GroupSettingController();
}());

EChat.TaskController = (function () {
    const TaskController = function () {
        const _this = this;
        let dialog;
        let groupInfo;

        this.MessageGroupID = "";
        this.TaskID = 0;
        this.Title = 0;
        this.CustomerID = 0;
        this.AssignToUserID = 0;
        this.ObjectiveTypeID = 0;
        this.ObjectiveID = 0;
        this.TaskStatusID = 0;
        this.FeatureID = 0;
        this.FoundIn = "";

        this.AddTask = function (group) {
            return new Promise(() => {
                Clear();
                groupInfo = group;
                _this.MessageGroupID = groupInfo.MessageGroupID;
                _this.ObjectiveID = !_this.ObjectiveID && IsSupport() ? 1 : _this.ObjectiveID;
                _this.ObjectiveTypeID = !_this.ObjectiveTypeID && IsSupport() ? 5 : _this.ObjectiveTypeID;
                _this.AssignToUserID = EC_Fmt.Null2ZeroInt(_this.AssignToUserID) === 0 ? UserID : _this.AssignToUserID;
                _this.FeatureID = !_this.FeatureID && IsSupport() ? 1 : _this.FeatureID;

                EChat.Util.ShowLoading("All");
                OpenDialog().then(() => {
                    ECP.Dialog.HideLoading();
                }).catch(EChat.Util.errorAlert);
            });
        };

        const OpenDialog = async function () {
            let EChatTaskDialogBase = document.getElementById("EChatTaskDialog");
            if (!EChatTaskDialogBase) {
                const htmlData = await EChat.MainPageController.loadEChatViewHtml();
                EChatTaskDialogBase = EC_Fmt.HtmlStrToElement(htmlData).querySelector("#EChatTaskDialog");
            }
            const DialogTitle = _this.TaskID === 0 ? "Add new task" : "Edit task";
            dialog = ECP.Dialog.ShowDialog(DialogTitle, EChatTaskDialogBase.innerHTML, {
                width: 680,
                height: 440,
                disableResize: true,
                confirmButtonTitle: "Save Changes"
            }, Clear);
            dialog.querySelector(".ecp-dialog-content").style.paddingRight = "1px";

            const promiseArr = [];
            promiseArr.push(AddField("Title"));
            promiseArr.push(AddField("Customer"));
            promiseArr.push(AddField("AssignTo"));
            promiseArr.push(AddField("ObjectiveType"));
            promiseArr.push(AddField("Objective"));
            promiseArr.push(AddField("Status"));

            if (IsSupport()) {
                promiseArr.push(AddField("Feature1505"));
                promiseArr.push(AddField("FoundIn"));
            }

            await Promise.all(promiseArr);

            dialog.querySelector(`#EChatTaskTitleDiv textarea`).focus();
            await AddCopyMessage();
        };

        const AddField = async function (FieldName) {
            const triggerElement = dialog.querySelector(`#EChatTask${FieldName}Div`);
            const InputName = `EChat${FieldName}Field`;
            let OnChangeCallback = null;

            let Option = {
                InputName,
                Width: 170,
                Required: false,
                LimitToRefList: true,
                IsSearch: false,
                Translate: false,
                ListLength: 40,
                AllowAddRelated: false
            };

            switch (FieldName) {
                case "Title": {
                    triggerElement.querySelector("textarea").style.minWidth = `${Option.Width}px`;
                    triggerElement.querySelector("textarea").style.maxWidth = `${Option.Width}px`;
                    triggerElement.querySelector("textarea").style.width = `${Option.Width}px`;
                    triggerElement.querySelector("textarea").tabIndex = 1;
                    triggerElement.querySelector("textarea").setAttribute("placeholder", "Task Title");
                    Option = null;
                    break;
                }
                case "Customer": {
                    Option.RefTable = "Customers";
                    Option.RefField = "CustomerID";
                    Option.DataType = ECP.DataType._Integer;
                    Option.RefFieldDisplay = "CustomerNumCompany";
                    Option.RefFieldDisplayDataType = ECP.DataType._Text;
                    Option.RefFieldFilter = "AccountStatus = 'Active'";
                    Option.CurValue = _this.CustomerID;
                    Option.TabIndex = 2;
                    Option.Placeholder = "Customer";
                    break;
                }
                case "AssignTo": {
                    Option.RefTable = "Users";
                    Option.RefField = "UserID";
                    Option.DataType = ECP.DataType._Integer;
                    Option.RefFieldDisplay = "PictureAndDesc";
                    Option.RefFieldDisplayDataType = ECP.DataType._Text;
                    Option.RefFieldFilter = `"Users"."UserTypeID" < 10 AND "Users"."Active" = 1`;
                    Option.CurValue = _this.AssignToUserID;
                    Option.TabIndex = 3;
                    Option.Placeholder = "Assign To";
                    break;
                }
                case "ObjectiveType": {
                    Option.RefTable = "ObjectiveTypes";
                    Option.RefField = "ObjectiveTypeID";
                    Option.DataType = ECP.DataType._Integer;
                    Option.RefFieldDisplay = "ObjectiveType";
                    Option.RefFieldDisplayDataType = ECP.DataType._Text;
                    Option.CurValue = _this.ObjectiveTypeID;
                    Option.TabIndex = 4;
                    Option.Placeholder = "Objective Type";
                    break;
                }
                case "Objective": {
                    Option.RefTable = "Objectives";
                    Option.RefField = "ObjectiveID";
                    Option.DataType = ECP.DataType._Integer;
                    Option.RefFieldDisplay = "Objective";
                    Option.RefFieldDisplayDataType = ECP.DataType._Text;
                    Option.CurValue = _this.ObjectiveID;
                    Option.TabIndex = 5;
                    Option.Placeholder = "Objective";
                    OnChangeCallback = () => {
                        AddField("Status");
                    };
                    break;
                }
                case "Status": {
                    if (dialog.querySelector("#EChatObjectiveFieldHidden")) {
                        if (_this.ObjectiveID === dialog.querySelector("#EChatObjectiveFieldHidden").value) {
                            Option = null;
                            break;
                        }
                        _this.ObjectiveID = dialog.querySelector("#EChatObjectiveFieldHidden").value;
                    }
                    triggerElement.innerHTML = await EChat.DataProvider.GetTaskStatusElementByObjectiveID(_this.ObjectiveID, 0);
                    triggerElement.querySelector("select").tabIndex = 6;
                    triggerElement.querySelector("select").style.width = `${Option.Width}px`;
                    Option = null;
                    break;
                }
                case "Feature1505": {
                    Option.RefTable = "ZZ_Features";
                    Option.RefField = "FeatureID";
                    Option.DataType = ECP.DataType._Integer;
                    Option.RefFieldDisplay = "FeatureDescription";
                    Option.RefFieldDisplayDataType = ECP.DataType._Text;
                    Option.CurValue = _this.FeatureID;
                    Option.TabIndex = 7;
                    Option.Placeholder = "Feature 1505";
                    triggerElement.parentElement.classList.remove("hidden");
                    break;
                }
                case "FoundIn": {
                    triggerElement.querySelector("textarea").tabIndex = 8;
                    triggerElement.querySelector("textarea").style.minWidth = `${Option.Width}px`;
                    triggerElement.querySelector("textarea").style.maxWidth = `${Option.Width}px`;
                    triggerElement.querySelector("textarea").style.width = `${Option.Width}px`;
                    triggerElement.querySelector("textarea").setAttribute("placeholder", "Found in");
                    triggerElement.parentElement.classList.remove("hidden");
                    Option = null;
                    break;
                }
            }

            if (Option) {
                triggerElement.innerHTML = "";
                await ECP.HTML.FillWithAutoComplete(triggerElement, Option, null, null, OnChangeCallback);
            }

            return triggerElement;
        };

        const AddCopyMessage = async function () {
            const MessageListDiv = dialog.querySelector("#EChatTaskCopyMessageList");
            if (groupInfo.Messages && groupInfo.Messages.length > 0) {
                dialog.querySelector(".eChat-no-copy-message").classList.remove("eChat-no-copy-message");
                MessageListDiv.innerHTML = "";
                EChat.CopyMessageController.GetCopyMessageListDom(groupInfo, MessageListDiv);
            }
        };

        const IsSupport = function () {
            return Distributor.indexOf("Support") === 0;
        };

        const Clear = function () {
            _this.MessageGroupID = "";
            _this.TaskID = 0;
            _this.Title = 0;
            _this.CustomerID = 0;
            _this.AssignToUserID = 0;
            _this.ObjectiveTypeID = 0;
            _this.ObjectiveID = 0;
            _this.TaskStatusID = 0;
            _this.FeatureID = 0;
            _this.FoundIn = "";
            _this.CopyMessageIDList = "";
            if (dialog) {
                dialog.remove();
            }
        };
    };

    return new TaskController();
}());

EChat.SavedController = function () {
    const _this = this;
    let searchIng = false;
    let timeOutThread = 0;
    let canEnter = true;
    let lastStartIndex = 0;

    const createSavedMessageElement = function (savedMessage) {
        const SavedMessageTemplate = EC_Fmt.HtmlStrToElement(document.getElementById("SavedMessageTemplate").innerHTML);
        const LastMessageDiv = SavedMessageTemplate.querySelector(".LastMessage");
        const lastMessageObj = EChat.MainPageController.GetLastMessage(savedMessage);
        const LastMessageTime = SavedMessageTemplate.querySelector(".saved-message-top .eChat-LastMessageTime");
        // Task 1052118: Better distinguish whether the messages of the Echat Saved page belong to a group or a task.
        const UnreadDom = SavedMessageTemplate.querySelector(".echat-unread-count");

        // Task 1052118: Better distinguish whether the messages of the Echat Saved page belong to a group or a task.
        if (savedMessage.GroupType === SocketUtil.GroupType.Task) {
            const userNameDiv = LastMessageDiv.querySelector(".eChat-LastMessageUserName");
            userNameDiv.textContent = lastMessageObj.SenderFullName;
            userNameDiv.setAttribute("title", lastMessageObj.SenderFullName);
            userNameDiv.setAttribute("data-user-name", lastMessageObj.SenderFullName);
            const userImg = LastMessageDiv.querySelector(".eChat-User-Img");
            if (lastMessageObj.SenderUserAvatar) {
                userImg.style.backgroundImage = `url(${lastMessageObj.SenderUserAvatar})`;
                userImg.classList.add("eChat-ico-GroupIcon");
            } else {
                userImg.classList.add("eChat-ico-DefaultUser");
            }
            LastMessageDiv.querySelector(".eChat-LastMessageTime").textContent = EChat.Util.longToDataTime(lastMessageObj.TimeCreated);
            LastMessageDiv.querySelector(".eChat-LastMessageInfo").classList.remove("hidden");
            UnreadDom.classList.add("unread-task");
        } else {
            LastMessageTime.textContent = EChat.Util.longToDataTime(lastMessageObj.TimeCreated);
            UnreadDom.classList.add("unread-messages");
        }
        UnreadDom.setAttribute("id", `Unread_${savedMessage.MessageGroupID}`);

        if (lastMessageObj.DisplayMessageDom) {
            LastMessageDiv.querySelector(".eChat-LastMessageBody").append(lastMessageObj.DisplayMessageDom);
        } else {
            LastMessageDiv.querySelector(".eChat-LastMessageBody").textContent = lastMessageObj.DisplayMessage;
        }

        LastMessageDiv.querySelector(".eChat-LastMessageBody").setAttribute("title", lastMessageObj.Message);
        SavedMessageTemplate.setAttribute("groupid", savedMessage.MessageGroupKey);
        SavedMessageTemplate.setAttribute("messagetime", savedMessage.MessageTime);
        SavedMessageTemplate.setAttribute("savedtime", savedMessage.SavedTime);

        const userIcoSpan = SavedMessageTemplate.querySelector(".user-ico-span");
        let groupName = lastMessageObj.SenderFullName;
        if (savedMessage.GroupType === SocketUtil.GroupType.System) {
            userIcoSpan.classList.add("ews-icon-warning");
            userIcoSpan.classList.add("eChat-ico-Group");
        } else if (savedMessage.GroupType === SocketUtil.GroupType.Task) {
            userIcoSpan.classList.add("ews-icon-task");
            userIcoSpan.classList.add("eChat-ico-Group");
            groupName = savedMessage.TaskTitle;
        } else if (lastMessageObj.SenderUserAvatar) {
            userIcoSpan.style.backgroundImage = `url(${lastMessageObj.SenderUserAvatar})`;
            userIcoSpan.classList.add("eChat-ico-GroupIcon");
        } else {
            userIcoSpan.style.backgroundImage = `url(${EChat.Setting.DefaultUserIcon})`;
            userIcoSpan.classList.add("eChat-ico-GroupIcon");
        }

        const nameSpan = SavedMessageTemplate.querySelector(".saved-message-name");
        const searchText = EChat.Util.getSearchText();
        if (searchText) {
            const groupNameDisplay = EChat.Util.highLight(groupName, searchText, "yellow", false).text;
            nameSpan.innerHTML = groupNameDisplay;
        } else {
            nameSpan.textContent = groupName;
        }

        nameSpan.setAttribute("title", groupName);
        nameSpan.setAttribute("data-user-name", groupName);
        let savedKey = "";
        const cancelBtn = SavedMessageTemplate.querySelector(".eChat-cancel-saved");
        if (savedMessage.TaskID) {
            cancelBtn.setAttribute("taskid", savedMessage.TaskID);
        }
        if (savedMessage.TaskDetailID) {
            savedKey = savedMessage.TaskDetailID;
            cancelBtn.setAttribute("taskdetailid", savedMessage.TaskDetailID);
        }
        if (savedMessage.TaskSourceEncompassID) {
            cancelBtn.setAttribute("tasksourceencompassid", savedMessage.TaskSourceEncompassID);
        }
        if (savedMessage.MessageGroupKey) {
            cancelBtn.setAttribute("messagegroupkey", savedMessage.MessageGroupKey);
        }
        if (savedMessage.MessageKey) {
            savedKey = savedMessage.MessageKey;
            cancelBtn.setAttribute("messagekey", savedMessage.MessageKey);
        }
        cancelBtn.addEventListener("click", (e) => {
            _this.cancelSavedMessage({
                TaskID: cancelBtn.getAttribute("taskid"),
                TaskDetailID: cancelBtn.getAttribute("taskdetailid"),
                TaskSourceEncompassID: cancelBtn.getAttribute("tasksourceencompassid"),
                MessageGroupKey: cancelBtn.getAttribute("messagegroupkey"),
                MessageKey: cancelBtn.getAttribute("messagekey")
            });

            e.stopPropagation();
        });

        SavedMessageTemplate.setAttribute("id", `SavedMessage_${savedKey}`);
        SavedMessageTemplate.addEventListener("click", (e) => {
            const groupId = savedMessage.MessageGroupID;
            EChat.DataProvider.GetGroupInfoByGroupID(groupId).then(async (groupInfo) => {
                // Task 1024583: Server EChat Click on Saved tab and then on a Message Group freezes browser
                if (groupInfo) {
                    const messsageWindow = EChat.MainPageController.getMessageWindow(groupInfo.MessageGroupID);
                    await messsageWindow.addRecentTab(groupInfo, true, false, savedKey);
                }
            });
            e.stopPropagation();
        });

        SavedMessageTemplate.addEventListener("mouseover", () => {
            SavedMessageTemplate.querySelector(".saved-message-button").classList.remove("hidden");
        });
        SavedMessageTemplate.addEventListener("mouseleave", () => {
            SavedMessageTemplate.querySelector(".saved-message-button").classList.add("hidden");
        });

        return SavedMessageTemplate;
    };

    this.addSavedMessage = async function (SavedMessage) {
        if (await EChat.DataProvider.AddSavedMessage(SavedMessage)) {
            if (!EChat.DataProvider.SavedMessage) {
                EChat.DataProvider.SavedMessage = [];
            }

            const savedKey = SavedMessage.TaskDetailID ? SavedMessage.TaskDetailID.toString() : SavedMessage.MessageKey;
            if (!EChat.DataProvider.SavedMessage.includes(savedKey)) {
                EChat.DataProvider.SavedMessage.push(savedKey);
                await EChat.MainPageController.refreshSavedMessage();
                drawSavedMessage(SavedMessage);
                EChat.IndexedDB.UpdateSetting("SavedMessages", EChat.DataProvider.SavedMessage, true);
            }
        }
    };

    this.cancelSavedMessage = async function (SavedMessage) {
        const success = await EChat.DataProvider.CancelSavedMessage(SavedMessage);
        const savedKey = SavedMessage.TaskDetailID > 0 ? SavedMessage.TaskDetailID : SavedMessage.MessageKey;
        const SavedMessageDom = document.getElementById(`SavedMessage_${savedKey}`);
        if (SavedMessageDom) {
            SavedMessageDom.remove();
        }

        if (success && EChat.DataProvider.SavedMessage) {
            const val = SavedMessage.TaskDetailID ? SavedMessage.TaskDetailID.toString() : SavedMessage.MessageKey;
            const index = EChat.DataProvider.SavedMessage.indexOf(val);
            if (index > -1) {
                EChat.DataProvider.SavedMessage.splice(index, 1);
            }
            await EChat.MainPageController.refreshSavedMessage();
            EChat.IndexedDB.UpdateSetting("SavedMessages", EChat.DataProvider.SavedMessage, true);
        }
    };

    const drawSavedMessage = function (SavedMessage) {
        const listEle = document.getElementById("EChatSavedList");
        const savedKey = SavedMessage.TaskDetailID > 0 ? SavedMessage.TaskDetailID : SavedMessage.MessageKey;
        const exist = document.getElementById(`SavedMessage_${savedKey}`);
        let TargetElement = null;
        const Sort = document.getElementById("EChatSavedSort").value;
        if (exist) {
            exist.remove();
        }

        const messageSortTime = SavedMessage.MessageTime;
        const groupElement = createSavedMessageElement(SavedMessage);
        if (groupElement) {
            if (!TargetElement) {
                let TargetLastMsgTime = -1;

                const ItemList = document.querySelectorAll("#EChatSavedList .SavedMessageItem");
                for (let i = 0, len = ItemList.length; i < len; i++) {
                    const Item = ItemList[i];
                    const tmpLastMsgTime = parseInt(Item.getAttribute("messagetime"));
                    if (tmpLastMsgTime > messageSortTime && (TargetLastMsgTime === -1 || TargetLastMsgTime >= tmpLastMsgTime)) {
                        TargetElement = Item;
                        TargetLastMsgTime = tmpLastMsgTime;
                    }
                }
            }

            if (Sort === "MessageTimeDESC") {
                if (!TargetElement) {
                    listEle.prepend(groupElement);
                } else {
                    TargetElement.after(groupElement);
                }
            } else if (Sort === "MessageTimeASC") {
                if (!TargetElement) {
                    listEle.append(groupElement);
                } else {
                    TargetElement.before(groupElement);
                }
            } else {
                listEle.prepend(groupElement);
            }

            groupElement.style.display = "block";
            // Task 1052118: Better distinguish whether the messages of the Echat Saved page belong to a group or a task.
            _this.updateUnreadCount(SavedMessage.MessageGroupID, SavedMessage.TaskID, "write", SavedMessage.UnreadCount);
        }
    };

    const showPage = function ({
        searchText, limit, startIndex, sort
    }) {
        return new Promise((resolve) => {
            const listEle = document.getElementById("EChatSavedList");
            if (startIndex === 0) {
                document.getElementById("EChatSavedList").innerHTML = "";
                EChat.Util.ShowLoading(listEle, searchText ? "Searching" : "");
            } else {
                EChat.Util.ShowLoader(listEle, false);
            }

            EChat.SavedMessageChange = false;

            SocketUtil.api("GetSavedMessage", {
                Search: searchText,
                Limit: limit,
                StartIndex: startIndex,
                Sort: sort
            }).then(async (data) => {
                if (startIndex === 0) {
                    ECP.Dialog.HideLoading();
                } else {
                    EChat.Util.HideLoader(listEle);
                }

                lastStartIndex = startIndex;
                let change = false;
                if (!EChat.DataProvider.SavedMessage) {
                    EChat.DataProvider.SavedMessage = [];
                }
                for (let i = 0, len = data.length; i < len; i++) {
                    const SavedMessage = data[i];
                    drawSavedMessage(SavedMessage);

                    const savedKey = SavedMessage.TaskDetailID ? SavedMessage.TaskDetailID.toString() : SavedMessage.MessageKey;
                    if (!EChat.DataProvider.SavedMessage.includes(savedKey)) {
                        EChat.DataProvider.SavedMessage.push(savedKey);
                        change = true;
                    }
                }

                if (change) {
                    await EChat.MainPageController.refreshSavedMessage();
                    EChat.IndexedDB.UpdateSetting("SavedMessages", EChat.DataProvider.SavedMessage, true);
                }

                resolve(data.length);
            }).catch((ex) => {
                EChat.Util.errorAlert(ex);
                resolve(0);
            });
        });
    };

    // Saved
    this.searchPanelKeyupEvent = function (e, searchObj, noWait) {
        const listDom = document.getElementById("EChatSavedList");
        EChat.CustomComponent.KeyCodeEvent({
            KeyCode: e ? e.keyCode : 0,
            ListDom: listDom,
            ItemClassArr: ["SavedMessageItem"],
            SelectClass: "eChatSelectItem",
            EnterOpenItem: !searchIng,
            InputEvent: () => {
                searchIng = true;
                clearTimeout(timeOutThread);
                timeOutThread = setTimeout(async () => {
                    canEnter = true;
                    const sort = document.getElementById("EChatSavedSort").value;
                    await showPage({
                        searchText: EChat.Util.getSearchText(), limit: EChat.FullWindowController.FullWindow ? 25 : 10, startIndex: 0, sort
                    });
                    searchIng = false;
                }, noWait ? 0 : 750);
            }
        });
    };

    this.updateUnreadCount = function (MessageGroupID, TaskID, action, unreadCount) {
        const unreadDom = document.querySelector(`#EChatSavedList .echat-unread-count[id='Unread_${MessageGroupID}']`);

        if (action === "read") {
            unreadDom.style.display = "none";
            unreadDom.innerHTML = "";
        } else if (action === "write" && unreadCount > 0) {
            unreadDom.style.display = "block";
            unreadDom.setAttribute("new", "true");
            if (TaskID === 0) {
                unreadDom.innerHTML = unreadCount;
            }
        }
    };

    const initEvent = function () {
        document.getElementById("EChatSavedList").addEventListener("scroll", async function () {
            if (this.scrollTop + this.clientHeight >= (this.scrollHeight - 1) && canEnter) {
                canEnter = false;
                const searchText = EChat.Util.getSearchText();
                const sort = document.getElementById("EChatSavedSort").value;
                const limit = 10;
                const count = await showPage({
                    searchText, limit, startIndex: lastStartIndex + limit, sort
                });
                if (count === 0) {
                    canEnter = false;
                } else {
                    canEnter = true;
                }
            }
        });

        document.getElementById("EChatSavedSort").addEventListener("change", (event) => {
            canEnter = true;
            const sort = event.currentTarget.value;
            showPage({
                searchText: EChat.Util.getSearchText(), limit: 10, startIndex: 0, sort
            });
        });
    };

    initEvent();
};

EChat.InputAreaComponentEvent = {
    ValueChange: "ValueChange",
    SendMessage: "SendMessage"
};

EChat.CustomComponent = {
    BasicWindow(windowProperty) {
        const BasicWindowClass = function () {
            // property
            const property = {
                id: windowProperty.id || null,
                height: windowProperty.height || 400,
                width: windowProperty.width || 400,
                top: windowProperty.top || null,
                left: windowProperty.left || null,
                draggable: windowProperty.draggable || false,
                headerTitle: windowProperty.headerTitle || null,
                closeCallBack: windowProperty.closeCallBack || null,
                taskID: windowProperty.taskID || 0
            };
            let baseWindow = null;
            let header = null;
            let content = null;
            const createWindow = function () {
                baseWindow = EC_Fmt.HtmlStrToElement(`<div class='eChatWindow eChat-NoTextSelect'style=height:${property.height}px;width:${property.width}px></div>`);
                if (property.id) {
                    baseWindow.setAttribute("id", property.id);
                }

                header = EC_Fmt.HtmlStrToElement("<div class=eChatWindowHead></div>");

                header.addEventListener("click", (e) => {
                    if (EChat.eChatMoving) {
                        EChat.eChatMoving = false;
                    }
                    e.stopPropagation();
                });
                if (property.headerTitle) {
                    const title = EC_Fmt.HtmlStrToElement(`<span class=eChatWindowHeadTitle>${property.headerTitle}</span>`);
                    header.append(title);
                }
                // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
                const closeBtn = EC_Fmt.HtmlStrToElement("<div style=float:right;margin-right:5px;margin-top:0></div>");
                closeBtn.append(EC_Fmt.HtmlStrToElement("<ecp-btn type=ghost icon=ews-icon-close style=font-size:16px;width:26px;height:26px></ecp-btn>"));
                closeBtn.addEventListener("click", (e) => {
                    deleteWindow();
                    e.stopPropagation();
                });
                header.append(closeBtn);

                content = EC_Fmt.HtmlStrToElement(`<div class='eChatWindowContent' style='height:${property.height - 30}px'></div>`);

                baseWindow.append(header);
                baseWindow.append(content);
                document.querySelector("html > body").append(baseWindow);

                const top = EC_Fmt.isNull(property.top) ? (window.innerHeight / 2 - baseWindow.clientHeight / 2) : property.top;
                const left = EC_Fmt.isNull(property.left) ? (window.innerWidth / 2 - baseWindow.clientWidth / 2) : property.left;
                baseWindow.style.top = `${top}px`;
                baseWindow.style.left = `${left}px`;

                baseWindow.classList.add("eChatDraggable");
                baseWindow.style.zIndex = EChat.Util.draggableZIndex();
                EChat.Util.dragDialog({
                    dialog: baseWindow,
                    handle: baseWindow.querySelector(".eChatWindowHead"),
                    handleWidthFix: 0,
                    handleHeightFix: 0,
                    start(dom) {
                        dom.style.zIndex = EChat.Util.draggableZIndex();
                    },
                    stop(dom) {
                        dom.style.height = "auto";
                    }
                });
            };
            const deleteWindow = function () {
                if (typeof property.closeCallBack === "function") {
                    property.closeCallBack();
                }
                if (baseWindow) {
                    baseWindow.remove();
                }
            };

            this.insertContent = function (element) {
                if (content) {
                    content.append(element);
                }
            };
            this.closeWindow = function () {
                deleteWindow();
            };
            createWindow();
        };

        return new BasicWindowClass();
    },

    Maximize() {
        let MessageGroupID = "";
        let TaskID = "";
        let TaskSourceEncompassID = "";
        const currentWindow = EChat.MainPageController.currentMessageWindow;
        if (currentWindow?.currentTab?.GroupInfo) {
            const GroupInfo = currentWindow.currentTab.GroupInfo;
            if (GroupInfo.GroupType === SocketUtil.GroupType.Task) {
                TaskSourceEncompassID = GroupInfo.MessageGroupID.split("_")[0];
                TaskID = GroupInfo.MessageGroupID.split("_")[1];
            } else {
                MessageGroupID = GroupInfo.MessageGroupID;
            }
        }
        let url = `Home?DashboardID=174945`;
        if (EChat.MainPageController.mainPageTab) {
            url += `&Tab=${EChat.MainPageController.mainPageTab}`;
        }

        if (TaskID) {
            url += `&TaskID=${TaskID}`;
            url += `&TaskSourceEncompassID=${TaskSourceEncompassID}`;
        } else {
            url += `&MessageGroupID=${MessageGroupID}`;
        }

        // Task 646165: eChat: Threads in small eChat should have an echat icon next to them to allow you to jump into the existing echat group in the eChat dashboard
        document.querySelectorAll(".eChat-MaximizeButton").forEach((dom) => {
            dom.setAttribute("href", url);
        });
    },

    BasicButton(buttonProperty) {
        const property = {
            id: buttonProperty.id || null,
            imageUrl: buttonProperty.imageUrl || null,
            imageClass: buttonProperty.imageClass || null,
            imagePosition: buttonProperty.imagePosition || null,
            title: buttonProperty.title || "Button",
            // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
            icon: buttonProperty.icon || null,
            type: buttonProperty.type || null,
            ecpid: buttonProperty.ecpid || null,
            width: buttonProperty.width || null,
            arrow: buttonProperty.arrow || false,
            clickEvent: buttonProperty.clickEvent || null,
            blackButton: buttonProperty.blackButton || true
        };
        const baseButton = EC_Fmt.HtmlStrToElement("<div class='eChatBaseButton eChat-NoTextSelect'></div>");
        if (property.id) {
            baseButton.setAttribute("id", property.id);
        }
        if (!buttonProperty.blackButton) {
            baseButton.classList.add("White");
        }
        if (EC_Fmt.isNull(property.width)) {
            baseButton.style.width = `${property.width}px`;
        }
        // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
        const title = EC_Fmt.HtmlStrToElement(`<ecp-btn id='${property.ecpid}' icon='${property.icon}' type='${property.type}' ${property.dropdown}>${property.title}</ecp-btn>`);

        if (property.imageUrl) {
            const image = EChat.CustomComponent.BasicImage({
                imageUrl: property.imageUrl,
                imagePosition: property.imagePosition
            });
            image.style.float = "left";
            image.style.margin = "5px 0 5px 10px";
            baseButton.append(image);
        }
        if (property.imageClass) {
            const image = EChat.CustomComponent.BasicImage({});
            image.style.margin = "5px 0 0 10px";
            image.classList.add(property.imageClass);
        }
        baseButton.append(title);

        if (property.arrow) {
            const arrowDiv = EC_Fmt.HtmlStrToElement("<div class='eChatButtonArrow'></div>");
            arrowDiv.append(title);
            baseButton.append(arrowDiv);
        } else {
            baseButton.append(title);
        }
        baseButton.addEventListener("click", (e) => {
            if (typeof property.clickEvent === "function") {
                property.clickEvent(e);
            }
        });
        return baseButton;
    },

    BasicImage(imageProperty) {
        const property = {
            id: imageProperty.id || null,
            height: imageProperty.height || 16,
            width: imageProperty.width || 16,
            imageUrl: imageProperty.imageUrl || null,
            imagePosition: imageProperty.imagePosition || "0 0"
        };
        const baseImage = EC_Fmt.HtmlStrToElement(`<div class='eChatBaseImage' style='height:${property.height}px;width:${property.width}px'></div>`);
        if (property.id) {
            baseImage.setAttribute("id", property.id);
        }
        if (property.imageUrl) {
            baseImage.style.backgroundImage = property.imageUrl;
            baseImage.style.backgroundRepeat = "no-repeat";
            baseImage.style.backgroundPosition = property.imagePosition;
        }
        return baseImage;
    },

    Camera(videoId, imageCanvasId) {
        const CameraClass = function () {
            const _this = this;
            EChat.EventDispatcher.call(this);
            const videoEleId = videoId;
            const imageCanvasEleId = imageCanvasId;
            let videoStream = null;

            if (!document.getElementById(videoEleId) || !document.getElementById(imageCanvasEleId)) {
                return;
            }

            this.openCamera = function () {
                navigator.getMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({
                        video: true,
                        audio: false
                    }).then((stream) => {
                        videoStream = stream;
                        const element = document.getElementById(videoEleId);
                        if (element) {
                            element.srcObject = videoStream;
                            element.play();
                        } else {
                            _this.closeCamera();
                        }
                    }).catch((err) => {
                        let errInfo = err.name || err;
                        switch (errInfo) {
                            case "DevicesNotFoundError":
                                errInfo = "Devices Not Found Error";
                                break;
                            case "PermissionDeniedError":
                                errInfo = "Permission Denied Error";
                                break;
                            default:
                                break;
                        }
                        _this.dispatch("CameraError", _this.createHandlerArgument(null, errInfo));
                    });
                }
            };

            this.snapPhoto = function () {
                if (!videoStream) {
                    return null;
                }
                const imageCanvas = document.getElementById(imageCanvasEleId);
                const context = imageCanvas.getContext("2d");
                context.drawImage(document.getElementById(videoEleId), 0, 0, imageCanvas.width, imageCanvas.height);
                const imgData = imageCanvas.toDataURL("png");
                return imgData;
            };

            this.closeCamera = function () {
                if (videoStream) {
                    if (typeof videoStream.stop === "function") {
                        videoStream.stop();
                    } else {
                        const videoTrack = videoStream.getTracks()[0];
                        if (videoTrack && typeof videoTrack.stop === "function") {
                            videoTrack.stop();
                        }
                    }
                    videoStream = null;
                    const videoEle = document.getElementById(videoEleId);
                    if (videoEle) {
                        videoEle.removeAttribute("src");
                    }
                }
            };
        };

        return new CameraClass();
    },

    InputArea(element) {
        const AreaClass = function () {
            if (!element) {
                return;
            }
            const _this = this;
            const isFirFox = /firefox/.test(navigator.userAgent.toLowerCase());
            const isSafari = /safari/.test(navigator.userAgent.toLowerCase());

            EChat.EventDispatcher.call(this);

            const editorEvent = EChat.InputAreaComponentEvent;
            const editorElement = element;
            let mouseIsDown = false;
            let hasPasteContent = false;

            const initInputArea = function () {
                editorElement.setAttribute("contenteditable", true);
                EChat.Util.PreventScroll(editorElement);
                editorElement.addEventListener("paste", pasteEvent);
                editorElement.addEventListener("input", inputEvent);
                editorElement.addEventListener("keydown", keydownEvent);
                editorElement.addEventListener("keyup", keyupEvent);
                editorElement.addEventListener("click", clickEvent);
                editorElement.addEventListener("blur", blurEvent);
                editorElement.addEventListener("mouseout", mouseoutEvent);
                editorElement.addEventListener("mouseup", mouseupEvent);
                editorElement.addEventListener("mousedown", mousedownEvent);
            };

            this.getValueCount = function () {
                if (EChat.FullWindowController.FullWindow && EChat.FullWindowController.TextArea) {
                    EChat.FullWindowController.TextArea.save();
                }

                // Task 757946: EChat word count is incorrect
                let count = editorElement.innerHTML.length;
                editorElement.querySelectorAll("img").forEach((dom) => {
                    if (dom.src.indexOf("data:image") === 0) {
                        // Each picture is calculated according to 300 characters.
                        count -= dom.src.length - 300;
                    }
                });
                return count;
            };

            this.getValue = function () {
                if (EChat.FullWindowController.FullWindow && EChat.FullWindowController.TextArea) {
                    EChat.FullWindowController.TextArea.save();
                }
                return editorElement.innerHTML.replace(/\n/g, "");
            };

            this.setValue = function (str) {
                editorElement.innerHTML = str;
                if (EChat.FullWindowController.FullWindow && EChat.FullWindowController.TextArea) {
                    EChat.FullWindowController.TextArea.setContent(str);
                    EChat.FullWindowController.TextArea.save();
                }
                if (!str) {
                    hasPasteContent = false;
                }
            };

            this.focus = function () {
                editorElement.focus();
                if (window.getSelection !== undefined && blurRange) {
                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(blurRange);
                }
            };

            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            // this.replaceLink = function (title, url) {
            this.replaceLink = function (title, url, name) {
                _this.focus();
                if (typeof title === "string" && title) {
                    // const link = EC_Fmt.HtmlStrToElement(`<a target='blank' href='${url}'>${title}</a>`);
                    const link = EC_Fmt.HtmlStrToElement(`<a title='${name}' href='${url}'>${title}</a>`);
                    replaceNode(title, link);
                }
            };

            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            this.replaceLinkNew = function (title, url, name) {
                _this.focus();
                if (typeof title === "string" && title) {
                    const link = EC_Fmt.HtmlStrToElement(`<a title='${name}' target='blank' href='${url}'>${title}</a>`);
                    replaceNode(title, link);
                }
            };

            const replaceNode = function (str, node) {
                if (window.getSelection !== undefined) {
                    const selection = window.getSelection();
                    const range = selection.getRangeAt(0);
                    if (blurRange) {
                        blurRange.deleteContents();
                    }
                    range.insertNode(node);
                }
            };

            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            // this.insertLink = function (title, url) {
            this.insertLink = function (title, url, name) {
                _this.focus();
                if (title === "") {
                    title = "Link";
                }
                // const link = EC_Fmt.HtmlStrToElement(`<a target='blank' href='${url}'>${title}</a> `);
                const link = EC_Fmt.HtmlStrToElement(`<a titile='${name}' href='${url}'>${title}</a> `);
                insertNode(link);
            };

            // Task 1133007: eChat: Unify the Insert/edit link function within Task Edit and eChat
            this.insertLinkNew = function (title, url, name) {
                _this.focus();
                if (title === "") {
                    title = "Link";
                }
                const link = EC_Fmt.HtmlStrToElement(`<a titile='${name}' target='blank' href='${url}'>${title}</a> `);
                insertNode(link);
            };

            this.insertImage = function (url) {
                _this.focus();
                const img = new Image();
                img.src = url;
                imageHandler(img);
                insertNode(img);
            };

            this.processImgData = function () {
                const obj = {
                    htmlString: "",
                    imgList: []
                };

                if (EChat.FullWindowController.FullWindow && EChat.FullWindowController.TextArea) {
                    EChat.FullWindowController.TextArea.save();
                }

                let formatIndex = 0;
                editorElement.querySelectorAll("img").forEach((dom) => {
                    const dataSrc = dom.src.toString();
                    const str = "data:image";
                    if (dataSrc.substr(0, str.length) === str) {
                        dom.outerHTML = `{${formatIndex}}`;
                        formatIndex++;
                        obj.imgList.push(dataSrc);
                    }
                });
                obj.htmlString = element.innerHTML;
                return obj;
            };

            const pasteEvent = function (e) {
                hasPasteContent = true;
                if (isFirFox) { // FirFox automatically inserts
                    return;
                }

                const clipboardData = e.clipboardData;
                let items;
                let item;
                let types;
                if (clipboardData) {
                    items = clipboardData.items;
                    if (items?.length === 1) {
                        item = items[0];
                        types = clipboardData.types || [];
                        for (let i = 0; i < types.length; i++) {
                            if (types[i] === "Files") {
                                item = items[i];

                                break;
                            }
                        }
                        if (item?.kind === "file" && /image\/\w+/.test(item.type)) {
                            imageReader(item);
                        }
                    }
                }
            };

            const imageReader = function (item) {
                if (item) {
                    const fileData = item.getAsFile();
                    const fileReader = new FileReader();
                    fileReader.onload = function (e) {
                        setTimeout(() => {
                            // Task 689760: There will be two duplicate images when you paste echat on chrome 83
                            let exist = false;
                            document.querySelectorAll(".eChat-MessageWindowTextArea img").forEach((dom) => {
                                if (dom.src === e.target.result) {
                                    exist = true;
                                }
                            });

                            // Task 748051: EChat pictures are still stored in the input box after sending
                            if (exist || !hasPasteContent) {
                                return;
                            }

                            const img = new Image();
                            img.src = e.target.result;
                            imageHandler(img);
                            insertNode(img);
                            _this.dispatch(editorEvent.ValueChange, _this.createHandlerArgument(null, null));
                        }, 300);
                    };
                    fileReader.readAsDataURL(fileData);
                }
            };

            const imageHandler = function (img) {
                if (img.getAttribute("title") === "") {
                    img.getAttribute("title", EC_Fmt.Trn("Double-click to view full size"));
                    img.classList.add("eChat-Cursor");
                    img.addEventListener("load", function () {
                        EChat.Util.autoResizeImage(500, 80, this);
                    });
                    img.addEventListener("dblclick", function () {
                        window.open(this.src);
                    });
                }
            };

            const inputEvent = function () {
                editorElement.querySelectorAll("img").forEach((dom) => {
                    imageHandler(dom);
                });
                _this.dispatch(editorEvent.ValueChange, _this.createHandlerArgument(null, null));
            };

            // Task 1003603: eChat: Returns in messages should support shift+enter
            const keydownEvent = function (e) {
                if (e.keyCode === 13) {
                    if (e.ctrlKey || e.metaKey || e.shiftKey) {
                        insertEnter();
                        e.stopPropagation();
                        e.preventDefault();
                    } else {
                        _this.dispatch(editorEvent.SendMessage, _this.createHandlerArgument(null, null));
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
            };

            const keyupEvent = function () {
                setRange();
            };

            const insertEnter = function () {
                if (window.getSelection !== undefined) {
                    const selection = window.getSelection();
                    const range = selection.getRangeAt(0);

                    let node;
                    const nodebr = document.createElement("br");
                    if (range.startContainer.length === range.startOffset
                        && range.startOffset === range.endOffset
                        && range.endOffset === range.endContainer.length
                        && !(/msie/.test(navigator.userAgent.toLowerCase()))) {
                        const nodediv = document.createElement("DIV");

                        if (range.commonAncestorContainer && range.commonAncestorContainer.parentElement && !range.commonAncestorContainer.parentElement.classList.contains("eChat-MessageWindowTextArea")) {
                            insertAfter(nodebr, range.commonAncestorContainer.parentElement);
                            insertAfter(nodediv, range.commonAncestorContainer.parentElement);
                        } else {
                            range.insertNode(nodebr);
                            range.insertNode(nodediv);
                        }
                        node = nodediv;
                    } else {
                        range.insertNode(nodebr);
                        node = nodebr;
                    }
                    selection.removeAllRanges();

                    const newrange = document.createRange();
                    newrange.setStartAfter(node);
                    newrange.setEndAfter(node);
                    selection.addRange(newrange);
                }
            };

            const insertNode = function (node) {
                if (window.getSelection) {
                    const selection = window.getSelection();
                    const range = selection.getRangeAt(0);
                    range.insertNode(node);
                    selection.removeAllRanges();

                    const newrange = document.createRange();
                    newrange.setStartAfter(node);
                    newrange.setEndAfter(node);
                    selection.addRange(newrange);

                    setRange();
                }
            };

            const insertAfter = function (newElement, targetElement) {
                const parent = targetElement.parentNode;
                if (parent.lastChild === targetElement) {
                    parent.append(newElement);
                } else {
                    parent.insertBefore(newElement, targetElement.nextSibling);
                }
            };

            let blurRange = null;
            const setRange = function () {
                if (window.getSelection) {
                    const selection = window.getSelection();
                    if (selection) {
                        let range = null;
                        try {
                            range = selection.getRangeAt(0);
                        } catch (e) {
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                        if (range) {
                            blurRange = range.cloneRange();
                        }
                    }
                }
            };

            const clickEvent = function () {
                setRange();
            };

            const mouseupEvent = function () {
                mouseIsDown = false;
                setRange();
            };

            const mouseoutEvent = function () {
                if (mouseIsDown) {
                    mouseIsDown = false;
                    setRange();
                }
            };

            const mousedownEvent = function () {
                mouseIsDown = true;
            };

            const blurEvent = function () {
                if (!isFirFox && !isSafari) {
                    setRange();
                }
            };

            this.getSelectValue = function () {
                if (blurRange) {
                    return blurRange.toString();
                }
                return null;
            };

            this.clearSelectFmt = function () {
                // Task 757955: EChat clear format tool does not preserve line breaks
                const editorElementText = editorElement.innerText;
                editorElement.innerHTML = editorElementText.replace(/\n/g, "<br>");
                if (window.getSelection && editorElementText) { // IE9+、Firefox、Safari、Chrome和Opera
                    const selection = window.getSelection();
                    const range = document.createRange();
                    const editorElementLastNode = editorElement.lastChild;
                    range.setStart(editorElementLastNode, editorElementLastNode.length);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    setRange();
                    _this.focus();
                    editorElement.scrollTop = editorElement.scrollHeight;
                } else {
                    _this.focus();
                }
            };

            initInputArea();
        };

        return new AreaClass();
    },

    ImageCrop(canvasId, imageSource) {
        const ImageCropClass = function () {
            const canvas = document.getElementById(canvasId);
            if (!canvas && imageSource) {
                return;
            }

            function Selection(x, y, w, h) {
                this.x = x; // initial positions
                this.y = y;
                this.w = w; // and size
                this.h = h;

                this.px = x; // extra variables to dragging calculations
                this.py = y;

                this.csize = 2; // resize cubes size
                this.csizeh = 4; // resize cubes size (on hover)

                this.bHow = [false, false, false, false]; // hover statuses
                this.iCSize = [this.csize, this.csize, this.csize, this.csize]; // resize cubes sizes
                this.bDrag = [false, false, false, false]; // drag statuses
                this.bDragAll = false; // drag whole selection
            }

            Selection.prototype.draw = function () {
                ctx.strokeStyle = "var(--primary-120)";
                ctx.lineWidth = 2;
                ctx.strokeRect(this.x, this.y, this.w, this.h);

                // draw part of original image
                if (this.w > 0 && this.h > 0) {
                    ctx.drawImage(image, this.x, this.y, this.w, this.h, this.x, this.y, this.w, this.h);
                }

                // draw resize cubes
                ctx.fillStyle = "var(--bg)";
                ctx.fillRect(this.x - this.iCSize[0], this.y - this.iCSize[0], this.iCSize[0] * 2, this.iCSize[0] * 2);
                ctx.fillRect(this.x + this.w - this.iCSize[1], this.y - this.iCSize[1], this.iCSize[1] * 2, this.iCSize[1] * 2);
                ctx.fillRect(this.x + this.w - this.iCSize[2], this.y + this.h - this.iCSize[2], this.iCSize[2] * 2, this.iCSize[2] * 2);
                ctx.fillRect(this.x - this.iCSize[3], this.y + this.h - this.iCSize[3], this.iCSize[3] * 2, this.iCSize[3] * 2);
            };

            const drawScene = function () {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height); // clear canvas

                // draw source image
                ctx.drawImage(image, 0, 0, ctx.canvas.width, ctx.canvas.height);

                // and make it darker
                ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
                ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

                // draw selection
                selectObj.draw();
            };

            const createSelection = function () {
                let startLen;
                if (image.width < 300 || image.height < 300) {
                    startLen = image.width < image.height ? image.width : image.height;
                    startLen -= 10;
                } else {
                    startLen = 250;
                }
                const x = ctx.canvas.width / 2 - startLen / 2;
                const y = ctx.canvas.height / 2 - startLen / 2;
                return new Selection(x, y, startLen, startLen);
            };

            const ctx = canvas.getContext("2d");
            let iMouseX = 1;
            let iMouseY = 1;
            let selectObj = null;
            const image = new Image();
            image.onload = function () {
                selectObj = createSelection();
                drawScene();
                canvas.addEventListener("mousemove", (e) => {
                    const rect = canvas.getBoundingClientRect();
                    const canvasOffset = {
                        top: rect.top + document.body.scrollTop,
                        left: rect.left + document.body.scrollLeft
                    };

                    iMouseX = Math.floor(e.pageX - canvasOffset.left);
                    iMouseY = Math.floor(e.pageY - canvasOffset.top);

                    if (selectObj.bDragAll) {
                        let cx = iMouseX - selectObj.px;
                        cx = cx < 0 ? 0 : cx;
                        const mx = ctx.canvas.width - selectObj.w;
                        cx = cx > mx ? mx : cx;
                        selectObj.x = cx;
                        let cy = iMouseY - selectObj.py;
                        cy = cy < 0 ? 0 : cy;
                        const my = ctx.canvas.height - selectObj.h;
                        cy = cy > my ? my : cy;
                        selectObj.y = cy;
                    }
                    for (let i = 0; i < 4; i++) {
                        selectObj.bHow[i] = false;
                        selectObj.iCSize[i] = selectObj.csize;
                    }

                    // hovering over resize cubes
                    if (iMouseX > selectObj.x - selectObj.csizeh && iMouseX < selectObj.x + selectObj.csizeh
                        && iMouseY > selectObj.y - selectObj.csizeh && iMouseY < selectObj.y + selectObj.csizeh) {
                        selectObj.bHow[0] = true;
                        selectObj.iCSize[0] = selectObj.csizeh;
                    }
                    if (iMouseX > selectObj.x + selectObj.w - selectObj.csizeh && iMouseX < selectObj.x + selectObj.w + selectObj.csizeh
                        && iMouseY > selectObj.y - selectObj.csizeh && iMouseY < selectObj.y + selectObj.csizeh) {
                        selectObj.bHow[1] = true;
                        selectObj.iCSize[1] = selectObj.csizeh;
                    }
                    if (iMouseX > selectObj.x + selectObj.w - selectObj.csizeh && iMouseX < selectObj.x + selectObj.w + selectObj.csizeh
                        && iMouseY > selectObj.y + selectObj.h - selectObj.csizeh && iMouseY < selectObj.y + selectObj.h + selectObj.csizeh) {
                        selectObj.bHow[2] = true;
                        selectObj.iCSize[2] = selectObj.csizeh;
                    }
                    if (iMouseX > selectObj.x - selectObj.csizeh && iMouseX < selectObj.x + selectObj.csizeh
                        && iMouseY > selectObj.y + selectObj.h - selectObj.csizeh && iMouseY < selectObj.y + selectObj.h + selectObj.csizeh) {
                        selectObj.bHow[3] = true;
                        selectObj.iCSize[3] = selectObj.csizeh;
                    }

                    // in case of dragging of resize cubes
                    let iFW;
                    let iFH;
                    let iFX;
                    let iFY;
                    if (selectObj.bDrag[0]) {
                        iFX = iMouseX - selectObj.px;
                        iFY = iMouseY - selectObj.py;
                        iFW = selectObj.w + selectObj.x - iFX;
                        iFH = selectObj.h + selectObj.y - iFY;
                        const mx = iFX + iFW;
                        const my = iFY + iFH;
                        const l = iFW < iFH ? iFH : iFW;
                        iFW = l;
                        iFH = l;
                        iFX = mx - l;
                        iFY = my - l;
                    }
                    if (selectObj.bDrag[1]) {
                        iFX = selectObj.x;
                        iFY = iMouseY - selectObj.py;
                        iFW = iMouseX - selectObj.px - iFX;
                        iFH = selectObj.h + selectObj.y - iFY;
                        const my = iFY + iFH;
                        const l = iFW < iFH ? iFH : iFW;
                        iFW = l;
                        iFH = l;
                        iFY = my - l;
                    }
                    if (selectObj.bDrag[2]) {
                        iFX = selectObj.x;
                        iFY = selectObj.y;
                        iFW = iMouseX - selectObj.px - iFX;
                        iFH = iMouseY - selectObj.py - iFY;
                        const l = iFW < iFH ? iFH : iFW;
                        iFW = l;
                        iFH = l;
                    }
                    if (selectObj.bDrag[3]) {
                        iFX = iMouseX - selectObj.px;
                        iFY = selectObj.y;
                        iFW = selectObj.w + selectObj.x - iFX;
                        iFH = iMouseY - selectObj.py - iFY;
                        const mx = iFX + iFW;
                        const l = iFW < iFH ? iFH : iFW;
                        iFW = l;
                        iFH = l;
                        iFX = mx - l;
                    }

                    if (iFX >= 0 && iFX <= ctx.canvas.width
                        && iFY >= 0 && iFY <= ctx.canvas.height
                        && (iFW + iFX) <= ctx.canvas.width && iFW > selectObj.csizeh * 2
                        && (iFH + iFY) <= ctx.canvas.height && iFH > selectObj.csizeh * 2) {
                        selectObj.w = iFW;
                        selectObj.h = iFH;

                        selectObj.x = iFX;
                        selectObj.y = iFY;
                    }
                    drawScene();
                });

                canvas.addEventListener("mousedown", (e) => {
                    const rect = canvas.getBoundingClientRect();
                    const canvasOffset = {
                        top: rect.top + document.body.scrollTop,
                        left: rect.left + document.body.scrollLeft
                    };
                    iMouseX = Math.floor(e.pageX - canvasOffset.left);
                    iMouseY = Math.floor(e.pageY - canvasOffset.top);

                    selectObj.px = iMouseX - selectObj.x;
                    selectObj.py = iMouseY - selectObj.y;

                    if (selectObj.bHow[0]) {
                        selectObj.px = iMouseX - selectObj.x;
                        selectObj.py = iMouseY - selectObj.y;
                    }
                    if (selectObj.bHow[1]) {
                        selectObj.px = iMouseX - selectObj.x - selectObj.w;
                        selectObj.py = iMouseY - selectObj.y;
                    }
                    if (selectObj.bHow[2]) {
                        selectObj.px = iMouseX - selectObj.x - selectObj.w;
                        selectObj.py = iMouseY - selectObj.y - selectObj.h;
                    }
                    if (selectObj.bHow[3]) {
                        selectObj.px = iMouseX - selectObj.x;
                        selectObj.py = iMouseY - selectObj.y - selectObj.h;
                    }

                    if (iMouseX > selectObj.x + selectObj.csizeh
                        && iMouseX < selectObj.x + selectObj.w - selectObj.csizeh
                        && iMouseY > selectObj.y + selectObj.csizeh
                        && iMouseY < selectObj.y + selectObj.h - selectObj.csizeh) {
                        selectObj.bDragAll = true;
                    }

                    for (let i = 0; i < 4; i++) {
                        if (selectObj.bHow[i]) {
                            selectObj.bDrag[i] = true;
                        }
                    }
                });

                // Task 995299: eChat's avatar change function is abnormal.
                canvas.addEventListener("mouseleave", () => {
                    selectObj.bDragAll = false;
                    for (let i = 0; i < 4; i++) {
                        selectObj.bDrag[i] = false;
                    }
                    selectObj.px = 0;
                    selectObj.py = 0;
                });
                canvas.addEventListener("mouseup", () => {
                    selectObj.bDragAll = false;
                    for (let i = 0; i < 4; i++) {
                        selectObj.bDrag[i] = false;
                    }
                    selectObj.px = 0;
                    selectObj.py = 0;
                });
            };
            image.src = imageSource;

            this.getImageData = function () {
                const tmpCanvas = document.createElement("canvas");
                const tmpCtx = tmpCanvas.getContext("2d");
                tmpCanvas.width = selectObj.w;
                tmpCanvas.height = selectObj.h;
                tmpCtx.drawImage(image, selectObj.x, selectObj.y, selectObj.w, selectObj.h, 0, 0, selectObj.w, selectObj.h);
                return tmpCanvas.toDataURL();
            };
        };

        return new ImageCropClass();
    },

    ChangePictureButton(callback, btnDiv) {
        let cameraComponent = null;
        let imageCrop = null;
        const createEditPhotoWindow = function (image) {
            const editPhotoWindow = EChat.CustomComponent.BasicWindow({
                id: "EChatTakePhoto",
                height: 470,
                width: 600,
                draggable: true,
                headerTitle: "Edit Photo"
            });
            const x = image.width;
            const y = image.height;
            EChat.Util.autoResizeImage(600, 400, image);
            const content = EC_Fmt.HtmlStrToElement("<div class=eChatWindowContent style=height:400px></div>");
            const canvas = EC_Fmt.HtmlStrToElement("<canvas id=EChatImageCanvas></canvas>");
            canvas.width = image.width;
            canvas.height = image.height;
            content.append(canvas);

            const footer = EC_Fmt.HtmlStrToElement("<div class=eChatWindowFooter></div>");
            const okBtn = EChat.CustomComponent.BasicButton({
                title: EC_Fmt.Trn("OK"),
                width: 100,
                whiteButton: false,
                clickEvent() {
                    if (typeof callback === "function") {
                        callback(imageCrop.getImageData());
                    }
                    editPhotoWindow.closeWindow();
                }
            });
            footer.append(okBtn);

            editPhotoWindow.insertContent(content);
            editPhotoWindow.insertContent(footer);

            const canvasTop = content.clientHeight / 2 - image.height / 2;
            canvas.style.marginTop = `${canvasTop}px`;

            const tmpCtx = canvas.getContext("2d");
            tmpCtx.drawImage(image, 0, 0, x, y, 0, 0, canvas.width, canvas.height);
            imageCrop = EChat.CustomComponent.ImageCrop("EChatImageCanvas", canvas.toDataURL());

            return editPhotoWindow;
        };
        const createTakePhotoWindow = function () {
            const takePhotoWindow = EChat.CustomComponent.BasicWindow({
                id: "EChatTakePhoto",
                height: 370,
                width: 400,
                draggable: true,
                headerTitle: "Take Photo",
                closeCallBack() {
                    if (cameraComponent) {
                        cameraComponent.closeCamera();
                    }
                }
            });

            const content = EC_Fmt.HtmlStrToElement("<div class='eChatWindowContent eChatTakePhotoBackground'></div>");
            const video = EC_Fmt.HtmlStrToElement(`<video autoplay='true' id='EChatVideo' style='width:400px;height:300px;'></video>`);
            const canvas = EC_Fmt.HtmlStrToElement("<canvas id='EChatImageCanvas' style='display:none'></canvas>");
            canvas.width = 400;
            canvas.height = 300;
            content.append(video);
            content.append(canvas);
            const footer = EC_Fmt.HtmlStrToElement("<div class='eChatWindowFooter'></div>");
            const snapshotBtn = EChat.CustomComponent.BasicButton({
                imageClass: "ews-icon-emphotograph",
                title: EC_Fmt.Trn("Snapshot"),
                clickEvent() {
                    const imageData = cameraComponent.snapPhoto();
                    if (imageData) {
                        snapshotBtn.style.display = "none";
                        retakeBtn.style.display = "inline-block";
                        okBtn.style.display = "inline-block";
                        canvas.style.display = "inline-block";
                        video.style.display = "none";
                        imageCrop = EChat.CustomComponent.ImageCrop("EChatImageCanvas", imageData);
                    }
                }
            });
            const retakeBtn = EChat.CustomComponent.BasicButton({
                // imageUrl: "url(images/EChatToolSprite.png)",
                // imagePosition: "-160px -55px",
                imageClass: "ews-icon-redo",
                title: EC_Fmt.Trn("Retake"),
                blackButton: false,
                width: 100,
                clickEvent() {
                    retakeBtn.style.display = "none";
                    okBtn.style.display = "none";
                    snapshotBtn.style.display = "inline-block";
                    video.style.display = "inline-block";
                    canvas.style.display = "none";
                }
            });
            retakeBtn.style.display = "none";

            const okBtn = EChat.CustomComponent.BasicButton({
                title: EC_Fmt.Trn("OK"),
                blackButton: true,
                width: 100,
                clickEvent() {
                    if (typeof callback === "function") {
                        callback(imageCrop.getImageData());
                    }
                    takePhotoWindow.closeWindow();
                }
            });
            okBtn.style.display = "none";
            footer.append(snapshotBtn);
            footer.append(retakeBtn);
            footer.append(okBtn);

            takePhotoWindow.insertContent(content);
            takePhotoWindow.insertContent(footer);
            return takePhotoWindow;
        };

        const initBtn = function () {
            if (!btnDiv) {
                btnDiv = EChat.CustomComponent.BasicButton({
                    title: EC_Fmt.Trn("Change Picture"),
                    blackButton: false,
                    arrow: true,
                    clickEvent: (e) => {
                        if (hidendiv.clientWidth > 0) {
                            hidendiv.style.display = "none";
                        } else {
                            hidendiv.style.display = "block";
                        }
                        e.stopPropagation();
                    }
                });
                btnDiv.style.width = "124px";
                // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
                // btnDiv.style.maxHeight = "82px";
                btnDiv.style.overflow = "hidden";
            } else {
                btnDiv.addEventListener("click", (e) => {
                    hidendiv.style.position = "absolute";
                    hidendiv.style.top = "0px";
                    hidendiv.style.left = "0px";
                    hidendiv.style.width = "auto";
                    if (hidendiv.clientWidth > 0) {
                        hidendiv.style.display = "none";
                    } else {
                        hidendiv.style.display = "block";
                    }
                    e.stopPropagation();
                });
            }

            const hidendiv = EC_Fmt.HtmlStrToElement("<div class='eChatAvatarBtnList Hideable' style=position:relative;z-index:10;display:none></div>");
            const takePhotoBtn = EChat.CustomComponent.BasicButton({
                imageClass: "ews-icon-emphotograph",
                blackButton: false,
                title: EC_Fmt.Trn("Take Photo"),
                clickEvent() {
                    const supportPhoto = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                    if (!supportPhoto) {
                        ECP.Dialog.Alert(EC_Fmt.Trn("Browser does not support take photo function"));
                    } else if (!document.getElementById("EChatTakePhoto")) {
                        createTakePhotoWindow();
                        cameraComponent = EChat.CustomComponent.Camera("EChatVideo", "EChatImageCanvas");
                        cameraComponent.bind("CameraError", (data) => {
                            ECP.Dialog.Alert(data.data);
                        });
                        if (cameraComponent) {
                            cameraComponent.openCamera();
                        }
                    }
                }
            });
            hidendiv.append(takePhotoBtn);
            const uploadBtn = EChat.CustomComponent.BasicButton({
                imageClass: "ews-icon-upload",
                blackButton: false,
                title: EC_Fmt.Trn("Upload Photo"),
                clickEvent(e) {
                    if (document.getElementById("EChatTakePhoto")) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
            });
            const inputValueChangeEvent = function () {
                const iconFile = this;
                if (iconFile.value) {
                    if (EChat.Util.checkImage(iconFile.value)) {
                        const fileReader = new FileReader();
                        fileReader.onload = function (e) {
                            const tmpImage = new Image();
                            tmpImage.onload = function () {
                                createEditPhotoWindow(tmpImage);
                                iconFile.value = "";
                                if (iconFile.value) {
                                    const parentNode = iconFile.parentNode;
                                    const cloneInput = iconFile.cloneNode();
                                    cloneInput.addEventListener("change", inputValueChangeEvent);
                                    iconFile.remove();
                                    parentNode.append(cloneInput);
                                }
                            };
                            tmpImage.src = e.target.result;
                        };
                        fileReader.readAsDataURL(this.files[0]);
                    } else {
                        ECP.Dialog.Alert(EC_Fmt.Trn("Please select image file. (.jpg, .png, .jpeg, .gif)"));
                    }
                }
            };
            const inputElement = EC_Fmt.HtmlStrToElement("<input class='eChat-Cursor' type='file' id='EChatUploadPhoto'>");
            inputElement.addEventListener("change", inputValueChangeEvent);
            uploadBtn.style.overflow = "hidden";
            uploadBtn.append(inputElement);
            hidendiv.append(uploadBtn);
            const closeeChatAvatarBtn = EC_Fmt.HtmlStrToElement("<div class='CloseDialog eChatAbsolute' style='position: absolute;top: 3px;right: 3px;'></div>");
            closeeChatAvatarBtn.addEventListener("click", (e) => {
                hidendiv.style.display = "none";
                e.stopPropagation();
            });
            hidendiv.append(closeeChatAvatarBtn);
            takePhotoBtn.classList.add("eChatAvatarBtnListItem");
            uploadBtn.classList.add("eChatAvatarBtnListItem");

            btnDiv.append(hidendiv);
            return btnDiv;
        };
        return initBtn();
    },
    // Task 1108551: Editing eChat Group Image updates User image.
    UserAvaterDisplay(parentElement, url, userCount, pWidth, pHeight, IsUserAvater) {
        // css border-box model parentElement must append to dom
        if (parentElement) {
            let userIconDisplay;
            if (IsUserAvater) {
                userIconDisplay = EC_Fmt.HtmlStrToElement("<div class='eChatUserAvatarDisplay' style='cursor:pointer'></div>");
                EChat.CustomComponent.ChangePictureButton((imageData) => {
                    if (imageData) {
                        document.querySelectorAll(".eChatUserAvatarDisplay").forEach((dom) => {
                            dom.style.backgroundSize = "cover";
                            dom.style.backgroundRepeat = "no-repeat";
                            dom.style.backgroundImage = `url(${imageData})`;
                        });
                        const UserAvatarDisplay = document.getElementById("user-avatar-display");
                        if (UserAvatarDisplay) {
                            UserAvatarDisplay.setAttribute("src", imageData);
                        }
                        EChat.DataProvider.uploadUserAvatar(imageData);
                    }
                }, userIconDisplay);
            } else {
                userIconDisplay = EC_Fmt.HtmlStrToElement("<div class='eChatGroupAvatarDisplay' style='cursor:pointer'></div>");
            }

            let imageUrl;
            if (url) {
                imageUrl = `url(${url})`;
                userIconDisplay.style.backgroundImage = imageUrl;
                userIconDisplay.style.backgroundRepeat = "no-repeat";
            } else {
                if (userCount > 2) {
                    userIconDisplay.style.backgroundImage = `url("${EChat.Setting.DefaultGroupIcon}")`;
                } else {
                    userIconDisplay.style.backgroundImage = `url("${EChat.Setting.DefaultUserIcon}")`;
                }
                userIconDisplay.style.backgroundRepeat = "no-repeat";
            }
            // Task 758473: The default avatar of eChat users is not displayed correctly
            userIconDisplay.style.backgroundSize = "cover";
            userIconDisplay.style.height = `${pHeight}px`;
            userIconDisplay.style.width = `${pWidth}px`;
            userIconDisplay.style.borderRadius = `${pHeight / 2}px`;

            const AuthenticationID = EChat.DataProvider.CurrentUserInfo.AuthenticationID;
            const UserAvailabilityI = EC_Fmt.HtmlStrToElement("<i class='eChat-UserAvailability'></i>");
            if (EChat.DataProvider.CurrentUserInfo.AuthenticationID > 0) {
                UserAvailabilityI.classList.add(`eChat-UserAvailability-${AuthenticationID}`);
            }
            parentElement.append(userIconDisplay);
            parentElement.append(UserAvailabilityI);
        }
    },

    UserItemDisplay(userInfo, checkbox, showUserType) {
        const divElement = EC_Fmt.HtmlStrToElement(`<div class='eChatUserItem' style='display:inline-block;' select='false' userid='${userInfo.UserID}'></div>`);
        divElement.setAttribute("usertype", userInfo.UserType);
        divElement.setAttribute("authid", userInfo.AuthenticationID);

        let iconUrl;
        if (!userInfo.Icon) {
            iconUrl = EChat.Setting.DefaultUserIcon;
        } else {
            iconUrl = userInfo.Icon;
        }

        const iconImgSpan = EC_Fmt.HtmlStrToElement("<span class='Left eChat-User-Img'></span>");
        const iconSpan = EC_Fmt.HtmlStrToElement(`<span class=eChatUserIcon style='background-image:url(${iconUrl});border-radius:12px;'></span>`);
        const PrimaryEncompassID = userInfo.PrimaryEncompassID ? ` (${userInfo.PrimaryEncompassID})` : "";
        const Department = userInfo.Department ? ` (Department includes ${userInfo.Department})` : "";
        const JobTitle = userInfo.JobTitle ? ` (JobTitle includes ${userInfo.JobTitle})` : "";
        const DisplayDepartment = userInfo.DisplayDepartment ? ` (Department includes ${userInfo.DisplayDepartment})` : Department;
        const DisplayJobTitle = userInfo.DisplayJobTitle ? ` (JobTitle includes ${userInfo.DisplayJobTitle})` : JobTitle;

        const nameSpan = EC_Fmt.HtmlStrToElement(`<span class='eChatUserName eChat-TextHidden'>${userInfo.DisplayName ? userInfo.DisplayName : userInfo.Name}${PrimaryEncompassID}${DisplayDepartment}${DisplayJobTitle}</span>`);
        nameSpan.setAttribute("title", userInfo.Name + PrimaryEncompassID + Department + JobTitle);
        const checkBoxLable = EC_Fmt.HtmlStrToElement("<label class=eChatCheckBoxLable></label>");
        const checkBoxSpan = EC_Fmt.HtmlStrToElement("<span class=eChatCheckBoxSpan></span>");
        const checkBoxInput = EC_Fmt.HtmlStrToElement(`<input class='eChat-Cursor' type='checkbox' userid='${userInfo.UserID}' authid='${userInfo.AuthenticationID}' encompassid='${userInfo.EncompassID}'/>`);
        checkBoxInput.setAttribute("fullname", userInfo.Name);
        checkBoxInput.setAttribute("username", userInfo.UserName);

        checkBoxLable.append(checkBoxInput);
        checkBoxLable.append(checkBoxSpan);
        iconImgSpan.append(iconSpan);
        if (checkbox) {
            divElement.append(checkBoxLable);
        }
        divElement.append(iconImgSpan);
        divElement.append(nameSpan);

        if (showUserType) {
            const typeSpan = EC_Fmt.HtmlStrToElement(`<span class='eChatUserType eChat-TextHidden'>${userInfo.UserType}</span>`);
            typeSpan.setAttribute("title", userInfo.UserType);
            divElement.append(typeSpan);
        }
        return divElement;
    },

    async InitUserSearchMenu(menu) {
        EChat.Util.ShowLoading();
        let EChatUserAdvancedSearch = document.getElementById("EChatUserAdvancedSearch");
        let data;
        try {
            data = await EChat.DataProvider.api("EChat_GetUserSearchFilters");
        } catch (e) {
            ECP.Dialog.HideLoading();
            return;
        }

        if (!EChatUserAdvancedSearch) {
            const htmlData = await EChat.MainPageController.loadEChatViewHtml();
            EChatUserAdvancedSearch = EC_Fmt.HtmlStrToElement(htmlData).querySelector("#EChatUserAdvancedSearch");
        }
        menu.innerHTML = EChatUserAdvancedSearch.innerHTML;

        const changeEvent = function () {
            const menuUserTypeValues = menu.querySelector("#EChatSelectUserType input[type='hidden']").value;
            const menuLocationValues = menu.querySelector("#EChatSelectLocation input[type='hidden']").value;
            const menuRoleValues = menu.querySelector("#EChatSelectRole input[type='hidden']").value;

            const filterButton = document.querySelector("#EChatMainPageContent .eChat-advanced-search-btn");
            const SendMessageUserAdvancedSearchBtn = document.getElementById("SendMessageUserAdvancedSearchBtn");
            if (filterButton) {
                filterButton.style.color = menuUserTypeValues || menuLocationValues || menuRoleValues ? "#0e5aa7" : "var(--primary-120)";
            }
            if (SendMessageUserAdvancedSearchBtn) {
                SendMessageUserAdvancedSearchBtn.style.color = menuUserTypeValues || menuLocationValues || menuRoleValues ? "#0e5aa7" : "#bbb";
            }
        };

        const locationDom = menu.querySelector("#EChatSelectLocation");
        if (data.Locations) {
            let ValuesArr = "";
            for (let i = 0; i < data.Locations.length; i++) {
                const locationInfo = data.Locations[i];
                if (ValuesArr) {
                    ValuesArr += "^";
                }
                ValuesArr += `${locationInfo.LocationID}|${locationInfo.Location}`;
            }

            await ECP.HTML.FillWithAutoComplete(locationDom,
                {
                    InputName: "EChatSelectLocationID",
                    DataType: ECP.DataType._AutoNumber,
                    Width: 190,
                    CurValue: "",
                    CurDisplayValue: "",
                    Required: false,
                    LimitToRefList: true,
                    IsSearch: true,
                    Translate: false,
                    TabIndex: 1,
                    ValuesArr,
                    Placeholder: ""
                }, null, null, changeEvent);
        }

        const roleDom = menu.querySelector("#EChatSelectRole");
        if (data.Roles) {
            let ValuesArr = "";
            for (let i = 0; i < data.Roles.length; i++) {
                const roleInfo = data.Roles[i];
                if (ValuesArr) {
                    ValuesArr += "^";
                }
                ValuesArr += `${roleInfo.RoleID}|${roleInfo.Role}`;
            }

            roleDom.innerHTML = "";
            await ECP.HTML.FillWithAutoComplete(roleDom,
                {
                    InputName: "EChatSelectRoleID",
                    DataType: ECP.DataType._AutoNumber,
                    Width: 190,
                    CurValue: "",
                    CurDisplayValue: "",
                    Required: false,
                    LimitToRefList: true,
                    IsSearch: true,
                    Translate: false,
                    TabIndex: 1,
                    ValuesArr,
                    Placeholder: ""
                }, null, null, changeEvent);
        }

        const userTypeDom = menu.querySelector("#EChatSelectUserType");
        if (data.UserTypes) {
            let ValuesArr = "";
            for (let i = 0; i < data.UserTypes.length; i++) {
                const userTypeInfo = data.UserTypes[i];
                if (ValuesArr) {
                    ValuesArr += "^";
                }
                ValuesArr += `${userTypeInfo.UserTypeID}|${userTypeInfo.UserType}`;
            }

            userTypeDom.innerHTML = "";
            await ECP.HTML.FillWithAutoComplete(userTypeDom,
                {
                    InputName: "EChatSelectUserTypeID",
                    DataType: ECP.DataType._AutoNumber,
                    Width: 190,
                    CurValue: "",
                    CurDisplayValue: "",
                    Required: false,
                    LimitToRefList: true,
                    IsSearch: true,
                    Translate: false,
                    TabIndex: 1,
                    ValuesArr,
                    Placeholder: ""
                }, null, null, changeEvent);
        }

        // Task 937742: eChat: Updates to eChat Search.
        const AjaxClear = menu.querySelector("#EChatUserSearchClear");
        AjaxClear.addEventListener("click", (event) => {
            event.stopPropagation();
            // Task 1147400: DSDLink: eChat in the new Mobile Framework(echat Dashboard)
            if (EChat.MainPageController.ClientOS === "Mobile") {
                document.getElementById("EChatSelectUserTypeIDInput").setAttribute("selarray", "");
                document.getElementById("EChatSelectRoleIDInput").setAttribute("selarray", "");
                document.getElementById("EChatSelectLocationIDInput").setAttribute("selarray", "");

                document.getElementById("EChatSelectUserTypeIDInput").value = "";
                document.getElementById("EChatSelectRoleIDInput").value = "";
                document.getElementById("EChatSelectLocationIDInput").value = "";

                document.getElementById("EChatSelectUserTypeIDHidden").value = "";
                document.getElementById("EChatSelectRoleIDHidden").value = "";
                document.getElementById("EChatSelectLocationIDHidden").value = "";
            } else {
                const Checkboxes = document.querySelectorAll("#EChatSelectRoleID_Results input[type='checkbox']:checked, #EChatSelectUserTypeID_Results input[type='checkbox']:checked, #EChatSelectLocationID_Results input[type='checkbox']:checked");
                for (let i = 0, CheckboxesLength = Checkboxes.length; i < CheckboxesLength; i++) {
                    EC_Fmt.TriggerEvent(Checkboxes[i].parentElement, "click");
                }
                document.getElementById("EChatSelectUserTypeIDHidden").value = "";
                document.getElementById("EChatSelectRoleIDHidden").value = "";
                document.getElementById("EChatSelectLocationIDHidden").value = "";
            }
        });
        ECP.Dialog.HideLoading();
    },

    UserSelectEvnet(e, eChatUserItem, itemid, ClickCallBack, HiddenCreateGroupBtn) {
        let cancelAuthID = 0;
        const input = eChatUserItem.querySelector("input");
        if (e.target.className === "eChatCheckBoxSpan" || e.target.className === "eChatCheckBoxLable") {
            const eChatParentCheckBoxSpan = eChatUserItem.querySelector(".eChatCheckBoxSpan");
            input.checked = !input.checked;
            if (input.checked) {
                eChatParentCheckBoxSpan.style.backgroundPosition = "-30px -25px";
                eChatUserItem.setAttribute("select", "true");
            } else {
                cancelAuthID = input.getAttribute("authid");
                eChatParentCheckBoxSpan.style.backgroundPosition = "0px -25px";
                eChatUserItem.setAttribute("select", "false");
            }
        } else if (ClickCallBack) {
            ClickCallBack(input);
        }

        e.preventDefault();

        if (cancelAuthID && !HiddenCreateGroupBtn) {
            const EChatSearchText = document.getElementById("EChatSearchText");
            let selectAuthIDArr = [];
            const selectedStr = EChatSearchText.getAttribute("selected");
            if (selectedStr) {
                selectAuthIDArr = selectedStr.split(",");
            }

            const index = selectAuthIDArr.indexOf(cancelAuthID);
            if (index > -1) {
                selectAuthIDArr.splice(index, 1);
                EChatSearchText.setAttribute("selected", selectAuthIDArr.join(","));
            }

            if (selectAuthIDArr.length === 0 && !EChatSearchText.value && !EChatSearchText.getAttribute("tab")) {
                if (itemid === "EChatSuperSearchUserList") {
                    EC_Fmt.TriggerEvent(document.getElementById("EChatRecentSwitchBtn"), "click");
                }
            }
        }
        if (!HiddenCreateGroupBtn) {
            EChat.MainPageController.ShowCreateGroupButton(itemid);
        }
    },

    async UserSearch(option) {
        let NotInArr = option.NotInArr;
        const {
            All, UserTypeID, LocationID, RoleID, Search, Container, ClickCallBack, Mark, SearchDom, ShowUserType, ShowFilters, HiddenCreateGroupBtn, MessageGroupKey
        } = option;

        const hasFilter = All || UserTypeID !== "Null" || LocationID !== "Null" || RoleID !== "Null" || Search !== "";
        const userIdArr = [];
        let DefaultUserStr = "";
        Container.querySelectorAll(".eChatUserItem").forEach((dom) => {
            const select = dom.getAttribute("select");
            if (select === "false") {
                dom.remove();
            } else {
                if (hasFilter) {
                    dom.style.display = "none";
                } else {
                    dom.style.display = "inline-block";
                }
                userIdArr.push(parseInt(dom.getAttribute("userid")));
            }
        });

        if (!hasFilter) {
            Container.querySelectorAll("#EChatUserAdvancedSearchTool").forEach((dom) => {
                dom.remove();
            });

            if (userIdArr.length > 0) {
                let html = "";
                html += "<div id=EChatUserAdvancedSearchTool>";
                html += " <span id=EChatUserClear class=eChat-Clear>Clear All</span>";
                html += "</div>";
                Container.prepend(EC_Fmt.HtmlStrToElement(html));
                Container.querySelector("#EChatUserClear").addEventListener("click", () => {
                    Container.querySelectorAll(".eChatUserItem").forEach((dom) => {
                        dom.remove();
                    });
                    Container.querySelector("#EChatUserAdvancedSearchTool").remove();
                });
            }

            Container.querySelectorAll(".eChat-UserType").forEach((dom) => {
                dom.remove();
            });

            DefaultUserStr = SearchDom.getAttribute("default-user");
            if (userIdArr.length === 0 && !DefaultUserStr) {
                return;
            }
        }

        if (NotInArr) {
            NotInArr = NotInArr.join(",");
        } else {
            NotInArr = "";
        }

        EChat.Util.ShowLoading(Mark, Search ? "Searching" : "");
        let userInfoList = [];
        try {
            userInfoList = await EChat.DataProvider.api("EChat_SearchUser", {
                All, UserTypeID, LocationID, RoleID, Search, NotInArr, AuthenticationIDArr: EC_Fmt.Null2EmptyStr(DefaultUserStr), MessageGroupKey
            });

            Container.querySelectorAll("#EChatUserAdvancedSearchTool").forEach((dom) => {
                dom.remove();
            });

            Container.querySelectorAll(".eChat-UserType").forEach((dom) => {
                dom.remove();
            });

            if (DefaultUserStr) {
                const DefaultUserArr = DefaultUserStr.split(",");
                const sortUserInfoList = [];
                for (let i = 0; i < DefaultUserArr.length; i++) {
                    for (let j = 0; j < userInfoList.length; j++) {
                        if (userInfoList[j].AuthenticationID.toString() === DefaultUserArr[i]) {
                            sortUserInfoList.push(userInfoList[j]);
                        }
                    }
                }
                userInfoList = sortUserInfoList;
            }

            for (let i = 0; i < userInfoList.length; i++) {
                let UserItemDisplay;

                if (userIdArr.indexOf(parseInt(userInfoList[i].UserID)) > -1) {
                    UserItemDisplay = Container.querySelector(`.eChatUserItem[userid='${userInfoList[i].UserID}']`);
                    UserItemDisplay.style.display = "inline-block";
                } else {
                    if (DefaultUserStr) {
                        userInfoList[i].UserType = "Recent";
                    }

                    UserItemDisplay = EChat.CustomComponent.UserItemDisplay(userInfoList[i], true, ShowUserType);
                    UserItemDisplay.addEventListener("click", (e) => {
                        EChat.CustomComponent.UserSelectEvnet(e, UserItemDisplay, "EChatUserListItems", ClickCallBack, HiddenCreateGroupBtn);
                    });
                    Container.append(UserItemDisplay);
                }
            }
        } catch (e) {
            EChat.Util.errorAlert(e);
        }
        ECP.Dialog.HideLoading();

        let html = `<div id=EChatUserAdvancedSearchTool>`;
        // Task 1119613：eChat: Update all the buttons in eChat to ecp-btn
        html += `<ecp-btn id=EChatUserSelectAll type=ghost style=margin-right:0;height:26px> ${EC_Fmt.Trn("Select All")}</ecp-btn>`
            + ` | `
            + `<ecp-btn id=EChatUserClear type=ghost style=height:26px>${EC_Fmt.Trn("Clear")} </ecp-btn>`;
        if (ShowFilters) {
            html += ` <ecp-btn class=eChat-advanced-search-btn type=ghost icon=ews-icon-filterbold title='Advanced Search'style=width:70px;height:26px;font-size:13px>${EC_Fmt.Trn("Filters")}</ecp-btn>`;
        }
        html += `</div>`;

        Container.prepend(EC_Fmt.HtmlStrToElement(html));

        const menuUserType = document.querySelector("#EChatSelectUserType input[type='hidden']");
        const menuLocation = document.querySelector("#EChatSelectLocation input[type='hidden']");
        const menuRole = document.querySelector("#EChatSelectRole input[type='hidden']");
        const filterButton = Container.querySelector(".eChat-advanced-search-btn");
        if (filterButton && menuUserType && menuLocation && menuRole) {
            filterButton.style.color = menuUserType.value || menuLocation.value || menuRole.value ? "#0e5aa7" : "var(--primary-120)";
        }

        Container.querySelector("#EChatUserSelectAll").addEventListener("click", async () => {
            if (hasFilter) {
                NotInArr = NotInArr.split(",");
                option.All = true;
                option.NotInArr = NotInArr;
                await EChat.CustomComponent.UserSearch(option);
                // Task 1027496: User using echat tried to send a message to a group of people but there were some problems with it.
                if (!HiddenCreateGroupBtn) {
                    EChat.MainPageController.ShowCreateGroupButton("EChatUserListItems");
                }
            } else if (userInfoList.length > 0) {
                Container.querySelectorAll(".eChatUserItem").forEach((dom) => {
                    dom.querySelector("input").checked = true;
                    dom.querySelector(".eChatCheckBoxSpan").style.backgroundPosition = "-30px -25px";
                    dom.setAttribute("select", "true");
                });
                if (!HiddenCreateGroupBtn) {
                    EChat.MainPageController.ShowCreateGroupButton("EChatUserListItems");
                }
            }
        });

        Container.querySelector("#EChatUserClear").addEventListener("click", () => {
            Container.querySelectorAll(".eChatUserItem").forEach((dom) => {
                dom.querySelector("input").checked = false;
                dom.querySelector(".eChatCheckBoxSpan").style.backgroundPosition = "0px -25px";
                dom.setAttribute("select", "false");
            });
            EChat.MainPageController.ShowCreateGroupButton();
        });

        if (ShowFilters) {
            // Task 937742: eChat: Updates to eChat Search.
            Container.querySelector(".eChat-advanced-search-btn").addEventListener("click", () => {
                EWS.Command.ShowMenu("eChat-advanced-search", Container.querySelector(".eChat-advanced-search-btn"), {
                    Container,
                    ClickCallBack,
                    Mark,
                    NotInArr,
                    ShowUserType,
                    ShowFilters,
                    SearchDom: "eChat-advanced-search-btn"
                });
            });
        }

        if (All) {
            Container.querySelectorAll(".eChatUserItem").forEach((dom) => {
                dom.querySelector("input").checked = true;
                dom.querySelector(".eChatCheckBoxSpan").style.backgroundPosition = "-30px -25px";
                dom.setAttribute("select", "true");
            });
        }
    },

    KeyCodeEvent({
        KeyCode, ListDom, ItemClassArr, SelectClass, EnterOpenItem, EnterEvent, InputEvent
    }) {
        if (KeyCode > 40 || KeyCode < 9) {
            if (InputEvent) {
                InputEvent();
            }
            return;
        }

        const itemList = [];
        ListDom.querySelectorAll(`.${ItemClassArr.join(",.")}`).forEach((dom) => {
            if (dom.clientWidth) {
                itemList.push(dom);
            } else {
                // Task 955476: eChat: Wrong eChat group opens when pressing Enter
                dom.classList.remove(SelectClass);
            }
        });

        if (itemList.length === 0) {
            return;
        }

        let selectDom = ListDom.querySelector(`.${SelectClass}`);
        if (!selectDom) {
            selectDom = itemList[0];
            if (selectDom) { // Esc
                selectDom.classList.add(SelectClass);
                ListDom.scrollTop = 0;
            }
            return;
        }

        // Enter
        if (KeyCode === 13) {
            if (EnterEvent) {
                EnterEvent(selectDom);
                return;
            }

            if (EnterOpenItem) {
                selectDom.classList.remove(SelectClass);
                EC_Fmt.TriggerEvent(selectDom, "click");
                return;
            }
        }

        // Esc
        if (KeyCode === 27) {
            selectDom.classList.remove(SelectClass);
            return;
        }

        let moveIndex = -1;
        for (let i = 0; i < itemList.length; i++) {
            if (itemList[i] === selectDom) {
                moveIndex = i;
                break;
            }
        }

        if (KeyCode === 38) { // up
            moveIndex--;
        } else if (KeyCode === 40) { // down
            moveIndex++;
        }

        moveIndex = moveIndex === -1 ? itemList.length - 1 : moveIndex;
        moveIndex = moveIndex === itemList.length ? 0 : moveIndex;

        const moveDom = itemList[moveIndex];
        if (moveDom) {
            selectDom.classList.remove(SelectClass);
            moveDom.classList.add(SelectClass);
        } else {
            return;
        }

        // scroll
        if (moveIndex === 0) {
            ListDom.scrollTop = 0;
        } else {
            const listRect = ListDom.getBoundingClientRect();
            const moveRect = moveDom.getBoundingClientRect();
            let moveHeight = (moveRect.y + moveRect.height) - (listRect.y + listRect.height);
            if (moveHeight > 0) {
                ListDom.scrollTop += moveHeight;
            } else {
                moveHeight = listRect.top - moveRect.top;
                if (moveHeight > 0) {
                    ListDom.scrollTop -= moveHeight;
                }
            }
        }
    },

    SwichButton(buttonProperty, parentElement) {
        const ButtonClass = function () {
            if (parentElement) {
                const _this = this;
                const property = {
                    id: buttonProperty.id || null,
                    checked: buttonProperty.checked || null,
                    changeEvent: buttonProperty.changeEvent || null
                };

                const inputID = `${EChat.Util.getTimeStamp()}_${Math.floor(Math.random() * 0x100000)}`;
                const element = EC_Fmt.HtmlStrToElement(`<div class="toggle-switch-widget Right eChat-Switch"id=${property.id}>`
                    + `<div class=toggle-layer-small>`
                    + ` <input id=${inputID} type=checkbox class=toggle-switch-checkbox>`
                    + ` <label class=switch-icon for=${inputID}></label>`
                    + `</div>`
                    + `</div>`);

                const input = element.querySelector("input");
                input.checked = property.checked;
                input.addEventListener("change", () => {
                    property.changeEvent(input.checked ? 1 : 0);
                });

                this.Open = function () {
                    input.checked = true;
                };

                this.Close = function () {
                    input.checked = false;
                };

                this.Checked = function () {
                    return input.checked;
                };

                parentElement.append(element);
                return _this;
            }
            return null;
        };

        return new ButtonClass();
    },

    TextCheckBox(checkBoxProperty, parentElement) {
        const TextCheckBoxClass = function () {
            if (parentElement) {
                const _this = this;

                const property = {
                    id: checkBoxProperty.id || null,
                    checked: checkBoxProperty.checked || null,
                    changeEvent: checkBoxProperty.changeEvent || null,
                    text: checkBoxProperty.text || "checkbox",
                    checkCondition: checkBoxProperty.checkCondition || null
                };

                const selfChangeEvent = function (value, e) {
                    if (parseInt(value) === 1) {
                        checkBoxSpan.style.backgroundPosition = "-30px -25px";
                    } else {
                        checkBoxSpan.style.backgroundPosition = "-0px -25px";
                    }
                    if (e && typeof property.changeEvent === "function") {
                        property.changeEvent(value);
                    }
                };

                const element = EC_Fmt.HtmlStrToElement("<div style='display:inline-block;margin:0 5px 0 0'></div>");
                const checkBoxLable = EC_Fmt.HtmlStrToElement("<label class=eChatCheckBoxLable></label>");
                const checkBoxSpan = EC_Fmt.HtmlStrToElement("<span class=eChatCheckBoxSpan></span>");
                const checkBoxInput = EC_Fmt.HtmlStrToElement("<input class='eChat-Cursor eChatDisplayNone'type=checkbox>");
                checkBoxLable.append(checkBoxInput);
                checkBoxLable.append(checkBoxSpan);
                const textElement = EC_Fmt.HtmlStrToElement(`<span>${property.text}</span>`);
                element.append(checkBoxLable);
                element.append(textElement);

                checkBoxInput.addEventListener("click", (e) => {
                    if (typeof property.checkCondition === "function" && property.checkCondition() !== true) {
                        _this.Close();
                    } else {
                        selfChangeEvent(checkBoxInput.checked === true ? 1 : 0, e);
                    }
                });

                this.Open = function (triggerEvent) {
                    checkBoxInput.checked = true;
                    selfChangeEvent(1, triggerEvent);
                };

                this.Close = function (triggerEvent) {
                    checkBoxInput.checked = false;
                    selfChangeEvent(0, triggerEvent);
                };

                if (property.checked) {
                    _this.Open();
                } else {
                    _this.Close();
                }
                parentElement.append(element);
                return _this;
            }
            return null;
        };

        return new TextCheckBoxClass();
    },

    GetAlertDetailUrl(alertType, MessageGroupID) {
        let url;
        const type = EChat.EmployeesAlertsType;
        switch (alertType) {
            case type.Day_Close:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=Locations&`;
                break;
            case type.End_of_Day_Warnings:
                url = `Home?DashboardID=172425&Action=Inbox&MessageGroupKey=${MessageGroupID}`;
                break;
            case type.ASN_Receipt:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=ExchangeTasks&Search=FunctionalType~856|Direction~2`;
                break;
            case type.New_Customer_Account:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=Users&Search=UserTypeID~3^4&SelectSort=TimeCreated.Desc&SelectDisplayInParent=UserName,Name,UserTypeID,RoleID,LocationID,TimeCreated`;
                break;
            case type.PO_Receipt:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=ExchangeTasks&Search=Direction~1|FunctionalType~850`;
                break;
            case type.REMIT_Receipt:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=ExchangeTasks&Search=FunctionalType~820|Direction~1`;
                break;
            case type.Import_Conflict:
                // Task 683249: Convert Import Conflicts to dashboard.
                url = "Home?DashboardID=174029";
                break;
            // Task 608641: Alerts: Details button not redirecting to the Messages Inbox
            case type.Picker_Cut:
                url = `Home?DashboardID=172425&Action=Inbox&MessageGroupKey=${MessageGroupID}`;
                break;
            case type.Supplier_Comm_Warnings:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=ExchangeTasks&Search=Direction~2|ReportType~BudNet`;
                break;
            case type.EDI_Download_Reminder:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=ExchangeTasks&Search=Status~2`;
                break;
            case type.EDI_Inbound_Errors:
                url = `Home?DashboardID=172425&Action=Inbox&MessageGroupKey=${MessageGroupID}`;
                break;
            case type.EDI_Outbound_Errors:
                url = `Home?DashboardID=172425&Action=Inbox&MessageGroupKey=${MessageGroupID}`;
                break;
            case type.Account_Mismapping:
                url = `Home?DashboardID=${ECP.CommonDashboards.TableView}&TableName=IncomeAccounts&`;
                break;
            case type.Can_Count_Import:
                url = `Home?DashboardID=172425&Action=Inbox&MessageGroupKey=${MessageGroupID}`;
                break;
            default:
                // Task 640677: When I click Details on the Education Stipend Alert in the eChat dialog it takes me to messages table and shows ALL Messages
                url = `Home?DashboardID=172425&Action=Inbox&MessageGroupKey=${MessageGroupID}`;
                break;
        }
        return url;
    }
};

EChat.IndexedDB = (function () {
    const IndexedDBClass = function () {
        EChat.EventDispatcher.call(this);
        const _this = this;
        const DB_NAME = "EChat2005";
        const DB_VERSION = 2;
        let OLD_DB_VERSION = -1;
        const READ_WRITE = "readwrite";
        const READ_ONLY = "readonly";
        // Task 654140: JavaScript Error: UnknownFile (0) - Error in promise - NotFoundError: Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found.
        let SkipDBCheck = false;
        let openDBErrorCount = 0;
        let throwErrorCount = 0;// Task 452666: System Errors: LB1 JavaScript Error Captured: CSBG db
        this.check = function () {
            return window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
        };

        this.getDB = function () {
            return new Promise(((resolve, reject) => {
                const request = window.indexedDB.open(DB_NAME, DB_VERSION);
                request.onsuccess = function (evt) {
                    resolve(evt.target.result);
                };
                request.onerror = function () {
                    reject();
                };
                request.onupgradeneeded = function (evt) {
                    const db = request.result;
                    OLD_DB_VERSION = evt.oldVersion;
                    InitTable(db, evt.oldVersion, evt.newVersion);
                    EChat.Util.initMain();
                };
            }));
        };

        this.InitDB = function () {
            return new Promise(((resolve, reject) => {
                let db = null;

                setTimeout(() => {
                    // Task 749799: JavaScript Error: includes/DefaultAll.min.js (1) - TypeError: window.indexedDB.databases is not a function
                    if (!db && typeof (window.indexedDB.databases) === "function") {
                        window.indexedDB.databases().then((dbList) => {
                            for (let i = 0, len = dbList.length; i < len; i++) {
                                if (dbList[i].name === DB_NAME && dbList[i].version < DB_VERSION) {
                                    ECP.Dialog.Alert("Please restart your Browser to resume using eChat.");
                                    break;
                                }
                            }
                        });
                    }
                }, 2000);

                const request = window.indexedDB.open(DB_NAME, DB_VERSION);
                request.onsuccess = function (evt) {
                    db = evt.target.result;
                    if (checkDB(db)) {
                        DataUpgrade().then(() => {
                            resolve();
                        });

                        DataDelete();
                        // Task 439265
                        db.onclose = function () {
                            if (openDBErrorCount < 10) {
                                openDBErrorCount++;
                                _this.InitDB();
                            }
                        };
                        db.onerror = function () {
                            IndexedDBThrowError("db error");
                        };
                    }
                };

                request.onerror = function (evt) {
                    IndexedDBThrowError(`initDb error:${evt.target.errorCode}${evt.target.error}`);
                    reject();
                };

                request.onupgradeneeded = async function (evt) {
                    db = request.result;
                    OLD_DB_VERSION = evt.oldVersion;
                    InitTable(db, evt.oldVersion, evt.newVersion);
                    await EChat.IndexedDB.UpdateSetting("EChatV2010", EChat.Util.getTimeStamp(), false);
                    EChat.Util.initMain();
                };
            }));
        };

        const checkDB = function (db) {
            if (!SkipDBCheck && db.objectStoreNames.length === 0) {
                // eslint-disable-next-line no-console
                console.warn("db Init error. Rebuild.");
                const request = window.indexedDB.deleteDatabase(DB_NAME);
                request.onsuccess = function () {
                    SkipDBCheck = true;
                    _this.InitDB();
                };
                return false;
            }
            return true;
        };

        const InitTable = function (db) {
            if (!db.objectStoreNames.contains(EChat.DBTableName.GROUPINFO)) {
                db.createObjectStore(EChat.DBTableName.GROUPINFO, { keyPath: "MessageGroupID" }).createIndex("GroupType", "GroupType", { unique: false });
            }
            if (!db.objectStoreNames.contains(EChat.DBTableName.SETTINGS)) {
                db.createObjectStore(EChat.DBTableName.SETTINGS, { keyPath: "Key" });
            }
            if (!db.objectStoreNames.contains(EChat.DBTableName.TABLEALERTS)) {
                db.createObjectStore(EChat.DBTableName.TABLEALERTS, { keyPath: "AlertID" });
            }
            if (!db.objectStoreNames.contains(EChat.DBTableName.LOG)) {
                db.createObjectStore(EChat.DBTableName.LOG, { keyPath: "TimeStamp" }).createIndex("ErrorType", "ErrorType", { unique: false });
            }
            if (!db.objectStoreNames.contains(EChat.DBTableName.SENDMESSAGES)) {
                db.createObjectStore(EChat.DBTableName.SENDMESSAGES, { keyPath: "TimeStamp" });
            }
            if (!db.objectStoreNames.contains(EChat.DBTableName.TASKS)) {
                db.createObjectStore(EChat.DBTableName.TASKS, { keyPath: "TaskID" });
            }
        };

        const DataUpgrade = function () {
            return new Promise(((resolve) => {
                if (OLD_DB_VERSION >= 0) {
                    const oldVersion = OLD_DB_VERSION;
                    OLD_DB_VERSION = -1;
                    for (let i = oldVersion; i < DB_VERSION; i++) {
                        switch (i) {
                            case 0:
                                window.indexedDB.deleteDatabase("EChat");
                                window.localStorage.removeItem("ConnectGuid");
                                window.localStorage.removeItem("EChatTimer");
                                window.localStorage.removeItem("IsConnect");
                                window.localStorage.removeItem("UnReadCount");
                                window.localStorage.removeItem("EChatCommand");

                                break;
                            default:
                                break;
                        }
                        // eslint-disable-next-line no-console
                        console.log(`IndexedDB Upgrade ${oldVersion}`);
                    }
                }
                resolve();
            }));
        };
        const DataDelete = function () {
            DeleteOldData(EChat.DBTableName.SENDMESSAGES, "TimeStamp", 50);
            DeleteOldData(EChat.DBTableName.LOG, "TimeStamp", 50);
        };

        const DeleteOldData = function (TableName, KeyName, ReservedNumber) {
            if (parseInt(ReservedNumber) === 0) {
                _this.DeleteTableAllData(TableName);
            } else if (ReservedNumber > 0) {
                EChat.IndexedDB.GetTableAllData(TableName).then((DateList) => {
                    for (let i = 0; i < DateList.length - ReservedNumber; i++) {
                        _this.DeleteTableDataByKey(TableName, DateList[i][KeyName]);
                    }
                });
            }
        };

        this.UpdateGroupMessages = async function (messages, over, limit) {
            const newGroupIDList = [];
            if (messages) {
                Object.keys(messages).forEach((groupID) => {
                    newGroupIDList.push(groupID);
                });
                const oldGroupList = await EChat.IndexedDB.GetTableDataByKeyList(EChat.DBTableName.GROUPINFO, newGroupIDList);

                for (let i = 0, len = newGroupIDList.length; i < len; i++) {
                    const groupID = newGroupIDList[i];
                    const newMessages = messages[groupID];
                    let oldGroup = oldGroupList[groupID];
                    if (!oldGroup) {
                        oldGroup = await EChat.DataProvider.GetGroupInfoByGroupID(groupID, true);
                    }
                    if (oldGroup) {
                        if (over) {
                            oldGroup.Messages = mergeGroupMessage(null, newMessages, limit);
                        } else {
                            oldGroup.Messages = mergeGroupMessage(oldGroup.Messages, newMessages, limit);
                        }
                        await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.GROUPINFO, oldGroup);

                        if (oldGroup.GroupType === SocketUtil.GroupType.Task) {
                            const mergeTask = await EChat.IndexedDB.GetTableDataByKey(EChat.DBTableName.TASKS, oldGroup.TaskID);
                            if (oldGroup.Messages && oldGroup.Messages.length > 0) {
                                const tmpLastMessage = oldGroup.Messages[0];
                                if (!mergeTask.LastMessage || mergeTask.LastMessage.TimeCreated <= tmpLastMessage.TimeCreated) {
                                    mergeTask.LastMessage = tmpLastMessage;
                                    await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.TASKS, mergeTask);
                                }
                            }
                        }
                    }
                }
            }
            return newGroupIDList;
        };

        this.UpdateGroupUsers = async function (groupUsers, Notice) {
            const newGroupIDList = [];
            if (groupUsers) {
                Object.keys(groupUsers).forEach((groupId) => {
                    newGroupIDList.push(groupId);
                });
                const oldGroupList = await EChat.IndexedDB.GetTableDataByKeyList(EChat.DBTableName.GROUPINFO, newGroupIDList);
                for (let i = 0, len = newGroupIDList.length; i < len; i++) {
                    const groupId = newGroupIDList[i];
                    const newUsers = groupUsers[groupId];
                    const oldGroup = oldGroupList[groupId];
                    if (oldGroup) {
                        oldGroup.Users = newUsers;
                        await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.GROUPINFO, oldGroup);
                    }
                }

                if (Notice) {
                    _this.NoticeUpdate(EChat.DBTableName.GROUPINFO, newGroupIDList);
                }
            }
            return newGroupIDList;
        };

        this.UpdateGroupObject = async function ({
            GroupInfos, GroupUsers, GroupMessages, GroupReads
        }) {
            let changeGroupIDArr = [];

            if (GroupInfos) {
                changeGroupIDArr = changeGroupIDArr.concat(await _this.UpdateGroupInfo(GroupInfos));
            }

            if (GroupUsers) {
                changeGroupIDArr = changeGroupIDArr.concat(await _this.UpdateGroupUsers(GroupUsers));
            }

            if (GroupMessages) {
                changeGroupIDArr = changeGroupIDArr.concat(await _this.UpdateGroupMessages(GroupMessages, false, true));
            }

            if (GroupReads) {
                changeGroupIDArr = changeGroupIDArr.concat(await _this.UpdateGroupReads(GroupReads));
            }

            changeGroupIDArr = Array.from(new Set(changeGroupIDArr));

            return changeGroupIDArr;
        };

        this.UpdateGroupInfo = async function (groupList, Notice) {
            const newGroupIDList = [];
            if (groupList?.length > 0) {
                for (let i = 0, len = groupList.length; i < len; i++) {
                    newGroupIDList.push(groupList[i].MessageGroupID);
                }
                const oldGroupList = await EChat.IndexedDB.GetTableDataByKeyList(EChat.DBTableName.GROUPINFO, newGroupIDList);
                for (let i = 0, len = newGroupIDList.length; i < len; i++) {
                    const newGroup = groupList[i];
                    const oldGroup = oldGroupList[newGroup.MessageGroupID];
                    const margeGroup = margeGroupInfo(oldGroup, newGroup);

                    await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.GROUPINFO, margeGroup);
                }
                if (Notice) {
                    _this.NoticeUpdate(EChat.DBTableName.GROUPINFO, newGroupIDList);
                }
            }
            return newGroupIDList;
        };

        // New
        this.UpdateTaskGroup = async function (taskGroups) {
            const TaskIDList = [];
            for (let i = 0, len = taskGroups.length; i < len; i++) {
                TaskIDList.push(taskGroups[i].TaskID);
            }

            const oldTaskList = await EChat.IndexedDB.GetTableDataByKeyList(EChat.DBTableName.TASKS, TaskIDList);
            for (let i = 0; i < taskGroups.length; i++) {
                const taskGroup = taskGroups[i];
                const taskID = taskGroup.TaskID;
                if (oldTaskList[taskID]) {
                    const oldGroupList = oldTaskList[taskID].MessageGroups;
                    for (let j = 0; j < oldGroupList.length; j++) {
                        const oldGroup = oldGroupList[j];
                        if (taskGroup.MessageGroupID === oldGroup.MessageGroupID) {
                            oldGroupList[j] = taskGroup;
                        }
                    }
                } else {
                    oldTaskList[taskID] = { TaskID: taskID, MessageGroups: [taskGroup] };
                }
            }
            const oldTaskIdList = Object.keys(oldTaskList);
            for (let i = 0, len = oldTaskIdList.length; i < len; i++) {
                await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.TASKS, oldTaskList[oldTaskIdList[i]]);
            }
        };

        this.UpdateGroupReads = async function (groupReads, Notice) {
            const newGroupIDList = [];
            if (groupReads) {
                for (let i = 0, len = groupReads.length; i < len; i++) {
                    newGroupIDList.push(groupReads[i].MessageGroupID);
                }
                const oldGroupList = await EChat.IndexedDB.GetTableDataByKeyList(EChat.DBTableName.GROUPINFO, newGroupIDList);
                for (let i = 0, len = groupReads.length; i < len; i++) {
                    const groupRead = groupReads[i];
                    const oldGroup = oldGroupList[groupRead.MessageGroupID];
                    if (oldGroup) {
                        oldGroup.LastReadTime = groupRead.LastReadTime;
                        oldGroup.ReadCount = groupRead.ReadCount;
                        oldGroup.MessageCount = groupRead.MessageCount;
                        oldGroup.UnReadCount = groupRead.UnReadCount;
                        oldGroup.MessageUpdated = groupRead.MessageUpdated;
                        oldGroup.Prompt = groupRead.Prompt;
                        oldGroup.PostPermission = groupRead.PostPermission;

                        await EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.GROUPINFO, oldGroup);
                    }
                }

                if (Notice) {
                    _this.NoticeUpdate(EChat.DBTableName.GROUPINFO, newGroupIDList);
                }
            }
            return newGroupIDList;
        };

        this.AsyncLock = {};
        this.SyncExecue = function (lockName, fun, arg1, arg2, arg3) {
            return new Promise((resolve) => {
                _this.AsyncLock[lockName] = SyncQueue(_this.AsyncLock[lockName], fun, arg1, arg2, arg3).finally(resolve);
            });
        };

        const SyncQueue = function (lockPromiss, fun, arg1, arg2, arg3) {
            return new Promise((resolve) => {
                if (lockPromiss) {
                    lockPromiss.finally(() => {
                        fun(arg1, arg2, arg3).finally(resolve);
                    });
                } else {
                    fun(arg1, arg2, arg3).finally(resolve);
                }
            });
        };

        this.UpdateGroupUnread = async function (groupIdArr, unreadCount, absoluteValue) {
            await _this.SyncExecue("UpdateGroupUnread", UpdateGroupUnreadSubThread, groupIdArr, unreadCount, absoluteValue);
        };

        const UpdateGroupUnreadSubThread = async function (groupIdArr, unreadCount, absoluteValue) {
            const UnreadGroup = await EChat.IndexedDB.GetSetting("UnreadGroup");
            if (!UnreadGroup) {
                return;
            }
            let hasChange = false;
            let Notice = false;

            for (let i = 0; i < groupIdArr.length; i++) {
                const MessageGroupID = groupIdArr[i];
                if (parseInt(unreadCount) === 0 && !EC_Fmt.isNull(UnreadGroup[MessageGroupID])) {
                    delete UnreadGroup[MessageGroupID];
                    hasChange = true;
                    Notice = true;
                } else if (unreadCount > 0) {
                    hasChange = true;
                    if (EC_Fmt.isNull(UnreadGroup[MessageGroupID])) {
                        Notice = true;
                        UnreadGroup[MessageGroupID] = unreadCount;
                    } else if (absoluteValue) {
                        UnreadGroup[MessageGroupID] = unreadCount;
                    } else {
                        UnreadGroup[MessageGroupID] += unreadCount;
                    }
                }
            }

            if (hasChange) {
                await _this.UpdateSetting("UnreadGroup", UnreadGroup, Notice);
                await EChat.MainPageController.unreadSumCountChange(UnreadGroup);
            }
        };

        const DeleteGroup = async function (deleteGroups) {
            for (let i = 0, len = deleteGroups.length; i < len; i++) {
                await EChat.DataProvider.deleteGroupData(deleteGroups[i], true, false);
            }
            if (deleteGroups.length > 0) {
                await EChat.MainPageController.updateUnReadNumIcon("group delete");
            }
        };

        this.InitDBData = async function (retry, force) {
            if (!force) {
                const ConnectionTime = await EChat.IndexedDB.GetSetting("ConnectionTime");
                let LastSyncLocalDate = await EChat.IndexedDB.GetSetting("LastSyncLocalDate");
                if (EC_Fmt.isNull(LastSyncLocalDate)) {
                    LastSyncLocalDate = -1;
                }

                if (ConnectionTime <= LastSyncLocalDate) {
                    return;
                }
            }

            try {
                EChat.InitDataing = true;
                EChat.Util.Loading(true);

                const data = await EChat.DataProvider.SyncData();
                const changeGroupIDArr = await _this.UpdateGroupObject({
                    GroupInfos: data.MessageGroups,
                    GroupUsers: data.GroupUsers,
                    GroupMessages: data.Messages,
                    GroupReads: data.GroupReads
                });

                await DeleteGroup(data.DeleteGroups);

                await _this.UpdateSetting("LastSyncDate", data.LastSyncDate);
                if (data.SavedMessages) {
                    await _this.UpdateSetting("SavedMessages", data.SavedMessages, true);
                    EChat.DataProvider.SavedMessage = data.SavedMessages;
                    await EChat.MainPageController.refreshSavedMessage();
                }

                if (data.GroupHistorySyncDate) {
                    await _this.UpdateSetting("GroupHistorySyncDate", data.GroupHistorySyncDate);
                }
                _this.NoticeUpdate(EChat.DBTableName.GROUPINFO, changeGroupIDArr);
                await _this.UpdateSetting("LastSyncLocalDate", EChat.Util.getTimeStamp());
            } catch (e) {
                if (!retry) {
                    retry = 1;
                } else {
                    retry++;
                }

                if (retry < 3) {
                    setTimeout(() => {
                        // eslint-disable-next-line no-console
                        console.log(`InitDBData retry ${retry}`);
                        _this.InitDBData(retry, true);
                    }, 2000);
                    return;
                }
                EChat.MainPageController.RefreshBtnColor("red");
                EChat.InitDataing = false;
                EChat.Util.Loading(false);
                await _this.InitViewData();
                return;
            }

            await _this.InitViewData();

            EChat.MainPageController.RefreshBtnColor("var(--neutral-70)");
            EChat.InitDataing = false;
            EChat.Util.Loading(false);
        };

        this.InitViewData = async function () {
            if (EChat.eChatState) {
                // Init CurrentUser Availability
                const recentList = await _this.GetTableAllData(EChat.DBTableName.GROUPINFO);

                if (recentList) {
                    await EChat.MainPageController.dataCompleteEvent({
                        Recent: recentList
                    });
                }
            } else {
                EChat.MainPageController.updateUnReadNumIcon("init view data");
            }
        };

        const margeGroupInfo = function (oldGroup, newGroup) {
            let margeGroup = {};
            if (oldGroup && newGroup) {
                margeGroup.MessageGroupID = oldGroup.MessageGroupID;
                if (newGroup.GroupCode) {
                    margeGroup.GroupCode = newGroup.GroupCode;
                } else {
                    margeGroup.GroupCode = oldGroup.GroupCode;
                }

                if (newGroup.GroupType) {
                    margeGroup.GroupType = newGroup.GroupType;
                } else {
                    margeGroup.GroupType = oldGroup.GroupType;
                }

                if (newGroup.UserCount > -1) {
                    margeGroup.UserCount = newGroup.UserCount;
                } else {
                    margeGroup.UserCount = oldGroup.UserCount;
                }

                if (newGroup.GroupName !== null && newGroup.GroupName !== undefined) {
                    margeGroup.GroupName = newGroup.GroupName;
                } else {
                    margeGroup.GroupName = oldGroup.GroupName;
                }

                if (newGroup.Icon !== null && newGroup.Icon !== undefined) {
                    margeGroup.Icon = newGroup.Icon;
                } else {
                    margeGroup.Icon = oldGroup.Icon;
                }

                if (newGroup.LastReadTime !== null && newGroup.LastReadTime !== undefined) {
                    margeGroup.LastReadTime = newGroup.LastReadTime;
                } else {
                    margeGroup.LastReadTime = oldGroup.LastReadTime;
                }

                if (newGroup.UnReadCount !== null && newGroup.UnReadCount !== undefined) {
                    margeGroup.UnReadCount = newGroup.UnReadCount;
                } else {
                    margeGroup.UnReadCount = oldGroup.UnReadCount;
                }

                if (newGroup.MessageUpdated !== null && newGroup.MessageUpdated !== undefined) {
                    margeGroup.MessageUpdated = newGroup.MessageUpdated;
                } else {
                    margeGroup.MessageUpdated = oldGroup.MessageUpdated;
                }

                if (newGroup.TimeUpdated !== null && newGroup.TimeUpdated !== undefined) {
                    margeGroup.TimeUpdated = newGroup.TimeUpdated;
                } else {
                    margeGroup.TimeUpdated = oldGroup.TimeUpdated;
                }

                if (newGroup.TimeCreated !== null && newGroup.TimeCreated !== undefined) {
                    margeGroup.TimeCreated = newGroup.TimeCreated;
                } else {
                    margeGroup.TimeCreated = oldGroup.TimeCreated;
                }

                if (newGroup.CreatedBy !== null && newGroup.CreatedBy !== undefined) {
                    margeGroup.CreatedBy = newGroup.CreatedBy;
                } else {
                    margeGroup.CreatedBy = oldGroup.CreatedBy;
                }

                if (newGroup.UserUpdated !== null && newGroup.UserUpdated !== undefined) {
                    margeGroup.UserUpdated = newGroup.UserUpdated;
                } else {
                    margeGroup.UserUpdated = oldGroup.UserUpdated;
                }

                if (newGroup.EncompassID !== null && newGroup.EncompassID !== undefined) {
                    margeGroup.EncompassID = newGroup.EncompassID;
                } else {
                    margeGroup.EncompassID = oldGroup.EncompassID;
                }

                if (newGroup.UpdatedBy !== null && newGroup.UpdatedBy !== undefined) {
                    margeGroup.UpdatedBy = newGroup.UpdatedBy;
                } else {
                    margeGroup.UpdatedBy = oldGroup.UpdatedBy;
                }

                if (newGroup.TaskID !== null && newGroup.TaskID !== undefined) {
                    margeGroup.TaskID = newGroup.TaskID;
                } else {
                    margeGroup.TaskID = oldGroup.TaskID;
                }

                if (newGroup.DisplayName !== null && newGroup.DisplayName !== undefined) {
                    margeGroup.DisplayName = newGroup.DisplayName;
                } else {
                    margeGroup.DisplayName = oldGroup.DisplayName;
                }

                if (newGroup.Users !== null && newGroup.Users !== undefined && newGroup.Users.length > 0) {
                    margeGroup.Users = newGroup.Users;
                } else if (oldGroup.Users !== null && oldGroup.Users !== undefined && oldGroup.Users.length > 0) {
                    margeGroup.Users = oldGroup.Users;
                }

                if (newGroup.Prompt !== null && newGroup.Prompt !== undefined) {
                    margeGroup.Prompt = newGroup.Prompt;
                } else if (oldGroup.Prompt !== null && newGroup.Prompt !== undefined) {
                    margeGroup.Prompt = oldGroup.Prompt;
                } else {
                    margeGroup.Prompt = EChat.PromptType.Normal;
                }

                if (newGroup.PostPermission !== null && newGroup.PostPermission !== undefined) {
                    margeGroup.PostPermission = newGroup.PostPermission;
                } else if (oldGroup.PostPermission !== null && newGroup.PostPermission !== undefined) {
                    margeGroup.PostPermission = oldGroup.PostPermission;
                } else {
                    margeGroup.PostPermission = EChat.PostPermissionType.Post;
                }

                if (newGroup.LastSenderAuthenticationID !== null && newGroup.LastSenderAuthenticationID !== undefined) {
                    margeGroup.LastSenderAuthenticationID = newGroup.LastSenderAuthenticationID;
                } else {
                    margeGroup.LastSenderAuthenticationID = oldGroup.LastSenderAuthenticationID;
                }

                if (newGroup.LastSenderFullName !== null && newGroup.LastSenderFullName !== undefined) {
                    margeGroup.LastSenderFullName = newGroup.LastSenderFullName;
                } else {
                    margeGroup.LastSenderFullName = oldGroup.LastSenderFullName;
                }

                if (newGroup.LastSenderUserAvatar !== null && newGroup.LastSenderUserAvatar !== undefined) {
                    margeGroup.LastSenderUserAvatar = newGroup.LastSenderUserAvatar;
                } else {
                    margeGroup.LastSenderUserAvatar = oldGroup.LastSenderUserAvatar;
                }

                if (newGroup.LastMessageBody !== null && newGroup.LastMessageBody !== undefined) {
                    margeGroup.LastMessageBody = newGroup.LastMessageBody;
                } else {
                    margeGroup.LastMessageBody = oldGroup.LastMessageBody;
                }

                if (newGroup.LastMessageID !== null && newGroup.LastMessageID !== undefined) {
                    margeGroup.LastMessageID = newGroup.LastMessageID;
                } else {
                    margeGroup.LastMessageID = oldGroup.LastMessageID;
                }

                margeGroup.Messages = mergeGroupMessage(oldGroup.Messages, newGroup.Messages, false);

                // Task 441343
            } else if (!newGroup) {
                margeGroup = oldGroup;
            } else if (!oldGroup) {
                margeGroup = newGroup;
            }

            if (margeGroup && !margeGroup.Messages) {
                margeGroup.Messages = [];
            }

            if (margeGroup && !margeGroup.Users) {
                margeGroup.Users = [];
            }

            if (margeGroup.DisplayName && EChat.DataProvider.CurrentUserInfo && margeGroup.DisplayName !== EChat.DataProvider.CurrentUserInfo.FullName) {
                margeGroup.DisplayName = margeGroup.DisplayName.replace(`${EChat.DataProvider.CurrentUserInfo.FullName}, `, "").replace(`, ${EChat.DataProvider.CurrentUserInfo.FullName}`, "");
            }

            return margeGroup;
        };

        const mergeGroupMessage = function (oldMessageList, newMessageList, limit) {
            let mergeMessageList = oldMessageList;
            if (newMessageList && mergeMessageList) {
                for (let i = 0, len = newMessageList.length; i < len; i++) {
                    const newMessage = newMessageList[i];
                    let isExist = false;
                    for (let j = 0, len2 = mergeMessageList.length; j < len2; j++) {
                        if (newMessage.MessageID === mergeMessageList[j].MessageID) {
                            mergeMessageList[j] = newMessage;
                            isExist = true;
                            break;
                        }
                    }

                    if (!isExist) {
                        mergeMessageList.push(newMessage);
                    }
                }
            } else if (!mergeMessageList) {
                mergeMessageList = newMessageList;
            } else if (!newMessageList) {
                mergeMessageList = oldMessageList;
            }

            if (!mergeMessageList) {
                mergeMessageList = [];
            }

            mergeMessageList = mergeMessageList.sort((a, b) => b.TimeCreated - a.TimeCreated);
            if (limit) {
                mergeMessageList.length = Math.min(mergeMessageList.length, 200);
            }

            return mergeMessageList;
        };

        this.NoticeUpdate = function (TableName, keyList) {
            if (keyList?.length > 0) {
                EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.DBUPDATE, JSON.stringify({
                    TableName,
                    Time: EChat.Util.getTimeStamp(),
                    Key: keyList
                }));
            }
        };

        this.InsertOrUpdate = function (tableName, DataObj) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tableName, READ_WRITE);
                    const store = transaction.objectStore(tableName);
                    try {
                        const request = store.put(DataObj);
                        request.onerror = function () {
                            db.close();
                            IndexedDBThrowError(`db put error:${request.error}`);
                            reject();
                        };

                        request.onsuccess = function () {
                            db.close();
                            resolve(DataObj);
                        };
                    } catch (e) {
                        db.close();
                        // eslint-disable-next-line no-console
                        console.error(DataObj);
                        IndexedDBThrowError(`db put error:${e.message}`);
                        reject();
                    }
                });
            }));
        };

        this.GetRecentGroupList = function (LastMessageTimeCreated, MinTime) {
            return new Promise(((resolve) => {
                LastMessageTimeCreated = parseInt(LastMessageTimeCreated);
                const Groups = [];
                const Limit = 20;
                let MinMessageTimeCreated = -1;
                if (LastMessageTimeCreated >= 0) {
                    _this.GetTableAllData(EChat.DBTableName.GROUPINFO).then((GroupList) => {
                        if (GroupList) {
                            const sortGroup = GroupList.sort((a, b) => _this.GetGroupSortTime(b) - _this.GetGroupSortTime(a));
                            const checkGroup = function (groupInfo) {
                                if (groupInfo.GroupType === SocketUtil.GroupType.Message) {
                                    return true;
                                }
                                if (groupInfo.GroupType === SocketUtil.GroupType.Task) {
                                    return true;
                                }
                                if (groupInfo.GroupType === SocketUtil.GroupType.System) {
                                    return true;
                                }
                                return false;
                            };

                            let count = 0;
                            for (let i = 0, len = sortGroup.length; i < len; i++) {
                                // Task 695920: Showing unread echat notifications when there are no unread echats
                                if (checkGroup(sortGroup[i])) {
                                    const sortTime = EChat.IndexedDB.GetGroupSortTime(sortGroup[i]);
                                    if (sortTime < LastMessageTimeCreated || LastMessageTimeCreated === 0) {
                                        if (sortTime >= MinTime) {
                                            Groups.push(GroupList[i]);
                                            count++;
                                        }
                                    }
                                }
                                if (count >= Limit) {
                                    break;
                                }
                            }
                            if (count) {
                                MinMessageTimeCreated = _this.GetGroupSortTime(Groups[Groups.length - 1]);
                            }

                            resolve({ Groups, LastMessageTimeCreated: MinMessageTimeCreated });
                        }
                    });
                } else {
                    resolve({ Groups, LastMessageTimeCreated });
                }
            }));
        };

        this.GetGroupSortTime = function (groupInfo) {
            let sortTime = 0;
            if (groupInfo) {
                sortTime = parseInt(groupInfo.MessageUpdated);
                if (groupInfo.Messages && groupInfo.Messages.length > 0 && groupInfo.GroupType !== SocketUtil.GroupType.Task) {
                    sortTime = parseInt(groupInfo.Messages[0].TimeCreated);
                }
            }
            return sortTime;
        };

        this.UpdateSetting = function (Key, Value, Notice) {
            return new Promise(((resolve) => {
                EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.SETTINGS, { Key, Value }).then(() => {
                    if (Notice) {
                        _this.NoticeUpdate(EChat.DBTableName.SETTINGS, [Key]);
                    }
                    resolve();
                }).catch(() => {
                    resolve();
                });
            }));
        };

        this.GetTableAllData = function (tableName, limit) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tableName, READ_ONLY);
                    const objectStore = transaction.objectStore(tableName);
                    const request = objectStore.openCursor();
                    let count = 0;
                    const DataList = [];

                    request.onerror = function () {
                        db.close();
                        IndexedDBThrowError(`db GetTableAllData error: ${request.error}`);
                        reject();
                    };

                    request.onsuccess = function (event) {
                        const cursor = event.target.result;

                        if (cursor) {
                            DataList.push(cursor.value);
                            count++;
                            if (!limit || (limit - count) > 0) {
                                cursor.continue();
                            } else {
                                db.close();
                                resolve(DataList);
                            }
                        } else {
                            db.close();
                            resolve(DataList);
                        }
                    };
                });
            }));
        };

        this.GetTableDataByIndex = function (tableName, index, key) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tableName, READ_ONLY);
                    const objectStore = transaction.objectStore(tableName);
                    const dbIndex = objectStore.index(index);
                    const request = dbIndex.openCursor(IDBKeyRange.only(key));

                    const DataList = [];

                    request.onerror = function () {
                        db.close();
                        IndexedDBThrowError(`db GetTableAllData error: ${request.error}`);
                        reject();
                    };

                    request.onsuccess = function (event) {
                        const cursor = event.target.result;

                        if (cursor) {
                            DataList.push(cursor.value);
                            cursor.continue();
                        } else {
                            db.close();
                            resolve(DataList);
                        }
                    };
                });
            }));
        };

        this.GetTableDataByKeyList = function (tableName, keyList) {
            return new Promise(((resolve) => {
                if (keyList?.length > 0) {
                    _this.getDB().then((db) => {
                        const transaction = db.transaction(tableName, READ_ONLY);
                        const objectStore = transaction.objectStore(tableName);
                        const DataDic = {};

                        for (let i = 0, len = keyList.length; i < len; i++) {
                            let key = keyList[i];
                            if (tableName === EChat.DBTableName.TABLEALERTS) {
                                key = parseInt(key);
                                if (!EC_Fmt.isNumber(key)) {
                                    key = null;
                                }
                            }

                            // Task 673775: Constant Javascript errors for a specific user - Error in promise - DataError: Failed to execute 'get' on 'IDBObjectStore': No key or key range specified.
                            if (!EC_Fmt.isNull(key)) {
                                objectStore.get(key).onsuccess = function (event) {
                                    const cursor = this.result;
                                    if (cursor !== null && cursor !== undefined) {
                                        const primaryKey = event.target.source.keyPath;
                                        DataDic[cursor[primaryKey]] = cursor;
                                    }
                                };
                            }
                        }

                        transaction.oncomplete = function () {
                            db.close();
                            resolve(DataDic);
                        };
                    });
                } else {
                    resolve({});
                }
            }));
        };

        this.GetTableDataByKey = function (tabeName, key) {
            return new Promise(((resolve) => {
                if (tabeName === EChat.DBTableName.USERS) {
                    EChat.DataProvider.GetUserInfo([key]).then((users) => {
                        if (users.length === 1) {
                            resolve(users[0]);
                        } else {
                            resolve(null);
                        }
                    });
                    return;
                }
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tabeName, READ_ONLY);
                    const objectStore = transaction.objectStore(tabeName);
                    let DataObj = null;
                    if (!EC_Fmt.isNull(key)) {
                        const request = objectStore.get(key);

                        request.onerror = function () {
                            db.close();
                            IndexedDBThrowError(`GetTableDataByKey error:${request.error}`);
                            resolve(null);
                        };

                        request.onsuccess = function () {
                            DataObj = request.result;
                            db.close();
                            resolve(DataObj);
                        };
                    } else {
                        db.close();
                        resolve(null);
                    }
                });
            }));
        };

        this.GetTableDataCount = function (tabeName) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tabeName, READ_ONLY);
                    const objectStore = transaction.objectStore(tabeName);
                    let Count = 0;
                    const request = objectStore.count();

                    request.onerror = function () {
                        db.close();
                        IndexedDBThrowError(`GetTableDataCount error:${request.error}`);
                        reject();
                    };

                    request.onsuccess = function () {
                        Count = request.result;
                        db.close();
                        resolve(Count);
                    };
                });
            }));
        };

        this.DeleteTableDataByKey = function (tabeName, key, Notice) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tabeName, READ_WRITE);
                    const objectStore = transaction.objectStore(tabeName);
                    const request = objectStore.delete(key);
                    if (!EC_Fmt.isNull(key)) {
                        request.onerror = function () {
                            db.close();
                            IndexedDBThrowError(`DeleteTableDataByKey error:${request.error}`);
                            reject();
                        };

                        request.onsuccess = function () {
                            if (Notice) {
                                EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.DBDELETED, JSON.stringify({
                                    TableName: tabeName,
                                    Time: EChat.Util.getTimeStamp(),
                                    Key: [key]
                                }));
                            }
                            db.close();
                            resolve(key);
                        };
                    } else {
                        db.close();
                        reject();
                    }
                });
            }));
        };

        this.DeleteTableDataByKeyList = function (tabeName, keyList, Notice) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tabeName, READ_WRITE);
                    const objectStore = transaction.objectStore(tabeName);
                    let request = null;
                    for (let i = 0, len = keyList.length; i < len; i++) {
                        const key = keyList[i];
                        if (i === keyList.length - 1) {
                            request = objectStore.delete(key);
                        } else {
                            objectStore.delete(key);
                        }
                    }

                    request.onerror = function () {
                        db.close();
                        IndexedDBThrowError(`DeleteTableDataByKeyList error:${request.error}`);
                        reject();
                    };

                    request.onsuccess = function () {
                        if (Notice && keyList?.length > 0) {
                            EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.DBDELETED, JSON.stringify({
                                TableName: tabeName,
                                Time: EChat.Util.getTimeStamp(),
                                Key: keyList
                            }));
                        }
                        db.close();
                        resolve(keyList);
                    };
                });
            }));
        };

        this.DeleteTableAllData = function (tabeName, Notice) {
            return new Promise(((resolve) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tabeName, READ_WRITE);
                    const objectStore = transaction.objectStore(tabeName);
                    const request = objectStore.clear();

                    request.onerror = function () {
                        db.close();
                        resolve();
                        IndexedDBThrowError(`DeleteTableAllData error:${request.error}`);
                    };

                    request.onsuccess = function () {
                        if (Notice) {
                            EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.DBDELETED, JSON.stringify({
                                TableName: tabeName,
                                Time: EChat.Util.getTimeStamp(),
                                Key: []
                            }));
                        }
                        db.close();
                        resolve();
                    };
                });
            }));
        };

        this.DropTable = function (tabeName, Notice) {
            return new Promise(((resolve, reject) => {
                _this.getDB().then((db) => {
                    const transaction = db.transaction(tabeName, READ_WRITE);
                    const objectStore = transaction.objectStore(tabeName);
                    const request = objectStore.clear();

                    request.onerror = function () {
                        db.close();
                        IndexedDBThrowError(`DeleteTableAllData error:${request.error}`);
                        reject();
                    };

                    request.onsuccess = function () {
                        if (Notice) {
                            EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.DBDELETED, JSON.stringify({
                                TableName: tabeName,
                                Time: EChat.Util.getTimeStamp(),
                                Key: []
                            }));
                        }
                        db.close();
                        resolve();
                    };
                });
            }));
        };

        this.UpdateTableAlert = function (TableAlertList, Notice) {
            return new Promise(((resolve) => {
                const keyList = [];
                const errorList = [];
                if (TableAlertList?.length > 0) {
                    const lastKey = TableAlertList[TableAlertList.length - 1].AlertID;

                    for (let i = 0; i < TableAlertList.length; i++) {
                        keyList.push(TableAlertList[i].AlertID);
                        EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.TABLEALERTS, TableAlertList[i]).then((newData) => {
                            if (lastKey === newData.AlertID) {
                                if (Notice) {
                                    _this.NoticeUpdate(EChat.DBTableName.TABLEALERTS, keyList);
                                }
                                resolve();
                            }
                        }).catch((newData) => {
                            errorList.push(newData.AlertID);
                            if (lastKey === newData.AlertID) {
                                resolve(errorList);
                            }
                        });
                    }
                } else {
                    resolve();
                }
            }));
        };

        this.UpdateSentMessage = function (webscoketMessage, Notice) {
            return new Promise(((resolve, reject) => {
                EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.SENDMESSAGES, webscoketMessage).then(() => {
                    if (Notice) {
                        _this.NoticeUpdate(EChat.DBTableName.SENDMESSAGES, [webscoketMessage.TimeStamp]);
                    }
                    resolve();
                }).catch(() => {
                    reject();
                });
            }));
        };

        this.WriteError = function (msg, stack) {
            return new Promise(((resolve, reject) => {
                let stackTrace = "";
                if (stack) {
                    stackTrace = stack;
                }

                EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.LOG, {
                    TimeStamp: EChat.Util.getTimeStamp(), ErrorType: "ErrorType", Message: msg, Stack: stackTrace
                }).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            }));
        };

        this.WriteDebug = function (msg) {
            return new Promise(((resolve, reject) => {
                EChat.IndexedDB.InsertOrUpdate(EChat.DBTableName.LOG, { TimeStamp: EChat.Util.getTimeStamp(), ErrorType: "Debug", Message: msg }).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            }));
        };

        this.InsertMessage = function (message, addUnreadCount, Notice) {
            return new Promise(((resolve, reject) => {
                if (message !== null && message !== undefined && message.MessageGroupID) {
                    EChat.DataProvider.GetGroupInfoByGroupID(message.MessageGroupID).then((groupInfo) => {
                        let isExist = false;
                        for (let i = 0, len = groupInfo.Messages.length; i < len; i++) {
                            if (groupInfo.Messages[i].MessageID === message.MessageID) {
                                isExist = true;
                                break;
                            }
                        }
                        if (!isExist) {
                            message.TimeUpdated = message.TimeCreated;
                            groupInfo.Messages.push(message);
                            groupInfo.Messages = groupInfo.Messages.sort((a, b) => b.TimeCreated - a.TimeCreated);
                            groupInfo.Messages.length = Math.min(groupInfo.Messages.length, 200);
                            groupInfo.MessageUpdated = message.TimeCreated;
                            if (addUnreadCount) {
                                if (groupInfo.UnReadCount) {
                                    groupInfo.UnReadCount++;
                                } else {
                                    groupInfo.UnReadCount = 1;
                                }
                            }

                            _this.InsertOrUpdate(EChat.DBTableName.GROUPINFO, groupInfo).then(async () => {
                                // Update Unread Sum Count
                                if (!EChat.DataProvider.IsCurrentUser(message.SenderAuthenticationID) && addUnreadCount) {
                                    if (message.DataInfo && message.DataInfo.TaskID) {
                                        await EChat.IndexedDB.UpdateGroupUnread([`${message.MessageGroupID}_${message.DataInfo.TaskID}`], 1, false);
                                    } else if (groupInfo.Prompt !== EChat.PromptType.DoNotDisturb) {
                                        await EChat.IndexedDB.UpdateGroupUnread([message.MessageGroupID], 1, false);
                                    }
                                }
                                if (!EChat.eChatState) {
                                    EChat.MainPageController.updateUnReadNumIcon("Receive message.");
                                }

                                await EChat.MainPageController.redrawGroupEvent(groupInfo);

                                if (Notice) {
                                    _this.NoticeUpdate(EChat.DBTableName.GROUPINFO, [groupInfo.MessageGroupID]);
                                }
                                resolve();
                            }).catch((ex) => {
                                // eslint-disable-next-line no-console
                                console.error(ex);
                                reject(ex);
                            });
                        } else {
                            resolve();
                        }
                    }).catch(() => {
                        // eslint-disable-next-line no-console
                        console.error(ex);
                        reject();
                    });
                } else {
                    reject();
                }
            }));
        };

        this.InsertTaskDetail = function (message) {
            return new Promise(((resolve) => {
                if (message?.MessageGroupID && message?.TaskID) {
                    const key = `${message.TaskSourceEncompassID}_${message.TaskID}`;

                    EChat.DataProvider.GetGroupInfoByGroupID(key).then((groupInfo) => {
                        groupInfo.MessageUpdated = message.TimeCreated;
                        if (!EChat.DataProvider.IsCurrentUser(message.SenderAuthenticationID)) {
                            if (groupInfo.UnReadCount) {
                                groupInfo.UnReadCount++;
                            } else {
                                groupInfo.UnReadCount = 1;
                            }
                        }

                        groupInfo.LastMessageBody = message.Message;
                        groupInfo.LastSenderUserAvatar = message.SenderUserAvatar;
                        groupInfo.LastSenderAuthenticationID = message.SenderAuthenticationID;
                        groupInfo.LastSenderFullName = message.SenderFullName;
                        groupInfo.LastMessageID = message.MessageID;

                        _this.InsertOrUpdate(EChat.DBTableName.GROUPINFO, groupInfo).then(() => {
                            // Update Unread Sum Count
                            if (!EChat.DataProvider.IsCurrentUser(message.SenderAuthenticationID)) {
                                EChat.IndexedDB.UpdateGroupUnread([key], 1, false);
                            }
                            if (!EChat.eChatState) {
                                EChat.MainPageController.updateUnReadNumIcon("Receive task detial.");
                            }

                            EChat.LocalStorage.writeLocalStorage(EChat.LocalStorageType.RECEIVETASKDETAIL, JSON.stringify(message));
                            EChat.MainPageController.receiveTaskDetail(message, false);
                            resolve();
                        }).catch((ex) => {
                            // eslint-disable-next-line no-console
                            console.error(ex);
                            resolve();
                        });
                    }).catch((ex) => {
                        // eslint-disable-next-line no-console
                        console.error(ex);
                        resolve();
                    });
                } else {
                    resolve();
                }
            }));
        };

        this.CheckCurrentDBAuthID = function (newAuthID) {
            return new Promise(((resolve) => {
                _this.GetSetting("CurrentUser").then((CurrentUser) => {
                    if (!CurrentUser || !CurrentUser.AuthenticationID || parseInt(CurrentUser.AuthenticationID) !== parseInt(newAuthID) || Distributor !== CurrentUser.EncompassID) {
                        _this.ClearDateBase().then(() => {
                            if (SocketUtil.GetSocketState() === SocketUtil.SocketState.Connect) {
                                SocketUtil.Reconnect();
                            }
                            if (EChat.MainPageController) {
                                EChat.MainPageController.closeAllWindow();
                            }
                            _this.UpdateSetting("CurrentUser", { AuthenticationID: newAuthID, EncompassID: Distributor }).then(async () => {
                                await EChat.IndexedDB.UpdateSetting("EChatV2010", EChat.Util.getTimeStamp(), false);
                                resolve();
                            });
                        });
                    } else {
                        resolve();
                    }
                }).catch(() => {
                    resolve();
                });
            }));
        };

        this.ClearDateBase = async function () {
            await _this.DeleteTableAllData(EChat.DBTableName.GROUPINFO, true);
            await _this.DeleteTableAllData(EChat.DBTableName.SETTINGS, true);
            await _this.DeleteTableAllData(EChat.DBTableName.TABLEALERTS, true);
            await _this.DeleteTableAllData(EChat.DBTableName.SENDMESSAGES, true);
            await _this.DeleteTableAllData(EChat.DBTableName.TASKS, true);
            await _this.DeleteTableAllData(EChat.DBTableName.LOG, true);
        };

        this.GetSetting = function (SettingName) {
            return new Promise(((resolve) => {
                _this.GetTableDataByKey(EChat.DBTableName.SETTINGS, SettingName).then((Setting) => {
                    if (Setting && Setting.Value !== null && Setting.Value !== undefined) {
                        resolve(Setting.Value);
                    } else {
                        resolve(null);
                    }
                });
            }));
        };

        const IndexedDBThrowError = function (msg) {
            if (!msg) {
                return;
            }

            throwErrorCount++;
            if (throwErrorCount > 1) {
                return;
            }

            // Task 754000: eChat Server: eChat page is not loading is is giving the user an 'Uncaught db GetTableAllData Error'
            if (msg.indexOf("Failed to read large IndexedDB value") > -1) {
                // eslint-disable-next-line no-console
                console.warn("Failed to read large IndexedDB value. ReloadEChatData");
                EChat.MainPageController.ReloadEChatData("Data loading failed. Will automatically reload.");
                throw msg;
            } else {
                throw msg;
            }
        };

        this.DBHandleQueue = function (HandleArr) {
            return new Promise(((resolve) => {
                if (HandleArr.length > 0) {
                    const nextStep = function () {
                        if (HandleArr.length === 1) {
                            resolve();
                        }
                        HandleArr.splice(0, 1);
                        _this.DBHandleQueue(HandleArr).then(resolve).catch(resolve);
                    };
                    HandleArr[0]().then(nextStep).catch(nextStep);
                } else {
                    resolve();
                }
            }));
        };
    };
    return new IndexedDBClass();
}());

EChat.FullWindowController = (function () {
    const FullWindowController = function () {
        const _this = this;
        let oldTop = 0;
        let oldLeft = 0;
        let oldHeight = 0;
        let keyupFlag = 0;
        let first = true;
        const oldWidth = EChat.__width;
        this.FullWindow = false;
        this.TextArea = null;

        this.SwichWindow = function () {
            if (_this.FullWindow) {
                SwichSmallWindow();
            } else {
                SwichFullWindow();
            }
        };

        const SwichFullWindow = function () {
            _this.FullWindow = true;
            // ui class
            const EChatMainPage = document.getElementById("EChatMainPage");
            EChatMainPage.classList.add("EChatFullWindow");

            // icon
            // Task 1074079：eChat: Close window buttons do not use the standard UI Kit
            const EChatMaximizeBtn = document.querySelector("#EChatMaximizeBtn ecp-btn");
            EChatMaximizeBtn.setAttribute("icon", "ews-icon-recoverwindow");

            _this.ResizeFullWindow();
            EChat.MainPageController.resizeDialog();

            // curr window
            const windowList = EChat.MainPageController.messageWindowList;
            const EChatFullWindowContent = document.getElementById("EChatFullWindowContent");
            if (windowList.length > 0) {
                for (let i = 0; i < windowList.length; i++) {
                    const messageWindow = windowList[i];
                    if (messageWindow === EChat.MainPageController.currentMessageWindow) {
                        EChatFullWindowContent.append(messageWindow.element);
                        ScorllToBottom(messageWindow.currentTab);
                    } else {
                        messageWindow.closeMessageWindow();
                    }
                }
            }

            _this.ResizeTextArea().then(() => {
                if (first) {
                    first = false;
                    setTimeout(() => {
                        document.addEventListener("keydown", (event) => {
                            // Task 1027356: Full Screen UI: Best way to return to small view.
                            if ((event.code === "Escape" || event.key === "Escape") && _this.FullWindow) {
                                SwichSmallWindow();
                            }
                        });
                    }, 100);
                }
            });
            UpdateTextCount();
        };

        const UpdateTextCount = function () {
            const textArea = document.querySelector(".eChat-MessageWindowTextArea");
            if (textArea) {
                EC_Fmt.TriggerEvent(textArea, "input");
            }
        };

        const ScorllToBottom = function (chatTab) {
            if (chatTab) {
                const chatBoxElement = document.getElementById(`chatBox_${chatTab.ID}`);
                if (chatBoxElement) {
                    chatBoxElement.scrollTop = chatBoxElement.scrollHeight;
                }
            }
        };

        const SwichSmallWindow = function () {
            _this.FullWindow = false;
            // ui class
            const EChatMainPage = document.getElementById("EChatMainPage");
            EChatMainPage.classList.remove("EChatFullWindow");

            // icon
            const EChatMaximizeBtn = document.querySelector("#EChatMaximizeBtn ecp-btn");
            EChatMaximizeBtn.setAttribute("icon", "ews-icon-break-out");

            // location
            EChatMainPage.style.top = `${oldTop}px`;
            EChatMainPage.style.left = `${oldLeft}px`;

            // size
            EChat.MainPageController.mainWindowSize = { height: oldHeight };
            EChatMainPage.style.setProperty("--height", `${oldHeight}px`);
            EChatMainPage.style.setProperty("--width", `${oldWidth}px`);
            EChat.MainPageController.resizeDialog();

            // curr window
            const windowList = EChat.MainPageController.messageWindowList;
            const EChatFullWindowContent = document.getElementById("EChatFullWindowContent");
            if (windowList.length > 0) {
                const messageWindow = windowList[0];
                if (messageWindow.chatTabListCount > EChat.Setting.TabNumPerWindow) {
                    const tabArr = [];
                    const groupIDArr = Object.keys(messageWindow.chatTabList);
                    for (let i = 0; i < groupIDArr.length; i++) {
                        const chatTab = messageWindow.chatTabList[groupIDArr[i]];
                        tabArr.push({
                            tab: chatTab,
                            time: chatTab.TabCreateTime
                        });
                    }
                    tabArr.sort((a, b) => b.time - a.time);

                    for (let i = EChat.Setting.TabNumPerWindow; i < tabArr.length; i++) {
                        tabArr[i].tab.closeEvent();
                    }
                }

                EChat.Util.SetWindowLocation(messageWindow.element);
                document.querySelector("html > body").append(messageWindow.element);
                ScorllToBottom(messageWindow.currentTab);
            }

            // clear ui
            EChatFullWindowContent.innerHTML = "";
            oldHeight = 0;
            oldTop = 0;
            oldLeft = 0;

            _this.ResizeTextArea();
            UpdateTextCount();

            const messageWindow = windowList[0];
            const messageWindowMinimize = messageWindow.element.querySelector(".eChat-MessageWindowMinimize").style.display;
            if (messageWindowMinimize === "block") {
                messageWindow.element.querySelector(".eChat-MessageWindowDialog").style.display = "none";
                messageWindow.element.querySelector(".eChat-MessageWindowSend").style.display = "none";
                messageWindow.element.querySelector(".eChat-MessageWindowTitleBox").style.display = "none";
                const screenHeight = window.innerHeight;
                const echatLeft = document.getElementById("EChatMainPage").offsetLeft;
                const messageWindowLeft = messageWindow.element.clientWidth;
                messageWindow.element.style.top = `${screenHeight - 30}px`;
                messageWindow.element.style.left = `${echatLeft - messageWindowLeft}px`;
            }
        };

        this.ResizeFullWindow = function () {
            if (_this.FullWindow) {
                // location
                const topMin = EChat.Util.getHeaderHeight();
                const leftMin = 0;
                oldTop = oldTop || EChatMainPage.getBoundingClientRect().top;
                oldLeft = oldLeft || EChatMainPage.getBoundingClientRect().left;
                EChatMainPage.style.top = `${topMin}px`;
                EChatMainPage.style.left = `${leftMin}px`;

                // size
                const maxHeight = window.innerHeight - topMin;
                const maxWidth = window.innerWidth - leftMin;
                const EChatMainPageHead = document.getElementById("EChatMainPageHead");
                const height = maxHeight - EChatMainPageHead.getBoundingClientRect().height;

                if (!oldHeight) {
                    oldHeight = EChat.MainPageController.mainWindowSize.height ? EChat.MainPageController.mainWindowSize.height : EChat.__height;
                }
                EChat.MainPageController.mainWindowSize = { height };
                EChatMainPage.style.setProperty("--height", `${height}px`);
                EChatMainPage.style.setProperty("--width", `${maxWidth}px`);
            }
        };

        const InitTextArea = async function () {
            const MessageWindowTextArea = document.querySelector(".eChat-MessageWindowTextArea");
            if (!MessageWindowTextArea) {
                return;
            }
            const smallTool = document.querySelector(".eChat-MessageWindowInputTool");
            EChat.Util.ShowLoading(smallTool);
            const Option = {
                height: 110,
                toolbar: ["link uploadfiles removeformat openechat searchhistory copytotask delaysend mutegroup unmutegroup echat fontsizeselect bold italic hr aligncenter alignleft alignright alignjustify bullist numlist wordcount"],
                plugins: ["hr link code"],
                elementpath: false,
                statusbar: false,
                content_style: "body{"
                    + "height:100%"
                    + "} "
                    + "body>* {"
                    + "margin:0!important;"
                    + "font-size:13px"
                    + "}",
                setup: (editor) => {
                    editor.on("keyup", () => {
                        clearTimeout(keyupFlag);
                        keyupFlag = setTimeout(() => {
                            if (_this.TextArea) {
                                _this.TextArea.save();
                            }
                            UpdateTextCount();
                        }, 500);
                    });
                    editor.on("keydown", (e) => {
                        if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
                            EC_Fmt.TriggerEvent(document.getElementById("EChat_Send_Btn"), "click");
                        }
                    });
                    editor.addButton("uploadfiles", {
                        title: "Upload Files",
                        icon: "ews-icon-uploadfiles",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowFileTool"), "click");
                        }
                    });
                    editor.addButton("openechat", {
                        title: "Open eChat",
                        icon: "ews-icon-echat",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowOpenEChatTool"), "click");
                        }
                    });
                    editor.addButton("searchhistory", {
                        title: "Search History",
                        icon: "ews-icon-chatshistory",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowSearchTool"), "click");
                        }
                    });
                    editor.addButton("copytotask", {
                        title: "Copy or Create New Task",
                        icon: "ews-icon-copy",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowCopyTool"), "click");
                        }
                    });
                    editor.addButton("delaysend", {
                        title: "Delay Send",
                        icon: "ews-icon-senddelay",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowSendDelayTool"), "click");
                        }
                    });
                    editor.addButton("mutegroup", {
                        title: "Mute eChat Group",
                        icon: "ews-icon-alert",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowAlertTool"), "click");
                        }
                    });
                    editor.addButton("unmutegroup", {
                        title: "Unmute eChat Group",
                        icon: "ews-icon-DisablesVoice",
                        onclick: (e) => {
                            e.stopPropagation();
                            EC_Fmt.TriggerEvent(smallTool.querySelector(".eChat-MessageWindowAlertTool"), "click");
                        }
                    });
                },
                extended_valid_elements: "strong"
            };

            ECP.HTML.AddControl(ECP.HTML.ControlType.HtmlEdit);
            try {
                await ECP.HTML.LoadControls(true);
                _this.TextArea = (await EWS.TinymceEdit(".eChat-MessageWindowTextArea", "", null, Option))[0];
                _this.TextArea.contentDocument.querySelector("html").style.height = "115px";
                _this.TextArea.iframeElement.style.height = "130px";
                _this.TextArea.editorContainer.style.height = "165px";
            } catch (ex) {
                EWS.Alert(`The rich text edit box failed to load. ${ex}`);
            }

            if (smallTool) {
                smallTool.classList.add("hidden");
            }

            ECP.Dialog.HideLoading();
        };

        this.ResizeTextArea = async function () {
            // Task 1067218: DSDLink: eChat in the new Mobile Framework
            if (_this.FullWindow && !_this.TextArea && EChat.MainPageController.ClientOS === "PC") {
                await InitTextArea();
            } else if (!_this.FullWindow) {
                _this.Destroy();
            }

            const messageWindow = EChat.MainPageController.currentMessageWindow;
            if (messageWindow?.currentTab?.GroupInfo) {
                messageWindow.switchWindowType(messageWindow.currentTab && messageWindow.currentTab.GroupInfo.GroupType, false);
            }
        };

        this.Destroy = function () {
            if (_this.TextArea) {
                _this.TextArea.save();
                _this.TextArea.remove();
                _this.TextArea = null;
            }

            const smallTool = document.querySelector(".eChat-MessageWindowInputTool");
            if (smallTool) {
                smallTool.classList.remove("hidden");
            }
        };
        // Task 1067218: DSDLink: eChat in the new Mobile Framework
        this.ResizeMobileFullWindow = function () {
            if (EChat.MainPageController.ClientOS !== "PC") {
                const EChatMainPageHead = document.getElementById("EChatMainPageHead");
                const EChatMainPageContent = document.getElementById("EChatMainPageContent");
                const EcahtTabHead = EChatMainPageHead.querySelector("#EChatTabHead");
                const EcahtSearchText = EChatMainPageContent.querySelector("#EChatSearchText");

                EChatMainPageContent.style.width = `100%`;
                // EcahtTabHead.style.width = `${parseInt(EChatMainPageHead.style.width) - 61}px`;
                // EcahtTabHead.style.display = "flex";
                // EcahtTabHead.style.JustifyContent = "space-between";

                EcahtTabHead.style.setProperty("display", "flex");
                EcahtTabHead.style.setProperty("justify-content", "space-between");
                EcahtTabHead.style.setProperty("width", `${parseInt(window.innerWidth) - 82}px`);
                EcahtSearchText.style.width = "99%";
            }
        };
    };

    return new FullWindowController();
}());

// Task 524311: Unable to change picture for eChat group
// eslint-disable-next-line no-unused-vars
function AddMapMarker(lat, lng, zoom, address) {
    if (typeof (google) === "undefined") {
        ECP.Dialog.Alert("Failed to load Google Maps. Please refresh the page.");
        return;
    }
    const myOptions = {
        zoom, mapTypeControl: false, center: new google.maps.LatLng(lat, lng), mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    const map = new google.maps.Map(document.getElementById("MainLayout"), myOptions);
    const marker = new google.maps.Marker({
        position: {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        },
        map
    });

    if (address) {
        const infowindow = new google.maps.InfoWindow({
            content: address
        });

        infowindow.open(map, marker);

        google.maps.event.addListener(marker, "click", () => {
            infowindow.open(map, marker);
        });
    }
}

EWS.Ready((EWS) => {
    // Task 646165: eChat: Threads in small eChat should have an echat icon next to them to allow you to jump into the existing echat group in the eChat dashboard
    if (EC_Fmt.GetURLParameters(window.location.href).AloneEChat === "true" || EC_Fmt.GetPageParameter("RunCodeItemTest")) {
        return;
    }
    if (!IsImpersonateUser && window.parent === window) {
        requestIdleCallback(() => {
            // VerifyErrorAction
            let initFail = false;
            const VerifyErrorAction = function () {
                // eslint-disable-next-line no-console
                console.error("init EChat fail. Session Expired/ Network error.");
                initFail = true;
                SocketUtil.on("connect", () => {
                    if (initFail) {
                        initFail = false;
                        // eslint-disable-next-line no-console
                        console.log("init EChat.");
                        EChat.Util.initEChat().then(() => {
                            EC_Fmt.TriggerEvent(document, "EChatReady");
                        });
                    }
                });
            };

            EWS.VerifySession(() => {
                EChat.Util.initEChat().then(() => {
                    // Task 1027181: eChat: Redirect the old full screen eChat dashboard to the new full screen eChat
                    EC_Fmt.TriggerEvent(document, "EChatReady");
                });
            }, false, VerifyErrorAction, VerifyErrorAction);

            EChat.Util.ListenerVisibility();
        });
    }
});
